var Yo = Object.defineProperty;
var en = (t, e, r) => e in t ? Yo(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r;
var j = (t, e, r) => en(t, typeof e != "symbol" ? e + "" : e, r);
import { jsx as u, Fragment as w, jsxs as f } from "react/jsx-runtime";
import De, { useState as G, useEffect as $, lazy as b, useContext as X, createContext as J, Suspense as Dt, useCallback as Gt, useRef as tn, useMemo as me } from "react";
import ht from "@mui/material/CircularProgress";
import rn from "@mui/material/Backdrop";
import Q from "@mui/material/Button";
import F from "@mui/material/Icon";
import on from "@mui/material/Link";
import { createLink as xe, createRootRoute as nn, createFileRoute as k, useParams as Rt, useNavigate as Ee, Navigate as an, useSearch as ge, createRoute as sn, createBrowserHistory as un, createRouter as Ar, RouterProvider as ln } from "@tanstack/react-router";
import h from "@mui/material/Box";
import cn from "@mui/material/Tooltip";
import U from "@mui/material/Typography";
import dn from "@emotion/cache";
import { CacheProvider as pn } from "@emotion/react";
import mn from "@mui/material/CssBaseline";
import yn from "@mui/material/GlobalStyles";
import { LocalizationProvider as gn, DatePicker as mt } from "@mui/x-date-pickers";
import { AdapterDateFns as bn } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { createTheme as Vt } from "@mui/material/styles";
import fn from "@mui/material/styles/createPalette";
import { useQuery as g, useMutation as y, useQueryClient as te, QueryClient as hn, QueryClientProvider as Fr, queryOptions as In, useIsFetching as Sn, useIsMutating as Pn } from "@tanstack/react-query";
import { toast as W, ToastContainer as Cn } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { confirmable as qn, createConfirmationCreater as vn, createReactTreeMounter as Tn, createMountPoint as Bn } from "react-confirm";
import It from "@mui/material/Dialog";
import Or from "@mui/material/DialogActions";
import St from "@mui/material/DialogContent";
import { useTranslation as T } from "react-i18next";
import Ln from "@mui/material/DialogTitle";
import z from "@mui/material/IconButton";
import Nt from "@mui/material/Drawer";
import { DateLocalizationProvider as Gn, BillOfMaterialsDisplay as An, ConfigurationSummaryDisplay as Fn } from "@plansoft-configuration-renderer/components";
import dt from "i18next";
import On from "@mui/material/Alert";
import wn from "@mui/material/AlertTitle";
import { stringify as Dn } from "qs";
import Rn from "@mui/material/ListItemText/ListItemText";
import yt from "@mui/material/Paper";
import { IconButton as At, Icon as gt, Menu as Mt, MenuItem as bt, Tooltip as Ue, TextField as wr, InputAdornment as Dr, debounce as Vn, ButtonGroup as Nn, Checkbox as Ft, Divider as xt, OutlinedInput as Rr, FormControl as Vr, FormLabel as Mn, FormHelperText as xn, Switch as En, ListItemIcon as Un, lighten as lr, Typography as Nr, Box as Ce, Badge as Qn, InputLabel as kn, Select as jn } from "@mui/material";
import ve from "@mui/material/TextField";
import { format as $n } from "date-fns";
import { useMaterialReactTable as zn, MaterialReactTable as Kn, createMRTColumnHelper as Mr, MRT_ToggleRowActionMenuButton as Hn } from "material-react-table";
import { ReactTableDevtools as _n } from "@tanstack/react-table-devtools";
import { useDebounceCallback as xr } from "@react-hook/debounce";
import Et from "@mui/material/FormControl";
import Er from "@mui/material/InputLabel";
import le from "@mui/material/MenuItem";
import Ut from "@mui/material/Select";
import Wn from "@mui/material/ListItemIcon";
import { useTreeItemState as Zn, useTreeViewApiRef as Xn, SimpleTreeView as Jn } from "@mui/x-tree-view";
import { TreeItem as Yn } from "@mui/x-tree-view/TreeItem";
import ei from "clsx";
import ti from "@mui/material/Chip";
import cr from "@mui/material/FormControlLabel";
import Ur from "@mui/material/AppBar";
import ri from "@mui/material/Container";
import oi from "@mui/material/Table";
import ni from "@mui/material/TableContainer";
import ii from "@mui/material/TableBody";
import Qr from "@mui/material/TableCell";
import kr from "@mui/material/TableRow";
import ai from "@mui/material/TableHead";
import si from "@mui/icons-material/Print";
import { useCsConfigurationApi as jr } from "@plansoft-configuration-renderer/framework";
function qe(t, e, r = !1) {
  t || console.error("useLocalStorage: localStorageKey is required", {
    localStorageKey: t
  });
  const [o, n] = G(() => {
    if (r)
      try {
        const i = localStorage.getItem(t);
        if (i !== null)
          return JSON.parse(i);
      } catch (i) {
        console.error("useLocalStorage: Error parsing localStorage value", {
          error: i
        });
      }
    return e;
  });
  return $(() => {
    try {
      localStorage.setItem(t, JSON.stringify(o));
    } catch (i) {
      console.error("useLocalStorage: Error updating localStorage value", {
        error: i,
        localStorageKey: t,
        value: o
      });
    }
  }, [o, t]), [o, n];
}
function ui() {
  return /* @__PURE__ */ u(
    rn,
    {
      open: !0,
      sx: { color: "#fff", zIndex: (t) => t.zIndex.drawer + 1e4 },
      children: /* @__PURE__ */ u(ht, { color: "inherit" })
    }
  );
}
function li() {
  return /* @__PURE__ */ u(Q, { disabled: !0, startIcon: /* @__PURE__ */ u(F, { children: "add" }), children: "Guided Selling" });
}
const ci = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20id='Ebene_2'%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20148.21%2039.73'%3e%3cdefs%3e%3cstyle%3e.cls-1{fill:%23fff;}.cls-2{fill:%235cb8b2;}%3c/style%3e%3c/defs%3e%3cg%20id='Ebene_2-2'%3e%3cg%3e%3cg%3e%3cpath%20class='cls-2'%20d='M16.45,.12L.42,9.7c-.26,.16-.42,.45-.42,.75V29.28c0,.31,.16,.59,.42,.75l16.03,9.58c.27,.16,.61,.16,.89,0l16.22-9.58c.26-.16,.43-.44,.43-.75V10.45c0-.31-.16-.59-.43-.75L17.34,.12c-.27-.16-.62-.16-.89,0Z'/%3e%3cpath%20class='cls-1'%20d='M14.42,4.94h0L5.25,10.43c-.28,.17-.28,.44,0,.61l1.72,1.03c.28,.17,.74,.17,1.02,0l8.68-5.18c.28-.17,.75-.17,1.03,0l1.07,.64c.28,.17,.28,.44,0,.61l-8.7,5.18c-.28,.17-.28,.44,0,.61l1.73,1.04c.28,.17,.74,.17,1.02,0l8.72-5.18c.29-.17,.75-.17,1.03,0l1.08,.64c.29,.17,.29,.44,0,.61l-8.74,5.18c-.28,.17-.28,.44,0,.61l1.74,1.04c.28,.17,.75,.17,1.03,0l9.28-5.48,2.8-1.65h0L17.7,3.59c-.28-.17-.75-.17-1.03,0l-2.25,1.35Z'/%3e%3cpath%20class='cls-1'%20d='M12.04,19.13h0l-6.89-4.11h0l-2.73-1.64h0v13.89c0,.33,.23,.73,.51,.9l1.72,1.03c.28,.17,.51,.04,.51-.29v-4.44c0-.33,.23-.46,.51-.29l6.38,3.81,2.73,1.63h0v-8.25c0-.33-.23-.73-.51-.9l-2.23-1.33h0Zm-6.89,.92v-1.25c0-.33,.23-.46,.51-.29l5.87,3.51c.28,.17,.51,.57,.51,.9v1.25c0,.33-.23,.46-.51,.29l-5.87-3.51c-.28-.17-.51-.57-.51-.9Z'/%3e%3cpath%20class='cls-1'%20d='M29.04,15.6h0l-6.67,3.95h0l-2.65,1.56h0v13.3c0,.31,.22,.44,.49,.28l2.16-1.27,6.67-3.94,2.65-1.57h0V14.61c0-.31-.22-.44-.49-.28l-2.16,1.27Zm-6.18,6.73l5.69-3.36c.27-.16,.49-.04,.49,.28v3.61c0,.51-.53,1.08-.84,.9l-.78-.44c-.19-.11-.5,.07-.7,.41l-1.18,2.06c-.19,.34-.19,.7,0,.81l.78,.44c.31,.18,.09,.92-.35,1.18l-3.12,1.84c-.27,.16-.49,.04-.49-.28v-6.59c0-.31,.22-.7,.49-.86h.01Z'/%3e%3c/g%3e%3cpath%20class='cls-1'%20d='M46.06,34.77c-.21,0-.38-.16-.38-.37V5.32c0-.2,.17-.37,.38-.37s.38,.16,.38,.37v29.08c0,.2-.17,.37-.38,.37Z'/%3e%3cg%3e%3cpath%20class='cls-1'%20d='M60.85,30.78l3.07-4.2c1.76,1.68,3.89,2.91,6.3,2.91,2.81,0,4.67-1.22,4.67-3.43,0-2.52-1.47-4.08-7.72-4.08v-4.71c5.16,0,6.79-1.57,6.79-3.85,0-2.02-1.29-3.17-3.54-3.17-2.04,0-3.59,.93-5.37,2.51l-3.37-4.05c2.65-2.27,5.54-3.68,9.04-3.68,5.97,0,9.92,2.83,9.92,7.89,0,2.96-1.7,5.08-4.79,6.38v.18c3.32,.95,5.73,3.29,5.73,7.01,0,5.35-4.9,8.37-10.69,8.37-4.65,0-7.91-1.65-10.02-4.07h-.02Z'/%3e%3cpath%20class='cls-2'%20d='M86.63,5.03h8.53c6.7,0,11.21,2.25,11.21,8.8s-4.49,9.23-11.03,9.23h-4.91v11.85h-3.8s0-29.88,0-29.88Zm8.24,14.94c5.23,0,7.72-1.89,7.72-6.15s-2.65-5.71-7.9-5.71h-4.25v11.86h4.43Z'/%3e%3cpath%20class='cls-2'%20d='M109.74,19.73c0-9.28,5.11-14.92,12.39-14.92s12.39,5.65,12.39,14.92-5.11,15.13-12.39,15.13-12.39-5.84-12.39-15.13Zm20.97,0c0-7.22-3.4-11.67-8.58-11.67s-8.58,4.45-8.58,11.67,3.4,12.07,8.58,12.07,8.58-4.69,8.58-12.07Zm-8.58,7.73l3.83-.29c1.17,3.06,4.01,4.58,7.43,4.58,1.29,0,2.27-.19,3.04-.42l.71,2.85c-.87,.34-2.41,.67-4.14,.67-5.56,0-9.32-3.17-10.88-7.39h.01Z'/%3e%3c/g%3e%3c/g%3e%3cpath%20class='cls-2'%20d='M137.13,5.95c0-3.44,2.5-5.82,5.54-5.82s5.54,2.38,5.54,5.82-2.5,5.79-5.54,5.79-5.54-2.35-5.54-5.79Zm9.91,0c0-2.78-1.89-4.75-4.37-4.75s-4.37,1.97-4.37,4.75,1.89,4.72,4.37,4.72,4.37-1.93,4.37-4.72Zm-6.51-3.07h2.25c1.23,0,2.3,.5,2.3,1.91,0,.72-.44,1.39-1.11,1.63l1.36,2.44h-1.35l-1.05-2.06h-1.19v2.06h-1.21V2.87h0Zm1.97,2.98c.79,0,1.29-.33,1.29-.98,0-.59-.33-.99-1.21-.99h-.83v1.97h.75Z'/%3e%3c/g%3e%3c/svg%3e", di = xe(on);
function pi() {
  return /* @__PURE__ */ u(di, { to: "/", children: /* @__PURE__ */ u("img", { src: ci, height: "32px", alt: "logo", className: "logo" }) });
}
function mi() {
  return /* @__PURE__ */ u(pi, {});
}
function yi() {
  return /* @__PURE__ */ u(w, {});
}
const gi = b(
  () => import("./AddCustomProductDialogButton-BDfG9CBn.js").then(
    (t) => ({
      default: t.AddCustomProductDialogButton
    })
  )
), bi = b(
  () => import("./IndicatorConfigurableProductSimple-Bm8-z0KU.js").then((t) => ({
    default: t.IndicatorConfigurableProductSimple
  }))
), fi = b(
  () => Promise.resolve().then(() => Ey).then((t) => ({
    default: t.IndicatorConfigurableProductInLineItem
  }))
), hi = b(
  () => import("./PageSubHeading-C5XvjifH.js").then((t) => ({
    default: t.PageSubHeading
  }))
), Ii = b(
  () => import("./PriceSummary-BQsjMJwR.js").then((t) => ({
    default: t.PriceSummary
  }))
), Si = b(
  () => Promise.resolve().then(() => vy)
), Pi = b(
  () => import("./RootRouteComponent-DwygUg0X.js")
), Ci = b(
  () => import("./DocGenRouteComponent-C4PxWR8j.js").then((t) => ({
    default: t.DocGenRouteComponent
  }))
), qi = b(
  () => import("./ConfiguratorRouteComponent-CeRIkgo9.js")
), vi = b(
  () => import("./PresetsRouteComponent-BEyTzZW8.js")
), Ti = b(
  () => import("./OpportunityRouteComponent-C02Y_jWP.js")
), Bi = b(
  () => import("./QuotesRouteComponent-zxNf8Wwb.js")
), Li = b(
  () => import("./QuotesQuoteIdRouteComponent-Dwa0hEy0.js")
), Gi = b(
  () => import("./CatalogRouteComponent-pJsfSnpz.js")
), Ai = b(
  () => import("./QuoteInfoRouteComponent-B0GJQIQL.js")
), Fi = b(
  () => import("./ConfigurationRenderer-CCubVssH.js")
), Oi = b(() => import("./Presets-BRsFb__6.js")), wi = b(
  () => Promise.resolve().then(() => Dy)
), Di = b(
  () => import("./PriceTag-D00htuwB.js").then((t) => ({
    default: t.PriceTag
  }))
), Ri = b(
  () => import("./ListPricePriceTag-DG_SGcpg.js").then((t) => ({
    default: t.ListPricePriceTag
  }))
), Vi = b(
  () => import("./CostPriceTag-Cd5XAVHM.js").then((t) => ({
    default: t.CostPriceTag
  }))
), Ni = b(
  () => import("./AddLineItemButton-TxgbW_XP.js")
), Mi = b(
  () => import("./AddLineItemButtonWrapper-9GPAhC5k.js").then((t) => ({
    default: t.AddLineItemButtonWrapper
  }))
), xi = b(
  () => Promise.resolve().then(() => Gy)
), Ei = b(
  () => Promise.resolve().then(() => Ly)
), Ui = b(
  () => import("./MainHeader-D5o99L_f.js")
), Qi = b(
  () => import("./LanguageSelectContainer-DLdBWhjM.js")
), ki = b(
  () => Promise.resolve().then(() => Ay)
), ji = b(
  () => import("./UpperQuoteInfoPlaceholder-uOkanZXU.js")
), $i = b(
  () => import("./GeneralInformationComponent-DlzhapX1.js")
), zi = b(
  () => import("./LowerQuoteInfoPlaceholder-9nsmYIFT.js")
), Ki = b(
  () => Promise.resolve().then(() => bm)
), Hi = b(
  () => import("./QuoteCurrencySelect-Ci06ckQs.js")
), _i = b(
  () => Promise.resolve().then(() => Ry)
), Wi = b(
  () => import("./AddItemGroupButton-Bst2MQxj.js").then(
    (t) => ({
      default: t.AddItemGroupButton
    })
  )
), Zi = b(
  () => import("./QuoteActionsWrapper-DClts0MU.js").then(
    (t) => ({
      default: t.QuoteActionsWrapper
    })
  )
), Xi = b(
  () => import("./ImportExcelToQuote-S4KNaVqT.js").then(
    (t) => ({
      default: t.ImportExcelToQuote
    })
  )
), Ji = b(
  () => import("./ExportQuoteToExcel-Ca3bJKHF.js").then(
    (t) => ({
      default: t.ExportQuoteToExcel
    })
  )
), Yi = b(
  () => import("./QuoteWrapperShowHideColumnsButton-VdA8aoah.js").then((t) => ({
    default: t.QuoteWrapperShowHideColumnsButton
  }))
), ea = b(
  () => import("./AddToQuoteMenuLineItem-DBjWbve8.js").then((t) => ({
    default: t.AddToQuoteMenuLineItem
  }))
), ta = b(
  () => import("./CartViewHeading-VWEHvorp.js").then((t) => ({
    default: t.CartViewHeading
  }))
), ra = b(
  () => import("./CartViewPageSubHeading-B_1aRzif.js").then((t) => ({
    default: t.CartViewPageSubHeading
  }))
), oa = b(
  () => import("./CartButtons-UORYFnim.js").then((t) => ({
    default: t.CartButtons
  }))
), na = b(
  () => import("./AddConfigurationToCartButton-BB4CUX3x.js").then(
    (t) => ({
      default: t.AddConfigurationToCartButton
    })
  )
), ia = b(
  () => import("./AddArticleToCartButton-BhweIGXY.js").then(
    (t) => ({
      default: t.AddArticleToCartButton
    })
  )
), aa = b(
  () => import("./ImportExcelToCart-1y-Zt6aR.js").then((t) => ({
    default: t.ImportExcelToCart
  }))
), sa = b(
  () => import("./ExportCartToExcel-B1Yx01Tu.js").then((t) => ({
    default: t.ExportCartToExcel
  }))
), ua = b(
  () => import("./PrintShoppingCart-pBGdS35_.js").then((t) => ({
    default: t.PrintShoppingCart
  }))
), la = b(
  () => import("./CartViewEmptyCart-B7ug_u8w.js").then((t) => ({
    default: t.CartViewEmptyCart
  }))
), ca = b(
  () => import("./CartViewFooter-D_dic8RH.js").then((t) => ({
    default: t.CartViewFooter
  }))
), da = b(
  () => import("./ShoppingCartSummary-DtXc2V81.js").then(
    (t) => ({
      default: t.ShoppingCartSummary
    })
  )
), pa = b(
  () => import("./ShoppingCartSummaryContainer-JP0TP98e.js").then((t) => ({
    default: t.ShoppingCartSummaryContainer
  }))
), ma = b(
  () => import("./Status-fq_guyet.js").then((t) => ({
    default: t.Status
  }))
), ya = b(
  () => import("./ArticleNumber-B8AKmdNo.js").then((t) => ({
    default: t.ArticleNumber
  }))
), ga = b(
  () => import("./GoBackToOpportunitiesButton-D_GQZJEZ.js").then((t) => ({
    default: t.GoBackToOpportunitiesButton
  }))
), ba = b(
  () => import("./GoBackToOpportunityButton-BNzRRim_.js").then((t) => ({
    default: t.GoBackToOpportunityButton
  }))
), fa = b(
  () => import("./LineItemAccordion-YjeLYYzs.js").then((t) => ({
    default: t.LineItemAccordion
  }))
), ha = b(
  () => import("./LineItem-7__KWvvU.js").then((t) => ({
    default: t.LineItem
  }))
), Ia = b(
  () => import("./Rank-Dvee5OI4.js").then((t) => ({
    default: t.Rank
  }))
), Sa = b(
  () => Promise.resolve().then(() => Mp).then((t) => ({
    default: t.ProductImage
  }))
), Pa = b(
  () => import("./BasicItemInfo-BLEQq05P.js").then((t) => ({
    default: t.BasicItemInfo
  }))
), Ca = b(
  () => import("./DownloadLineItemButton-DuOT4MuM.js").then((t) => ({
    default: t.DownloadLineItemButton
  }))
), qa = b(
  () => import("./PricesAndDiscountsBar-BLNvn1PS.js").then((t) => ({
    default: t.PricesAndDiscountsBar
  }))
), va = b(
  () => import("./ConnectedQuantity-4ltw0pmP.js").then((t) => ({
    default: t.ConnectedQuantity
  }))
), Ta = b(
  () => import("./ListPrice-Mrhe8fVV.js").then((t) => ({
    default: t.ListPrice
  }))
), Ba = b(
  () => import("./TotalList-DaQ1ABB4.js").then((t) => ({
    default: t.TotalList
  }))
), La = b(
  () => import("./TotalDiscountPercentage-B0RuEhXe.js").then(
    (t) => ({
      default: t.TotalDiscountPercentage
    })
  )
), Ga = b(
  () => import("./TotalDiscount-Bnb-X8zb.js").then((t) => ({
    default: t.TotalDiscount
  }))
), Aa = b(
  () => import("./TotalCost-BciXAcSd.js").then((t) => ({
    default: t.TotalCost
  }))
), Fa = b(
  () => import("./TotalNet-CyvyAGas.js").then((t) => ({
    default: t.TotalNet
  }))
), Oa = b(
  () => import("./OpportunityHeading-BOQcHNHf.js").then((t) => ({
    default: t.OpportunityHeading
  }))
), wa = b(
  () => import("./SubItems-BD09xxnv.js").then((t) => ({
    default: t.SubItems
  }))
), Da = b(
  () => import("./PageHeading-BwMZ316w.js").then((t) => ({
    default: t.PageHeading
  }))
), Ra = b(
  () => import("./ProductsTable-Bra2X6Pj.js").then((t) => ({
    default: t.ProductsTable
  }))
), Va = b(
  () => import("./IndexRouteComponent-Cs4t4f6K.js").then((t) => ({
    default: t.IndexRouteComponent
  }))
), Na = b(
  () => import("./CatalogButtons-DnQEdcg8.js").then((t) => ({
    default: t.CatalogButtons
  }))
), Ma = b(
  () => import("./AddFilterButton-BrXrRlzd.js").then(
    (t) => ({
      default: t.AddFilterButton
    })
  )
), xa = b(
  () => import("./LineItemsOverviewToggleButton-B9Vduh9I.js").then((t) => ({
    default: t.LineItemsOverviewToggleButton
  }))
), Ea = b(
  () => import("./CartIdRouteComponent-jm-3gpIb.js").then((t) => ({
    default: t.CartIdRouteComponent
  }))
), Ua = b(
  () => import("./OpportunityIdRouteComponent-ayGCXFQu.js").then(
    (t) => ({
      default: t.OpportunityIdRouteComponent
    })
  )
), Qa = b(
  () => import("./CloneQuoteButton-CiNaaznw.js").then(
    (t) => ({
      default: t.CloneQuoteButton
    })
  )
), ka = b(
  () => import("./GoToCartButton-BwB5YreT.js").then(
    (t) => ({
      default: t.GoToCartButton
    })
  )
), ja = b(
  () => import("./GenericSearchField-BwoDAwNk.js").then((t) => ({
    default: t.GenericSearchField
  }))
), $a = b(
  () => import("./CloneRowMenuItem-DAyrBtRn.js").then(
    (t) => ({
      default: t.CloneRowMenuItem
    })
  )
), za = b(
  () => import("./DeleteRowMenuItem-Bq8_FoPU.js").then(
    (t) => ({
      default: t.DeleteRowMenuItem
    })
  )
), Ka = b(
  () => import("./EditRowMenuItem-WA5UihX7.js").then((t) => ({
    default: t.EditRowMenuItem
  }))
), Ha = b(
  () => Promise.resolve().then(() => _y).then((t) => ({
    default: t.ItemActionMenu
  }))
), _a = b(
  () => import("./QuoteStatus-BBxXDriL.js").then((t) => ({
    default: t.QuoteStatus
  }))
), Wa = b(
  () => import("./CloneItemIconButton-B59HFuko.js").then((t) => ({
    default: t.CloneItemIconButton
  }))
), Za = b(
  () => import("./DeleteItemIconButton-Czce404D.js").then((t) => ({
    default: t.DeleteItemIconButton
  }))
), Xa = b(
  () => import("./EditCustomProductButton-Rk07Qj3H.js").then((t) => ({
    default: t.EditCustomProductDialogButton
  }))
), Ja = b(
  () => import("./QuoteTableRowActions-D9BOmACx.js").then((t) => ({
    default: t.QuoteTableRowActions
  }))
), Ya = b(
  () => import("./QuoteNumericInputPercentage-Cm-nU2GG.js").then(
    (t) => ({
      default: t.QuoteNumericInputPercentage
    })
  )
), es = b(
  () => import("./MoveRowMenu-NDLQy9sX.js").then((t) => ({
    default: t.MoveRowMenu
  }))
), ts = b(
  () => import("./MoveRowMenuButton-BW7pufm8.js").then(
    (t) => ({
      default: t.MoveRowMenuButton
    })
  )
), rs = b(
  () => import("./UserWidget-DAha1D8s.js").then((t) => ({
    default: t.UserWidget
  }))
), os = b(
  () => import("./CartViewLineItemActions-DIUBzUnf.js").then((t) => ({
    default: t.CartViewLineItemActions
  }))
), ns = b(
  () => import("./GoBackToCatalogButton-DFrEaier.js").then(
    (t) => ({
      default: t.GoBackToCatalogButton
    })
  )
), is = b(
  () => import("./QuoteDetailsNavigation-lpd9_W01.js").then(
    (t) => ({
      default: t.QuoteDetailsNavigation
    })
  )
);
var as = /* @__PURE__ */ ((t) => (t.AddCustomProductDialogButton = "AddCustomProductDialogButton", t.IndicatorConfigurableProductSimple = "IndicatorConfigurableProductSimple", t.IndicatorConfigurableProductInLineItem = "IndicatorConfigurableProductInLineItem", t.MainHeader = "MainHeader", t.LanguageSelectContainer = "LanguageSelectContainer", t.LanguageSelect = "LanguageSelect", t.PageSubHeading = "PageSubHeading", t.ItemGroupsFilter = "ItemGroupsFilter", t.PriceSummary = "PriceSummary", t.QuotesQuoteIdNotFoundPage = "QuotesQuoteIdNotFoundPage", t.QuoteDetailsViewPageHeader = "QuoteDetailsViewPageHeader", t.CatalogButtons = "CatalogButtons", t.AddFilterButton = "AddFilterButton", t.LineItemsOverviewToggleButton = "LineItemsOverviewToggleButton", t.RootRouteComponent = "RootRouteComponent", t.ConfiguratorRouteComponent = "ConfiguratorRouteComponent", t.PresetsRouteComponent = "PresetsRouteComponent", t.OpportunityRouteComponent = "OpportunityRouteComponent", t.QuotesRouteComponent = "QuotesRouteComponent", t.QuotesQuoteIdRouteComponent = "QuotesQuoteIdRouteComponent", t.CatalogRouteComponent = "CatalogRouteComponent", t.QuoteInfoRouteComponent = "QuoteInfoRouteComponent", t.ConfiguratorFooter = "ConfiguratorFooter", t.ConfiguratorFooterContent = "ConfiguratorFooterContent", t.ConfigurationRenderer = "ConfigurationRenderer", t.Presets = "Presets", t.AddProductsToQuoteWidget = "AddProductsToQuoteWidget", t.PriceTag = "PriceTag", t.AddLineItemButton = "AddLineItemButton", t.AddLineItemButtonWrapper = "AddLineItemButtonWrapper", t.ItemGroupAdditionalActions = "ItemGroupAdditionalActions", t.OpportunityActionButtonsArea = "OpportunityActionButtonsArea", t.ItemGroupActionButtonsArea = "ItemGroupActionButtonsArea", t.GuidedSellingButton = "GuidedSellingButton", t.UpperQuoteInfoPlaceholder = "UpperQuoteInfoPlaceholder", t.GeneralInformationComponent = "GeneralInformationComponent", t.LowerQuoteInfoPlaceholder = "LowerQuoteInfoPlaceholder", t.PriceListSelect = "PriceListSelect", t.QuoteCurrencySelect = "QuoteCurrencySelect", t.QuoteDiscounts = "QuoteDiscounts", t.AbsoluteProgressIndicator = "AbsoluteProgressIndicator", t.AddItemGroupButton = "AddItemGroupButton", t.QuoteActionsWrapper = "QuoteActionsWrapper", t.ImportExcelToQuote = "ImportExcelToQuote", t.ExportQuoteToExcel = "ExportQuoteToExcel", t.QuoteWrapperShowHideColumnsButton = "QuoteWrapperShowHideColumnsButton", t.AddToQuoteMenuLineItem = "AddToQuoteMenuLineItem", t.CartViewHeading = "CartViewHeading", t.CartViewPageSubHeading = "CartViewPageSubHeading", t.CartButtons = "CartButtons", t.AddConfigurationToCartButton = "AddConfigurationToCartButton", t.AddArticleToCartButton = "AddArticleToCartButton", t.ImportExcelToCart = "ImportExcelToCart", t.ExportCartToExcel = "ExportCartToExcel", t.PrintShoppingCart = "PrintShoppingCart", t.CartViewEmptyCart = "CartViewEmptyCart", t.CartViewFooter = "CartViewFooter", t.ShoppingCartSummary = "ShoppingCartSummary", t.ShoppingCartSummaryContainer = "ShoppingCartSummaryContainer", t.Status = "Status", t.ArticleNumber = "ArticleNumber", t.GoBackToOpportunitiesButton = "GoBackToOpportunitiesButton", t.GoBackToOpportunityButton = "GoBackToOpportunityButton", t.LineItemAccordion = "LineItemAccordion", t.LineItem = "LineItem", t.Rank = "Rank", t.ProductImage = "ProductImage", t.BasicItemInfo = "BasicItemInfo", t.DownloadLineItemButton = "DownloadLineItemButton", t.PricesAndDiscountsBar = "PricesAndDiscountsBar", t.ConnectedQuantity = "ConnectedQuantity", t.ListPrice = "ListPrice", t.TotalList = "TotalList", t.TotalDiscountPercentage = "TotalDiscountPercentage", t.TotalDiscount = "TotalDiscount", t.TotalCost = "TotalCost", t.TotalNet = "TotalNet", t.SubItems = "SubItems", t.OpportunityHeading = "OpportunityHeading", t.PageHeading = "PageHeading", t.ProductsTable = "ProductsTable", t.IndexRouteComponent = "IndexRouteComponent", t.CartIdRouteComponent = "CartIdRouteComponent", t.OpportunityIdRouteComponent = "OpportunityIdRouteComponent", t.CloneQuoteButton = "CloneQuoteButton", t.GoToCartButton = "GoToCartButton", t.GenericSearchField = "GenericSearchField", t.CloneRowMenuItem = "CloneRowMenuItem", t.DeleteRowMenuItem = "DeleteRowMenuItem", t.EditRowMenuItem = "EditRowMenuItem", t.ItemActionMenu = "ItemActionMenu", t.QuoteStatus = "QuoteStatus", t.DocGenRouteComponent = "DocGenRouteComponent", t.CloneItemIconButton = "CloneItemIconButton", t.DeleteItemIconButton = "DeleteItemIconButton", t.EditCustomProductDialogButton = "EditCustomProductDialogButton", t.QuoteTableRowActions = "QuoteTableRowActions", t.QuoteNumericInputPercentage = "QuoteNumericInputPercentage", t.MoveRowMenu = "MoveRowMenu", t.MoveRowMenuButton = "MoveRowMenuButton", t.ListPricePriceTag = "ListPricePriceTag", t.CostPriceTag = "CostPriceTag", t.UserWidget = "UserWidget", t.CartViewLineItemActions = "CartViewLineItemActions", t.MainHeaderLogo = "MainHeaderLogo", t.GoBackToCatalogButton = "GoBackToCatalogButton", t.QuoteDetailsNavigation = "QuoteDetailsNavigation", t))(as || {});
const Re = {
  RootRouteComponent: Pi,
  AddCustomProductDialogButton: gi,
  IndicatorConfigurableProductSimple: bi,
  IndicatorConfigurableProductInLineItem: fi,
  MainHeader: Ui,
  LanguageSelect: ki,
  LanguageSelectContainer: Qi,
  PageSubHeading: hi,
  ItemGroupsFilter: () => /* @__PURE__ */ u(w, {}),
  PriceSummary: Ii,
  QuotesQuoteIdNotFoundPage: () => /* @__PURE__ */ u("div", { children: "QuotesQuoteIdNotFoundPage" }),
  CatalogButtons: Na,
  AddFilterButton: Ma,
  LineItemsOverviewToggleButton: xa,
  QuoteDetailsViewPageHeader: Si,
  ConfiguratorRouteComponent: qi,
  PresetsRouteComponent: vi,
  OpportunityRouteComponent: Ti,
  OpportunityIdRouteComponent: Ua,
  QuotesRouteComponent: Bi,
  QuotesQuoteIdRouteComponent: Li,
  CatalogRouteComponent: Gi,
  QuoteInfoRouteComponent: Ai,
  ConfigurationRenderer: Fi,
  Presets: Oi,
  AddProductsToQuoteWidget: wi,
  PriceTag: Di,
  ListPricePriceTag: Ri,
  CostPriceTag: Vi,
  AddLineItemButton: Ni,
  AddLineItemButtonWrapper: Mi,
  ItemGroupAdditionalActions: yi,
  OpportunityActionButtonsArea: xi,
  ItemGroupActionButtonsArea: Ei,
  GuidedSellingButton: li,
  UpperQuoteInfoPlaceholder: ji,
  GeneralInformationComponent: $i,
  LowerQuoteInfoPlaceholder: zi,
  PriceListSelect: Ki,
  QuoteCurrencySelect: Hi,
  QuoteDiscounts: _i,
  //for some reason this can not be lazy imported, it will break in cpq-standard
  AbsoluteProgressIndicator: ui,
  AddItemGroupButton: Wi,
  QuoteActionsWrapper: Zi,
  ImportExcelToQuote: Xi,
  ExportQuoteToExcel: Ji,
  QuoteWrapperShowHideColumnsButton: Yi,
  AddToQuoteMenuLineItem: ea,
  CartViewHeading: ta,
  CartViewPageSubHeading: ra,
  CartButtons: oa,
  AddConfigurationToCartButton: na,
  AddArticleToCartButton: ia,
  ImportExcelToCart: aa,
  ExportCartToExcel: sa,
  PrintShoppingCart: ua,
  CartViewEmptyCart: la,
  CartViewFooter: ca,
  ShoppingCartSummary: da,
  ShoppingCartSummaryContainer: pa,
  Status: ma,
  ArticleNumber: ya,
  GoBackToOpportunitiesButton: ga,
  GoBackToOpportunityButton: ba,
  LineItemAccordion: fa,
  LineItem: ha,
  Rank: Ia,
  ProductImage: Sa,
  BasicItemInfo: Pa,
  DownloadLineItemButton: Ca,
  PricesAndDiscountsBar: qa,
  ConnectedQuantity: va,
  ListPrice: Ta,
  TotalList: Ba,
  TotalDiscountPercentage: La,
  TotalDiscount: Ga,
  TotalCost: Aa,
  TotalNet: Fa,
  SubItems: wa,
  OpportunityHeading: Oa,
  PageHeading: Da,
  ProductsTable: Ra,
  IndexRouteComponent: Va,
  CartIdRouteComponent: Ea,
  CloneQuoteButton: Qa,
  GoToCartButton: ka,
  GenericSearchField: ja,
  CloneRowMenuItem: $a,
  DeleteRowMenuItem: za,
  EditRowMenuItem: Ka,
  ItemActionMenu: Ha,
  QuoteStatus: _a,
  DocGenRouteComponent: Ci,
  CloneItemIconButton: Wa,
  DeleteItemIconButton: Za,
  EditCustomProductDialogButton: Xa,
  QuoteNumericInputPercentage: Ya,
  QuoteTableRowActions: Ja,
  MoveRowMenu: es,
  MoveRowMenuButton: ts,
  UserWidget: rs,
  CartViewLineItemActions: os,
  MainHeaderLogo: mi,
  GoBackToCatalogButton: ns,
  QuoteDetailsNavigation: is
};
function ss({
  name: t,
  Component: e,
  isStandardType: r,
  propKeys: o
}) {
  const n = t + (r ? " (Standard)" : " (Overridden)"), i = o.length ? `
 Set default props: ${o == null ? void 0 : o.join(", ")}` : "", a = `${n}${i}`;
  return /* @__PURE__ */ u(cn, { title: a, followCursor: !0, children: /* @__PURE__ */ f(
    h,
    {
      sx: {
        margin: "2px",
        border: "solid 1px",
        borderColor: r ? "red" : "green",
        backgroundColor: r ? "rgba(255, 0, 0, 0.1)" : "rgba(255,136,0,0.1)",
        position: "relative",
        borderRadius: "4px",
        width: "auto"
      },
      children: [
        /* @__PURE__ */ u(
          h,
          {
            sx: {
              padding: "2px",
              borderRadius: "0 0 3px 0",
              backgroundColor: r ? "red" : "orange",
              color: "white"
            },
            children: /* @__PURE__ */ u(U, { variant: "caption", fontSize: "0.7rem", children: a })
          }
        ),
        e
      ]
    }
  ) });
}
function us({
  standard: t,
  overridden: e
}) {
  const r = dr(t, !0), o = dr(e);
  return { ...r, ...o };
}
function dr(t, e) {
  const r = t;
  return Object.keys(r).reduce(
    (o, n) => {
      const i = n, a = r[i];
      return a && (o[i] = (s) => /* @__PURE__ */ u(
        ss,
        {
          name: n,
          propKeys: Object.keys(s),
          Component: /* @__PURE__ */ u(a, { ...s }),
          isStandardType: e
        }
      )), o;
    },
    {}
  );
}
const $r = J({
  overridableComponents: Re,
  showOverridableComponents: !1,
  setShowOverridableComponents: () => {
    console.error("setShowOverridableComponents not implemented");
  },
  showTableDebugTools: !1,
  setShowTableDebugTools: () => {
    console.error("setShowTableDebugTools not implemented");
  }
});
function ls({
  children: t,
  componentsOverride: e
}) {
  const [r, o] = qe("showOverridableComponents", !1, !0), [n, i] = G(!1), a = {
    ...Re,
    ...e
  }, s = r ? us({
    standard: Re,
    overridden: e
  }) : a;
  return /* @__PURE__ */ u(
    $r.Provider,
    {
      value: {
        overridableComponents: s,
        showOverridableComponents: r,
        setShowOverridableComponents: o,
        showTableDebugTools: n,
        setShowTableDebugTools: i
      },
      children: t
    }
  );
}
function zr() {
  return X($r);
}
function cs({
  componentKey: t,
  ...e
}) {
  const { overridableComponents: r } = zr(), o = (
    //todo fix
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-expect-error
    r[t] || Re[t]
  );
  return t === "LineItem" || t === "LineItemAccordion" || t === "ShoppingCartSummary" ? /* @__PURE__ */ u(o, { ...e }) : /* @__PURE__ */ u(Dt, { fallback: /* @__PURE__ */ u(ht, { size: "15px" }), children: /* @__PURE__ */ u(o, { ...e }) });
}
const C = Object.keys(
  Re
).reduce((t, e) => {
  const r = e;
  return t[r] = (o) => /* @__PURE__ */ u(cs, { componentKey: r, ...o }), t;
}, {});
function be() {
  return /* @__PURE__ */ u(C.AbsoluteProgressIndicator, {});
}
const Kr = J({
  enableDevTools: !1,
  setEnableDevTools: (t) => console.log("setEnableDevTools not implemented"),
  showDevTools: !1,
  setShowDevTools: (t) => console.log("setShowDevTools not implemented"),
  showSettingsVisualizer: !1,
  setShowSettingsVisualizer: (t) => console.log("setShowSettingsVisualizer not implemented")
});
function ds({
  defaultValues: t,
  children: e
}) {
  const [r, o] = qe(
    "cpq_enableDevTools",
    t.enableDevTools || !1,
    !0
  ), [n, i] = qe(
    "cpq_showDevTools",
    t.showDevTools || !1,
    !0
  ), [a, s] = qe(
    "cpq_showSettingsVisualizer",
    t.showSettingsVisualizer || !1,
    !0
  );
  return /* @__PURE__ */ u(
    Kr,
    {
      value: {
        enableDevTools: r,
        setEnableDevTools: o,
        showDevTools: n && r,
        setShowDevTools: i,
        showSettingsVisualizer: r && a,
        setShowSettingsVisualizer: s
      },
      children: e
    }
  );
}
const se = {
  primary: {
    default: "#FF8B36",
    hover: "#F5B063",
    dark: "#3C3C3B",
    contrastText: "#ffffff"
  },
  textColors: {
    primary: "#212529DE",
    secondary: "#6F6F6F",
    disable: "#00000061"
  },
  action: {
    active: "#0000008F",
    hover: "#0000000A"
  }
}, x = fn({
  primary: {
    main: se.primary.default,
    light: se.primary.hover,
    contrastText: se.primary.contrastText
  },
  secondary: {
    main: "#81848F",
    dark: se.primary.dark
  },
  text: {
    primary: se.textColors.primary,
    secondary: se.textColors.secondary,
    disabled: se.textColors.disable
  },
  background: { default: "#f5f5f5" },
  action: {
    active: se.action.active,
    hover: se.action.hover
  }
}), ps = Vt({
  palette: x,
  typography: {
    fontFamily: ["Roboto", "Arial", "Helvetica", "sans-serif"].join(","),
    h1: { fontSize: "1.5rem", fontWeight: 500, color: x.primary.main },
    body1: { fontSize: "0.875rem" }
  },
  components: {
    MuiTypography: {
      styleOverrides: { h1: { color: x.text.primary } }
    },
    MuiTreeItem: {
      styleOverrides: {
        content: {
          border: "none",
          borderRadius: "0",
          "&.Mui-selected": {
            backgroundColor: x.action.hover,
            ".MuiTypography-root": {
              fontWeight: 700
            },
            "&.Mui-focused": {
              backgroundColor: x.action.hover
            }
          },
          "&.Mui-selected:hover": {
            backgroundColor: x.action.hover
          }
        }
      }
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          color: x.primary.contrastText,
          backgroundColor: x.secondary.dark,
          padding: "0.625rem",
          ".MuiInputBase-root": {
            color: x.primary.contrastText
          },
          ".MuiInputLabel-root": {
            color: x.primary.contrastText
          },
          ".MuiOutlinedInput-notchedOutline": {
            borderColor: x.text.secondary
          },
          ".MuiOutlinedInput-root": {
            "&:hover": {
              ".MuiOutlinedInput-notchedOutline": {
                borderColor: x.primary.main
              }
            }
          }
        }
      }
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          color: x.primary.main
        }
      }
    },
    MuiBreadcrumbs: {
      styleOverrides: {
        li: {
          a: {
            textDecoration: "none"
          }
        }
      }
    },
    MuiDialogActions: { styleOverrides: { root: { padding: "1.5rem" } } },
    MuiAccordion: {
      defaultProps: { square: !0 },
      styleOverrides: {
        root: {
          marginBottom: "1rem",
          "&:before": { display: "none" },
          "&.Mui-expanded": {
            margin: "0 0 1rem 0"
          }
        }
      }
    },
    MuiAccordionSummary: {
      defaultProps: { expandIcon: /* @__PURE__ */ u(F, { children: "keyboard_arrow_down" }) },
      styleOverrides: {
        root: {
          fontSize: "14px",
          ".MuiAccordionSummary-content": {
            justifyContent: "space-between",
            flexWrap: "wrap"
          }
        },
        expandIconWrapper: { marginLeft: "1rem" }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: "2px"
        }
      }
    },
    MuiIcon: {
      styleOverrides: {
        colorPrimary: {
          color: x.text.primary
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: "0.75rem",
          textTransform: "capitalize",
          borderRadius: "2px",
          "&:not(.MuiButton-text)": { boxShadow: "none" }
        },
        contained: {
          "&:hover": { backgroundColor: x.primary.main }
        },
        textPrimary: {
          color: x.text.primary
        },
        text: {
          "&:hover": {
            backgroundColor: x.action.hover
          }
        }
      }
    },
    MuiTextField: { defaultProps: { size: "small" } },
    MuiFormControl: { defaultProps: { size: "small" } },
    MuiListItemText: {
      styleOverrides: {
        primary: { fontSize: "0.9rem" },
        secondary: { fontSize: "1rem" }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          "&.Mui-selected ": {
            color: x.text.primary,
            fontWeight: 700
          }
        }
      }
    },
    MuiTabs: {
      styleOverrides: { indicator: { backgroundColor: x.primary.main } }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          "&.MuiPaper-elevation": {
            borderRadius: "0px"
          },
          "&.MuiPaper-elevation8": {
            boxShadow: "0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)",
            border: `1px solid ${x.primary.main}`
          }
        }
      }
    },
    MuiFormLabel: {
      styleOverrides: {
        asterisk: {
          fontWeight: "bold",
          color: "red"
        }
      }
    }
  }
}), ms = "AttachmentCategoriesServiceGetAllAttachmentCategories", ys = ({
  filter: t,
  includes: e,
  order: r,
  size: o,
  sort: n,
  start: i
} = {}, a) => [
  ms,
  ...a ?? [{ filter: t, includes: e, order: r, size: o, sort: n, start: i }]
], gs = "AttachmentCategoriesServiceGetAttachmentCategories", bs = ({
  filter: t,
  id: e,
  includes: r,
  order: o,
  size: n,
  sort: i,
  start: a
}, s) => [
  gs,
  ...s ?? [{ filter: t, id: e, includes: r, order: o, size: n, sort: i, start: a }]
], fs = "AttachmentItemsServiceGetAttachmentItems", hs = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s) => [
  fs,
  ...s ?? [
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a }
  ]
], Is = "AttachmentItemsServiceGetByIdAttachmentItems", Ss = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l) => [
  Is,
  ...l ?? [
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s }
  ]
], Ps = "AttachmentsServiceGetAllAttachments", Cs = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s) => [
  Ps,
  ...s ?? [
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a }
  ]
], qs = "AttachmentsServiceGetAttachments", vs = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l) => [
  qs,
  ...l ?? [
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s }
  ]
], Ts = "AttachmentsServiceDownloadFileAttachments", Bs = ({
  id: t
}, e) => [
  Ts,
  ...e ?? [{ id: t }]
], Ls = "AttachmentSetsServiceGetAllAttachmentSets", Gs = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s) => [
  Ls,
  ...s ?? [
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a }
  ]
], As = "AttachmentSetsServiceGetByIdAttachmentSets", Fs = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l) => [
  As,
  ...l ?? [
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s }
  ]
], Os = "AttachmentTypesServiceGetAllAttachmentTypes", ws = ({
  filter: t,
  includes: e,
  order: r,
  size: o,
  sort: n,
  start: i
} = {}, a) => [
  Os,
  ...a ?? [{ filter: t, includes: e, order: r, size: o, sort: n, start: i }]
], Ds = "AttachmentTypesServiceGetAttachmentTypes", Rs = ({
  filter: t,
  id: e,
  includes: r,
  order: o,
  size: n,
  sort: i,
  start: a
}, s) => [
  Ds,
  ...s ?? [{ filter: t, id: e, includes: r, order: o, size: n, sort: i, start: a }]
], Vs = "AuthorizationsServiceGetUserInfoAuthorizations", Ns = (t) => [
  Vs,
  ...t ?? []
], Ms = "BaseAttributesServiceGetBaseAttributes", xs = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s) => [
  Ms,
  ...s ?? [
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a }
  ]
], Es = "BaseAttributesServiceGetByIdBaseAttributes", Us = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l) => [
  Es,
  ...l ?? [
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s }
  ]
], Qs = "BaseAttributesServiceGetFilterableBaseAttributes", ks = ({
  languageIds: t,
  parentId: e
}, r) => [
  Qs,
  ...r ?? [{ languageIds: t, parentId: e }]
], js = "BaseValuesServiceGetBaseValues", $s = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s) => [
  js,
  ...s ?? [
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a }
  ]
], zs = "BaseValuesServiceGetByIdBaseValues", Ks = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l) => [
  zs,
  ...l ?? [
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s }
  ]
], Hs = "CommentItemsServiceGetCommentItems", _s = ({
  eager: t
} = {}, e) => [Hs, ...e ?? [{ eager: t }]], Ws = "CommentItemsServiceGetByIdCommentItems", Zs = ({
  eager: t,
  id: e
}, r) => [
  Ws,
  ...r ?? [{ eager: t, id: e }]
], Xs = "CommentSetsServiceGetCommentSets", Js = ({
  filter: t,
  includes: e,
  order: r,
  size: o,
  sort: n,
  start: i
} = {}, a) => [
  Xs,
  ...a ?? [{ filter: t, includes: e, order: r, size: o, sort: n, start: i }]
], Ys = "CommentSetsServiceGetByIdCommentSets", eu = ({
  filter: t,
  id: e,
  includes: r,
  order: o,
  size: n,
  sort: i,
  start: a
}, s) => [
  Ys,
  ...s ?? [{ filter: t, id: e, includes: r, order: o, size: n, sort: i, start: a }]
], tu = "CompaniesServiceGetAllCompanies", ru = ({
  filter: t,
  includes: e,
  order: r,
  size: o,
  sort: n,
  start: i
} = {}, a) => [
  tu,
  ...a ?? [{ filter: t, includes: e, order: r, size: o, sort: n, start: i }]
], ou = "CompaniesServiceGetByIdCompanies", nu = ({
  filter: t,
  id: e,
  includes: r,
  order: o,
  size: n,
  sort: i,
  start: a
}, s) => [
  ou,
  ...s ?? [{ filter: t, id: e, includes: r, order: o, size: n, sort: i, start: a }]
], iu = "ConfigurationsServiceGetConfigurations", au = (t) => [iu, ...t ?? []], su = "ConfigurationsServiceGetByIdConfigurations", uu = ({
  id: t
}, e) => [
  su,
  ...e ?? [{ id: t }]
], lu = "CustomersServiceGetAllCustomers", cu = ({
  filter: t,
  includes: e,
  order: r,
  size: o,
  sort: n,
  start: i
} = {}, a) => [
  lu,
  ...a ?? [{ filter: t, includes: e, order: r, size: o, sort: n, start: i }]
], du = "CustomersServiceGetByIdCustomers", pu = ({
  filter: t,
  id: e,
  includes: r,
  order: o,
  size: n,
  sort: i,
  start: a
}, s) => [
  du,
  ...s ?? [{ filter: t, id: e, includes: r, order: o, size: n, sort: i, start: a }]
], mu = "DataTypesServiceGetDataTypes", yu = (t) => [mu, ...t ?? []], gu = "DataTypesServiceGetByIdDataTypes", bu = ({
  id: t
}, e) => [gu, ...e ?? [{ id: t }]], fu = "DiscountsServiceGetDiscounts", hu = ({
  filter: t,
  includes: e,
  order: r,
  size: o,
  sort: n,
  start: i
} = {}, a) => [
  fu,
  ...a ?? [{ filter: t, includes: e, order: r, size: o, sort: n, start: i }]
], Iu = "DiscountsServiceGetByIdDiscounts", Su = ({
  filter: t,
  id: e,
  includes: r,
  order: o,
  size: n,
  sort: i,
  start: a
}, s) => [
  Iu,
  ...s ?? [{ filter: t, id: e, includes: r, order: o, size: n, sort: i, start: a }]
], Pu = "DiscountTypesServiceGetDiscountTypes", Cu = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s) => [
  Pu,
  ...s ?? [
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a }
  ]
], qu = "DiscountTypesServiceGetByIdDiscountTypes", vu = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l) => [
  qu,
  ...l ?? [
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s }
  ]
], Tu = "ExcelServiceTemplateExcel", Bu = (t) => [Tu, ...t ?? []], Lu = "ExcelServiceExportExcel", Gu = ({
  quoteId: t
}, e) => [Lu, ...e ?? [{ quoteId: t }]], Au = "HealthServiceLivenessHealth", Fu = (t) => [Au, ...t ?? []], Ou = "HealthServiceReadinessHealth", wu = (t) => [Ou, ...t ?? []], Du = "InfosServiceGetInfosInfos", Ru = (t) => [Du, ...t ?? []], Vu = "ItemGroupsServiceGetItemGroups", Nu = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s) => [
  Vu,
  ...s ?? [
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a }
  ]
], Hr = "ItemGroupsServiceGetByIdItemGroups", Mu = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l) => [
  Hr,
  ...l ?? [
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s }
  ]
], xu = "LanguagesServiceGetLanguages", Eu = ({
  filter: t,
  includes: e,
  languageCode: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s) => [
  xu,
  ...s ?? [
    { filter: t, includes: e, languageCode: r, order: o, size: n, sort: i, start: a }
  ]
], Uu = "LanguagesServiceGetByIdLanguages", Qu = ({
  filter: t,
  id: e,
  includes: r,
  order: o,
  size: n,
  sort: i,
  start: a
}, s) => [
  Uu,
  ...s ?? [{ filter: t, id: e, includes: r, order: o, size: n, sort: i, start: a }]
], ku = "LineItemsServiceGetLineItems", ju = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s) => [
  ku,
  ...s ?? [
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a }
  ]
], $u = "LineItemsServiceGetByIdLineItems", zu = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l) => [
  $u,
  ...l ?? [
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s }
  ]
], _r = "OpportunitiesServiceGetOpportunities", Ku = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s) => [
  _r,
  ...s ?? [
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a }
  ]
], Hu = "OpportunitiesServiceGetByIdOpportunities", _u = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l) => [
  Hu,
  ...l ?? [
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s }
  ]
], Wu = "PriceCurrenciesServiceGetPriceCurrencies", Zu = ({
  filter: t,
  includes: e,
  order: r,
  size: o,
  sort: n,
  start: i
} = {}, a) => [
  Wu,
  ...a ?? [{ filter: t, includes: e, order: r, size: o, sort: n, start: i }]
], Xu = "PriceCurrenciesServiceGetByIdPriceCurrencies", Ju = ({
  filter: t,
  id: e,
  includes: r,
  order: o,
  size: n,
  sort: i,
  start: a
}, s) => [
  Xu,
  ...s ?? [{ filter: t, id: e, includes: r, order: o, size: n, sort: i, start: a }]
], Yu = "PriceListsServiceGetPriceLists", el = ({
  filter: t,
  includes: e,
  order: r,
  size: o,
  sort: n,
  start: i
} = {}, a) => [
  Yu,
  ...a ?? [{ filter: t, includes: e, order: r, size: o, sort: n, start: i }]
], tl = "PriceListsServiceGetByIdPriceLists", rl = ({
  filter: t,
  id: e,
  includes: r,
  order: o,
  size: n,
  sort: i,
  start: a
}, s) => [
  tl,
  ...s ?? [{ filter: t, id: e, includes: r, order: o, size: n, sort: i, start: a }]
], ol = "PricesServiceGetPrices", nl = ({
  filter: t,
  includes: e,
  order: r,
  size: o,
  sort: n,
  start: i
} = {}, a) => [
  ol,
  ...a ?? [{ filter: t, includes: e, order: r, size: o, sort: n, start: i }]
], il = "PricesServiceGetByIdPrices", al = ({
  filter: t,
  id: e,
  includes: r,
  order: o,
  size: n,
  sort: i,
  start: a
}, s) => [
  il,
  ...s ?? [{ filter: t, id: e, includes: r, order: o, size: n, sort: i, start: a }]
], sl = "PriceTypesServiceGetPriceTypes", ul = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s) => [
  sl,
  ...s ?? [
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a }
  ]
], ll = "PriceTypesServiceGetByIdPriceTypes", cl = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l) => [
  ll,
  ...l ?? [
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s }
  ]
], dl = "ProductAttributesServiceGetProductAttributes", pl = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s) => [
  dl,
  ...s ?? [
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a }
  ]
], ml = "ProductAttributesServiceGetByIdProductAttributes", yl = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l) => [
  ml,
  ...l ?? [
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s }
  ]
], gl = "ProductCategoriesServiceGetProductCategories", bl = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s) => [
  gl,
  ...s ?? [
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a }
  ]
], fl = "ProductCategoriesServiceGetByIdProductCategories", hl = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l) => [
  fl,
  ...l ?? [
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s }
  ]
], Il = "ProductCategoriesServiceGetByResourceIdProductCategories", Sl = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  resourceId: n,
  size: i,
  sort: a,
  start: s
}, l) => [
  Il,
  ...l ?? [
    { filter: t, includes: e, languageIds: r, order: o, resourceId: n, size: i, sort: a, start: s }
  ]
], Pl = "ProductCategoryChildrenServiceGetProductCategoryChildren", Cl = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s) => [
  Pl,
  ...s ?? [
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a }
  ]
], ql = "ProductCategoryChildrenServiceGetByIdProductCategoryChildren", vl = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l) => [
  ql,
  ...l ?? [
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s }
  ]
], Tl = "ProductGroupsServiceGetProductGroups", Bl = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s) => [
  Tl,
  ...s ?? [
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a }
  ]
], Ll = "ProductGroupsServiceGetByIdProductGroups", Gl = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l) => [
  Ll,
  ...l ?? [
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s }
  ]
], Al = "ProductHierarchiesServiceGetProductHierarchies", Fl = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s) => [
  Al,
  ...s ?? [
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a }
  ]
], Ol = "ProductHierarchiesServiceGetByIdProductHierarchies", wl = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l) => [
  Ol,
  ...l ?? [
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s }
  ]
], Dl = "ProductHierarchiesServiceGetTreeProductHierarchies", Rl = ({
  languageIds: t,
  productSearch: e,
  sort: r
} = {}, o) => [
  Dl,
  ...o ?? [{ languageIds: t, productSearch: e, sort: r }]
], Vl = "ProductHierarchiesServiceGetTreeByIdProductHierarchies", Nl = ({
  id: t,
  languageIds: e,
  productSearch: r,
  sort: o
}, n) => [
  Vl,
  ...n ?? [{ id: t, languageIds: e, productSearch: r, sort: o }]
], Ml = "ProductHierarchyCategoriesServiceGetProductHierarchyCategories", xl = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s) => [
  Ml,
  ...s ?? [
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a }
  ]
], El = "ProductHierarchyCategoriesServiceGetByIdProductHierarchyCategories", Ul = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l) => [
  El,
  ...l ?? [
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s }
  ]
], Ql = "ProductsServiceGetProducts", kl = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  quoteId: n,
  size: i,
  sort: a,
  start: s
} = {}, l) => [
  Ql,
  ...l ?? [
    { filter: t, includes: e, languageIds: r, order: o, quoteId: n, size: i, sort: a, start: s }
  ]
], jl = "ProductsServiceGetByIdProducts", $l = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  quoteId: i,
  size: a,
  sort: s,
  start: l
}, c) => [
  jl,
  ...c ?? [
    { filter: t, id: e, includes: r, languageIds: o, order: n, quoteId: i, size: a, sort: s, start: l }
  ]
], zl = "ProductsServiceGetByParentIdProducts", Kl = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  parentId: n,
  quoteId: i,
  size: a,
  sort: s,
  start: l
}, c) => [
  zl,
  ...c ?? [
    {
      filter: t,
      includes: e,
      languageIds: r,
      order: o,
      parentId: n,
      quoteId: i,
      size: a,
      sort: s,
      start: l
    }
  ]
], Hl = "ProductsServiceGetRelatedProductsProducts", _l = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  quoteId: i,
  size: a,
  sort: s,
  start: l
}, c) => [
  Hl,
  ...c ?? [
    { filter: t, id: e, includes: r, languageIds: o, order: n, quoteId: i, size: a, sort: s, start: l }
  ]
], Wl = "ProductsServiceGetAlternativeProductsProducts", Zl = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  quoteId: i,
  size: a,
  sort: s,
  start: l
}, c) => [
  Wl,
  ...c ?? [
    { filter: t, id: e, includes: r, languageIds: o, order: n, quoteId: i, size: a, sort: s, start: l }
  ]
], Xl = "ProductStatesServiceGetByIdProductStates", Jl = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l) => [
  Xl,
  ...l ?? [
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s }
  ]
], Yl = "ProductStatesServiceGetProductStates", ec = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s) => [
  Yl,
  ...s ?? [
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a }
  ]
], tc = "ProductTypesServiceGetByIdProductTypes", rc = ({
  id: t,
  languageIds: e
}, r) => [
  tc,
  ...r ?? [{ id: t, languageIds: e }]
], oc = "ProductTypesServiceGetProductTypes", nc = ({
  languageIds: t
} = {}, e) => [
  oc,
  ...e ?? [{ languageIds: t }]
], ic = "ProductValuesServiceGetProductValues", ac = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s) => [
  ic,
  ...s ?? [
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a }
  ]
], sc = "ProductValuesServiceGetByIdProductValues", uc = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l) => [
  sc,
  ...l ?? [
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s }
  ]
], lc = "PropertiesServiceGetProperties", cc = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s) => [
  lc,
  ...s ?? [
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a }
  ]
], dc = "PropertiesServiceGetByIdProperties", pc = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l) => [
  dc,
  ...l ?? [
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s }
  ]
], mc = "PropertySetsServiceGetPropertySets", yc = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s) => [
  mc,
  ...s ?? [
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a }
  ]
], gc = "PropertySetsServiceGetByIdPropertySets", bc = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l) => [
  gc,
  ...l ?? [
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s }
  ]
], fc = "QuotesServiceGetQuotes", hc = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s) => [
  fc,
  ...s ?? [
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a }
  ]
], K = "QuotesServiceGetByIdQuotes", Ic = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  onlyOptional: n,
  order: i,
  searchIncludes: a,
  size: s,
  sort: l,
  start: c
}, m) => [
  K,
  ...m ?? [
    {
      filter: t,
      id: e,
      includes: r,
      languageIds: o,
      onlyOptional: n,
      order: i,
      searchIncludes: a,
      size: s,
      sort: l,
      start: c
    }
  ]
], Sc = "RelationPriceListsServiceGetAllRelationPriceLists", Pc = ({
  itemGroupId: t,
  lineItemId: e,
  quoteId: r,
  subItemId: o
} = {}, n) => [
  Sc,
  ...n ?? [{ itemGroupId: t, lineItemId: e, quoteId: r, subItemId: o }]
], Cc = "RelationSalesLocationsServiceGetAllRelationSalesLocations", qc = ({
  filter: t,
  includes: e,
  order: r,
  size: o,
  sort: n,
  start: i
} = {}, a) => [
  Cc,
  ...a ?? [{ filter: t, includes: e, order: r, size: o, sort: n, start: i }]
], vc = "SalesLocationsServiceGetAllSalesLocations", Tc = ({
  filter: t,
  includes: e,
  order: r,
  size: o,
  sort: n,
  start: i
} = {}, a) => [
  vc,
  ...a ?? [{ filter: t, includes: e, order: r, size: o, sort: n, start: i }]
], Bc = "SalesLocationsServiceGetByIdSalesLocations", Lc = ({
  filter: t,
  id: e,
  includes: r,
  order: o,
  size: n,
  sort: i,
  start: a
}, s) => [
  Bc,
  ...s ?? [{ filter: t, id: e, includes: r, order: o, size: n, sort: i, start: a }]
], Gc = "SeedingServiceGetSeeding", Ac = (t) => [
  Gc,
  ...t ?? []
], Qt = "StatusServiceGetStatus", Fc = ({
  filter: t,
  includes: e,
  order: r,
  size: o,
  sort: n,
  start: i
} = {}, a) => [
  Qt,
  ...a ?? [{ filter: t, includes: e, order: r, size: o, sort: n, start: i }]
], Oc = "StatusServiceGetByIdStatus", wc = ({
  filter: t,
  id: e,
  includes: r,
  order: o,
  size: n,
  sort: i,
  start: a
}, s) => [
  Oc,
  ...s ?? [{ filter: t, id: e, includes: r, order: o, size: n, sort: i, start: a }]
], Dc = "SubItemsServiceGetSubItems", Rc = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s) => [
  Dc,
  ...s ?? [
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a }
  ]
], Vc = "SubItemsServiceGetByIdSubItems", Nc = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l) => [
  Vc,
  ...l ?? [
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s }
  ]
], Mc = "TenantsServiceGetTenants", xc = (t) => [
  Mc,
  ...t ?? []
], Ec = "TenantsServiceGetByIdTenants", Uc = ({
  id: t
}, e) => [Ec, ...e ?? [{ id: t }]], Qc = "UnitsServiceGetUnits", kc = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s) => [
  Qc,
  ...s ?? [
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a }
  ]
], jc = "UnitsServiceGetByIdUnits", $c = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l) => [
  jc,
  ...l ?? [
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s }
  ]
], zc = "UserServiceGetAllUser", Kc = ({
  filter: t,
  includes: e,
  order: r,
  size: o,
  sort: n,
  start: i
} = {}, a) => [
  zc,
  ...a ?? [{ filter: t, includes: e, order: r, size: o, sort: n, start: i }]
], Hc = "UserServiceGetUser", _c = ({
  filter: t,
  id: e,
  includes: r,
  order: o,
  size: n,
  sort: i,
  start: a
}, s) => [
  Hc,
  ...s ?? [{ filter: t, id: e, includes: r, order: o, size: n, sort: i, start: a }]
];
class pr {
  constructor() {
    j(this, "_fns");
    this._fns = [];
  }
  eject(e) {
    const r = this._fns.indexOf(e);
    r !== -1 && (this._fns = [...this._fns.slice(0, r), ...this._fns.slice(r + 1)]);
  }
  use(e) {
    this._fns = [...this._fns, e];
  }
}
const d = {
  BASE: "/preview",
  CREDENTIALS: "include",
  ENCODE_PATH: void 0,
  HEADERS: void 0,
  PASSWORD: void 0,
  TOKEN: void 0,
  USERNAME: void 0,
  VERSION: "1.0",
  WITH_CREDENTIALS: !1,
  interceptors: {
    request: new pr(),
    response: new pr()
  }
};
class mr extends Error {
  constructor(r, o, n) {
    super(n);
    j(this, "url");
    j(this, "status");
    j(this, "statusText");
    j(this, "body");
    j(this, "request");
    this.name = "ApiError", this.url = o.url, this.status = o.status, this.statusText = o.statusText, this.body = o.body, this.request = r;
  }
}
class Wc extends Error {
  constructor(e) {
    super(e), this.name = "CancelError";
  }
  get isCancelled() {
    return !0;
  }
}
class Zc {
  constructor(e) {
    j(this, "_isResolved");
    j(this, "_isRejected");
    j(this, "_isCancelled");
    j(this, "cancelHandlers");
    j(this, "promise");
    j(this, "_resolve");
    j(this, "_reject");
    this._isResolved = !1, this._isRejected = !1, this._isCancelled = !1, this.cancelHandlers = [], this.promise = new Promise((r, o) => {
      this._resolve = r, this._reject = o;
      const n = (s) => {
        this._isResolved || this._isRejected || this._isCancelled || (this._isResolved = !0, this._resolve && this._resolve(s));
      }, i = (s) => {
        this._isResolved || this._isRejected || this._isCancelled || (this._isRejected = !0, this._reject && this._reject(s));
      }, a = (s) => {
        this._isResolved || this._isRejected || this._isCancelled || this.cancelHandlers.push(s);
      };
      return Object.defineProperty(a, "isResolved", {
        get: () => this._isResolved
      }), Object.defineProperty(a, "isRejected", {
        get: () => this._isRejected
      }), Object.defineProperty(a, "isCancelled", {
        get: () => this._isCancelled
      }), e(n, i, a);
    });
  }
  get [Symbol.toStringTag]() {
    return "Cancellable Promise";
  }
  then(e, r) {
    return this.promise.then(e, r);
  }
  catch(e) {
    return this.promise.catch(e);
  }
  finally(e) {
    return this.promise.finally(e);
  }
  cancel() {
    if (!(this._isResolved || this._isRejected || this._isCancelled)) {
      if (this._isCancelled = !0, this.cancelHandlers.length)
        try {
          for (const e of this.cancelHandlers)
            e();
        } catch (e) {
          console.warn("Cancellation threw an error", e);
          return;
        }
      this.cancelHandlers.length = 0, this._reject && this._reject(new Wc("Request aborted"));
    }
  }
  get isCancelled() {
    return this._isCancelled;
  }
}
const Qe = (t) => typeof t == "string", Bt = (t) => Qe(t) && t !== "", kt = (t) => t instanceof Blob, Wr = (t) => t instanceof FormData, Xc = (t) => {
  try {
    return btoa(t);
  } catch {
    return Buffer.from(t).toString("base64");
  }
}, Jc = (t) => {
  const e = [], r = (n, i) => {
    e.push(`${encodeURIComponent(n)}=${encodeURIComponent(String(i))}`);
  }, o = (n, i) => {
    i != null && (i instanceof Date ? r(n, i.toISOString()) : Array.isArray(i) ? i.forEach((a) => o(n, a)) : typeof i == "object" ? Object.entries(i).forEach(([a, s]) => o(`${n}[${a}]`, s)) : r(n, i));
  };
  return Object.entries(t).forEach(([n, i]) => o(n, i)), e.length ? `?${e.join("&")}` : "";
}, Yc = (t, e) => {
  const r = t.ENCODE_PATH || encodeURI, o = e.url.replace("{api-version}", t.VERSION).replace(/{(.*?)}/g, (i, a) => {
    var s;
    return (s = e.path) != null && s.hasOwnProperty(a) ? r(String(e.path[a])) : i;
  }), n = t.BASE + o;
  return e.query ? n + Jc(e.query) : n;
}, ed = (t) => {
  if (t.formData) {
    const e = new FormData(), r = (o, n) => {
      Qe(n) || kt(n) ? e.append(o, n) : e.append(o, JSON.stringify(n));
    };
    return Object.entries(t.formData).filter(([, o]) => o != null).forEach(([o, n]) => {
      Array.isArray(n) ? n.forEach((i) => r(o, i)) : r(o, n);
    }), e;
  }
}, lt = async (t, e) => typeof e == "function" ? e(t) : e, td = async (t, e) => {
  const [r, o, n, i] = await Promise.all([
    lt(e, t.TOKEN),
    lt(e, t.USERNAME),
    lt(e, t.PASSWORD),
    lt(e, t.HEADERS)
  ]), a = Object.entries({
    Accept: "application/json",
    ...i,
    ...e.headers
  }).filter(([, s]) => s != null).reduce((s, [l, c]) => ({
    ...s,
    [l]: String(c)
  }), {});
  if (Bt(r) && (a.Authorization = `Bearer ${r}`), Bt(o) && Bt(n)) {
    const s = Xc(`${o}:${n}`);
    a.Authorization = `Basic ${s}`;
  }
  return e.body !== void 0 && (e.mediaType ? a["Content-Type"] = e.mediaType : kt(e.body) ? a["Content-Type"] = e.body.type || "application/octet-stream" : Qe(e.body) ? a["Content-Type"] = "text/plain" : Wr(e.body) || (a["Content-Type"] = "application/json")), new Headers(a);
}, rd = (t) => {
  var e, r;
  if (t.body !== void 0)
    return (e = t.mediaType) != null && e.includes("application/json") || (r = t.mediaType) != null && r.includes("+json") ? JSON.stringify(t.body) : Qe(t.body) || kt(t.body) || Wr(t.body) ? t.body : JSON.stringify(t.body);
}, od = async (t, e, r, o, n, i, a) => {
  const s = new AbortController();
  let l = {
    headers: i,
    body: o ?? n,
    method: e.method,
    signal: s.signal
  };
  t.WITH_CREDENTIALS && (l.credentials = t.CREDENTIALS);
  for (const c of t.interceptors.request._fns)
    l = await c(l);
  return a(() => s.abort()), await fetch(r, l);
}, nd = (t, e) => {
  if (e) {
    const r = t.headers.get(e);
    if (Qe(r))
      return r;
  }
}, id = async (t) => {
  if (t.status !== 204)
    try {
      const e = t.headers.get("Content-Type");
      if (e) {
        const r = ["application/octet-stream", "application/pdf", "application/zip", "audio/", "image/", "video/"];
        if (e.includes("application/json") || e.includes("+json"))
          return await t.json();
        if (r.some((o) => e.includes(o)))
          return await t.blob();
        if (e.includes("multipart/form-data"))
          return await t.formData();
        if (e.includes("text/"))
          return await t.text();
      }
    } catch (e) {
      console.error(e);
    }
}, ad = (t, e) => {
  const o = {
    400: "Bad Request",
    401: "Unauthorized",
    402: "Payment Required",
    403: "Forbidden",
    404: "Not Found",
    405: "Method Not Allowed",
    406: "Not Acceptable",
    407: "Proxy Authentication Required",
    408: "Request Timeout",
    409: "Conflict",
    410: "Gone",
    411: "Length Required",
    412: "Precondition Failed",
    413: "Payload Too Large",
    414: "URI Too Long",
    415: "Unsupported Media Type",
    416: "Range Not Satisfiable",
    417: "Expectation Failed",
    418: "Im a teapot",
    421: "Misdirected Request",
    422: "Unprocessable Content",
    423: "Locked",
    424: "Failed Dependency",
    425: "Too Early",
    426: "Upgrade Required",
    428: "Precondition Required",
    429: "Too Many Requests",
    431: "Request Header Fields Too Large",
    451: "Unavailable For Legal Reasons",
    500: "Internal Server Error",
    501: "Not Implemented",
    502: "Bad Gateway",
    503: "Service Unavailable",
    504: "Gateway Timeout",
    505: "HTTP Version Not Supported",
    506: "Variant Also Negotiates",
    507: "Insufficient Storage",
    508: "Loop Detected",
    510: "Not Extended",
    511: "Network Authentication Required",
    ...t.errors
  }[e.status];
  if (o)
    throw new mr(t, e, o);
  if (!e.ok) {
    const n = e.status ?? "unknown", i = e.statusText ?? "unknown", a = (() => {
      try {
        return JSON.stringify(e.body, null, 2);
      } catch {
        return;
      }
    })();
    throw new mr(
      t,
      e,
      `Generic Error: status: ${n}; status text: ${i}; body: ${a}`
    );
  }
}, p = (t, e) => new Zc(async (r, o, n) => {
  try {
    const i = Yc(t, e), a = ed(e), s = rd(e), l = await td(t, e);
    if (!n.isCancelled) {
      let c = await od(t, e, i, s, a, l, n);
      for (const q of t.interceptors.response._fns)
        c = await q(c);
      const m = await id(c), P = nd(c, e.responseHeader), S = {
        url: i,
        ok: c.ok,
        status: c.status,
        statusText: c.statusText,
        body: P ?? m
      };
      ad(e, S), r(S.body);
    }
  } catch (i) {
    o(i);
  }
});
class ke {
  /**
   * @param data The data for the request.
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMAttachmentCategories OK
   * @throws ApiError
   */
  static getAllAttachmentCategories(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/attachmentcategories",
      query: {
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns VMAttachmentCategories OK
   * @throws ApiError
   */
  static createAttachmentCategories(e = {}) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/attachmentcategories",
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMAttachmentCategories OK
   * @throws ApiError
   */
  static getAttachmentCategories(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/attachmentcategories/{id}",
      path: {
        id: e.id
      },
      query: {
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns VMAttachmentCategories OK
   * @throws ApiError
   */
  static updateAttachmentCategories(e) {
    return p(d, {
      method: "PUT",
      url: "/api/3pq-cpq/v1/attachmentcategories/{id}",
      path: {
        id: e.id
      },
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean OK
   * @throws ApiError
   */
  static deleteAttachmentCategories(e) {
    return p(d, {
      method: "DELETE",
      url: "/api/3pq-cpq/v1/attachmentcategories/{id}",
      path: {
        id: e.id
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class je {
  /**
   * @param data The data for the request.
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMAttachmentItems OK
   * @throws ApiError
   */
  static getAttachmentItems(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/attachmentitems",
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns VMAttachmentItems OK
   * @throws ApiError
   */
  static createAttachmentItems(e = {}) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/attachmentitems",
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMAttachmentItems OK
   * @throws ApiError
   */
  static getByIdAttachmentItems(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/attachmentitems/{id}",
      path: {
        id: e.id
      },
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns VMAttachmentItems OK
   * @throws ApiError
   */
  static updateAttachmentItems(e) {
    return p(d, {
      method: "PUT",
      url: "/api/3pq-cpq/v1/attachmentitems/{id}",
      path: {
        id: e.id
      },
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean OK
   * @throws ApiError
   */
  static deleteAttachmentItems(e) {
    return p(d, {
      method: "DELETE",
      url: "/api/3pq-cpq/v1/attachmentitems/{id}",
      path: {
        id: e.id
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class Te {
  /**
   * @param data The data for the request.
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMAttachments OK
   * @throws ApiError
   */
  static getAllAttachments(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/attachments",
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.formData
   * @returns VMAttachments OK
   * @throws ApiError
   */
  static createAttachments(e = {}) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/attachments",
      formData: e.formData,
      mediaType: "multipart/form-data",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMAttachments OK
   * @throws ApiError
   */
  static getAttachments(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/attachments/{id}",
      path: {
        id: e.id
      },
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.formData
   * @returns VMAttachments OK
   * @throws ApiError
   */
  static updateAttachments(e) {
    return p(d, {
      method: "PUT",
      url: "/api/3pq-cpq/v1/attachments/{id}",
      path: {
        id: e.id
      },
      formData: e.formData,
      mediaType: "multipart/form-data",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean OK
   * @throws ApiError
   */
  static deleteAttachments(e) {
    return p(d, {
      method: "DELETE",
      url: "/api/3pq-cpq/v1/attachments/{id}",
      path: {
        id: e.id
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @returns binary OK
   * @throws ApiError
   */
  static downloadFileAttachments(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/attachments/download/{id}",
      path: {
        id: e.id
      },
      errors: {
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class $e {
  /**
   * @param data The data for the request.
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMAttachmentSets OK
   * @throws ApiError
   */
  static getAllAttachmentSets(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/attachmentsets",
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns VMAttachmentSets OK
   * @throws ApiError
   */
  static createAttachmentSets(e = {}) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/attachmentsets",
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMAttachmentSets OK
   * @throws ApiError
   */
  static getByIdAttachmentSets(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/attachmentsets/{id}",
      path: {
        id: e.id
      },
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns VMAttachmentSets OK
   * @throws ApiError
   */
  static updateAttachmentSets(e) {
    return p(d, {
      method: "PUT",
      url: "/api/3pq-cpq/v1/attachmentsets/{id}",
      path: {
        id: e.id
      },
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean OK
   * @throws ApiError
   */
  static deleteAttachmentSets(e) {
    return p(d, {
      method: "DELETE",
      url: "/api/3pq-cpq/v1/attachmentsets/{id}",
      path: {
        id: e.id
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class ze {
  /**
   * @param data The data for the request.
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMAttachmentTypes OK
   * @throws ApiError
   */
  static getAllAttachmentTypes(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/attachmenttypes",
      query: {
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns VMAttachmentTypes OK
   * @throws ApiError
   */
  static createAttachmentTypes(e = {}) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/attachmenttypes",
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMAttachmentTypes OK
   * @throws ApiError
   */
  static getAttachmentTypes(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/attachmenttypes/{id}",
      path: {
        id: e.id
      },
      query: {
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns VMAttachmentTypes OK
   * @throws ApiError
   */
  static updateAttachmentTypes(e) {
    return p(d, {
      method: "PUT",
      url: "/api/3pq-cpq/v1/attachmenttypes/{id}",
      path: {
        id: e.id
      },
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean OK
   * @throws ApiError
   */
  static deleteAttachmentTypes(e) {
    return p(d, {
      method: "DELETE",
      url: "/api/3pq-cpq/v1/attachmenttypes/{id}",
      path: {
        id: e.id
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class sd {
  /**
   * @returns VMUserInfo OK
   * @throws ApiError
   */
  static getUserInfoAuthorizations() {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/authorizations/getuserinfo",
      errors: {
        409: "Conflict"
      }
    });
  }
}
class jt {
  /**
   * @param data The data for the request.
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMBaseAttributes OK
   * @throws ApiError
   */
  static getBaseAttributes(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/baseattributes",
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMBaseAttributes OK
   * @throws ApiError
   */
  static getByIdBaseAttributes(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/baseattributes/{id}",
      path: {
        id: e.id
      },
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.parentId
   * @param data.languageIds
   * @returns VMBaseAttributes OK
   * @throws ApiError
   */
  static getFilterableBaseAttributes(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/baseattributes/filterable/{parentId}",
      path: {
        parentId: e.parentId
      },
      query: {
        languageIds: e.languageIds
      },
      errors: {
        400: "Bad Request"
      }
    });
  }
}
class Zr {
  /**
   * @param data The data for the request.
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMBaseValues OK
   * @throws ApiError
   */
  static getBaseValues(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/basevalues",
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMBaseValues OK
   * @throws ApiError
   */
  static getByIdBaseValues(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/basevalues/{id}",
      path: {
        id: e.id
      },
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class Ke {
  /**
   * @param data The data for the request.
   * @param data.eager
   * @returns VMCommentItems OK
   * @throws ApiError
   */
  static getCommentItems(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/commentitems",
      query: {
        eager: e.eager
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns VMCommentItems OK
   * @throws ApiError
   */
  static createCommentItems(e = {}) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/commentitems",
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.eager
   * @returns VMCommentItems OK
   * @throws ApiError
   */
  static getByIdCommentItems(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/commentitems/{id}",
      path: {
        id: e.id
      },
      query: {
        eager: e.eager
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns VMCommentItems OK
   * @throws ApiError
   */
  static updateCommentItems(e) {
    return p(d, {
      method: "PUT",
      url: "/api/3pq-cpq/v1/commentitems/{id}",
      path: {
        id: e.id
      },
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean OK
   * @throws ApiError
   */
  static deleteCommentItems(e) {
    return p(d, {
      method: "DELETE",
      url: "/api/3pq-cpq/v1/commentitems/{id}",
      path: {
        id: e.id
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class He {
  /**
   * @param data The data for the request.
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMCommentSets OK
   * @throws ApiError
   */
  static getCommentSets(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/commentsets",
      query: {
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns VMCommentSets OK
   * @throws ApiError
   */
  static createCommentSets(e = {}) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/commentsets",
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMCommentSets OK
   * @throws ApiError
   */
  static getByIdCommentSets(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/commentsets/{id}",
      path: {
        id: e.id
      },
      query: {
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns VMCommentSets OK
   * @throws ApiError
   */
  static updateCommentSets(e) {
    return p(d, {
      method: "PUT",
      url: "/api/3pq-cpq/v1/commentsets/{id}",
      path: {
        id: e.id
      },
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean OK
   * @throws ApiError
   */
  static deleteCommentSets(e) {
    return p(d, {
      method: "DELETE",
      url: "/api/3pq-cpq/v1/commentsets/{id}",
      path: {
        id: e.id
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class _e {
  /**
   * @param data The data for the request.
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMCompanies OK
   * @throws ApiError
   */
  static getAllCompanies(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/companies",
      query: {
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns VMCompanies OK
   * @throws ApiError
   */
  static createCompanies(e = {}) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/companies",
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMCompanies OK
   * @throws ApiError
   */
  static getByIdCompanies(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/companies/{id}",
      path: {
        id: e.id
      },
      query: {
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns VMCompanies OK
   * @throws ApiError
   */
  static updateCompanies(e) {
    return p(d, {
      method: "PUT",
      url: "/api/3pq-cpq/v1/companies/{id}",
      path: {
        id: e.id
      },
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean OK
   * @throws ApiError
   */
  static deleteCompanies(e) {
    return p(d, {
      method: "DELETE",
      url: "/api/3pq-cpq/v1/companies/{id}",
      path: {
        id: e.id
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class We {
  /**
   * @returns VMConfigurations OK
   * @throws ApiError
   */
  static getConfigurations() {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/configurations",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns VMConfigurations OK
   * @throws ApiError
   */
  static createConfigurations(e = {}) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/configurations",
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @returns VMConfigurations OK
   * @throws ApiError
   */
  static getByIdConfigurations(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/configurations/{id}",
      path: {
        id: e.id
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns VMConfigurations OK
   * @throws ApiError
   */
  static updateConfigurations(e) {
    return p(d, {
      method: "PUT",
      url: "/api/3pq-cpq/v1/configurations/{id}",
      path: {
        id: e.id
      },
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean OK
   * @throws ApiError
   */
  static deleteConfigurations(e) {
    return p(d, {
      method: "DELETE",
      url: "/api/3pq-cpq/v1/configurations/{id}",
      path: {
        id: e.id
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class Ze {
  /**
   * @param data The data for the request.
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMCustomers OK
   * @throws ApiError
   */
  static getAllCustomers(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/customers",
      query: {
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns VMCustomers OK
   * @throws ApiError
   */
  static createCustomers(e = {}) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/customers",
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMCustomers OK
   * @throws ApiError
   */
  static getByIdCustomers(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/customers/{id}",
      path: {
        id: e.id
      },
      query: {
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns VMCustomers OK
   * @throws ApiError
   */
  static updateCustomers(e) {
    return p(d, {
      method: "PUT",
      url: "/api/3pq-cpq/v1/customers/{id}",
      path: {
        id: e.id
      },
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean OK
   * @throws ApiError
   */
  static deleteCustomers(e) {
    return p(d, {
      method: "DELETE",
      url: "/api/3pq-cpq/v1/customers/{id}",
      path: {
        id: e.id
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class Xe {
  /**
   * @returns VMDataTypes OK
   * @throws ApiError
   */
  static getDataTypes() {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/datatypes",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns VMDataTypes OK
   * @throws ApiError
   */
  static createDataTypes(e = {}) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/datatypes",
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @returns VMDataTypes OK
   * @throws ApiError
   */
  static getByIdDataTypes(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/datatypes/{id}",
      path: {
        id: e.id
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns VMDataTypes OK
   * @throws ApiError
   */
  static updateDataTypes(e) {
    return p(d, {
      method: "PUT",
      url: "/api/3pq-cpq/v1/datatypes/{id}",
      path: {
        id: e.id
      },
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean OK
   * @throws ApiError
   */
  static deleteDataTypes(e) {
    return p(d, {
      method: "DELETE",
      url: "/api/3pq-cpq/v1/datatypes/{id}",
      path: {
        id: e.id
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class Xr {
  /**
   * @param data The data for the request.
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMDiscounts OK
   * @throws ApiError
   */
  static getDiscounts(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/discounts",
      query: {
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMDiscounts OK
   * @throws ApiError
   */
  static getByIdDiscounts(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/discounts/{id}",
      path: {
        id: e.id
      },
      query: {
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class Jr {
  /**
   * @param data The data for the request.
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMDiscountTypes OK
   * @throws ApiError
   */
  static getDiscountTypes(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/discounttypes",
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMDiscountTypes OK
   * @throws ApiError
   */
  static getByIdDiscountTypes(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/discounttypes/{id}",
      path: {
        id: e.id
      },
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class $t {
  /**
   * @returns binary OK
   * @throws ApiError
   */
  static templateExcel() {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/excel/template"
    });
  }
  /**
   * @param data The data for the request.
   * @param data.quoteId
   * @returns binary OK
   * @throws ApiError
   */
  static exportExcel(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/excel/export/{quoteId}",
      path: {
        quoteId: e.quoteId
      },
      errors: {
        400: "Bad Request"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.quoteId
   * @param data.importType
   * @param data.formData
   * @returns binary OK
   * @throws ApiError
   */
  static importExcel(e) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/excel/import/{quoteId}",
      path: {
        quoteId: e.quoteId
      },
      query: {
        importType: e.importType
      },
      formData: e.formData,
      mediaType: "multipart/form-data",
      errors: {
        400: "Bad Request"
      }
    });
  }
}
class Yr {
  /**
   * @returns unknown OK
   * @throws ApiError
   */
  static livenessHealth() {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/health/liveness"
    });
  }
  /**
   * @returns unknown OK
   * @throws ApiError
   */
  static readinessHealth() {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/health/readiness",
      errors: {
        409: "Conflict",
        503: "Service Unavailable"
      }
    });
  }
}
class ud {
  /**
   * Imports the releasesDB from the DataManager.
   * !!! IMPORTANT: A release has to be created AND deployed to the publishTarget on which this CPQ instance runs (default is 'Preview') !!!
   * The current publishTarget can be retrieved from the `/infos` endpoint.
   * @returns string OK
   * @throws ApiError
   */
  static importReleaseImport() {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/import/release",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class ld {
  /**
   * @returns VMInfos OK
   * @throws ApiError
   */
  static getInfosInfos() {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/infos",
      errors: {
        409: "Conflict"
      }
    });
  }
}
class fe {
  /**
   * @param data The data for the request.
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMItemGroupsList OK
   * @throws ApiError
   */
  static getItemGroups(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/itemgroups",
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns VMItemGroups OK
   * @throws ApiError
   */
  static createItemGroups(e = {}) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/itemgroups",
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMItemGroups OK
   * @throws ApiError
   */
  static getByIdItemGroups(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/itemgroups/{id}",
      path: {
        id: e.id
      },
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns VMItemGroups OK
   * @throws ApiError
   */
  static updateItemGroups(e) {
    return p(d, {
      method: "PUT",
      url: "/api/3pq-cpq/v1/itemgroups/{id}",
      path: {
        id: e.id
      },
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean OK
   * @throws ApiError
   */
  static deleteItemGroups(e) {
    return p(d, {
      method: "DELETE",
      url: "/api/3pq-cpq/v1/itemgroups/{id}",
      path: {
        id: e.id
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.cloneAttachments
   * @param data.cloneProperties
   * @param data.cloneComments
   * @param data.cloneConfiguration
   * @param data.cloneDeep
   * @returns VMItemGroups OK
   * @throws ApiError
   */
  static cloneItemGroups(e) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/itemgroups/clone/{id}",
      path: {
        id: e.id
      },
      query: {
        CloneAttachments: e.cloneAttachments,
        CloneProperties: e.cloneProperties,
        CloneComments: e.cloneComments,
        CloneConfiguration: e.cloneConfiguration,
        CloneDeep: e.cloneDeep
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.isOptional
   * @returns VMItemGroups OK
   * @throws ApiError
   */
  static setOptionalItemGroups(e) {
    return p(d, {
      method: "PUT",
      url: "/api/3pq-cpq/v1/itemgroups/setoptional/{id}",
      path: {
        id: e.id
      },
      query: {
        isOptional: e.isOptional
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class eo {
  /**
   * @param data The data for the request.
   * @param data.languageCode Example: `en-US`
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMLanguages OK
   * @throws ApiError
   */
  static getLanguages(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/languages",
      query: {
        languageCode: e.languageCode,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMLanguages OK
   * @throws ApiError
   */
  static getByIdLanguages(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/languages/{id}",
      path: {
        id: e.id
      },
      query: {
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class oe {
  /**
   * @param data The data for the request.
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMLineItemsList OK
   * @throws ApiError
   */
  static getLineItems(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/lineitems",
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns VMLineItems OK
   * @throws ApiError
   */
  static createLineItems(e = {}) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/lineitems",
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMLineItems OK
   * @throws ApiError
   */
  static getByIdLineItems(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/lineitems/{id}",
      path: {
        id: e.id
      },
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns VMLineItems OK
   * @throws ApiError
   */
  static updateLineItems(e) {
    return p(d, {
      method: "PUT",
      url: "/api/3pq-cpq/v1/lineitems/{id}",
      path: {
        id: e.id
      },
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean OK
   * @throws ApiError
   */
  static deleteLineItems(e) {
    return p(d, {
      method: "DELETE",
      url: "/api/3pq-cpq/v1/lineitems/{id}",
      path: {
        id: e.id
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns VMLineItems OK
   * @throws ApiError
   */
  static createManyLineItems(e = {}) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/lineitems/bulk",
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.cloneAttachments
   * @param data.cloneProperties
   * @param data.cloneComments
   * @param data.cloneConfiguration
   * @param data.cloneDeep
   * @returns VMLineItems OK
   * @throws ApiError
   */
  static cloneLineItems(e) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/lineitems/clone/{id}",
      path: {
        id: e.id
      },
      query: {
        CloneAttachments: e.cloneAttachments,
        CloneProperties: e.cloneProperties,
        CloneComments: e.cloneComments,
        CloneConfiguration: e.cloneConfiguration,
        CloneDeep: e.cloneDeep
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns VMLineItems OK
   * @throws ApiError
   */
  static searchConfigLineItems(e = {}) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/lineitems/searchconfig",
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown OK
   * @throws ApiError
   */
  static updateDiscountBulkLineItems(e = {}) {
    return p(d, {
      method: "PUT",
      url: "/api/3pq-cpq/v1/lineitems/setdiscount/bulk",
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.isOptional
   * @returns VMLineItems OK
   * @throws ApiError
   */
  static setOptionalLineItems(e) {
    return p(d, {
      method: "PUT",
      url: "/api/3pq-cpq/v1/lineitems/setoptional/{id}",
      path: {
        id: e.id
      },
      query: {
        isOptional: e.isOptional
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class Be {
  /**
   * @param data The data for the request.
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMOpportunitiesList OK
   * @throws ApiError
   */
  static getOpportunities(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/opportunities",
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns VMOpportunities OK
   * @throws ApiError
   */
  static createOpportunities(e = {}) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/opportunities",
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMOpportunities OK
   * @throws ApiError
   */
  static getByIdOpportunities(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/opportunities/{id}",
      path: {
        id: e.id
      },
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns VMOpportunities OK
   * @throws ApiError
   */
  static updateOpportunities(e) {
    return p(d, {
      method: "PUT",
      url: "/api/3pq-cpq/v1/opportunities/{id}",
      path: {
        id: e.id
      },
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean OK
   * @throws ApiError
   */
  static deleteOpportunities(e) {
    return p(d, {
      method: "DELETE",
      url: "/api/3pq-cpq/v1/opportunities/{id}",
      path: {
        id: e.id
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.cloneAttachments
   * @param data.cloneProperties
   * @param data.cloneComments
   * @param data.cloneConfiguration
   * @param data.cloneDeep
   * @returns VMOpportunities OK
   * @throws ApiError
   */
  static cloneOpportunities(e) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/opportunities/clone/{id}",
      path: {
        id: e.id
      },
      query: {
        CloneAttachments: e.cloneAttachments,
        CloneProperties: e.cloneProperties,
        CloneComments: e.cloneComments,
        CloneConfiguration: e.cloneConfiguration,
        CloneDeep: e.cloneDeep
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class to {
  /**
   * @param data The data for the request.
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMPriceCurrencies OK
   * @throws ApiError
   */
  static getPriceCurrencies(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/pricecurrencies",
      query: {
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMPriceCurrencies OK
   * @throws ApiError
   */
  static getByIdPriceCurrencies(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/pricecurrencies/{id}",
      path: {
        id: e.id
      },
      query: {
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class ro {
  /**
   * @param data The data for the request.
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMPriceLists OK
   * @throws ApiError
   */
  static getPriceLists(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/pricelists",
      query: {
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMPriceLists OK
   * @throws ApiError
   */
  static getByIdPriceLists(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/pricelists/{id}",
      path: {
        id: e.id
      },
      query: {
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class oo {
  /**
   * @param data The data for the request.
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMPrices OK
   * @throws ApiError
   */
  static getPrices(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/prices",
      query: {
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMPrices OK
   * @throws ApiError
   */
  static getByIdPrices(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/prices/{id}",
      path: {
        id: e.id
      },
      query: {
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class no {
  /**
   * @param data The data for the request.
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMPriceTypes OK
   * @throws ApiError
   */
  static getPriceTypes(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/pricetypes",
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMPriceTypes OK
   * @throws ApiError
   */
  static getByIdPriceTypes(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/pricetypes/{id}",
      path: {
        id: e.id
      },
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class io {
  /**
   * @param data The data for the request.
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMProductAttributes OK
   * @throws ApiError
   */
  static getProductAttributes(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/productattributes",
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMProductAttributes OK
   * @throws ApiError
   */
  static getByIdProductAttributes(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/productattributes/{id}",
      path: {
        id: e.id
      },
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class Pt {
  /**
   * @param data The data for the request.
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMProductCategories OK
   * @throws ApiError
   */
  static getProductCategories(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/productcategories",
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMProductCategories OK
   * @throws ApiError
   */
  static getByIdProductCategories(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/productcategories/{id}",
      path: {
        id: e.id
      },
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.resourceId
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMProductCategories OK
   * @throws ApiError
   */
  static getByResourceIdProductCategories(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/productcategories/tree/{resourceId}",
      path: {
        resourceId: e.resourceId
      },
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @param data.requestBody
   * @returns VMProductCategories OK
   * @throws ApiError
   */
  static searchProductCategories(e = {}) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/productcategories/search",
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        409: "Conflict"
      }
    });
  }
}
class ao {
  /**
   * @param data The data for the request.
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMProductCategoryChildren OK
   * @throws ApiError
   */
  static getProductCategoryChildren(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/productcategorychildren",
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMProductCategoryChildren OK
   * @throws ApiError
   */
  static getByIdProductCategoryChildren(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/productcategorychildren/{id}",
      path: {
        id: e.id
      },
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class so {
  /**
   * @param data The data for the request.
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMProductGroups OK
   * @throws ApiError
   */
  static getProductGroups(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/productgroups",
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMProductGroups OK
   * @throws ApiError
   */
  static getByIdProductGroups(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/productgroups/{id}",
      path: {
        id: e.id
      },
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class he {
  /**
   * @param data The data for the request.
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMProductHierarchies OK
   * @throws ApiError
   */
  static getProductHierarchies(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/producthierarchies",
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMProductHierarchies OK
   * @throws ApiError
   */
  static getByIdProductHierarchies(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/producthierarchies/{id}",
      path: {
        id: e.id
      },
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.sort
   * @param data.productSearch
   * @param data.languageIds
   * @returns VMStructureTreeCompact OK
   * @throws ApiError
   */
  static getTreeProductHierarchies(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/producthierarchies/tree",
      query: {
        sort: e.sort,
        productSearch: e.productSearch,
        languageIds: e.languageIds
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.sort
   * @param data.productSearch
   * @param data.languageIds
   * @returns VMStructureTreeCompact OK
   * @throws ApiError
   */
  static getTreeByIdProductHierarchies(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/producthierarchies/{id}/tree",
      path: {
        id: e.id
      },
      query: {
        sort: e.sort,
        productSearch: e.productSearch,
        languageIds: e.languageIds
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.sort
   * @param data.productSearch
   * @param data.languageIds
   * @param data.requestBody
   * @returns VMStructureTreeCompact OK
   * @throws ApiError
   */
  static getTreeWithAttributeFiltersProductHierarchies(e = {}) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/producthierarchies/treefilter",
      query: {
        sort: e.sort,
        productSearch: e.productSearch,
        languageIds: e.languageIds
      },
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.sort
   * @param data.productSearch
   * @param data.languageIds
   * @param data.requestBody
   * @returns VMStructureTreeCompact OK
   * @throws ApiError
   */
  static getTreeByIdWithAttributeFiltersProductHierarchies(e) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/producthierarchies/{id}/treefilter",
      path: {
        id: e.id
      },
      query: {
        sort: e.sort,
        productSearch: e.productSearch,
        languageIds: e.languageIds
      },
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @param data.requestBody
   * @returns VMProductHierarchies OK
   * @throws ApiError
   */
  static searchProductHierarchies(e = {}) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/producthierarchies/search",
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        409: "Conflict"
      }
    });
  }
}
class uo {
  /**
   * @param data The data for the request.
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMProductHierarchyCategories OK
   * @throws ApiError
   */
  static getProductHierarchyCategories(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/producthierarchycategories",
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMProductHierarchyCategories OK
   * @throws ApiError
   */
  static getByIdProductHierarchyCategories(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/producthierarchycategories/{id}",
      path: {
        id: e.id
      },
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class ne {
  /**
   * @param data The data for the request.
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @param data.quoteId
   * @returns VMProductsList OK
   * @throws ApiError
   */
  static getProducts(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/products",
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter,
        quoteId: e.quoteId
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns VMProducts OK
   * @throws ApiError
   */
  static createProducts(e = {}) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/products",
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @param data.quoteId
   * @returns VMProducts OK
   * @throws ApiError
   */
  static getByIdProducts(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/products/{id}",
      path: {
        id: e.id
      },
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter,
        quoteId: e.quoteId
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns VMProducts OK
   * @throws ApiError
   */
  static updateProducts(e) {
    return p(d, {
      method: "PUT",
      url: "/api/3pq-cpq/v1/products/{id}",
      path: {
        id: e.id
      },
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean OK
   * @returns ProblemDetails Error
   * @throws ApiError
   */
  static deleteProducts(e) {
    return p(d, {
      method: "DELETE",
      url: "/api/3pq-cpq/v1/products/{id}",
      path: {
        id: e.id
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.parentId
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @param data.quoteId
   * @returns VMProductsList OK
   * @throws ApiError
   */
  static getByParentIdProducts(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/products/tree/{parentId}",
      path: {
        parentId: e.parentId
      },
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter,
        quoteId: e.quoteId
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @param data.quoteId
   * @returns VMProductsList OK
   * @throws ApiError
   */
  static getRelatedProductsProducts(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/products/relatedproducts/{id}",
      path: {
        id: e.id
      },
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter,
        quoteId: e.quoteId
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @param data.quoteId
   * @returns VMProductsList OK
   * @throws ApiError
   */
  static getAlternativeProductsProducts(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/products/alternativeproducts/{id}",
      path: {
        id: e.id
      },
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter,
        quoteId: e.quoteId
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.parentId
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @param data.quoteId
   * @param data.requestBody
   * @returns VMProductsList OK
   * @throws ApiError
   */
  static getByParentIdWithAttributeFiltersProducts(e) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/products/treefilter/{parentId}",
      path: {
        parentId: e.parentId
      },
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter,
        quoteId: e.quoteId
      },
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @param data.requestBody
   * @returns VMProductsList OK
   * @throws ApiError
   */
  static searchProducts(e = {}) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/products/search",
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        409: "Conflict"
      }
    });
  }
}
class Je {
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMProductStates OK
   * @throws ApiError
   */
  static getByIdProductStates(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/productstates/{id}",
      path: {
        id: e.id
      },
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns VMProductStates OK
   * @throws ApiError
   */
  static updateProductStates(e) {
    return p(d, {
      method: "PUT",
      url: "/api/3pq-cpq/v1/productstates/{id}",
      path: {
        id: e.id
      },
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean OK
   * @throws ApiError
   */
  static deleteProductStates(e) {
    return p(d, {
      method: "DELETE",
      url: "/api/3pq-cpq/v1/productstates/{id}",
      path: {
        id: e.id
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMProductStates OK
   * @throws ApiError
   */
  static getProductStates(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/productstates",
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns VMProductStates OK
   * @throws ApiError
   */
  static createProductStates(e = {}) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/productstates",
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class Ye {
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.languageIds
   * @returns VMProductTypes OK
   * @throws ApiError
   */
  static getByIdProductTypes(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/producttypes/{id}",
      path: {
        id: e.id
      },
      query: {
        languageIds: e.languageIds
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns VMProductTypes OK
   * @throws ApiError
   */
  static updateProductTypes(e) {
    return p(d, {
      method: "PUT",
      url: "/api/3pq-cpq/v1/producttypes/{id}",
      path: {
        id: e.id
      },
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean OK
   * @throws ApiError
   */
  static deleteProductTypes(e) {
    return p(d, {
      method: "DELETE",
      url: "/api/3pq-cpq/v1/producttypes/{id}",
      path: {
        id: e.id
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.languageIds
   * @returns VMProductTypes OK
   * @throws ApiError
   */
  static getProductTypes(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/producttypes",
      query: {
        languageIds: e.languageIds
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns VMProductTypes OK
   * @throws ApiError
   */
  static createProductTypes(e = {}) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/producttypes",
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class lo {
  /**
   * @param data The data for the request.
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMProductValues OK
   * @throws ApiError
   */
  static getProductValues(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/productvalues",
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMProductValues OK
   * @throws ApiError
   */
  static getByIdProductValues(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/productvalues/{id}",
      path: {
        id: e.id
      },
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class et {
  /**
   * @param data The data for the request.
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMProperties OK
   * @throws ApiError
   */
  static getProperties(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/properties",
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns VMProperties OK
   * @throws ApiError
   */
  static createProperties(e = {}) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/properties",
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMProperties OK
   * @throws ApiError
   */
  static getByIdProperties(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/properties/{id}",
      path: {
        id: e.id
      },
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns VMProperties OK
   * @throws ApiError
   */
  static updateProperties(e) {
    return p(d, {
      method: "PUT",
      url: "/api/3pq-cpq/v1/properties/{id}",
      path: {
        id: e.id
      },
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean OK
   * @throws ApiError
   */
  static deleteProperties(e) {
    return p(d, {
      method: "DELETE",
      url: "/api/3pq-cpq/v1/properties/{id}",
      path: {
        id: e.id
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class tt {
  /**
   * @param data The data for the request.
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMPropertySets OK
   * @throws ApiError
   */
  static getPropertySets(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/propertysets",
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns VMPropertySets OK
   * @throws ApiError
   */
  static createPropertySets(e = {}) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/propertysets",
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMPropertySets OK
   * @throws ApiError
   */
  static getByIdPropertySets(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/propertysets/{id}",
      path: {
        id: e.id
      },
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns VMPropertySets OK
   * @throws ApiError
   */
  static updatePropertySets(e) {
    return p(d, {
      method: "PUT",
      url: "/api/3pq-cpq/v1/propertysets/{id}",
      path: {
        id: e.id
      },
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean OK
   * @throws ApiError
   */
  static deletePropertySets(e) {
    return p(d, {
      method: "DELETE",
      url: "/api/3pq-cpq/v1/propertysets/{id}",
      path: {
        id: e.id
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class Ie {
  /**
   * @param data The data for the request.
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMQuotesList OK
   * @throws ApiError
   */
  static getQuotes(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/quotes",
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns VMQuotes OK
   * @throws ApiError
   */
  static createQuotes(e = {}) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/quotes",
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * Gets a specific quote with the given ID
   * @param data The data for the request.
   * @param data.id
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @param data.searchIncludes A search string to filter included sub objects like item groups and line items. Name, description, product identifier and product partId are taken into account
   * @param data.onlyOptional Specify to get only sub objects with the given status of optional or null to get all.
   * @returns VMQuotes OK
   * @throws ApiError
   */
  static getByIdQuotes(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/quotes/{id}",
      path: {
        id: e.id
      },
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter,
        searchIncludes: e.searchIncludes,
        onlyOptional: e.onlyOptional
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns VMQuotes OK
   * @throws ApiError
   */
  static updateQuotes(e) {
    return p(d, {
      method: "PUT",
      url: "/api/3pq-cpq/v1/quotes/{id}",
      path: {
        id: e.id
      },
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean OK
   * @throws ApiError
   */
  static deleteQuotes(e) {
    return p(d, {
      method: "DELETE",
      url: "/api/3pq-cpq/v1/quotes/{id}",
      path: {
        id: e.id
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.cloneAttachments
   * @param data.cloneProperties
   * @param data.cloneComments
   * @param data.cloneConfiguration
   * @param data.cloneDeep
   * @returns VMQuotes OK
   * @throws ApiError
   */
  static cloneQuotes(e) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/quotes/clone/{id}",
      path: {
        id: e.id
      },
      query: {
        CloneAttachments: e.cloneAttachments,
        CloneProperties: e.cloneProperties,
        CloneComments: e.cloneComments,
        CloneConfiguration: e.cloneConfiguration,
        CloneDeep: e.cloneDeep
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown OK
   * @throws ApiError
   */
  static refreshPricesQuotes(e) {
    return p(d, {
      method: "PATCH",
      url: "/api/3pq-cpq/v1/quotes/{id}/refreshprices",
      path: {
        id: e.id
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class Ct {
  /**
   * @param data The data for the request.
   * @param data.quoteId
   * @param data.itemGroupId
   * @param data.lineItemId
   * @param data.subItemId
   * @returns VMRelationPriceLists OK
   * @throws ApiError
   */
  static getAllRelationPriceLists(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/relationpricelists",
      query: {
        QuoteId: e.quoteId,
        ItemGroupId: e.itemGroupId,
        LineItemId: e.lineItemId,
        SubItemId: e.subItemId
      },
      errors: {
        409: "Conflict"
      }
    });
  }
  /**
   * Adds a reference to a price list with the given `priceListId` to the quote/itemGroup/lineItem/subItem, depending on which ID is set.
   * Additionally a `precedence` can be set, to define the order in which price lists are selected. The lower the precedence the more
   * preferred that price list is.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns VMRelationPriceLists OK
   * @throws ApiError
   */
  static createRelationPriceLists(e = {}) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/relationpricelists",
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        409: "Conflict"
      }
    });
  }
  /**
   * Deletes a reference of a price list to a quote/itemGroup/lineItem/subItem, depending on which ID is set.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns boolean OK
   * @throws ApiError
   */
  static deleteRelationPriceLists(e = {}) {
    return p(d, {
      method: "DELETE",
      url: "/api/3pq-cpq/v1/relationpricelists",
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * Replaces the set of price list IDs that is selected on a quote/itemGroup/lineItem/subItem by the given set of IDs with the given precedences.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown OK
   * @returns ProblemDetails Error
   * @throws ApiError
   */
  static replaceAllRelationPriceLists(e = {}) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/relationpricelists/replaceall",
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class rt {
  /**
   * @param data The data for the request.
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMRelationSalesLocations OK
   * @throws ApiError
   */
  static getAllRelationSalesLocations(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/relationsaleslocations",
      query: {
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.customerId
   * @param data.requestBody
   * @returns string OK
   * @throws ApiError
   */
  static createManyWithCustomerRelationSalesLocations(e) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/relationsaleslocations/customer/{customerId}",
      path: {
        customerId: e.customerId
      },
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.quoteId
   * @param data.requestBody
   * @returns string OK
   * @throws ApiError
   */
  static createManyWithQuoteRelationSalesLocations(e) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/relationsaleslocations/quote/{quoteId}",
      path: {
        quoteId: e.quoteId
      },
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.salesLocationId
   * @param data.requestBody
   * @returns string OK
   * @throws ApiError
   */
  static createManyWithSalesLocationRelationSalesLocations(e) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/relationsaleslocations/saleslocation/{salesLocationId}",
      path: {
        salesLocationId: e.salesLocationId
      },
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean OK
   * @throws ApiError
   */
  static deleteRelationSalesLocations(e) {
    return p(d, {
      method: "DELETE",
      url: "/api/3pq-cpq/v1/relationsaleslocations/{id}",
      path: {
        id: e.id
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class ot {
  /**
   * @param data The data for the request.
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMSalesLocations OK
   * @throws ApiError
   */
  static getAllSalesLocations(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/saleslocations",
      query: {
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns VMSalesLocations OK
   * @throws ApiError
   */
  static createSalesLocations(e = {}) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/saleslocations",
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMSalesLocations OK
   * @throws ApiError
   */
  static getByIdSalesLocations(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/saleslocations/{id}",
      path: {
        id: e.id
      },
      query: {
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns VMSalesLocations OK
   * @throws ApiError
   */
  static updateSalesLocations(e) {
    return p(d, {
      method: "PUT",
      url: "/api/3pq-cpq/v1/saleslocations/{id}",
      path: {
        id: e.id
      },
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean OK
   * @throws ApiError
   */
  static deleteSalesLocations(e) {
    return p(d, {
      method: "DELETE",
      url: "/api/3pq-cpq/v1/saleslocations/{id}",
      path: {
        id: e.id
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class cd {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns VMQuotes OK
   * @throws ApiError
   */
  static searchSearch(e = {}) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/search",
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class co {
  /**
   * @returns VMSeeding OK
   * @throws ApiError
   */
  static getSeeding() {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/seeding",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.seedingId
   * @param data.clearDb
   * @returns boolean OK
   * @throws ApiError
   */
  static seedSeeding(e = {}) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/seeding",
      query: {
        seedingId: e.seedingId,
        clearDB: e.clearDb
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class Le {
  /**
   * @param data The data for the request.
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMStatus OK
   * @throws ApiError
   */
  static getStatus(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/status",
      query: {
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns VMStatus OK
   * @throws ApiError
   */
  static createStatus(e = {}) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/status",
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMStatus OK
   * @throws ApiError
   */
  static getByIdStatus(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/status/{id}",
      path: {
        id: e.id
      },
      query: {
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns VMStatus OK
   * @throws ApiError
   */
  static updateStatus(e) {
    return p(d, {
      method: "PUT",
      url: "/api/3pq-cpq/v1/status/{id}",
      path: {
        id: e.id
      },
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean OK
   * @throws ApiError
   */
  static deleteStatus(e) {
    return p(d, {
      method: "DELETE",
      url: "/api/3pq-cpq/v1/status/{id}",
      path: {
        id: e.id
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class ie {
  /**
   * @param data The data for the request.
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMSubItemsList OK
   * @throws ApiError
   */
  static getSubItems(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/subitems",
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns VMSubItems OK
   * @throws ApiError
   */
  static createSubItems(e = {}) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/subitems",
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMSubItems OK
   * @throws ApiError
   */
  static getByIdSubItems(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/subitems/{id}",
      path: {
        id: e.id
      },
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns VMSubItems OK
   * @throws ApiError
   */
  static updateSubItems(e) {
    return p(d, {
      method: "PUT",
      url: "/api/3pq-cpq/v1/subitems/{id}",
      path: {
        id: e.id
      },
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean OK
   * @throws ApiError
   */
  static deleteSubItems(e) {
    return p(d, {
      method: "DELETE",
      url: "/api/3pq-cpq/v1/subitems/{id}",
      path: {
        id: e.id
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns VMSubItems OK
   * @throws ApiError
   */
  static createManySubItems(e = {}) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/subitems/bulk",
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns VMSubItems OK
   * @throws ApiError
   */
  static searchConfigSubItems(e = {}) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/subitems/searchconfig",
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.cloneAttachments
   * @param data.cloneProperties
   * @param data.cloneComments
   * @param data.cloneConfiguration
   * @returns VMSubItems OK
   * @throws ApiError
   */
  static cloneSubItems(e) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/subitems/clone/{id}",
      path: {
        id: e.id
      },
      query: {
        CloneAttachments: e.cloneAttachments,
        CloneProperties: e.cloneProperties,
        CloneComments: e.cloneComments,
        CloneConfiguration: e.cloneConfiguration
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown OK
   * @throws ApiError
   */
  static updateDiscountBulkSubItems(e = {}) {
    return p(d, {
      method: "PUT",
      url: "/api/3pq-cpq/v1/subitems/setdiscount/bulk",
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.isOptional
   * @returns VMLineItems OK
   * @throws ApiError
   */
  static setOptionalSubItems(e) {
    return p(d, {
      method: "PUT",
      url: "/api/3pq-cpq/v1/subitems/setoptional/{id}",
      path: {
        id: e.id
      },
      query: {
        isOptional: e.isOptional
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class nt {
  /**
   * @returns VMTenants OK
   * @throws ApiError
   */
  static getTenants() {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/tenants",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns VMTenants OK
   * @throws ApiError
   */
  static createTenants(e = {}) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/tenants",
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns VMTenants OK
   * @throws ApiError
   */
  static updateTenants(e = {}) {
    return p(d, {
      method: "PUT",
      url: "/api/3pq-cpq/v1/tenants",
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @returns VMTenants OK
   * @throws ApiError
   */
  static getByIdTenants(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/tenants/{id}",
      path: {
        id: e.id
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean OK
   * @throws ApiError
   */
  static deleteTenants(e) {
    return p(d, {
      method: "DELETE",
      url: "/api/3pq-cpq/v1/tenants/{id}",
      path: {
        id: e.id
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class po {
  /**
   * @param data The data for the request.
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMUnits OK
   * @throws ApiError
   */
  static getUnits(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/units",
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.languageIds A list of languages, used to include translations in the result. The translations in the result are grouped by languageCode (e.g. 'en-US'). If `languageIds` is `null` then all available translations will be included.
   *
   *
   * Requires the `Includes` field to contain `Translations.Language` on each property that should include the translations in the output.
   * Example: `Translations.Language,PropertySet.Properties.Translations.Language` will add the translations for the requested entity as well as the translations of its Properties.
   *
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMUnits OK
   * @throws ApiError
   */
  static getByIdUnits(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/units/{id}",
      path: {
        id: e.id
      },
      query: {
        LanguageIds: e.languageIds,
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
class it {
  /**
   * @param data The data for the request.
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMUsers OK
   * @throws ApiError
   */
  static getAllUser(e = {}) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/user",
      query: {
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns VMUsers OK
   * @throws ApiError
   */
  static createUser(e = {}) {
    return p(d, {
      method: "POST",
      url: "/api/3pq-cpq/v1/user",
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.start The start index of the page requested. Must be a non-negative integer. Requires `Order` and `Size` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.size The size of the page, i.e. number of requested elements. Must be a non-negative integer. Requires `Order` and `Start` to be set.
   *
   * <strong>Possible values:</strong>`0`, `1`, `2`, ...
   *
   * @param data.sort The sort direction used when ordering the result. Default is `ASC`
   * <strong>Possible values:</strong>`ASC`, `DESC`
   * @param data.order The name of the property on which the result should be sorted.
   *
   * <strong>Example:</strong>`Identifier`
   * @param data.includes The comma-separated list of include expressions used to include properties in the output.
   * Include expressions can be chained via `.` to include properties of substructures.
   *
   * An include expressions may contain a filter expression (via `:`), in order to include the properties for which a specified condition is true.
   *
   *
   * <strong>Example (without filter expression):</strong>`PropertySet.Properties.Translations.Language,AttachmentSet.AttachmentItems.Attachment`
   *
   * <strong>Example (with filter expression):</strong>`Quotes.PropertySet.Properties:(Identifier==Foo&Value==Bar)` Includes all Quotes and additionally for each Quote all Properties, that match Foo=Bar
   *
   *
   * <strong>Example (with filter expression):</strong>`Quotes:PropertySet.Properties.(Identifier==Foo&Value==Bar)` Includes all Quotes that contain a Property, that matches Foo=Bar
   *
   * @param data.filter Expression used to filter the result list.
   *
   * Expression are of the form `[PROPERTY][OPERATOR][VALUE]`, where `[PROPERTY]` is the name of the property to filter on,
   * `[VALUE]` is the value that should be matched against the respective property's value of the result and `[OPERATOR]` is one of ` == != ~= !~ <= >= < > `.
   * The operators `~=` and `!~` check whether the value is contained (or not) based on the string representation and are case-insensitive.
   *
   * Properties may be chained like with the `Includes` field.
   * Expressions may be combined by `&` (AND), `|` (OR) and `!` (NOT).
   *
   * Filter expressions can be put in parentheses, either on top-level or on sub-levels after a `.`.
   *
   *
   * <strong>Example (top-level parantheses):</strong>`(Identifier~=Motor|Identifier~=Valve)&Value==True`
   *
   * <strong>Example (sub-level parantheses):</strong>`PropertySet.Properties.(Identifier==Foo&Value==Bar)`
   *
   * <strong>Example (sub-level parantheses with not):</strong>`PropertySet.Properties.(!(Identifier==Foo&Value==Bar))`
   * @returns VMUsers OK
   * @throws ApiError
   */
  static getUser(e) {
    return p(d, {
      method: "GET",
      url: "/api/3pq-cpq/v1/user/{id}",
      path: {
        id: e.id
      },
      query: {
        Start: e.start,
        Size: e.size,
        Sort: e.sort,
        Order: e.order,
        Includes: e.includes,
        Filter: e.filter
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns VMUsers OK
   * @throws ApiError
   */
  static updateUser(e) {
    return p(d, {
      method: "PUT",
      url: "/api/3pq-cpq/v1/user/{id}",
      path: {
        id: e.id
      },
      body: e.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean OK
   * @throws ApiError
   */
  static deleteUser(e) {
    return p(d, {
      method: "DELETE",
      url: "/api/3pq-cpq/v1/user/{id}",
      path: {
        id: e.id
      },
      errors: {
        400: "Bad Request",
        404: "Not Found",
        409: "Conflict"
      }
    });
  }
}
const pb = ({
  filter: t,
  includes: e,
  order: r,
  size: o,
  sort: n,
  start: i
} = {}, a, s) => g({
  queryKey: ys(
    { filter: t, includes: e, order: r, size: o, sort: n, start: i },
    a
  ),
  queryFn: () => ke.getAllAttachmentCategories({
    filter: t,
    includes: e,
    order: r,
    size: o,
    sort: n,
    start: i
  }),
  ...s
}), mb = ({
  filter: t,
  id: e,
  includes: r,
  order: o,
  size: n,
  sort: i,
  start: a
}, s, l) => g({
  queryKey: bs(
    { filter: t, id: e, includes: r, order: o, size: n, sort: i, start: a },
    s
  ),
  queryFn: () => ke.getAttachmentCategories({
    filter: t,
    id: e,
    includes: r,
    order: o,
    size: n,
    sort: i,
    start: a
  }),
  ...l
}), yb = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s, l) => g({
  queryKey: hs(
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a },
    s
  ),
  queryFn: () => je.getAttachmentItems({
    filter: t,
    includes: e,
    languageIds: r,
    order: o,
    size: n,
    sort: i,
    start: a
  }),
  ...l
}), gb = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l, c) => g({
  queryKey: Ss(
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s },
    l
  ),
  queryFn: () => je.getByIdAttachmentItems({
    filter: t,
    id: e,
    includes: r,
    languageIds: o,
    order: n,
    size: i,
    sort: a,
    start: s
  }),
  ...c
}), bb = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s, l) => g({
  queryKey: Cs(
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a },
    s
  ),
  queryFn: () => Te.getAllAttachments({
    filter: t,
    includes: e,
    languageIds: r,
    order: o,
    size: n,
    sort: i,
    start: a
  }),
  ...l
}), fb = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l, c) => g({
  queryKey: vs(
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s },
    l
  ),
  queryFn: () => Te.getAttachments({
    filter: t,
    id: e,
    includes: r,
    languageIds: o,
    order: n,
    size: i,
    sort: a,
    start: s
  }),
  ...c
}), hb = ({
  id: t
}, e, r) => g({
  queryKey: Bs(
    { id: t },
    e
  ),
  queryFn: () => Te.downloadFileAttachments({ id: t }),
  ...r
}), Ib = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s, l) => g({
  queryKey: Gs(
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a },
    s
  ),
  queryFn: () => $e.getAllAttachmentSets({
    filter: t,
    includes: e,
    languageIds: r,
    order: o,
    size: n,
    sort: i,
    start: a
  }),
  ...l
}), Sb = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l, c) => g({
  queryKey: Fs(
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s },
    l
  ),
  queryFn: () => $e.getByIdAttachmentSets({
    filter: t,
    id: e,
    includes: r,
    languageIds: o,
    order: n,
    size: i,
    sort: a,
    start: s
  }),
  ...c
}), Pb = ({
  filter: t,
  includes: e,
  order: r,
  size: o,
  sort: n,
  start: i
} = {}, a, s) => g({
  queryKey: ws(
    { filter: t, includes: e, order: r, size: o, sort: n, start: i },
    a
  ),
  queryFn: () => ze.getAllAttachmentTypes({
    filter: t,
    includes: e,
    order: r,
    size: o,
    sort: n,
    start: i
  }),
  ...s
}), Cb = ({
  filter: t,
  id: e,
  includes: r,
  order: o,
  size: n,
  sort: i,
  start: a
}, s, l) => g({
  queryKey: Rs(
    { filter: t, id: e, includes: r, order: o, size: n, sort: i, start: a },
    s
  ),
  queryFn: () => ze.getAttachmentTypes({
    filter: t,
    id: e,
    includes: r,
    order: o,
    size: n,
    sort: i,
    start: a
  }),
  ...l
}), qb = (t, e) => g({
  queryKey: Ns(t),
  queryFn: () => sd.getUserInfoAuthorizations(),
  ...e
}), vb = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s, l) => g({
  queryKey: xs(
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a },
    s
  ),
  queryFn: () => jt.getBaseAttributes({
    filter: t,
    includes: e,
    languageIds: r,
    order: o,
    size: n,
    sort: i,
    start: a
  }),
  ...l
}), Tb = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l, c) => g({
  queryKey: Us(
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s },
    l
  ),
  queryFn: () => jt.getByIdBaseAttributes({
    filter: t,
    id: e,
    includes: r,
    languageIds: o,
    order: n,
    size: i,
    sort: a,
    start: s
  }),
  ...c
}), Bb = ({
  languageIds: t,
  parentId: e
}, r, o) => g({
  queryKey: ks(
    { languageIds: t, parentId: e },
    r
  ),
  queryFn: () => jt.getFilterableBaseAttributes({
    languageIds: t,
    parentId: e
  }),
  ...o
}), Lb = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s, l) => g({
  queryKey: $s(
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a },
    s
  ),
  queryFn: () => Zr.getBaseValues({
    filter: t,
    includes: e,
    languageIds: r,
    order: o,
    size: n,
    sort: i,
    start: a
  }),
  ...l
}), Gb = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l, c) => g({
  queryKey: Ks(
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s },
    l
  ),
  queryFn: () => Zr.getByIdBaseValues({
    filter: t,
    id: e,
    includes: r,
    languageIds: o,
    order: n,
    size: i,
    sort: a,
    start: s
  }),
  ...c
}), Ab = ({
  eager: t
} = {}, e, r) => g({
  queryKey: _s(
    { eager: t },
    e
  ),
  queryFn: () => Ke.getCommentItems({ eager: t }),
  ...r
}), Fb = ({
  eager: t,
  id: e
}, r, o) => g({
  queryKey: Zs(
    { eager: t, id: e },
    r
  ),
  queryFn: () => Ke.getByIdCommentItems({ eager: t, id: e }),
  ...o
}), Ob = ({
  filter: t,
  includes: e,
  order: r,
  size: o,
  sort: n,
  start: i
} = {}, a, s) => g({
  queryKey: Js(
    { filter: t, includes: e, order: r, size: o, sort: n, start: i },
    a
  ),
  queryFn: () => He.getCommentSets({
    filter: t,
    includes: e,
    order: r,
    size: o,
    sort: n,
    start: i
  }),
  ...s
}), wb = ({
  filter: t,
  id: e,
  includes: r,
  order: o,
  size: n,
  sort: i,
  start: a
}, s, l) => g({
  queryKey: eu(
    { filter: t, id: e, includes: r, order: o, size: n, sort: i, start: a },
    s
  ),
  queryFn: () => He.getByIdCommentSets({
    filter: t,
    id: e,
    includes: r,
    order: o,
    size: n,
    sort: i,
    start: a
  }),
  ...l
}), Db = ({
  filter: t,
  includes: e,
  order: r,
  size: o,
  sort: n,
  start: i
} = {}, a, s) => g({
  queryKey: ru(
    { filter: t, includes: e, order: r, size: o, sort: n, start: i },
    a
  ),
  queryFn: () => _e.getAllCompanies({
    filter: t,
    includes: e,
    order: r,
    size: o,
    sort: n,
    start: i
  }),
  ...s
}), Rb = ({
  filter: t,
  id: e,
  includes: r,
  order: o,
  size: n,
  sort: i,
  start: a
}, s, l) => g({
  queryKey: nu(
    { filter: t, id: e, includes: r, order: o, size: n, sort: i, start: a },
    s
  ),
  queryFn: () => _e.getByIdCompanies({
    filter: t,
    id: e,
    includes: r,
    order: o,
    size: n,
    sort: i,
    start: a
  }),
  ...l
}), Vb = (t, e) => g({
  queryKey: au(t),
  queryFn: () => We.getConfigurations(),
  ...e
}), mo = ({
  id: t
}, e, r) => g({
  queryKey: uu(
    { id: t },
    e
  ),
  queryFn: () => We.getByIdConfigurations({ id: t }),
  ...r
}), Nb = ({
  filter: t,
  includes: e,
  order: r,
  size: o,
  sort: n,
  start: i
} = {}, a, s) => g({
  queryKey: cu(
    { filter: t, includes: e, order: r, size: o, sort: n, start: i },
    a
  ),
  queryFn: () => Ze.getAllCustomers({
    filter: t,
    includes: e,
    order: r,
    size: o,
    sort: n,
    start: i
  }),
  ...s
}), Mb = ({
  filter: t,
  id: e,
  includes: r,
  order: o,
  size: n,
  sort: i,
  start: a
}, s, l) => g({
  queryKey: pu(
    { filter: t, id: e, includes: r, order: o, size: n, sort: i, start: a },
    s
  ),
  queryFn: () => Ze.getByIdCustomers({
    filter: t,
    id: e,
    includes: r,
    order: o,
    size: n,
    sort: i,
    start: a
  }),
  ...l
}), dd = (t, e) => g({
  queryKey: yu(t),
  queryFn: () => Xe.getDataTypes(),
  ...e
}), xb = ({
  id: t
}, e, r) => g({
  queryKey: bu({ id: t }, e),
  queryFn: () => Xe.getByIdDataTypes({ id: t }),
  ...r
}), Eb = ({
  filter: t,
  includes: e,
  order: r,
  size: o,
  sort: n,
  start: i
} = {}, a, s) => g({
  queryKey: hu(
    { filter: t, includes: e, order: r, size: o, sort: n, start: i },
    a
  ),
  queryFn: () => Xr.getDiscounts({
    filter: t,
    includes: e,
    order: r,
    size: o,
    sort: n,
    start: i
  }),
  ...s
}), Ub = ({
  filter: t,
  id: e,
  includes: r,
  order: o,
  size: n,
  sort: i,
  start: a
}, s, l) => g({
  queryKey: Su(
    { filter: t, id: e, includes: r, order: o, size: n, sort: i, start: a },
    s
  ),
  queryFn: () => Xr.getByIdDiscounts({
    filter: t,
    id: e,
    includes: r,
    order: o,
    size: n,
    sort: i,
    start: a
  }),
  ...l
}), Qb = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s, l) => g({
  queryKey: Cu(
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a },
    s
  ),
  queryFn: () => Jr.getDiscountTypes({
    filter: t,
    includes: e,
    languageIds: r,
    order: o,
    size: n,
    sort: i,
    start: a
  }),
  ...l
}), kb = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l, c) => g({
  queryKey: vu(
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s },
    l
  ),
  queryFn: () => Jr.getByIdDiscountTypes({
    filter: t,
    id: e,
    includes: r,
    languageIds: o,
    order: n,
    size: i,
    sort: a,
    start: s
  }),
  ...c
}), jb = (t, e) => g({
  queryKey: Bu(t),
  queryFn: () => $t.templateExcel(),
  ...e
}), $b = ({
  quoteId: t
}, e, r) => g({
  queryKey: Gu({ quoteId: t }, e),
  queryFn: () => $t.exportExcel({ quoteId: t }),
  ...r
}), zb = (t, e) => g({
  queryKey: Fu(t),
  queryFn: () => Yr.livenessHealth(),
  ...e
}), Kb = (t, e) => g({
  queryKey: wu(t),
  queryFn: () => Yr.readinessHealth(),
  ...e
}), pd = (t, e) => g({
  queryKey: Ru(t),
  queryFn: () => ld.getInfosInfos(),
  ...e
}), Hb = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s, l) => g({
  queryKey: Nu(
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a },
    s
  ),
  queryFn: () => fe.getItemGroups({
    filter: t,
    includes: e,
    languageIds: r,
    order: o,
    size: n,
    sort: i,
    start: a
  }),
  ...l
}), md = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l, c) => g({
  queryKey: Mu(
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s },
    l
  ),
  queryFn: () => fe.getByIdItemGroups({
    filter: t,
    id: e,
    includes: r,
    languageIds: o,
    order: n,
    size: i,
    sort: a,
    start: s
  }),
  ...c
}), yd = ({
  filter: t,
  includes: e,
  languageCode: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s, l) => g({
  queryKey: Eu(
    { filter: t, includes: e, languageCode: r, order: o, size: n, sort: i, start: a },
    s
  ),
  queryFn: () => eo.getLanguages({
    filter: t,
    includes: e,
    languageCode: r,
    order: o,
    size: n,
    sort: i,
    start: a
  }),
  ...l
}), _b = ({
  filter: t,
  id: e,
  includes: r,
  order: o,
  size: n,
  sort: i,
  start: a
}, s, l) => g({
  queryKey: Qu(
    { filter: t, id: e, includes: r, order: o, size: n, sort: i, start: a },
    s
  ),
  queryFn: () => eo.getByIdLanguages({
    filter: t,
    id: e,
    includes: r,
    order: o,
    size: n,
    sort: i,
    start: a
  }),
  ...l
}), Wb = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s, l) => g({
  queryKey: ju(
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a },
    s
  ),
  queryFn: () => oe.getLineItems({
    filter: t,
    includes: e,
    languageIds: r,
    order: o,
    size: n,
    sort: i,
    start: a
  }),
  ...l
}), Zb = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l, c) => g({
  queryKey: zu(
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s },
    l
  ),
  queryFn: () => oe.getByIdLineItems({
    filter: t,
    id: e,
    includes: r,
    languageIds: o,
    order: n,
    size: i,
    sort: a,
    start: s
  }),
  ...c
}), Xb = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s, l) => g({
  queryKey: Ku(
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a },
    s
  ),
  queryFn: () => Be.getOpportunities({
    filter: t,
    includes: e,
    languageIds: r,
    order: o,
    size: n,
    sort: i,
    start: a
  }),
  ...l
}), Jb = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l, c) => g({
  queryKey: _u(
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s },
    l
  ),
  queryFn: () => Be.getByIdOpportunities({
    filter: t,
    id: e,
    includes: r,
    languageIds: o,
    order: n,
    size: i,
    sort: a,
    start: s
  }),
  ...c
}), gd = ({
  filter: t,
  includes: e,
  order: r,
  size: o,
  sort: n,
  start: i
} = {}, a, s) => g({
  queryKey: Zu(
    { filter: t, includes: e, order: r, size: o, sort: n, start: i },
    a
  ),
  queryFn: () => to.getPriceCurrencies({
    filter: t,
    includes: e,
    order: r,
    size: o,
    sort: n,
    start: i
  }),
  ...s
}), Yb = ({
  filter: t,
  id: e,
  includes: r,
  order: o,
  size: n,
  sort: i,
  start: a
}, s, l) => g({
  queryKey: Ju(
    { filter: t, id: e, includes: r, order: o, size: n, sort: i, start: a },
    s
  ),
  queryFn: () => to.getByIdPriceCurrencies({
    filter: t,
    id: e,
    includes: r,
    order: o,
    size: n,
    sort: i,
    start: a
  }),
  ...l
}), bd = ({
  filter: t,
  includes: e,
  order: r,
  size: o,
  sort: n,
  start: i
} = {}, a, s) => g({
  queryKey: el(
    { filter: t, includes: e, order: r, size: o, sort: n, start: i },
    a
  ),
  queryFn: () => ro.getPriceLists({
    filter: t,
    includes: e,
    order: r,
    size: o,
    sort: n,
    start: i
  }),
  ...s
}), ef = ({
  filter: t,
  id: e,
  includes: r,
  order: o,
  size: n,
  sort: i,
  start: a
}, s, l) => g({
  queryKey: rl(
    { filter: t, id: e, includes: r, order: o, size: n, sort: i, start: a },
    s
  ),
  queryFn: () => ro.getByIdPriceLists({
    filter: t,
    id: e,
    includes: r,
    order: o,
    size: n,
    sort: i,
    start: a
  }),
  ...l
}), tf = ({
  filter: t,
  includes: e,
  order: r,
  size: o,
  sort: n,
  start: i
} = {}, a, s) => g({
  queryKey: nl(
    { filter: t, includes: e, order: r, size: o, sort: n, start: i },
    a
  ),
  queryFn: () => oo.getPrices({
    filter: t,
    includes: e,
    order: r,
    size: o,
    sort: n,
    start: i
  }),
  ...s
}), rf = ({
  filter: t,
  id: e,
  includes: r,
  order: o,
  size: n,
  sort: i,
  start: a
}, s, l) => g({
  queryKey: al(
    { filter: t, id: e, includes: r, order: o, size: n, sort: i, start: a },
    s
  ),
  queryFn: () => oo.getByIdPrices({
    filter: t,
    id: e,
    includes: r,
    order: o,
    size: n,
    sort: i,
    start: a
  }),
  ...l
}), of = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s, l) => g({
  queryKey: ul(
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a },
    s
  ),
  queryFn: () => no.getPriceTypes({
    filter: t,
    includes: e,
    languageIds: r,
    order: o,
    size: n,
    sort: i,
    start: a
  }),
  ...l
}), nf = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l, c) => g({
  queryKey: cl(
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s },
    l
  ),
  queryFn: () => no.getByIdPriceTypes({
    filter: t,
    id: e,
    includes: r,
    languageIds: o,
    order: n,
    size: i,
    sort: a,
    start: s
  }),
  ...c
}), af = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s, l) => g({
  queryKey: pl(
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a },
    s
  ),
  queryFn: () => io.getProductAttributes({
    filter: t,
    includes: e,
    languageIds: r,
    order: o,
    size: n,
    sort: i,
    start: a
  }),
  ...l
}), sf = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l, c) => g({
  queryKey: yl(
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s },
    l
  ),
  queryFn: () => io.getByIdProductAttributes({
    filter: t,
    id: e,
    includes: r,
    languageIds: o,
    order: n,
    size: i,
    sort: a,
    start: s
  }),
  ...c
}), uf = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s, l) => g({
  queryKey: bl(
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a },
    s
  ),
  queryFn: () => Pt.getProductCategories({
    filter: t,
    includes: e,
    languageIds: r,
    order: o,
    size: n,
    sort: i,
    start: a
  }),
  ...l
}), lf = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l, c) => g({
  queryKey: hl(
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s },
    l
  ),
  queryFn: () => Pt.getByIdProductCategories({
    filter: t,
    id: e,
    includes: r,
    languageIds: o,
    order: n,
    size: i,
    sort: a,
    start: s
  }),
  ...c
}), cf = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  resourceId: n,
  size: i,
  sort: a,
  start: s
}, l, c) => g({
  queryKey: Sl(
    { filter: t, includes: e, languageIds: r, order: o, resourceId: n, size: i, sort: a, start: s },
    l
  ),
  queryFn: () => Pt.getByResourceIdProductCategories({
    filter: t,
    includes: e,
    languageIds: r,
    order: o,
    resourceId: n,
    size: i,
    sort: a,
    start: s
  }),
  ...c
}), df = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s, l) => g({
  queryKey: Cl(
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a },
    s
  ),
  queryFn: () => ao.getProductCategoryChildren({
    filter: t,
    includes: e,
    languageIds: r,
    order: o,
    size: n,
    sort: i,
    start: a
  }),
  ...l
}), pf = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l, c) => g({
  queryKey: vl(
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s },
    l
  ),
  queryFn: () => ao.getByIdProductCategoryChildren({
    filter: t,
    id: e,
    includes: r,
    languageIds: o,
    order: n,
    size: i,
    sort: a,
    start: s
  }),
  ...c
}), mf = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s, l) => g({
  queryKey: Bl(
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a },
    s
  ),
  queryFn: () => so.getProductGroups({
    filter: t,
    includes: e,
    languageIds: r,
    order: o,
    size: n,
    sort: i,
    start: a
  }),
  ...l
}), yf = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l, c) => g({
  queryKey: Gl(
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s },
    l
  ),
  queryFn: () => so.getByIdProductGroups({
    filter: t,
    id: e,
    includes: r,
    languageIds: o,
    order: n,
    size: i,
    sort: a,
    start: s
  }),
  ...c
}), gf = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s, l) => g({
  queryKey: Fl(
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a },
    s
  ),
  queryFn: () => he.getProductHierarchies({
    filter: t,
    includes: e,
    languageIds: r,
    order: o,
    size: n,
    sort: i,
    start: a
  }),
  ...l
}), bf = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l, c) => g({
  queryKey: wl(
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s },
    l
  ),
  queryFn: () => he.getByIdProductHierarchies({
    filter: t,
    id: e,
    includes: r,
    languageIds: o,
    order: n,
    size: i,
    sort: a,
    start: s
  }),
  ...c
}), fd = ({
  languageIds: t,
  productSearch: e,
  sort: r
} = {}, o, n) => g({
  queryKey: Rl(
    { languageIds: t, productSearch: e, sort: r },
    o
  ),
  queryFn: () => he.getTreeProductHierarchies({
    languageIds: t,
    productSearch: e,
    sort: r
  }),
  ...n
}), ff = ({
  id: t,
  languageIds: e,
  productSearch: r,
  sort: o
}, n, i) => g({
  queryKey: Nl(
    { id: t, languageIds: e, productSearch: r, sort: o },
    n
  ),
  queryFn: () => he.getTreeByIdProductHierarchies({
    id: t,
    languageIds: e,
    productSearch: r,
    sort: o
  }),
  ...i
}), hf = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s, l) => g({
  queryKey: xl(
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a },
    s
  ),
  queryFn: () => uo.getProductHierarchyCategories({
    filter: t,
    includes: e,
    languageIds: r,
    order: o,
    size: n,
    sort: i,
    start: a
  }),
  ...l
}), If = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l, c) => g({
  queryKey: Ul(
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s },
    l
  ),
  queryFn: () => uo.getByIdProductHierarchyCategories({
    filter: t,
    id: e,
    includes: r,
    languageIds: o,
    order: n,
    size: i,
    sort: a,
    start: s
  }),
  ...c
}), hd = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  quoteId: n,
  size: i,
  sort: a,
  start: s
} = {}, l, c) => g({
  queryKey: kl(
    { filter: t, includes: e, languageIds: r, order: o, quoteId: n, size: i, sort: a, start: s },
    l
  ),
  queryFn: () => ne.getProducts({
    filter: t,
    includes: e,
    languageIds: r,
    order: o,
    quoteId: n,
    size: i,
    sort: a,
    start: s
  }),
  ...c
}), Sf = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  quoteId: i,
  size: a,
  sort: s,
  start: l
}, c, m) => g({
  queryKey: $l(
    { filter: t, id: e, includes: r, languageIds: o, order: n, quoteId: i, size: a, sort: s, start: l },
    c
  ),
  queryFn: () => ne.getByIdProducts({
    filter: t,
    id: e,
    includes: r,
    languageIds: o,
    order: n,
    quoteId: i,
    size: a,
    sort: s,
    start: l
  }),
  ...m
}), Id = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  parentId: n,
  quoteId: i,
  size: a,
  sort: s,
  start: l
}, c, m) => g({
  queryKey: Kl(
    {
      filter: t,
      includes: e,
      languageIds: r,
      order: o,
      parentId: n,
      quoteId: i,
      size: a,
      sort: s,
      start: l
    },
    c
  ),
  queryFn: () => ne.getByParentIdProducts({
    filter: t,
    includes: e,
    languageIds: r,
    order: o,
    parentId: n,
    quoteId: i,
    size: a,
    sort: s,
    start: l
  }),
  ...m
}), Sd = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  quoteId: i,
  size: a,
  sort: s,
  start: l
}, c, m) => g({
  queryKey: _l(
    { filter: t, id: e, includes: r, languageIds: o, order: n, quoteId: i, size: a, sort: s, start: l },
    c
  ),
  queryFn: () => ne.getRelatedProductsProducts({
    filter: t,
    id: e,
    includes: r,
    languageIds: o,
    order: n,
    quoteId: i,
    size: a,
    sort: s,
    start: l
  }),
  ...m
}), Pd = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  quoteId: i,
  size: a,
  sort: s,
  start: l
}, c, m) => g({
  queryKey: Zl(
    { filter: t, id: e, includes: r, languageIds: o, order: n, quoteId: i, size: a, sort: s, start: l },
    c
  ),
  queryFn: () => ne.getAlternativeProductsProducts({
    filter: t,
    id: e,
    includes: r,
    languageIds: o,
    order: n,
    quoteId: i,
    size: a,
    sort: s,
    start: l
  }),
  ...m
}), Pf = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l, c) => g({
  queryKey: Jl(
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s },
    l
  ),
  queryFn: () => Je.getByIdProductStates({
    filter: t,
    id: e,
    includes: r,
    languageIds: o,
    order: n,
    size: i,
    sort: a,
    start: s
  }),
  ...c
}), Cf = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s, l) => g({
  queryKey: ec(
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a },
    s
  ),
  queryFn: () => Je.getProductStates({
    filter: t,
    includes: e,
    languageIds: r,
    order: o,
    size: n,
    sort: i,
    start: a
  }),
  ...l
}), qf = ({
  id: t,
  languageIds: e
}, r, o) => g({
  queryKey: rc(
    { id: t, languageIds: e },
    r
  ),
  queryFn: () => Ye.getByIdProductTypes({ id: t, languageIds: e }),
  ...o
}), vf = ({
  languageIds: t
} = {}, e, r) => g({
  queryKey: nc(
    { languageIds: t },
    e
  ),
  queryFn: () => Ye.getProductTypes({ languageIds: t }),
  ...r
}), Tf = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s, l) => g({
  queryKey: ac(
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a },
    s
  ),
  queryFn: () => lo.getProductValues({
    filter: t,
    includes: e,
    languageIds: r,
    order: o,
    size: n,
    sort: i,
    start: a
  }),
  ...l
}), Bf = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l, c) => g({
  queryKey: uc(
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s },
    l
  ),
  queryFn: () => lo.getByIdProductValues({
    filter: t,
    id: e,
    includes: r,
    languageIds: o,
    order: n,
    size: i,
    sort: a,
    start: s
  }),
  ...c
}), Lf = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s, l) => g({
  queryKey: cc(
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a },
    s
  ),
  queryFn: () => et.getProperties({
    filter: t,
    includes: e,
    languageIds: r,
    order: o,
    size: n,
    sort: i,
    start: a
  }),
  ...l
}), Gf = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l, c) => g({
  queryKey: pc(
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s },
    l
  ),
  queryFn: () => et.getByIdProperties({
    filter: t,
    id: e,
    includes: r,
    languageIds: o,
    order: n,
    size: i,
    sort: a,
    start: s
  }),
  ...c
}), Af = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s, l) => g({
  queryKey: yc(
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a },
    s
  ),
  queryFn: () => tt.getPropertySets({
    filter: t,
    includes: e,
    languageIds: r,
    order: o,
    size: n,
    sort: i,
    start: a
  }),
  ...l
}), Ff = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l, c) => g({
  queryKey: bc(
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s },
    l
  ),
  queryFn: () => tt.getByIdPropertySets({
    filter: t,
    id: e,
    includes: r,
    languageIds: o,
    order: n,
    size: i,
    sort: a,
    start: s
  }),
  ...c
}), Of = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s, l) => g({
  queryKey: hc(
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a },
    s
  ),
  queryFn: () => Ie.getQuotes({
    filter: t,
    includes: e,
    languageIds: r,
    order: o,
    size: n,
    sort: i,
    start: a
  }),
  ...l
}), Se = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  onlyOptional: n,
  order: i,
  searchIncludes: a,
  size: s,
  sort: l,
  start: c
}, m, P) => g({
  queryKey: Ic(
    {
      filter: t,
      id: e,
      includes: r,
      languageIds: o,
      onlyOptional: n,
      order: i,
      searchIncludes: a,
      size: s,
      sort: l,
      start: c
    },
    m
  ),
  queryFn: () => Ie.getByIdQuotes({
    filter: t,
    id: e,
    includes: r,
    languageIds: o,
    onlyOptional: n,
    order: i,
    searchIncludes: a,
    size: s,
    sort: l,
    start: c
  }),
  ...P
}), wf = ({
  itemGroupId: t,
  lineItemId: e,
  quoteId: r,
  subItemId: o
} = {}, n, i) => g({
  queryKey: Pc(
    { itemGroupId: t, lineItemId: e, quoteId: r, subItemId: o },
    n
  ),
  queryFn: () => Ct.getAllRelationPriceLists({
    itemGroupId: t,
    lineItemId: e,
    quoteId: r,
    subItemId: o
  }),
  ...i
}), Df = ({
  filter: t,
  includes: e,
  order: r,
  size: o,
  sort: n,
  start: i
} = {}, a, s) => g({
  queryKey: qc(
    { filter: t, includes: e, order: r, size: o, sort: n, start: i },
    a
  ),
  queryFn: () => rt.getAllRelationSalesLocations({
    filter: t,
    includes: e,
    order: r,
    size: o,
    sort: n,
    start: i
  }),
  ...s
}), Rf = ({
  filter: t,
  includes: e,
  order: r,
  size: o,
  sort: n,
  start: i
} = {}, a, s) => g({
  queryKey: Tc(
    { filter: t, includes: e, order: r, size: o, sort: n, start: i },
    a
  ),
  queryFn: () => ot.getAllSalesLocations({
    filter: t,
    includes: e,
    order: r,
    size: o,
    sort: n,
    start: i
  }),
  ...s
}), Vf = ({
  filter: t,
  id: e,
  includes: r,
  order: o,
  size: n,
  sort: i,
  start: a
}, s, l) => g({
  queryKey: Lc(
    { filter: t, id: e, includes: r, order: o, size: n, sort: i, start: a },
    s
  ),
  queryFn: () => ot.getByIdSalesLocations({
    filter: t,
    id: e,
    includes: r,
    order: o,
    size: n,
    sort: i,
    start: a
  }),
  ...l
}), Nf = (t, e) => g({
  queryKey: Ac(t),
  queryFn: () => co.getSeeding(),
  ...e
}), yo = ({
  filter: t,
  includes: e,
  order: r,
  size: o,
  sort: n,
  start: i
} = {}, a, s) => g({
  queryKey: Fc(
    { filter: t, includes: e, order: r, size: o, sort: n, start: i },
    a
  ),
  queryFn: () => Le.getStatus({
    filter: t,
    includes: e,
    order: r,
    size: o,
    sort: n,
    start: i
  }),
  ...s
}), Mf = ({
  filter: t,
  id: e,
  includes: r,
  order: o,
  size: n,
  sort: i,
  start: a
}, s, l) => g({
  queryKey: wc(
    { filter: t, id: e, includes: r, order: o, size: n, sort: i, start: a },
    s
  ),
  queryFn: () => Le.getByIdStatus({
    filter: t,
    id: e,
    includes: r,
    order: o,
    size: n,
    sort: i,
    start: a
  }),
  ...l
}), xf = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s, l) => g({
  queryKey: Rc(
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a },
    s
  ),
  queryFn: () => ie.getSubItems({
    filter: t,
    includes: e,
    languageIds: r,
    order: o,
    size: n,
    sort: i,
    start: a
  }),
  ...l
}), Ef = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l, c) => g({
  queryKey: Nc(
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s },
    l
  ),
  queryFn: () => ie.getByIdSubItems({
    filter: t,
    id: e,
    includes: r,
    languageIds: o,
    order: n,
    size: i,
    sort: a,
    start: s
  }),
  ...c
}), Uf = (t, e) => g({
  queryKey: xc(t),
  queryFn: () => nt.getTenants(),
  ...e
}), Qf = ({
  id: t
}, e, r) => g({
  queryKey: Uc({ id: t }, e),
  queryFn: () => nt.getByIdTenants({ id: t }),
  ...r
}), kf = ({
  filter: t,
  includes: e,
  languageIds: r,
  order: o,
  size: n,
  sort: i,
  start: a
} = {}, s, l) => g({
  queryKey: kc(
    { filter: t, includes: e, languageIds: r, order: o, size: n, sort: i, start: a },
    s
  ),
  queryFn: () => po.getUnits({
    filter: t,
    includes: e,
    languageIds: r,
    order: o,
    size: n,
    sort: i,
    start: a
  }),
  ...l
}), jf = ({
  filter: t,
  id: e,
  includes: r,
  languageIds: o,
  order: n,
  size: i,
  sort: a,
  start: s
}, l, c) => g({
  queryKey: $c(
    { filter: t, id: e, includes: r, languageIds: o, order: n, size: i, sort: a, start: s },
    l
  ),
  queryFn: () => po.getByIdUnits({
    filter: t,
    id: e,
    includes: r,
    languageIds: o,
    order: n,
    size: i,
    sort: a,
    start: s
  }),
  ...c
}), $f = ({
  filter: t,
  includes: e,
  order: r,
  size: o,
  sort: n,
  start: i
} = {}, a, s) => g({
  queryKey: Kc(
    { filter: t, includes: e, order: r, size: o, sort: n, start: i },
    a
  ),
  queryFn: () => it.getAllUser({
    filter: t,
    includes: e,
    order: r,
    size: o,
    sort: n,
    start: i
  }),
  ...s
}), zf = ({
  filter: t,
  id: e,
  includes: r,
  order: o,
  size: n,
  sort: i,
  start: a
}, s, l) => g({
  queryKey: _c(
    { filter: t, id: e, includes: r, order: o, size: n, sort: i, start: a },
    s
  ),
  queryFn: () => it.getUser({
    filter: t,
    id: e,
    includes: r,
    order: o,
    size: n,
    sort: i,
    start: a
  }),
  ...l
}), Kf = (t) => y({
  mutationFn: ({ requestBody: e }) => ke.createAttachmentCategories({
    requestBody: e
  }),
  ...t
}), Hf = (t) => y({
  mutationFn: ({ requestBody: e }) => je.createAttachmentItems({
    requestBody: e
  }),
  ...t
}), _f = (t) => y({
  mutationFn: ({ formData: e }) => Te.createAttachments({
    formData: e
  }),
  ...t
}), Wf = (t) => y({
  mutationFn: ({ requestBody: e }) => $e.createAttachmentSets({
    requestBody: e
  }),
  ...t
}), Zf = (t) => y({
  mutationFn: ({ requestBody: e }) => ze.createAttachmentTypes({
    requestBody: e
  }),
  ...t
}), Xf = (t) => y({
  mutationFn: ({ requestBody: e }) => Ke.createCommentItems({
    requestBody: e
  }),
  ...t
}), Jf = (t) => y({
  mutationFn: ({ requestBody: e }) => He.createCommentSets({
    requestBody: e
  }),
  ...t
}), Yf = (t) => y({
  mutationFn: ({ requestBody: e }) => _e.createCompanies({
    requestBody: e
  }),
  ...t
}), eh = (t) => y({
  mutationFn: ({ requestBody: e }) => We.createConfigurations({
    requestBody: e
  }),
  ...t
}), th = (t) => y({
  mutationFn: ({ requestBody: e }) => Ze.createCustomers({
    requestBody: e
  }),
  ...t
}), Cd = (t) => y({
  mutationFn: ({ requestBody: e }) => Xe.createDataTypes({
    requestBody: e
  }),
  ...t
}), rh = (t) => y({
  mutationFn: ({ formData: e, importType: r, quoteId: o }) => $t.importExcel({
    formData: e,
    importType: r,
    quoteId: o
  }),
  ...t
}), oh = (t) => y({
  mutationFn: () => ud.importReleaseImport(),
  ...t
}), nh = (t) => y({
  mutationFn: ({ requestBody: e }) => fe.createItemGroups({
    requestBody: e
  }),
  ...t
}), qd = (t) => y({
  mutationFn: ({
    cloneAttachments: e,
    cloneComments: r,
    cloneConfiguration: o,
    cloneDeep: n,
    cloneProperties: i,
    id: a
  }) => fe.cloneItemGroups({
    cloneAttachments: e,
    cloneComments: r,
    cloneConfiguration: o,
    cloneDeep: n,
    cloneProperties: i,
    id: a
  }),
  ...t
}), vd = (t) => y({
  mutationFn: ({ requestBody: e }) => oe.createLineItems({
    requestBody: e
  }),
  ...t
}), go = (t) => y({
  mutationFn: ({ requestBody: e }) => oe.createManyLineItems({
    requestBody: e
  }),
  ...t
}), ih = (t) => y({
  mutationFn: ({
    cloneAttachments: e,
    cloneComments: r,
    cloneConfiguration: o,
    cloneDeep: n,
    cloneProperties: i,
    id: a
  }) => oe.cloneLineItems({
    cloneAttachments: e,
    cloneComments: r,
    cloneConfiguration: o,
    cloneDeep: n,
    cloneProperties: i,
    id: a
  }),
  ...t
}), ah = (t) => y({
  mutationFn: ({ requestBody: e }) => oe.searchConfigLineItems({
    requestBody: e
  }),
  ...t
}), Td = (t) => y({
  mutationFn: ({ requestBody: e }) => Be.createOpportunities({
    requestBody: e
  }),
  ...t
}), sh = (t) => y({
  mutationFn: ({
    cloneAttachments: e,
    cloneComments: r,
    cloneConfiguration: o,
    cloneDeep: n,
    cloneProperties: i,
    id: a
  }) => Be.cloneOpportunities({
    cloneAttachments: e,
    cloneComments: r,
    cloneConfiguration: o,
    cloneDeep: n,
    cloneProperties: i,
    id: a
  }),
  ...t
}), uh = (t) => y({
  mutationFn: ({
    filter: e,
    includes: r,
    languageIds: o,
    order: n,
    requestBody: i,
    size: a,
    sort: s,
    start: l
  }) => Pt.searchProductCategories({
    filter: e,
    includes: r,
    languageIds: o,
    order: n,
    requestBody: i,
    size: a,
    sort: s,
    start: l
  }),
  ...t
}), lh = (t) => y({
  mutationFn: ({ languageIds: e, productSearch: r, requestBody: o, sort: n }) => he.getTreeWithAttributeFiltersProductHierarchies(
    { languageIds: e, productSearch: r, requestBody: o, sort: n }
  ),
  ...t
}), ch = (t) => y({
  mutationFn: ({ id: e, languageIds: r, productSearch: o, requestBody: n, sort: i }) => he.getTreeByIdWithAttributeFiltersProductHierarchies(
    { id: e, languageIds: r, productSearch: o, requestBody: n, sort: i }
  ),
  ...t
}), dh = (t) => y({
  mutationFn: ({
    filter: e,
    includes: r,
    languageIds: o,
    order: n,
    requestBody: i,
    size: a,
    sort: s,
    start: l
  }) => he.searchProductHierarchies({
    filter: e,
    includes: r,
    languageIds: o,
    order: n,
    requestBody: i,
    size: a,
    sort: s,
    start: l
  }),
  ...t
}), ph = (t) => y({
  mutationFn: ({ requestBody: e }) => ne.createProducts({
    requestBody: e
  }),
  ...t
}), Bd = (t) => y({
  mutationFn: ({
    filter: e,
    includes: r,
    languageIds: o,
    order: n,
    parentId: i,
    quoteId: a,
    requestBody: s,
    size: l,
    sort: c,
    start: m
  }) => ne.getByParentIdWithAttributeFiltersProducts({
    filter: e,
    includes: r,
    languageIds: o,
    order: n,
    parentId: i,
    quoteId: a,
    requestBody: s,
    size: l,
    sort: c,
    start: m
  }),
  ...t
}), mh = (t) => y({
  mutationFn: ({
    filter: e,
    includes: r,
    languageIds: o,
    order: n,
    requestBody: i,
    size: a,
    sort: s,
    start: l
  }) => ne.searchProducts({
    filter: e,
    includes: r,
    languageIds: o,
    order: n,
    requestBody: i,
    size: a,
    sort: s,
    start: l
  }),
  ...t
}), yh = (t) => y({
  mutationFn: ({ requestBody: e }) => Je.createProductStates({
    requestBody: e
  }),
  ...t
}), gh = (t) => y({
  mutationFn: ({ requestBody: e }) => Ye.createProductTypes({
    requestBody: e
  }),
  ...t
}), bh = (t) => y({
  mutationFn: ({ requestBody: e }) => et.createProperties({
    requestBody: e
  }),
  ...t
}), fh = (t) => y({
  mutationFn: ({ requestBody: e }) => tt.createPropertySets({
    requestBody: e
  }),
  ...t
}), Ld = (t) => y({
  mutationFn: ({ requestBody: e }) => Ie.createQuotes({ requestBody: e }),
  ...t
}), hh = (t) => y({
  mutationFn: ({
    cloneAttachments: e,
    cloneComments: r,
    cloneConfiguration: o,
    cloneDeep: n,
    cloneProperties: i,
    id: a
  }) => Ie.cloneQuotes({
    cloneAttachments: e,
    cloneComments: r,
    cloneConfiguration: o,
    cloneDeep: n,
    cloneProperties: i,
    id: a
  }),
  ...t
}), Ih = (t) => y({
  mutationFn: ({ requestBody: e }) => Ct.createRelationPriceLists({
    requestBody: e
  }),
  ...t
}), Gd = (t) => y({
  mutationFn: ({ requestBody: e }) => Ct.replaceAllRelationPriceLists({
    requestBody: e
  }),
  ...t
}), Sh = (t) => y({
  mutationFn: ({ customerId: e, requestBody: r }) => rt.createManyWithCustomerRelationSalesLocations(
    { customerId: e, requestBody: r }
  ),
  ...t
}), Ph = (t) => y({
  mutationFn: ({ quoteId: e, requestBody: r }) => rt.createManyWithQuoteRelationSalesLocations(
    { quoteId: e, requestBody: r }
  ),
  ...t
}), Ch = (t) => y({
  mutationFn: ({ requestBody: e, salesLocationId: r }) => rt.createManyWithSalesLocationRelationSalesLocations(
    { requestBody: e, salesLocationId: r }
  ),
  ...t
}), qh = (t) => y({
  mutationFn: ({ requestBody: e }) => ot.createSalesLocations({
    requestBody: e
  }),
  ...t
}), vh = (t) => y({
  mutationFn: ({ requestBody: e }) => cd.searchSearch({ requestBody: e }),
  ...t
}), Th = (t) => y({
  mutationFn: ({ clearDb: e, seedingId: r }) => co.seedSeeding({
    clearDb: e,
    seedingId: r
  }),
  ...t
}), Ad = (t) => y({
  mutationFn: ({ requestBody: e }) => Le.createStatus({ requestBody: e }),
  ...t
}), Bh = (t) => y({
  mutationFn: ({ requestBody: e }) => ie.createSubItems({
    requestBody: e
  }),
  ...t
}), Fd = (t) => y({
  mutationFn: ({ requestBody: e }) => ie.createManySubItems({
    requestBody: e
  }),
  ...t
}), Lh = (t) => y({
  mutationFn: ({ requestBody: e }) => ie.searchConfigSubItems({
    requestBody: e
  }),
  ...t
}), Gh = (t) => y({
  mutationFn: ({
    cloneAttachments: e,
    cloneComments: r,
    cloneConfiguration: o,
    cloneProperties: n,
    id: i
  }) => ie.cloneSubItems({
    cloneAttachments: e,
    cloneComments: r,
    cloneConfiguration: o,
    cloneProperties: n,
    id: i
  }),
  ...t
}), Ah = (t) => y({
  mutationFn: ({ requestBody: e }) => nt.createTenants({
    requestBody: e
  }),
  ...t
}), Fh = (t) => y({
  mutationFn: ({ requestBody: e }) => it.createUser({ requestBody: e }),
  ...t
}), Oh = (t) => y({
  mutationFn: ({ id: e, requestBody: r }) => ke.updateAttachmentCategories({
    id: e,
    requestBody: r
  }),
  ...t
}), wh = (t) => y({
  mutationFn: ({ id: e, requestBody: r }) => je.updateAttachmentItems({
    id: e,
    requestBody: r
  }),
  ...t
}), Dh = (t) => y({
  mutationFn: ({ formData: e, id: r }) => Te.updateAttachments({
    formData: e,
    id: r
  }),
  ...t
}), Rh = (t) => y({
  mutationFn: ({ id: e, requestBody: r }) => $e.updateAttachmentSets({
    id: e,
    requestBody: r
  }),
  ...t
}), Vh = (t) => y({
  mutationFn: ({ id: e, requestBody: r }) => ze.updateAttachmentTypes({
    id: e,
    requestBody: r
  }),
  ...t
}), Nh = (t) => y({
  mutationFn: ({ id: e, requestBody: r }) => Ke.updateCommentItems({
    id: e,
    requestBody: r
  }),
  ...t
}), Mh = (t) => y({
  mutationFn: ({ id: e, requestBody: r }) => He.updateCommentSets({
    id: e,
    requestBody: r
  }),
  ...t
}), xh = (t) => y({
  mutationFn: ({ id: e, requestBody: r }) => _e.updateCompanies({
    id: e,
    requestBody: r
  }),
  ...t
}), Eh = (t) => y({
  mutationFn: ({ id: e, requestBody: r }) => We.updateConfigurations({
    id: e,
    requestBody: r
  }),
  ...t
}), Uh = (t) => y({
  mutationFn: ({ id: e, requestBody: r }) => Ze.updateCustomers({
    id: e,
    requestBody: r
  }),
  ...t
}), Qh = (t) => y({
  mutationFn: ({ id: e, requestBody: r }) => Xe.updateDataTypes({
    id: e,
    requestBody: r
  }),
  ...t
}), zt = (t) => y({
  mutationFn: ({ id: e, requestBody: r }) => fe.updateItemGroups({
    id: e,
    requestBody: r
  }),
  ...t
}), Od = (t) => y({
  mutationFn: ({ id: e, isOptional: r }) => fe.setOptionalItemGroups({
    id: e,
    isOptional: r
  }),
  ...t
}), Kt = (t) => y({
  mutationFn: ({ id: e, requestBody: r }) => oe.updateLineItems({
    id: e,
    requestBody: r
  }),
  ...t
}), kh = (t) => y({
  mutationFn: ({ requestBody: e }) => oe.updateDiscountBulkLineItems({
    requestBody: e
  }),
  ...t
}), wd = (t) => y({
  mutationFn: ({ id: e, isOptional: r }) => oe.setOptionalLineItems({
    id: e,
    isOptional: r
  }),
  ...t
}), jh = (t) => y({
  mutationFn: ({ id: e, requestBody: r }) => Be.updateOpportunities({
    id: e,
    requestBody: r
  }),
  ...t
}), $h = (t) => y({
  mutationFn: ({ id: e, requestBody: r }) => ne.updateProducts({
    id: e,
    requestBody: r
  }),
  ...t
}), zh = (t) => y({
  mutationFn: ({ id: e, requestBody: r }) => Je.updateProductStates({
    id: e,
    requestBody: r
  }),
  ...t
}), Kh = (t) => y({
  mutationFn: ({ id: e, requestBody: r }) => Ye.updateProductTypes({
    id: e,
    requestBody: r
  }),
  ...t
}), Hh = (t) => y({
  mutationFn: ({ id: e, requestBody: r }) => et.updateProperties({
    id: e,
    requestBody: r
  }),
  ...t
}), _h = (t) => y({
  mutationFn: ({ id: e, requestBody: r }) => tt.updatePropertySets({
    id: e,
    requestBody: r
  }),
  ...t
}), Dd = (t) => y({
  mutationFn: ({ id: e, requestBody: r }) => Ie.updateQuotes({
    id: e,
    requestBody: r
  }),
  ...t
}), Wh = (t) => y({
  mutationFn: ({ id: e, requestBody: r }) => ot.updateSalesLocations({
    id: e,
    requestBody: r
  }),
  ...t
}), Zh = (t) => y({
  mutationFn: ({ id: e, requestBody: r }) => Le.updateStatus({
    id: e,
    requestBody: r
  }),
  ...t
}), Ht = (t) => y({
  mutationFn: ({ id: e, requestBody: r }) => ie.updateSubItems({
    id: e,
    requestBody: r
  }),
  ...t
}), Xh = (t) => y({
  mutationFn: ({ requestBody: e }) => ie.updateDiscountBulkSubItems({
    requestBody: e
  }),
  ...t
}), Rd = (t) => y({
  mutationFn: ({ id: e, isOptional: r }) => ie.setOptionalSubItems({
    id: e,
    isOptional: r
  }),
  ...t
}), Jh = (t) => y({
  mutationFn: ({ requestBody: e }) => nt.updateTenants({
    requestBody: e
  }),
  ...t
}), Yh = (t) => y({
  mutationFn: ({ id: e, requestBody: r }) => it.updateUser({ id: e, requestBody: r }),
  ...t
}), eI = (t) => y({
  mutationFn: ({ id: e }) => Ie.refreshPricesQuotes({ id: e }),
  ...t
}), tI = (t) => y({
  mutationFn: ({ id: e }) => ke.deleteAttachmentCategories({
    id: e
  }),
  ...t
}), rI = (t) => y({
  mutationFn: ({ id: e }) => je.deleteAttachmentItems({
    id: e
  }),
  ...t
}), oI = (t) => y({
  mutationFn: ({ id: e }) => Te.deleteAttachments({ id: e }),
  ...t
}), nI = (t) => y({
  mutationFn: ({ id: e }) => $e.deleteAttachmentSets({
    id: e
  }),
  ...t
}), iI = (t) => y({
  mutationFn: ({ id: e }) => ze.deleteAttachmentTypes({
    id: e
  }),
  ...t
}), aI = (t) => y({
  mutationFn: ({ id: e }) => Ke.deleteCommentItems({
    id: e
  }),
  ...t
}), sI = (t) => y({
  mutationFn: ({ id: e }) => He.deleteCommentSets({ id: e }),
  ...t
}), uI = (t) => y({
  mutationFn: ({ id: e }) => _e.deleteCompanies({ id: e }),
  ...t
}), lI = (t) => y({
  mutationFn: ({ id: e }) => We.deleteConfigurations({
    id: e
  }),
  ...t
}), cI = (t) => y({
  mutationFn: ({ id: e }) => Ze.deleteCustomers({ id: e }),
  ...t
}), dI = (t) => y({
  mutationFn: ({ id: e }) => Xe.deleteDataTypes({ id: e }),
  ...t
}), Vd = (t) => y({
  mutationFn: ({ id: e }) => fe.deleteItemGroups({ id: e }),
  ...t
}), pI = (t) => y({
  mutationFn: ({ id: e }) => oe.deleteLineItems({ id: e }),
  ...t
}), mI = (t) => y({
  mutationFn: ({ id: e }) => Be.deleteOpportunities({
    id: e
  }),
  ...t
}), yI = (t) => y({
  mutationFn: ({ id: e }) => ne.deleteProducts({ id: e }),
  ...t
}), gI = (t) => y({
  mutationFn: ({ id: e }) => Je.deleteProductStates({
    id: e
  }),
  ...t
}), bI = (t) => y({
  mutationFn: ({ id: e }) => Ye.deleteProductTypes({
    id: e
  }),
  ...t
}), fI = (t) => y({
  mutationFn: ({ id: e }) => et.deleteProperties({ id: e }),
  ...t
}), hI = (t) => y({
  mutationFn: ({ id: e }) => tt.deletePropertySets({
    id: e
  }),
  ...t
}), II = (t) => y({
  mutationFn: ({ id: e }) => Ie.deleteQuotes({ id: e }),
  ...t
}), SI = (t) => y({
  mutationFn: ({ requestBody: e }) => Ct.deleteRelationPriceLists({
    requestBody: e
  }),
  ...t
}), PI = (t) => y({
  mutationFn: ({ id: e }) => rt.deleteRelationSalesLocations({
    id: e
  }),
  ...t
}), CI = (t) => y({
  mutationFn: ({ id: e }) => ot.deleteSalesLocations({
    id: e
  }),
  ...t
}), qI = (t) => y({
  mutationFn: ({ id: e }) => Le.deleteStatus({ id: e }),
  ...t
}), vI = (t) => y({
  mutationFn: ({ id: e }) => ie.deleteSubItems({ id: e }),
  ...t
}), TI = (t) => y({
  mutationFn: ({ id: e }) => nt.deleteTenants({ id: e }),
  ...t
}), BI = (t) => y({
  mutationFn: ({ id: e }) => it.deleteUser({ id: e }),
  ...t
});
function Nd(t, e = "blue") {
  const r = [
    "color: white",
    `background-color: ${e}`,
    "font-size: 12px",
    "padding: 20px",
    "border-radius: 5px"
  ].join(";");
  console.log(`%c ${t}`, r);
}
function Md() {
  const { data: t } = pd();
  return $(() => {
    t != null && t.apiVersion && Nd(
      `cpq-API v${t == null ? void 0 : t.apiVersion}`,
      ps.palette.primary.main
    );
  }, [t]), null;
}
const Z = "cpq-core-toast-container";
function xd(t) {
  const [e, r] = G(!1);
  return $(() => {
    document.querySelectorAll(
      `#${Z}`
    ).length === 0 ? r(!0) : (console.info(
      "FYI: The CpqCore ToastContainer is overridden by a CustomCpqToastContainerProvider."
    ), r(!1));
  }, []), e ? /* @__PURE__ */ u(Cn, { ...t, containerId: Z }) : null;
}
function Y(t, e) {
  return W(t, {
    ...e,
    containerId: Z
  });
}
Y.success = (t, e) => W.success(t, {
  ...e,
  containerId: Z
});
Y.error = (t, e) => W.error(t, {
  ...e,
  containerId: Z
});
Y.info = (t, e) => W.info(t, {
  ...e,
  containerId: Z
});
Y.warning = (t, e) => W.warning(t, {
  ...e,
  containerId: Z
});
Y.loading = (t, e) => W.loading(t, {
  ...e,
  containerId: Z
});
Y.promise = (t, { pending: e, success: r, error: o }, n) => W.promise(
  t,
  { pending: e, success: r, error: o },
  { ...n, containerId: Z }
);
Y.dismiss = (t) => typeof t == "object" ? W.dismiss({
  ...t,
  containerId: Z
}) : W.dismiss(t);
Y.clearWaitingQueue = W.clearWaitingQueue;
Y.isActive = (t) => W.isActive(t, Z);
Y.onChange = W.onChange;
Y.update = (t, e) => W.update(t, {
  ...e,
  containerId: Z
});
const at = Y;
function qt({
  title: t,
  subtitle: e,
  onClose: r
}) {
  return /* @__PURE__ */ f(Ln, { onClick: (o) => o.stopPropagation(), children: [
    t,
    e ? /* @__PURE__ */ u(U, { variant: "body1", children: e }) : null,
    /* @__PURE__ */ u(
      z,
      {
        "aria-label": "close",
        onClick: r,
        sx: {
          position: "absolute",
          right: 8,
          top: 8,
          color: (o) => o.palette.grey[500]
        },
        children: /* @__PURE__ */ u(F, { children: "close" })
      }
    )
  ] });
}
const Ed = ({
  show: t,
  proceed: e,
  cancelLabel: r,
  confirmLabel: o,
  title: n,
  subtitle: i,
  content: a
}) => {
  const { t: s } = T();
  return /* @__PURE__ */ f(It, { open: t, onClose: () => e(!1), children: [
    /* @__PURE__ */ u(
      qt,
      {
        title: n,
        subtitle: i,
        onClose: () => e(!1)
      }
    ),
    a && /* @__PURE__ */ u(St, { children: a }),
    /* @__PURE__ */ f(Or, { onClick: (l) => l.stopPropagation(), children: [
      /* @__PURE__ */ u(Q, { variant: "outlined", onClick: () => e(!1), children: r || s("CPQ:button.cancel") }),
      /* @__PURE__ */ u(Q, { variant: "contained", onClick: () => e(!0), children: o || s("CPQ:button.confirm") })
    ] })
  ] });
}, Ud = qn(Ed), bo = Tn(), Qd = vn(bo), kd = Bn(bo), jd = Qd(Ud);
var pe = /* @__PURE__ */ ((t) => (t.default = "default", t.number = "number", t.string = "string", t.double = "double", t))(pe || {});
const fo = J({
  dataTypes: {
    default: {
      id: "",
      identifier: "",
      rowVersion: 0
    },
    string: {
      id: "",
      identifier: "",
      rowVersion: 0
    },
    number: {
      id: "",
      identifier: "",
      rowVersion: 0
    },
    double: {
      id: "",
      identifier: "",
      rowVersion: 0
    }
  },
  dataTypesData: []
});
function $d(t) {
  const [e, r] = G(!1), { data: o, isFetching: n } = dd(
    void 0,
    {
      staleTime: 1 / 0
    }
  ), { mutateAsync: i, isPending: a } = Cd(), s = o == null ? void 0 : o.reduce(
    (l, c) => (l[c.identifier] = c, l),
    {}
  );
  if ($(() => {
    async function l() {
      r(!1);
      const c = o == null ? void 0 : o.reduce(
        (m, P) => (m[P.identifier] = P, m),
        {}
      );
      c != null && c[pe.string] || await i(
        {
          requestBody: {
            identifier: pe.string
          }
        },
        {
          onSuccess: () => {
            console.log("Datatype string created");
          }
        }
      ), c != null && c[pe.number] || await i(
        {
          requestBody: {
            identifier: pe.number
          }
        },
        {
          onSuccess: () => {
            console.log("Datatype number created");
          }
        }
      ), r(!0);
    }
    !n && o && l();
  }, [i, o, n]), n || a)
    return /* @__PURE__ */ u(be, {});
  if (!n && !a && e && o) {
    const l = o.reduce(
      (c, m) => (c[m.identifier] = m, c),
      {}
    );
    if (!l[pe.string])
      throw new Error("Datatype string not found");
    if (!l[pe.number])
      throw new Error("Datatype number not found");
  }
  if (!s || !o)
    throw new Error("DataTypes not found");
  return /* @__PURE__ */ u(fo.Provider, { value: { dataTypes: s, dataTypesData: o }, children: t.children });
}
const ho = J(void 0);
function zd({ children: t }) {
  const [e, r] = G(!1), [o, n] = G(null), i = (s) => {
    n(s), r(!0);
  }, a = () => {
    r(!1);
  };
  return /* @__PURE__ */ f(
    ho.Provider,
    {
      value: {
        openDrawer: i,
        closeDrawer: a,
        isOpen: e
      },
      children: [
        t,
        /* @__PURE__ */ u(Nt, { open: e, onClose: a, anchor: "right", children: /* @__PURE__ */ f(
          h,
          {
            display: "flex",
            flexDirection: "column",
            padding: 2,
            gap: 2,
            width: "45rem",
            children: [
              /* @__PURE__ */ u(h, { position: "absolute", top: "5px", right: "5px", children: /* @__PURE__ */ u(z, { onClick: a, children: /* @__PURE__ */ u(F, { children: "close" }) }) }),
              o
            ]
          }
        ) })
      ]
    }
  );
}
function Kd() {
  const t = X(ho);
  if (t === void 0)
    throw new Error("useDrawer must be used within a DrawerProvider");
  return t;
}
const Hd = {
  CPQ: {
    "opportunity.title": "Gelegenheit",
    "opportunity.heading": "Gelegenheit {{name}} {{id}}",
    "cart.title": "Warenkorb",
    "button.addQuote": "Angebot hinzufügen",
    "button.addLineItem": "Neue Position",
    "dialog.addLineItem.title": "Neue Position",
    "button.presets": "Voreinstellungen",
    "button.upload": "Hochladen",
    "button.archive": "Archivieren",
    "button.createOpportunity": "Gelegenheit erstellen",
    "button.cancel": "Abbrechen",
    "button.save": "Ok",
    "button.reset": "Zurücksetzen",
    "button.confirm": "Bestätigen",
    "button.inventoryDocumentation": "Bestandsdokumentation",
    "button.download": "Herunterladen",
    "button.start": "Starten",
    "button.logout": "Abmelden",
    "button.addCustomProduct": "Benutzerdefiniertes Produkt",
    "button.addProduct": "Produkt",
    "button.addFilter": "Filter hinzufügen",
    "button.delete": "Löschen",
    "select.language": "Sprache",
    "dialog.createOpportunity.subtitle": "Eine neue Gelegenheit erstellen",
    "dialog.updateOpportunity.title": "Gelegenheit bearbeiten",
    "dialog.updateOpportunity.subtitle": "Eine bestehende Gelegenheit anpassen",
    "button.footer.backToOverview": "Zurück zur Übersicht",
    "button.footer.saveAndExit": "Speichern und beenden",
    "footer.status.title": "Status",
    "button.footer.setStatusManually": "Status manuell setzen",
    "button.footer.generateDocument": "Dokument erstellen",
    "button.preview": "Vorschau",
    "button.footer.backToConfiguration": "Zurück zur Konfiguration",
    "button.addConfigurableProduct": "Konfigurierbares Produkt hinzufügen",
    "buttons.addConfigurationToItemGroupsButtonSelect.label": "Zum Angebot hinzufügen",
    "button.unarchiveOpportunity": "Wiederherstellen",
    "button.archiveOpportunity": "Archivieren",
    "button.addItemGroup": "Neue Gruppe",
    "button.updateItemGroup": "Bearbeiten",
    "dialog.createCustomer.title": "Kunden erstellen",
    "dialog.createCustomer.subtitle": "Einen neuen Kunden erstellen",
    "dialog.createCompany.title": "Firma erstellen",
    "dialog.createCompany.subtitle": "Eine neue Firma erstellen",
    "dialog.addLineItem.input.label.lineItemName": "Positionsname",
    "dialog.createOpportunity.input.label.opportunityName": "Name",
    "dialog.createOpportunity.input.label.customer": "Kunde",
    "dialog.createOpportunity.input.label.zipCode": "Postleitzahl",
    "dialog.createOpportunity.input.label.city": "Stadt",
    "dialog.createOpportunity.input.label.description": "Beschreibung",
    "dialog.createOpportunity.title": "Neue Gelegenheit",
    "dialog.createOpportunity.input.validFrom.label": "Gültig ab",
    "dialog.createOpportunity.input.validTo.label": "Gültig bis",
    "dialog.configuratorMode.title": "Neues Angebot erstellen",
    "dialog.configuratorMode.option.configurator.title": "Konfiguration",
    "dialog.configuratorMode.option.configurator.description": "Gesamtsystemkonfiguration",
    "dialog.configuratorMode.option.expressMode.title": "Expressmodus",
    "dialog.configuratorMode.option.expressMode.description": "Einzelartikelbestellung",
    "dialog.configuratorMode.description": "Wählen Sie Ihren bevorzugten Modus",
    "dialog.confirm.unarchiveQuote.title": "Angebot wiederherstellen",
    "dialog.confirm.unarchiveQuote.description": "Möchten Sie dieses Angebot wirklich wiederherstellen?",
    "dialog.confirm.archiveQuote.title": "Angebot archivieren",
    "dialog.confirm.archiveQuote.description": "Möchten Sie dieses Angebot wirklich archivieren?",
    "dialog.confirm.unarchiveOpportunity.title": "Gelegenheit wiederherstellen",
    "dialog.confirm.unarchiveOpportunity.description": "Möchten Sie diese Gelegenheit wirklich wiederherstellen?",
    "dialog.confirm.archiveOpportunity.title": "Gelegenheit archivieren",
    "dialog.confirm.archiveOpportunity.description": "Möchten Sie diese Gelegenheit wirklich archivieren?",
    "dialog.confirm.setOptional.title": "Optional festlegen",
    "dialog.confirm.unsetOptional.title": "Optional aufheben",
    "dialog.confirm.setOptional.subtitle": "Möchten Sie dieses Element wirklich als optional festlegen?",
    "dialog.confirm.unsetOptional.subtitle": "Möchten Sie dieses Element wirklich nicht mehr als optional festlegen?",
    "dialog.confirm.genericDelete.title": "Löschen",
    "dialog.confirm.genericDelete.subtitle": "Möchten Sie dieses Element wirklich löschen?",
    "dialog.addProducts.title.addProduct": "Produkte auswählen",
    "dialog.addItemGroup.title": "Neue Gruppe",
    "dialog.addItemGroup.input.label.itemGroupName": "Gruppenname",
    "dialog.updateItemGroup.title": "Gruppe bearbeiten",
    "dialog.updateItemGroup.input.label.itemGroupName": "Gruppenname",
    "dialog.updateLineItem.title": "Position bearbeiten",
    "dialog.updateLineItem.input.label.itemGroupName": "Positionsname",
    "dialog.updateDefault.title": "Bearbeiten",
    "dialog.updateDefault.input.label.name": "Name",
    "dialog.addCustomProduct.title": "Benutzerdefiniertes Produkt hinzufügen",
    "dialog.addCustomProduct.identifier": "Kennung",
    "dialog.addCustomProduct.partId": "Artikelnummer",
    "dialog.addCustomProduct.name": "Name",
    "dialog.addCustomProduct.description": "Beschreibung",
    "dialog.addCustomProduct.customer": "Kunde",
    "dialog.addCustomProduct.productTypeId": "Produkttyp",
    "dialog.addCustomProduct.productStateId": "Produktzustand",
    "dialog.addCustomProduct.isShared": "Gemeinsames Produkt",
    "dialog.addCustomProduct.isActive": "Aktiv",
    "breadcrumb.opportunities": "Gelegenheiten",
    "breadcrumb.quotes": "Angebote",
    "breadcrumb.itemGroups": "Gruppen",
    "breadcrumb.archive": "Archiv",
    "breadcrumb.configurator": "Konfigurator",
    "breadcrumb.expressMode": "Expressmodus",
    "breadcrumb.lineItems": "Positionen",
    "breadcrumb.overview": "Übersicht",
    "breadcrumb.catalog": "Katalog",
    "breadcrumb.salesQuotationView": "Verkaufsangebotansicht",
    "breadcrumb.summaryView": "Zusammenfassung",
    "breadcrumb.ManagementView": "Verwaltungsansicht",
    "breadcrumb.quoteInfo": "Angebotsinfo",
    "breadcrumb.texts": "Texte",
    "breadcrumb.documentGeneration": "Dokumentenerstellung",
    "header.opportunity": "Gelegenheit",
    "header.opportunities": "Gelegenheiten",
    "header.quoteDetails": "Angebot",
    "header.itemGroupDetails": "Gruppe",
    "header.archive": "Archiv",
    "header.configurator": "Konfigurator",
    "header.expressMode": "Expressmodus",
    "header.lineItemDetails": "Position",
    "header.presets": "Voreinstellungen",
    "dropZone.label": "Ziehen und Ablegen oder Durchsuchen",
    "dropZone.isDragActive.label": "Hier ablegen",
    "fileUpload.label": "Stockbilder",
    "filters.input.label.identifier": "Name",
    "filters.input.label.zipCode": "Postleitzahl",
    "filters.input.label.city": "Stadt",
    "filters.input.label.customer": "Kunde",
    "filters.input.label.status": "Status",
    "filters.input.label.search": "Suchen",
    "quote.property.label.uniqueNumberString": "Angebotsnummer",
    "quote.property.label.name": "Name",
    "quote.property.label.description": "Beschreibung",
    "quote.property.label.region": "Region",
    "quote.property.label.revision": "Revisionsnummer",
    "quote.property.label.createdBy": "Erstellt von",
    "quote.property.label.customer": "Kunde",
    "quote.property.label.lastUpdatedOn": "Zuletzt aktualisiert am",
    "quote.property.label.lastUpdatedBy": "Zuletzt aktualisiert von",
    "quote.property.label.status": "Status",
    "accordion.itemGroup.title": "Gruppe",
    "itemGroup.name": "Gruppenname",
    "table.actions.deleteRow": "Löschen",
    "table.lineItems.header.articleNumber": "Artikelnummer",
    "table.lineItems.header.partId": "Teilenummer",
    "table.lineItems.header.name": "Name",
    "table.lineItems.header.identifier": "Kennung",
    "table.lineItems.header.productIdentifier": "Produktkennung",
    "table.lineItems.header.description": "Beschreibung",
    "table.lineItems.header.quantity": "Menge",
    "table.lineItems.header.actions": "Aktionen",
    "table.lineItems.header.optional": "Optional",
    "table.lineItems.header.company": "Firma",
    "table.lineItems.actions.cloneRow": "Duplizieren",
    "table.lineItems.actions.deleteRow": "Löschen",
    "table.lineItems.actions.showBOM": "BOM anzeigen",
    "table.lineItems.actions.showSummary": "Summary anzeigen",
    "catalog.productTable.header.favorit": "Favorit",
    "catalog.productTable.header.preview": "Vorschau",
    "catalog.productTable.header.articleNumber": "Artikelnummer",
    "catalog.productTable.header.name": "Name",
    "catalog.productTable.header.description": "Beschreibung",
    "catalog.productTable.header.cost": "Kosten",
    "catalog.productTable.header.totalCost": "Gesamtkosten",
    "catalog.productTable.header.listPrice": "Listenpreis",
    "catalog.productTable.header.actions": "Menge",
    "catalog.productTable.header.createdByName": "Erstellt von",
    "catalog.productTable.header.createdOn": "Erstellt am",
    "catalog.productTable.header.lastUpdatedOn": "Zuletzt aktualisiert am",
    "catalog.productTable.header.lastUpdatedByName": "Zuletzt aktualisiert von",
    "catalog.productTable.buttons.addProductToGroup": "Hinzufügen",
    "catalog.productTable.buttons.addAllProductsToGroup": "Alle hinzufügen",
    "catalog.productTable.menu.addLineItemToNewGroup": "Neue Gruppe erstellen",
    "catalog.buttons.showLineItems": "Positionen anzeigen",
    "catalog.buttons.columnsSelection": "Spalten",
    "buttons.toggleSideView.label": "Seitenansicht",
    "product.types.tooltip.Configurable": "Konfigurierbar",
    "product.types.tooltip.NonConfigurable": "Nicht konfigurierbar",
    "product.types.tooltip.PreConfigured": "Vorkonfiguriert",
    "product.types.tooltip.configurationStatus.toConfigure": "Zu konfigurieren",
    "product.types.tooltip.configurationStatus.complete": "Konfiguration abgeschlossen",
    "product.types.tooltip.configurationStatus.incomplete": "Konfiguration unvollständig",
    "product.status.text.toConfigure": "Konfigurieren",
    "product.status.text.complete": "Konfiguriert",
    "product.status.text.incomplete": "Bearbeiten",
    "productsTable.tree.filter": "Filter",
    "productsTable.tree.categoriesToggleText": "Kategorien",
    "relatedProducts.title": "Verwandte Produkte",
    "relatedProducts.noProducts": "Keine Produkte",
    "alternativeProducts.title": "Alternative Produkte",
    "table.itemGroups.title": "Projekt",
    "table.itemGroups.header.rank": "Rang",
    "table.itemGroups.header.moveRow": "Zeile verschieben",
    "table.itemGroups.header.name": "Name",
    "table.itemGroups.header.description": "Beschreibung",
    "table.itemGroups.header.partId": "Part ID",
    "table.itemGroups.header.managingEntity": "Verwaltende Einheit (ME)",
    "table.itemGroups.header.priceList": "Preisliste",
    "table.itemGroups.header.supportingEntity": "Unterstützende Einheit (SE)",
    "table.itemGroups.header.qty": "Menge",
    "table.itemGroups.header.itemCost": "Artikelkosten",
    "table.itemGroups.header.costListPricing": "Cost+/List-Preise",
    "table.itemGroups.header.markup": "Aufschlag",
    "table.itemGroups.header.markupPercentage": "Kostenaufschlag (%)",
    "table.itemGroups.header.itemList": "Artikelliste",
    "table.itemGroups.header.totalList": "Gesamtliste",
    "table.itemGroups.header.discount": "Rabatt",
    "table.itemGroups.header.discount2": "Rabatt 2",
    "table.itemGroups.header.discount3": "Rabatt 3",
    "table.itemGroups.header.discount4": "Rabatt 4",
    "table.itemGroups.header.totalDiscount": "Gesamtrabatt",
    "table.itemGroups.input.label.markup": "Aufschlag",
    "table.itemGroups.input.label.discount": "Rabatt",
    "table.itemGroups.input.label.discount2": "Rabatt 2",
    "table.itemGroups.input.label.discount3": "Rabatt 3",
    "table.itemGroups.input.label.discount4": "Rabatt 4",
    "table.itemGroups.input.label.markupPercentage": "Aufschlag (%)",
    "table.itemGroups.input.label.discountPercentage": "Rabatt (%)",
    "table.itemGroups.input.label.discount2Percentage": "Rabatt 2 (%)",
    "table.itemGroups.input.label.discount3Percentage": "Rabatt 3 (%)",
    "table.itemGroups.input.label.discount4Percentage": "Rabatt 4 (%)",
    //TODO[sh]: Remove if BE discount fields are changed to discount 1, discount 2, etc
    "table.itemGroups.input.label.serviceDiscountPercentage": "Rabatt 2 (%)",
    "table.itemGroups.input.label.bonusDiscountPercentage": "Rabatt 3 (%)",
    "table.itemGroups.input.label.projectDiscountPercentage": "Rabatt 4 (%)",
    "table.itemGroups.header.discountPercentage": "Rabatt (%)",
    "table.itemGroups.header.discount2Percentage": "Rabatt 2 (%)",
    "table.itemGroups.header.discount3Percentage": "Rabatt 3 (%)",
    "table.itemGroups.header.discount4Percentage": "Rabatt 4 (%)",
    "table.itemGroups.header.totalDiscountPercentage": "Gesamtrabatt (%)",
    "table.itemGroups.header.totalNet": "Gesamtnetto",
    "table.itemGroups.header.margin": "Bruttomarge",
    "table.itemGroups.header.cost": "Kosten",
    "table.itemGroups.header.actions": "Aktionen",
    "table.itemGroups.header.totalCost": "Gesamtkosten",
    "table.itemGroups.header.listPrice": "Listenpreis",
    "table.itemGroupsOptional.title": "Optional",
    "categories.sharedProducts": "Geteilte Produkte",
    "categories.customProducts": "Benutzerdefinierte Produkte",
    "catalog.productTable.buttons.addProductToLineItem": "Zur Position hinzufügen",
    "catalog.productTable.buttons.addAllProductsToLineItem": "Alle zu Position hinzufügen",
    "catalog.productTable.buttons.addProductsToQuote": "Zum Angebot hinzufügen",
    "catalog.productTable.buttons.addAllProductsToQuote": "Alle zum Angebot hinzufügen",
    "quote.buttons.exportToExcel": "Exportieren",
    "catalog.selectACategoryFirst": "Zuerst eine Kategorie auswählen",
    "button.import": "Importieren",
    "dialog.importExcel.title": "Excel importieren",
    "dialog.createQuote.title": "Angebot erstellen",
    "dialog.createQuote.subtitle": "Ein neues Angebot erstellen",
    "dialog.createQuote.input.label.name": "Name",
    "dialog.createQuote.input.label.description": "Beschreibung",
    "dialog.createQuote.input.label.region": "Region",
    "dialog.createQuote.input.label.customer": "Kunde",
    "dialog.updateQuote.title": "Angebot bearbeiten",
    "dialog.updateQuote.subtitle": "Ein bestehendes Angebot anpassen",
    "button.uploadGeneric.placeholder": "Datei hochladen",
    "checkbox.import.label.override": "Hier klicken, um bestehende Einträge zu überschreiben",
    priceListSelectLabel: "Preisliste",
    currencySelectLabel: "Währung",
    "button.goBackToOpportunities": "Zurück zu Gelegenheiten",
    "button.goBackToOpportunity": "Zurück zur Gelegenheit",
    "button.goBackToQuote": "Zurück zum Angebot",
    "button.createQuote": "Angebot erstellen",
    "item.property.label.note": "Kundenposition / Anlagenposition",
    "item.property.label.listPrice": "Listenpreis",
    "item.property.label.totalList": "Gesamtlistenpreis",
    "item.property.label.discount": "Rabatt",
    "item.property.label.totalDiscount": "Gesamtrabatt",
    "item.property.label.totalCost": "Gesamtkosten",
    "item.property.label.totalNet": "Gesamtnettopreis",
    "item.property.label.status": "Status",
    "item.property.label.name": "Name",
    "item.property.label.partId": "Artikelnummer",
    "item.property.label.description": "Beschreibung",
    "item.property.label.quantity": "Menge",
    "subItem.property.label.totalList": "Liste",
    "subItem.property.label.totalCost": "Kosten",
    "subItem.property.label.totalNet": "Netto",
    "lineItems.bom.label": "Stückliste",
    "priceSummary.totalCost": "Gesamtkosten",
    "priceSummary.totalList": "Gesamtliste",
    "priceSummary.totalNet": "Gesamtnetto",
    "dialog.requestQuote.title": "Anfrage senden",
    "select.topBottom.option.label.top": "List",
    "select.topBottom.option.label.bottom": "Cost+",
    "priceList.select.confirm.title": "Möchten Sie fortfahren?",
    "priceList.select.confirm.subtitle": "Das Ändern der Preisliste auf dieser Ebene überschreibt alle Preislisten auf unteren Ebenen.",
    "toast.error.unknown": "Ein Fehler ist aufgetreten",
    "toast.success.groupCreated": "Gruppe wurde erstellt",
    "toast.success.itemWasAddedToQuote": "Item wurde zum Angebot hinzugefügt",
    "toast.success.groupWithItemsCreated": "Gruppe wurde erstellt und Items hinzugefügt",
    "toast.success.itemWasAddedToCart": "Zum Warenkorb hinzugefügt",
    "form.field.label.customerNumber": "Kundennummer",
    "form.field.label.companyName": "Firmenname",
    "form.field.label.company": "Firma",
    "form.field.label.name": "Name",
    "form.field.label.contactSalutation": "Anrede",
    "form.field.label.contactTitle": "Titel",
    "form.field.label.contactFirstName": "Vorname",
    "form.field.label.contactLastName": "Nachname",
    "form.field.label.street": "Straße",
    "form.field.label.streetNumber": "Nummer",
    "form.field.label.postalCode": "Postleitzahl",
    "form.field.label.town": "Stadt",
    "form.field.label.country": "Land",
    "form.field.label.emailAddress": "E-Mail",
    "form.field.label.phoneNumber": "Telefon",
    "form.field.label.mobileNumber": "Mobil",
    "form.field.label.companyId": "Firma",
    "form.field.label.description": "Beschreibung",
    "form.field.error.email": "E-Mail-Adresse ist ungültig",
    "quoteInfo.buttons.addNewCustomer": "Neuen Kunden hinzufügen",
    "quoteInfo.buttons.addNewCompany": "Neue Firma hinzufügen",
    "quoteInfo.buttons.addNewSalesLocation": "Vertrieb hinzufügen",
    "quoteInfo.buttons.assignSalesLocation": "Zuweisen",
    "quoteInfo.buttons.assignCustomer": "Kunde zuweisen",
    "quoteInfo.buttons.save": "Speichern",
    "quoteInfo.general.header": "Allgemeine Informationen",
    "quoteInfo.general.quoteId": "Angebots-ID",
    "quoteInfo.general.quote.uniqueNumberString": "Angebotsnummer",
    "quoteInfo.general.opportunity.uniqueNumberString": "Gelegenheitsnummer",
    "quoteInfo.general.currency": "Währung",
    "quoteInfo.general.createdByName": "Erstellt von",
    "quoteInfo.general.quoteCreationDate": "Erstellungsdatum des Angebots",
    "quoteInfo.general.lastUpdatedByName": "Zuletzt aktualisiert von",
    "quoteInfo.general.lastUpdatedOn": "Zuletzt aktualisiert am",
    "quoteInfo.salesLocation.header": "Vertrieb",
    "quoteInfo.customer.header": "Kunde",
    "quoteInfo.customer.customerNumber": "Kundennummer",
    "quoteInfo.customer.companyName": "Firmenname",
    "quoteInfo.customer.contactSalutation": "Anrede",
    "quoteInfo.customer.contactFirstName": "Vorname",
    "quoteInfo.customer.contactLastName": "Nachname",
    "quoteInfo.customer.contactTitle": "Titel",
    "quoteInfo.customer.street": "Straße",
    "quoteInfo.customer.streetNumber": "Straßennummer",
    "quoteInfo.customer.postalCode": "Postleitzahl",
    "quoteInfo.customer.town": "Stadt",
    "quoteInfo.customer.country": "Land",
    "quoteInfo.customer.emailAddress": "E-Mail",
    "quoteInfo.customer.phoneNumber": "Telefonnummer",
    "quoteInfo.customer.mobileNumber": "Mobilnummer",
    "dialog.createSalesLocation.title": "Vertrieb erstellen",
    "dialog.createSalesLocation.subtitle": "Einen neuen Vertrieb erstellen",
    "quoteInfo.customer.salesLocations.header": "Vertrieb",
    "quoteInfo.customer.salesLocations.salesLocationName": "Name des Verkaufsstandorts",
    "quoteInfo.customer.salesLocations.contactTitle": "Titel",
    "quoteInfo.customer.salesLocations.contactSalutation": "Anrede",
    "quoteInfo.customer.salesLocations.contactFirstName": "Vorname",
    "quoteInfo.customer.salesLocations.contactLastName": "Nachname",
    "quoteInfo.customer.salesLocations.street": "Straße",
    "quoteInfo.customer.salesLocations.streetNumber": "Straßennummer",
    "quoteInfo.customer.salesLocations.postalCode": "Postleitzahl",
    "quoteInfo.customer.salesLocations.town": "Stadt",
    "quoteInfo.customer.salesLocations.country": "Land",
    "quoteInfo.customer.salesLocations.emailAddress": "E-Mail",
    "quoteInfo.customer.salesLocations.phoneNumber": "Telefonnummer",
    "quoteInfo.customer.salesLocations.mobileNumber": "Mobilnummer",
    "dialog.addCustomProduct.priceCost.value": "Wert",
    "dialog.addCustomProduct.priceCost.validFrom": "Gültig von",
    "dialog.addCustomProduct.priceCost.validTo": "Gültig bis",
    "dialog.addCustomProduct.price": "Preis",
    "dialog.addCustomProduct.cost": "Kosten",
    "productDetails.partId": "Artikelnummer",
    "productDetails.listPrice": "Listenpreis",
    "productDetails.cost": "Kosten",
    "searchField.label": "Suchen",
    "SERVER_ERROR.DISCOUNT_EXCEEDS_LIMIT": "Rabatt überschreitet das Limit",
    "SERVER_ERROR.PRODUCT_IS_IN_USE": "Produkt wird verwendet und kann nicht gelöscht werden",
    "filter.filterAttributeInput.label": "Attribut",
    "filter.filterOperatorInput.label": "Operator",
    "filter.filterValueInput.label": "Wert",
    "filter.button.applyFilter": "Anwenden",
    "filter.button.clearAllFilter": "Alle löschen",
    "toast.error.filterAlreadyPresent": "Filter ist bereits vorhanden",
    "selectionBanner.text": "{{selectedProducts}} Produkte ausgewählt",
    "selectionBanner.clearSelection.text": "Auswahl löschen",
    "cart.label.emptyCart": "Ihr Warenkorb ist leer",
    "cart.button.addConfiguration": "Konfiguration hinzufügen",
    "cart.button.addArticle": "Artikel hinzufügen",
    "cart.button.saveShoppingCart": "Save shopping cart",
    "cart.button.printShoppingCart": "Print shopping cart",
    "cart.button.import": "Import",
    "cart.button.export": "Export",
    "cart.summary.subtotal.label": "Zwischensumme",
    "cart.summary.totalNet.label": "Gesamtnetto",
    "cart.summary.button.requestQuote": "Angebot anfordern",
    "cart.summary.button.proceedToCheckout": "Weiter zur Kasse",
    "quotes.table.uniqueNumberString": "Bezeichner",
    "quotes.table.name": "Name",
    "quotes.table.lastUpdatedOn": "Zuletzt aktualisiert",
    "quotes.table.creationDate": "Erstellungsdatum",
    "quotes.table.status": "Status",
    "quotes.table.toolbar.search": "Suchen",
    "quotes.table.toolbar.filters.status": "Status",
    "infotext.userNotLoggedIn": "Nicht eingeloggt",
    "iconButton.download": "Download",
    "iconButton.clone": "Duplizieren",
    "iconButton.delete": "Löschen",
    "buttons.save": "Speichern",
    "buttons.reset": "Zurücksetzen",
    "drawer.showBOM.title": "Stückliste",
    "drawer.showSummary.title": "Summary",
    "workflowSelect.title": "Bitte wählen Sie einen Workflow",
    "workflowSelect.customer.title": "Kunde",
    "workflowSelect.customer.subTitle": "Ein optimierter Arbeitsablauf zum Durchsuchen und Kaufen von Produkten.",
    "workflowSelect.sales.title": "Vertrieb",
    "workflowSelect.sales.subTitle": "Konfigurieren, bepreisen und offerieren Sie mit einem integrierten Katalog, der auf Verkäufer zugeschnitten ist.",
    "workflowSelect.projectList.title": "Projektliste",
    "workflowSelect.projectList.subTitle": "Verwalten Sie Artikel und Projekte effizient mit einer umfassenden Listenansicht.",
    "moveRowMenu.options.topPosition": "Obere Position",
    "opportunities.quotesTable.header.name": "Name",
    "opportunities.quotesTable.header.description": "Beschreibung",
    "opportunities.quotesTable.header.customer": "Kunde",
    "opportunities.quotesTable.header.quoteNumber": "Angebotsnummer",
    "opportunities.quotesTable.header.createdByName": "Erstellt von",
    "opportunities.quotesTable.header.lastUpdatedByName": "Zuletzt aktualisiert von",
    "opportunities.quotesTable.header.lastUpdatedOn": "Zuletzt aktualisiert am",
    "opportunities.quotesTable.header.status": "Status",
    "outputOptionsSelection.checkbox.includeLongText.label": "Enthält lange Texte",
    "outputOptionsSelection.checkbox.includePartId.label": "Enthält Artikelnummern",
    "outputOptionsSelection.checkbox.includePrices.label": "Enthält Preise",
    "outputOptionsSelection.checkbox.includeDiscounts.label": "Enthält Rabatte"
  }
}, _d = {
  CPQ: {
    "opportunity.title": "Opportunity",
    "opportunity.heading": "Opportunity {{name}} {{id}}",
    "cart.title": "Cart",
    "button.addQuote": "Add quote",
    "button.addLineItem": "New line item",
    "dialog.addLineItem.title": "New line item",
    "button.presets": "Presets",
    "button.upload": "Upload",
    "button.archive": "Archiv",
    "button.createOpportunity": "Create opportunity",
    "button.cancel": "Cancel",
    "button.save": "Ok",
    "button.reset": "Reset",
    "button.confirm": "Ok",
    "button.goToCatalog": "Go to catalog",
    "button.inventoryDocumentation": "Inventory documentation",
    "button.download": "Download",
    "button.start": "Start",
    "button.logout": "Logout",
    "button.addCustomProduct": "Custom product",
    "button.addProduct": "Product",
    "button.addFilter": "Add filter",
    "button.delete": "Delete",
    "select.language": "Language",
    "dialog.createOpportunity.subtitle": "Create a new opportunity",
    "dialog.updateOpportunity.title": "Edit opportunity",
    "dialog.updateOpportunity.subtitle": "Adjust an existing opportunity",
    "button.footer.backToOverview": "Back to overview",
    "button.footer.saveAndExit": "Save and exit",
    "footer.status.title": "Status",
    "button.footer.setStatusManually": "Set status manually",
    "button.footer.generateDocument": "Generate document",
    "button.preview": "Preview",
    "button.footer.backToConfiguration": "Back to configuration",
    "button.addConfigurableProduct": "Add configurable product",
    "buttons.addConfigurationToItemGroupsButtonSelect.label": "Add to quote",
    "button.unarchiveOpportunity": "restore",
    "button.archiveOpportunity": "archive",
    "button.addItemGroup": "New group",
    "button.updateItemGroup": "Edit",
    "dialog.createCustomer.title": "Create customer",
    "dialog.createCustomer.subtitle": "Create a new customer",
    "dialog.createCompany.title": "Create company",
    "dialog.createCompany.subtitle": "Create a new company",
    "dialog.addLineItem.input.label.lineItemName": "Line item name",
    "dialog.createOpportunity.input.label.opportunityName": "Name",
    "dialog.createOpportunity.input.label.customer": "Customer",
    "dialog.createOpportunity.input.label.zipCode": "Zip code",
    "dialog.createOpportunity.input.label.city": "City",
    "dialog.createOpportunity.input.label.description": "Description",
    "dialog.createOpportunity.title": "New Opportunity",
    "dialog.createOpportunity.input.validFrom.label": "Valid from",
    "dialog.createOpportunity.input.validTo.label": "Valid to",
    "dialog.configuratorMode.title": "Create new quote",
    "dialog.configuratorMode.option.configurator.title": "Configuration",
    "dialog.configuratorMode.option.configurator.description": "Overall system configuration",
    "dialog.configuratorMode.option.expressMode.title": "Express Mode",
    "dialog.configuratorMode.option.expressMode.description": "Single item order",
    "dialog.configuratorMode.description": "Choose your preferred mode",
    "dialog.confirm.unarchiveQuote.title": "Restore quote",
    "dialog.confirm.unarchiveQuote.description": "Do you really want to restore this quote?",
    "dialog.confirm.archiveQuote.title": "Archive quote",
    "dialog.confirm.archiveQuote.description": "Do you really want to archive this quote?",
    "dialog.confirm.unarchiveOpportunity.title": "Restore opportunity",
    "dialog.confirm.unarchiveOpportunity.description": "Do you really want to restore this opportunity?",
    "dialog.confirm.archiveOpportunity.title": "Archive opportunity",
    "dialog.confirm.archiveOpportunity.description": "Do you really want to archive this opportunity?",
    "dialog.confirm.setOptional.title": "Set optional",
    "dialog.confirm.unsetOptional.title": "Unset optional",
    "dialog.confirm.setOptional.subtitle": "Do you really want to set this item as optional?",
    "dialog.confirm.unsetOptional.subtitle": "Do you really want to unset this item as optional?",
    "dialog.confirm.genericDelete.title": "Delete",
    "dialog.confirm.genericDelete.subtitle": "Do you really want to delete this item?",
    "dialog.addProducts.title.addProduct": "Select products",
    "dialog.addItemGroup.title": "New group",
    "dialog.addItemGroup.input.label.itemGroupName": "Group name",
    "dialog.updateItemGroup.title": "Edit group",
    "dialog.updateItemGroup.input.label.itemGroupName": "Group name",
    "dialog.updateLineItem.title": "Edit line item",
    "dialog.updateLineItem.input.label.itemGroupName": "Line item name",
    "dialog.updateDefault.title": "Edit",
    "dialog.updateDefault.input.label.name": "Name",
    "dialog.addCustomProduct.title": "Add custom product",
    "dialog.addCustomProduct.identifier": "Identifier",
    "dialog.addCustomProduct.partId": "Article number",
    "dialog.addCustomProduct.name": "Name",
    "dialog.addCustomProduct.description": "Description",
    "dialog.addCustomProduct.customer": "Customer",
    "dialog.addCustomProduct.productTypeId": "Product Type",
    "dialog.addCustomProduct.productStateId": "Product State",
    "dialog.addCustomProduct.isShared": "Shared product",
    "dialog.addCustomProduct.isActive": "Active",
    "breadcrumb.opportunities": "Opportunities",
    "breadcrumb.quotes": "Quotes",
    "breadcrumb.itemGroups": "Item Groups",
    "breadcrumb.archive": "Archive",
    "breadcrumb.configurator": "Configurator",
    "breadcrumb.expressMode": "Express mode",
    "breadcrumb.lineItems": "Line item",
    "breadcrumb.overview": "Overview",
    "breadcrumb.catalog": "Catalog",
    "breadcrumb.salesQuotationView": "Sales quotation view",
    "breadcrumb.summaryView": "Summary view",
    "breadcrumb.ManagementView": "Management view",
    "breadcrumb.quoteInfo": "Quote info",
    "breadcrumb.texts": "Texts",
    "breadcrumb.documentGeneration": "Document generation",
    "header.opportunity": "Opportunity",
    "header.opportunities": "Opportunities",
    "header.quoteDetails": "Quote",
    "header.itemGroupDetails": "Item Group",
    "header.archive": "Archive",
    "header.configurator": "Configurator",
    "header.expressMode": "Express mode",
    "header.lineItemDetails": "Line item",
    "header.presets": "Presets",
    "dropZone.label": "Drag & drop or browse",
    "dropZone.isDragActive.label": "Drop here",
    "fileUpload.label": "Stock images",
    "filters.input.label.identifier": "Name",
    "filters.input.label.zipCode": "Zip code",
    "filters.input.label.city": "City",
    "filters.input.label.customer": "Customer",
    "filters.input.label.status": "Status",
    "filters.input.label.search": "Search",
    "quote.property.label.uniqueNumberString": "Quote number",
    "quote.property.label.name": "Name",
    "quote.property.label.description": "Description",
    "quote.property.label.region": "Region",
    "quote.property.label.revision": "Revision number",
    "quote.property.label.createdBy": "Created by",
    "quote.property.label.customer": "Customer",
    "quote.property.label.lastUpdatedOn": "Last updated on",
    "quote.property.label.lastUpdatedBy": "Last updated by",
    "quote.property.label.status": "Status",
    "accordion.itemGroup.title": "Group",
    "itemGroup.name": "Group Name",
    "table.actions.deleteRow": "Delete",
    "table.lineItems.header.articleNumber": "Article number",
    "table.lineItems.header.partId": "Part ID",
    "table.lineItems.header.name": "Name",
    "table.lineItems.header.identifier": "Identifier",
    "table.lineItems.header.productIdentifier": "Product identifier",
    "table.lineItems.header.description": "Description",
    "table.lineItems.header.quantity": "Quantity",
    "table.lineItems.header.actions": "Actions",
    "table.lineItems.header.optional": "Optional",
    "table.lineItems.header.company": "Company",
    "table.lineItems.actions.cloneRow": "Duplicate",
    "table.lineItems.actions.deleteRow": "Delete",
    "table.lineItems.actions.showBOM": "Show BOM",
    "table.lineItems.actions.showSummary": "Show Summary",
    "catalog.productTable.header.favorit": "Favorit",
    "catalog.productTable.header.preview": "Preview",
    "catalog.productTable.header.articleNumber": "Article number",
    "catalog.productTable.header.name": "Name",
    "catalog.productTable.header.description": "Description",
    "catalog.productTable.header.cost": "cost",
    "catalog.productTable.header.totalCost": "Total cost",
    "catalog.productTable.header.listPrice": "List price",
    "catalog.productTable.header.actions": "Quantity",
    "catalog.productTable.header.createdByName": "Created by",
    "catalog.productTable.header.createdOn": "Created On",
    "catalog.productTable.header.lastUpdatedOn": "Last updated on",
    "catalog.productTable.header.lastUpdatedByName": "Last updated by",
    "catalog.productTable.buttons.addProductToGroup": "Add",
    "catalog.productTable.buttons.addAllProductsToGroup": "Add all",
    "catalog.productTable.menu.addLineItemToNewGroup": "Create new group",
    "catalog.buttons.showLineItems": "Show line items",
    "catalog.buttons.columnsSelection": "Columns",
    "buttons.toggleSideView.label": "Sideview",
    "product.types.tooltip.Configurable": "Configurable",
    "product.types.tooltip.NonConfigurable": "Non configurable",
    "product.types.tooltip.PreConfigured": "Preconfigured",
    "product.types.tooltip.configurationStatus.toConfigure": "To be configured",
    "product.types.tooltip.configurationStatus.complete": "Configuration is complete",
    "product.types.tooltip.configurationStatus.incomplete": "Configuration is incomplete",
    "product.status.text.toConfigure": "Configure",
    "product.status.text.complete": "Configured",
    "product.status.text.incomplete": "Edit",
    "productsTable.tree.filter": "Filter",
    "productsTable.tree.categoriesToggleText": "Categories",
    "relatedProducts.title": "Related products",
    "relatedProducts.noProducts": "No products",
    "alternativeProducts.title": "Alternative products",
    "table.itemGroups.title": "Project",
    "table.itemGroups.header.rank": "Rank",
    "table.itemGroups.header.moveRow": "Move row",
    "table.itemGroups.header.name": "Name",
    "table.itemGroups.header.description": "Description",
    "table.itemGroups.header.partId": "Part ID",
    "table.itemGroups.header.managingEntity": "Managing entity (ME)",
    "table.itemGroups.header.priceList": "Price list",
    "table.itemGroups.header.supportingEntity": "Supporting entity (SE)",
    "table.itemGroups.header.qty": "Quantity",
    "table.itemGroups.header.itemCost": "Item cost",
    "table.itemGroups.header.costListPricing": "Cost+/List-pricing",
    "table.itemGroups.header.markup": "Markup",
    "table.itemGroups.header.markupPercentage": "Cost Markup (%)",
    "table.itemGroups.header.itemList": "Item list",
    "table.itemGroups.header.totalList": "Total List",
    "table.itemGroups.header.discount": "Discount",
    "table.itemGroups.header.discount2": "Discount 2",
    "table.itemGroups.header.discount3": "Discount 3",
    "table.itemGroups.header.discount4": "Discount 4",
    "table.itemGroups.header.totalDiscount": "Total discount",
    "table.itemGroups.input.label.markup": "Markup",
    "table.itemGroups.input.label.discount": "Discount",
    "table.itemGroups.input.label.discount2": "Discount 2",
    "table.itemGroups.input.label.discount3": "Discount 3",
    "table.itemGroups.input.label.discount4": "Discount 4",
    "table.itemGroups.input.label.markupPercentage": "Cost Markup (%)",
    "table.itemGroups.input.label.discountPercentage": "Discount (%)",
    "table.itemGroups.input.label.discount2Percentage": "Discount 2 (%)",
    "table.itemGroups.input.label.discount3Percentage": "Discount 3 (%)",
    "table.itemGroups.input.label.discount4Percentage": "Discount 4 (%)",
    //TODO[sh]: Remove if BE discount fields are changed to discount 1, discount 2, etc
    "table.itemGroups.input.label.serviceDiscountPercentage": "Discount 2 (%)",
    "table.itemGroups.input.label.bonusDiscountPercentage": "Discount 3 (%)",
    "table.itemGroups.input.label.projectDiscountPercentage": "Discount 4 (%)",
    "table.itemGroups.header.discountPercentage": "Discount (%)",
    "table.itemGroups.header.discount2Percentage": "Discount 2 (%)",
    "table.itemGroups.header.discount3Percentage": "Discount 3 (%)",
    "table.itemGroups.header.discount4Percentage": "Discount 4 (%)",
    "table.itemGroups.header.totalDiscountPercentage": "Total discount (%)",
    "table.itemGroups.header.totalNet": "Total Net",
    "table.itemGroups.header.margin": "Gross Margin",
    "table.itemGroups.header.cost": "Cost",
    "table.itemGroups.header.actions": "Actions",
    "table.itemGroups.header.totalCost": "Total cost",
    "table.itemGroups.header.listPrice": "List price",
    "table.itemGroupsOptional.title": "Optional",
    "categories.sharedProducts": "Shared products",
    "categories.customProducts": "Custom products",
    "catalog.productTable.buttons.addProductToLineItem": "Add to Line Item",
    "catalog.productTable.buttons.addAllProductsToLineItem": "Add all to Line Item",
    "catalog.productTable.buttons.addProductsToQuote": "Add to Quote",
    "catalog.productTable.buttons.addAllProductsToQuote": "Add all to Quote",
    "quote.buttons.exportToExcel": "Export",
    "catalog.selectACategoryFirst": "Select a category first",
    "button.import": "Import",
    "dialog.importExcel.title": "Import Excel",
    "dialog.createQuote.title": "Create quote",
    "dialog.createQuote.subtitle": "Create a new quote",
    "dialog.createQuote.input.label.name": "Name",
    "dialog.createQuote.input.label.description": "Description",
    "dialog.createQuote.input.label.region": "Region",
    "dialog.createQuote.input.label.customer": "Customer",
    "dialog.updateQuote.title": "Edit quote",
    "dialog.updateQuote.subtitle": "Adjust an existing quote",
    "button.uploadGeneric.placeholder": "Upload file",
    "checkbox.import.label.override": "Check here to override existing entries",
    priceListSelectLabel: "Price list",
    currencySelectLabel: "Currency",
    "button.goBackToOpportunities": "Back to opportunities",
    "button.goBackToOpportunity": "Back to opportunity",
    "button.goBackToQuote": "Back to quote",
    "button.createQuote": "Create quote",
    "item.property.label.note": "Customer position / asset position",
    "item.property.label.listPrice": "List price",
    "item.property.label.totalList": "Total list price",
    "item.property.label.discount": "Discount",
    "item.property.label.totalDiscount": "Total discount",
    "item.property.label.totalCost": "Total cost",
    "item.property.label.totalNet": "Total net price",
    "item.property.label.status": "Status",
    "item.property.label.name": "Name",
    "item.property.label.partId": "Article number",
    "item.property.label.description": "Description",
    "item.property.label.quantity": "Quantity",
    "subItem.property.label.totalList": "List",
    "subItem.property.label.totalCost": "Cost",
    "subItem.property.label.totalNet": "Net",
    "lineItems.bom.label": "Bill of materials",
    "priceSummary.totalCost": "Total cost",
    "priceSummary.totalList": "Total list",
    "priceSummary.totalNet": "Total net",
    "dialog.requestQuote.title": "Send request",
    "select.topBottom.option.label.top": "List",
    "select.topBottom.option.label.bottom": "Cost+",
    "priceList.select.confirm.title": "Do you want to proceed?",
    "priceList.select.confirm.subtitle": "Changing the price list at this level will overwrite all price lists at lower levels.",
    "toast.error.unknown": "An error occurred",
    "toast.success.itemWasAddedToQuote": "Item was added to quote",
    "toast.success.groupCreated": "The group was created",
    "toast.success.groupWithItemsCreated": "The group was created and Items were added",
    "toast.success.itemWasAddedToCart": "Item was added to the cart",
    "form.field.label.customerNumber": "Customer Number",
    "form.field.label.companyName": "Company Name",
    "form.field.label.company": "Company",
    "form.field.label.name": "Name",
    "form.field.label.contactSalutation": "Salutation",
    "form.field.label.contactTitle": "Title",
    "form.field.label.contactFirstName": "Name",
    "form.field.label.contactLastName": "Last Name",
    "form.field.label.street": "Street",
    "form.field.label.streetNumber": "Number",
    "form.field.label.postalCode": "Postal Code",
    "form.field.label.town": "Town",
    "form.field.label.country": "Country",
    "form.field.label.emailAddress": "Email",
    "form.field.label.phoneNumber": "Phone",
    "form.field.label.mobileNumber": "Mobile",
    "form.field.label.companyId": "Company",
    "form.field.label.description": "Description",
    "form.field.error.email": "Email address is not valid",
    "quoteInfo.buttons.addNewCustomer": "Add new customer",
    "quoteInfo.buttons.addNewCompany": "Add new company",
    "quoteInfo.buttons.addNewSalesLocation": "Add new sales",
    "quoteInfo.buttons.assignSalesLocation": "Assign",
    "quoteInfo.buttons.assignCustomer": "Assign customer",
    "quoteInfo.buttons.save": "Assign customer",
    "quoteInfo.general.header": "General information",
    "quoteInfo.general.quoteId": "Quote id",
    "quoteInfo.general.quote.uniqueNumberString": "Quote number",
    "quoteInfo.general.opportunity.uniqueNumberString": "Opportunity number",
    "quoteInfo.general.currency": "Currency",
    "quoteInfo.general.createdByName": "Created by",
    "quoteInfo.general.quoteCreationDate": "Quote creation date",
    "quoteInfo.general.lastUpdatedByName": "Last updated by",
    "quoteInfo.general.lastUpdatedOn": "Last updated on",
    "quoteInfo.salesLocation.header": "Sales",
    "quoteInfo.customer.header": "Customer",
    "quoteInfo.customer.customerNumber": "Customer number",
    "quoteInfo.customer.companyName": "Company name",
    "quoteInfo.customer.contactSalutation": "Salutation",
    "quoteInfo.customer.contactFirstName": "First name",
    "quoteInfo.customer.contactLastName": "Last name",
    "quoteInfo.customer.contactTitle": "Title",
    "quoteInfo.customer.street": "Street",
    "quoteInfo.customer.streetNumber": "Street number",
    "quoteInfo.customer.postalCode": "Postal code",
    "quoteInfo.customer.town": "Town",
    "quoteInfo.customer.country": "Country",
    "quoteInfo.customer.emailAddress": "Email",
    "quoteInfo.customer.phoneNumber": "Phone number",
    "quoteInfo.customer.mobileNumber": "Mobile number",
    "dialog.createSalesLocation.title": "Create sales location",
    "dialog.createSalesLocation.subtitle": "Create a new sales location",
    "quoteInfo.customer.salesLocations.header": "Sales",
    "quoteInfo.customer.salesLocations.salesLocationName": "Sales locations name",
    "quoteInfo.customer.salesLocations.contactTitle": "Title",
    "quoteInfo.customer.salesLocations.contactSalutation": "Salutation",
    "quoteInfo.customer.salesLocations.contactFirstName": "First name",
    "quoteInfo.customer.salesLocations.contactLastName": "Last name",
    "quoteInfo.customer.salesLocations.street": "Street",
    "quoteInfo.customer.salesLocations.streetNumber": "Street number",
    "quoteInfo.customer.salesLocations.postalCode": "Postal code",
    "quoteInfo.customer.salesLocations.town": "Town",
    "quoteInfo.customer.salesLocations.country": "Country",
    "quoteInfo.customer.salesLocations.emailAddress": "Email",
    "quoteInfo.customer.salesLocations.phoneNumber": "Phone number",
    "quoteInfo.customer.salesLocations.mobileNumber": "Mobile number",
    "dialog.addCustomProduct.priceCost.value": "Value",
    "dialog.addCustomProduct.priceCost.validFrom": "Valid from",
    "dialog.addCustomProduct.priceCost.validTo": "Valid to",
    "dialog.addCustomProduct.price": "Price",
    "dialog.addCustomProduct.cost": "Cost",
    "productDetails.partId": "Article number",
    "productDetails.listPrice": "List price",
    "productDetails.cost": "Cost",
    "searchField.label": "Search",
    "SERVER_ERROR.DISCOUNT_EXCEEDS_LIMIT": "Discount exceeds limit",
    "SERVER_ERROR.PRODUCT_IS_IN_USE": "Product is in use and cannot be deleted",
    "filter.filterAttributeInput.label": "Attribute",
    "filter.filterOperatorInput.label": "Operator",
    "filter.filterValueInput.label": "Value",
    "filter.button.applyFilter": "Apply",
    "filter.button.clearAllFilter": "Clear all",
    "toast.error.filterAlreadyPresent": "Filter already present",
    "selectionBanner.text": "{{selectedProducts}} products selected",
    "selectionBanner.clearSelection.text": "clear selection",
    "cart.label.emptyCart": "Your cart is empty",
    "cart.button.addConfiguration": "Add configuration",
    "cart.button.addArticle": "Add article",
    "cart.button.saveShoppingCart": "Save shopping cart",
    "cart.button.printShoppingCart": "Print shopping cart",
    "cart.button.import": "Import",
    "cart.button.export": "Export",
    "cart.summary.subtotal.label": "Subtotal",
    "cart.summary.totalNet.label": "Total net",
    "cart.summary.button.requestQuote": "Request Quote",
    "cart.summary.button.proceedToCheckout": "Proceed to Checkout",
    "quotes.table.uniqueNumberString": "Number",
    "quotes.table.name": "Name",
    "quotes.table.lastUpdatedOn": "Last updated",
    "quotes.table.creationDate": "Creation date",
    "quotes.table.status": "Status",
    "quotes.table.toolbar.search": "Search",
    "infotext.userNotLoggedIn": "Not logged in",
    "buttons.save": "Save",
    "buttons.reset": "Reset",
    "quotes.table.toolbar.filters.status": "Status",
    "iconButton.download": "Download",
    "iconButton.clone": "Duplicate",
    "iconButton.delete": "Delete",
    "drawer.showBOM.title": "Bill of materials",
    "drawer.showSummary.title": "Summary",
    "workflowSelect.title": "Please choose a Workflow",
    "workflowSelect.customer.title": "Customer",
    "workflowSelect.customer.subTitle": "A streamlined workflow for browsing and purchasing products.",
    "workflowSelect.sales.title": "Sales",
    "workflowSelect.sales.subTitle": "Configure, price and quote with an integrated catalog, tailored for sales persons.",
    "workflowSelect.projectList.title": "Project List",
    "workflowSelect.projectList.subTitle": "Manage articles and projects efficiently with a comprehensive list view.",
    "moveRowMenu.options.topPosition": "Top postion",
    "opportunities.quotesTable.header.name": "Name",
    "opportunities.quotesTable.header.description": "Description",
    "opportunities.quotesTable.header.customer": "Customer",
    "opportunities.quotesTable.header.quoteNumber": "Quote number",
    "opportunities.quotesTable.header.createdByName": "Created by",
    "opportunities.quotesTable.header.lastUpdatedByName": "Last updated by",
    "opportunities.quotesTable.header.lastUpdatedOn": "Last updated on",
    "opportunities.quotesTable.header.status": "Status",
    "outputOptionsSelection.checkbox.includeLongText.label": "Includes Long Text",
    "outputOptionsSelection.checkbox.includePartId.label": "Includes Part Number of Articles",
    "outputOptionsSelection.checkbox.includePrices.label": "Includes Prices",
    "outputOptionsSelection.checkbox.includeDiscounts.label": "Includes Discounts"
  }
}, yr = {
  en_US: _d,
  de_DE: Hd
}, Io = J({
  selectedLanguageId: null,
  selectedLanguage: null,
  languages: [],
  setLanguageById: () => console.error("Language context is not set up properly")
}), Wd = "en-US";
function Zd({
  children: t,
  languageCode: e
}) {
  const { data: r, isFetching: o } = yd(), { i18n: n } = T();
  $(() => {
    document.documentElement.lang = n.language;
  }, [n.language]);
  const [i, a] = G(null);
  $(() => {
    const l = "CPQ";
    dt.isInitialized && (dt.addResourceBundle("en-US", l, yr.en_US.CPQ, !0, !1), dt.addResourceBundle("de-DE", l, yr.de_DE.CPQ, !0, !1));
  }, []), $(() => {
    if (!o) {
      if (!(r != null && r.length)) {
        console.error(
          "No languages found",
          { languages: r },
          "check language fetch of cpq"
        );
        return;
      }
      const l = Jd(e, r);
      a((l == null ? void 0 : l.id) || null);
    }
  }, [e, o, r, n]), $(() => {
    if (i === "cimode")
      n.changeLanguage(i);
    else if (!o && i) {
      const l = Xd(
        i,
        r
      );
      l ? n.changeLanguage(l) : console.error(
        "could not find language with id: ",
        i,
        "check if cpq is fetching languages",
        r
      );
    }
  }, [i, o, r, n]);
  const s = (r == null ? void 0 : r.find((l) => l.id === i)) || null;
  return /* @__PURE__ */ u(
    Gn,
    {
      localeCode: (s == null ? void 0 : s.languageCode) || Wd,
      children: /* @__PURE__ */ u(
        Io.Provider,
        {
          value: {
            selectedLanguageId: i,
            selectedLanguage: s,
            languages: r || [],
            setLanguageById: (l) => a(l)
          },
          children: t
        }
      )
    }
  );
}
function Xd(t, e) {
  var r;
  return (r = e == null ? void 0 : e.find((o) => o.id === t)) == null ? void 0 : r.languageCode;
}
function Jd(t, e) {
  return e == null ? void 0 : e.find((r) => r.languageCode === t);
}
function gr(t) {
  if (!t)
    return !1;
  const e = t.find(
    (o) => o.identifier === "default"
  ), r = t.find(
    (o) => o.identifier === "archived"
  );
  return !(!e || !r);
}
const So = J({
  status: {
    default: {
      id: "",
      identifier: "",
      rowVersion: 0
    },
    archived: {
      id: "",
      identifier: "",
      rowVersion: 0
    }
  },
  statusData: []
});
function Yd(t) {
  const e = te(), { data: r, isFetching: o } = yo({}, void 0, {
    staleTime: 1 / 0
  }), { mutate: n, isPending: i } = Ad();
  $(() => {
    !o && r && (gr(r) || n(
      {
        requestBody: {
          identifier: "archived"
        }
      },
      {
        onSuccess: () => {
          e.invalidateQueries({
            queryKey: [Qt]
          });
        }
      }
    ));
  }, [r, o, n, e]);
  const a = r == null ? void 0 : r.reduce((s, l) => (s[l.identifier] = l, s), {});
  if (o || i)
    return /* @__PURE__ */ u(be, {});
  if (!o && !i && !r && !gr(r))
    throw new Error("Status data not found");
  if (!a || !r)
    throw new Error("Status data not found");
  return /* @__PURE__ */ u(So.Provider, { value: { status: a, statusData: r }, children: t.children });
}
var ep = /* @__PURE__ */ ((t) => (t.Customer = "Customer", t.Sales = "Sales", t.ProjectList = "ProjectList", t))(ep || {});
const _t = J(
  void 0
);
_t.displayName = "WorkflowContext";
const tp = ({
  children: t,
  defaultWorkflow: e
}) => {
  const [r, o] = qe(
    "workflow",
    e,
    !0
  ), n = {
    workflow: r,
    isCustomer: r === "Customer",
    isSales: r === "Sales",
    setWorkflow: o
  };
  return /* @__PURE__ */ u(_t.Provider, { value: n, children: t });
}, Wt = () => {
  const t = X(_t);
  if (!t)
    throw new Error("useWorkflow must be used within a WorkflowProvider");
  return t;
};
function rp(t) {
  const { isLoading: e, error: r } = yo(
    {},
    void 0,
    {
      retry: !1,
      enabled: t.isLocalDevelopment
    }
  );
  if (!t.isLocalDevelopment)
    return /* @__PURE__ */ u(w, {});
  if (e && console.log("___ STARTING AUTHENTICATION ___"), r && r.status === 401) {
    const n = window.location.toString(), i = "/oauth2/start?" + Dn({ returnUrl: n });
    window.location.replace(i);
  }
  r || console.log("___ AUTHENTICATION COMPLETE ___");
  const o = r ? /* @__PURE__ */ f(On, { severity: "error", children: [
    /* @__PURE__ */ u(wn, { children: "OAuthGuard" }),
    "HTTP Status ",
    status,
    " ",
    r.statusText
  ] }) : null;
  return /* @__PURE__ */ u(w, { children: o });
}
const ye = new hn({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: !1,
      retry: 1
    },
    mutations: {
      onError: (t) => {
        var e;
        if (t.status === 409 && ((e = t.body) != null && e.includes("DISPLAY_ERROR:"))) {
          const r = t.body.split("DISPLAY_ERROR:")[1];
          r && at.error(dt.t("CPQ:SERVER_ERROR." + r));
        }
        console.log({ error: t });
      }
    }
  }
});
function op({
  children: t
}) {
  try {
    if (te())
      return console.log(
        "CPQ: cpq query client is provided by the consuming app, it will be used instead of the internal cpq query client"
      ), /* @__PURE__ */ u(w, { children: t });
  } catch (e) {
    console.log("CPQ: internal cpq query client provider is used", { e });
  }
  return /* @__PURE__ */ u(Fr, { client: ye, children: t });
}
const Po = J(void 0), np = ({
  children: t,
  itemGroupsTableColumnsOverrideFn: e
}) => /* @__PURE__ */ u(Po.Provider, { value: e, children: t }), ip = () => X(Po), ap = dn({
  key: "noprefixer"
});
function sp({
  componentsOverride: t,
  languageCode: e,
  toastContainerProps: r,
  itemGroupsTableColumnsOverrideFn: o,
  children: n
}) {
  return /* @__PURE__ */ u(tp, { children: /* @__PURE__ */ f(op, { children: [
    /* @__PURE__ */ u(Md, {}),
    /* @__PURE__ */ u(rp, { basePath: "/", isLocalDevelopment: !1 }),
    /* @__PURE__ */ f(gn, { dateAdapter: bn, children: [
      /* @__PURE__ */ u(mn, {}),
      /* @__PURE__ */ u(
        yn,
        {
          styles: {
            body: {
              margin: "auto"
            }
          }
        }
      ),
      /* @__PURE__ */ u(Yd, { children: /* @__PURE__ */ u($d, { children: /* @__PURE__ */ u(Zd, { languageCode: e, children: /* @__PURE__ */ f(pn, { value: ap, children: [
        /* @__PURE__ */ u(kd, {}),
        /* @__PURE__ */ u(
          ls,
          {
            componentsOverride: t,
            children: /* @__PURE__ */ u(zd, { children: /* @__PURE__ */ f(
              np,
              {
                itemGroupsTableColumnsOverrideFn: o,
                children: [
                  /* @__PURE__ */ u(xd, { ...r }),
                  n
                ]
              }
            ) })
          }
        )
      ] }) }) }) })
    ] })
  ] }) });
}
const LI = {
  enum: ["Append", "Override"],
  type: "string"
}, GI = {
  type: "object",
  properties: {
    type: {
      type: "string",
      nullable: !0
    },
    title: {
      type: "string",
      nullable: !0
    },
    status: {
      type: "integer",
      format: "int32",
      nullable: !0
    },
    detail: {
      type: "string",
      nullable: !0
    },
    instance: {
      type: "string",
      nullable: !0
    }
  },
  additionalProperties: {}
}, AI = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    identifier: {
      pattern: "^[a-zA-Z0-9\\’\\’_\\‘\\\\s]{1,255}$",
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    }
  },
  additionalProperties: !1
}, FI = {
  type: "object",
  properties: {
    identifier: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    }
  },
  additionalProperties: !1
}, OI = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    }
  },
  additionalProperties: !1
}, wI = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    attachmentId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    attachement: {
      allOf: [
        {
          $ref: "#/components/schemas/VMAttachments"
        }
      ],
      nullable: !0
    }
  },
  additionalProperties: !1
}, DI = {
  type: "object",
  properties: {
    attachmentId: {
      type: "string",
      format: "uuid"
    },
    attachmentSetId: {
      type: "string",
      format: "uuid"
    }
  },
  additionalProperties: !1
}, RI = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    attachmentId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    attachmentSetId: {
      type: "string",
      format: "uuid",
      nullable: !0
    }
  },
  additionalProperties: !1
}, VI = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    itemIds: {
      type: "array",
      items: {
        type: "string",
        format: "uuid"
      },
      nullable: !0
    },
    items: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VMAttachmentItems"
      },
      nullable: !0
    }
  },
  additionalProperties: !1
}, NI = {
  type: "object",
  properties: {
    attachments: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VMAttachmentsEmbeddedPost"
      },
      nullable: !0
    }
  },
  additionalProperties: !1
}, MI = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    attachments: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VMAttachmentsEmbeddedPut"
      },
      nullable: !0
    }
  },
  additionalProperties: !1
}, xI = {
  type: "object",
  properties: {
    productId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    opportunityId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    quoteId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    itemGroupId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    lineItemId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    subItemId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    projectListId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    projectItemId: {
      type: "string",
      format: "uuid",
      nullable: !0
    }
  },
  additionalProperties: !1
}, EI = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    productId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    opportunityId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    quoteId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    itemGroupId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    lineItemId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    subItemId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    projectListId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    projectItemId: {
      type: "string",
      format: "uuid",
      nullable: !0
    }
  },
  additionalProperties: !1
}, UI = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    identifier: {
      pattern: "^[a-zA-Z0-9\\’\\’_\\‘\\\\s]{1,255}$",
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    }
  },
  additionalProperties: !1
}, QI = {
  type: "object",
  properties: {
    identifier: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    }
  },
  additionalProperties: !1
}, kI = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    }
  },
  additionalProperties: !1
}, jI = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    filename: {
      type: "string",
      nullable: !0
    },
    typeId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    categoryId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    propertySetId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    type: {
      allOf: [
        {
          $ref: "#/components/schemas/VMAttachmentTypes"
        }
      ],
      nullable: !0
    },
    category: {
      allOf: [
        {
          $ref: "#/components/schemas/VMAttachmentCategories"
        }
      ],
      nullable: !0
    },
    propertySet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPropertySets"
        }
      ],
      nullable: !0
    }
  },
  additionalProperties: !1
}, $I = {
  required: ["fileName"],
  type: "object",
  properties: {
    fileAsBytes: {
      type: "string",
      format: "byte",
      nullable: !0
    },
    fileName: {
      minLength: 1,
      type: "string"
    },
    typeId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    categoryId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    propertySet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPropertySetsEmbeddedPost"
        }
      ],
      nullable: !0
    }
  },
  additionalProperties: !1
}, zI = {
  required: ["id", "rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    id: {
      type: "string",
      format: "uuid"
    },
    fileAsBytes: {
      type: "string",
      format: "byte",
      nullable: !0
    },
    typeId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    categoryId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    }
  },
  additionalProperties: !1
}, KI = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    languageDependent: {
      type: "boolean"
    },
    multiValued: {
      type: "boolean"
    },
    readonly: {
      type: "boolean"
    },
    editable: {
      type: "boolean"
    },
    filterOperators: {
      type: "array",
      items: {
        type: "string"
      },
      nullable: !0
    },
    dataTypeId: {
      type: "string",
      format: "uuid"
    },
    baseValues: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VMBaseValues"
      },
      nullable: !0
    },
    translations: {
      type: "object",
      additionalProperties: {
        $ref: "#/components/schemas/VMTranslationProps"
      },
      nullable: !0
    }
  },
  additionalProperties: !1
}, HI = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    value: {
      type: "string",
      nullable: !0
    },
    typeCodeFragment: {
      type: "string",
      nullable: !0
    },
    defaultQuantity: {
      type: "number",
      format: "double",
      nullable: !0
    },
    defaultValue: {
      type: "boolean"
    },
    baseAttributeId: {
      type: "string",
      format: "uuid"
    },
    translations: {
      type: "object",
      additionalProperties: {
        $ref: "#/components/schemas/VMTranslationProps"
      },
      nullable: !0
    }
  },
  additionalProperties: !1
}, _I = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    commentSetId: {
      type: "string",
      format: "uuid"
    }
  },
  additionalProperties: !1
}, WI = {
  type: "object",
  properties: {
    identifier: {
      type: "string",
      nullable: !0
    },
    commentSetId: {
      type: "string",
      format: "uuid"
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    }
  },
  additionalProperties: !1
}, ZI = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    commentSetId: {
      type: "string",
      format: "uuid",
      nullable: !0
    }
  },
  additionalProperties: !1
}, XI = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    commentItemIds: {
      type: "array",
      items: {
        type: "string",
        format: "uuid"
      },
      nullable: !0
    },
    commentItems: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VMCommentItems"
      },
      nullable: !0
    },
    lineItemId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    subItemId: {
      type: "string",
      format: "uuid",
      nullable: !0
    }
  },
  additionalProperties: !1
}, JI = {
  type: "object",
  properties: {
    identifier: {
      type: "string",
      nullable: !0
    },
    lineItemId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    subItemId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    }
  },
  additionalProperties: !1
}, YI = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    lineItemId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    subItemId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    }
  },
  additionalProperties: !1
}, eS = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    name: {
      type: "string",
      nullable: !0
    },
    oldName: {
      type: "string",
      nullable: !0
    },
    country: {
      type: "string",
      nullable: !0
    },
    propertySetId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    propertySet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPropertySets"
        }
      ],
      nullable: !0
    }
  },
  additionalProperties: !1
}, tS = {
  type: "object",
  properties: {
    identifier: {
      type: "string",
      nullable: !0
    },
    name: {
      type: "string",
      nullable: !0
    },
    country: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    }
  },
  additionalProperties: !1
}, rS = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    name: {
      type: "string",
      nullable: !0
    },
    country: {
      type: "string",
      nullable: !0
    }
  },
  additionalProperties: !1
}, oS = {
  required: ["id", "identifier", "isComplete", "rowVersion", "state"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    identifier: {
      minLength: 1,
      type: "string"
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    state: {
      minLength: 1,
      type: "string"
    },
    configurationSummary: {
      type: "string",
      nullable: !0
    },
    bom: {
      type: "string",
      nullable: !0
    },
    isComplete: {
      type: "boolean"
    },
    productId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    lineItemId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    subItemId: {
      type: "string",
      format: "uuid",
      nullable: !0
    }
  },
  additionalProperties: !1
}, nS = {
  required: ["identifier", "state"],
  type: "object",
  properties: {
    identifier: {
      minLength: 1,
      type: "string"
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    state: {
      minLength: 1,
      type: "string"
    }
  },
  additionalProperties: !1
}, iS = {
  required: ["state"],
  type: "object",
  properties: {
    identifier: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    state: {
      minLength: 1,
      type: "string"
    },
    productId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    lineItemId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    subItemId: {
      type: "string",
      format: "uuid",
      nullable: !0
    }
  },
  additionalProperties: !1
}, aS = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    state: {
      type: "string",
      nullable: !0
    },
    configurationSummary: {
      type: "string",
      nullable: !0
    },
    bom: {
      type: "string",
      nullable: !0
    },
    productId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    lineItemId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    subItemId: {
      type: "string",
      format: "uuid",
      nullable: !0
    }
  },
  additionalProperties: !1
}, sS = {
  required: ["company", "rowVersion", "salesLocations"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    customerNumber: {
      type: "string",
      nullable: !0
    },
    contactSalutation: {
      type: "string",
      nullable: !0
    },
    contactTitle: {
      type: "string",
      nullable: !0
    },
    contactFirstName: {
      type: "string",
      nullable: !0
    },
    contactLastName: {
      type: "string",
      nullable: !0
    },
    street: {
      type: "string",
      nullable: !0
    },
    streetNumber: {
      type: "string",
      nullable: !0
    },
    postalCode: {
      type: "string",
      nullable: !0
    },
    town: {
      type: "string",
      nullable: !0
    },
    country: {
      type: "string",
      nullable: !0
    },
    emailAddress: {
      type: "string",
      nullable: !0
    },
    phoneNumber: {
      type: "string",
      nullable: !0
    },
    mobileNumber: {
      type: "string",
      nullable: !0
    },
    propertySetId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    companyId: {
      type: "string",
      format: "uuid"
    },
    propertySet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPropertySets"
        }
      ],
      nullable: !0
    },
    company: {
      allOf: [
        {
          $ref: "#/components/schemas/VMCompanies"
        }
      ]
    },
    salesLocations: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VMSalesLocations"
      }
    }
  },
  additionalProperties: !1
}, uS = {
  type: "object",
  properties: {
    identifier: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    customerNumber: {
      type: "string",
      nullable: !0
    },
    contactSalutation: {
      type: "string",
      nullable: !0
    },
    contactTitle: {
      type: "string",
      nullable: !0
    },
    contactFirstName: {
      type: "string",
      nullable: !0
    },
    contactLastName: {
      type: "string",
      nullable: !0
    },
    street: {
      type: "string",
      nullable: !0
    },
    streetNumber: {
      type: "string",
      nullable: !0
    },
    postalCode: {
      type: "string",
      nullable: !0
    },
    town: {
      type: "string",
      nullable: !0
    },
    country: {
      type: "string",
      nullable: !0
    },
    emailAddress: {
      type: "string",
      nullable: !0
    },
    phoneNumber: {
      type: "string",
      nullable: !0
    },
    mobileNumber: {
      type: "string",
      nullable: !0
    },
    companyId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    salesLocationIds: {
      type: "array",
      items: {
        type: "string",
        format: "uuid"
      },
      nullable: !0
    }
  },
  additionalProperties: !1
}, lS = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    customerNumber: {
      type: "string",
      nullable: !0
    },
    contactSalutation: {
      type: "string",
      nullable: !0
    },
    contactTitle: {
      type: "string",
      nullable: !0
    },
    contactFirstName: {
      type: "string",
      nullable: !0
    },
    contactLastName: {
      type: "string",
      nullable: !0
    },
    street: {
      type: "string",
      nullable: !0
    },
    streetNumber: {
      type: "string",
      nullable: !0
    },
    postalCode: {
      type: "string",
      nullable: !0
    },
    town: {
      type: "string",
      nullable: !0
    },
    country: {
      type: "string",
      nullable: !0
    },
    emailAddress: {
      type: "string",
      nullable: !0
    },
    phoneNumber: {
      type: "string",
      nullable: !0
    },
    mobileNumber: {
      type: "string",
      nullable: !0
    },
    companyId: {
      type: "string",
      format: "uuid",
      nullable: !0
    }
  },
  additionalProperties: !1
}, cS = {
  required: ["id", "identifier", "rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    identifier: {
      minLength: 1,
      type: "string"
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    }
  },
  additionalProperties: !1
}, dS = {
  required: ["identifier"],
  type: "object",
  properties: {
    identifier: {
      minLength: 1,
      type: "string"
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    }
  },
  additionalProperties: !1
}, pS = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    }
  },
  additionalProperties: !1
}, mS = {
  required: ["id", "rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    identifier: {
      type: "string",
      nullable: !0
    }
  },
  additionalProperties: !1
}, yS = {
  required: ["id", "rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    translations: {
      type: "object",
      additionalProperties: {
        $ref: "#/components/schemas/VMTranslationProps"
      },
      nullable: !0
    }
  },
  additionalProperties: !1
}, gS = {
  required: ["discountKindId", "discountTypeId", "id", "rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    isActive: {
      type: "boolean"
    },
    discountTypeId: {
      type: "string",
      format: "uuid"
    },
    discountKindId: {
      type: "string",
      format: "uuid"
    },
    priceListId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    currencyId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    unitId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    discountType: {
      allOf: [
        {
          $ref: "#/components/schemas/VMDiscountTypes"
        }
      ],
      nullable: !0
    },
    discountKind: {
      allOf: [
        {
          $ref: "#/components/schemas/VMDiscountKinds"
        }
      ],
      nullable: !0
    },
    currency: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPriceCurrencies"
        }
      ],
      nullable: !0
    },
    unit: {
      allOf: [
        {
          $ref: "#/components/schemas/VMUnits"
        }
      ],
      nullable: !0
    }
  },
  additionalProperties: !1
}, bS = {
  required: ["ids"],
  type: "object",
  properties: {
    ids: {
      type: "array",
      items: {
        type: "string",
        format: "uuid"
      }
    },
    discount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    discountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceDiscount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceDiscountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    projectDiscount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    projectDiscountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    bonusDiscount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    bonusDiscountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    markup: {
      type: "number",
      format: "double",
      nullable: !0
    },
    markupPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceMarkup: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceMarkupPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    }
  },
  additionalProperties: !1
}, fS = {
  type: "object",
  properties: {
    apiName: {
      type: "string",
      nullable: !0
    },
    apiVersion: {
      type: "string",
      nullable: !0
    },
    apiBuild: {
      type: "string",
      nullable: !0
    },
    publishTarget: {
      type: "string",
      nullable: !0
    },
    releaseVersionId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    releaseIdentifier: {
      type: "string",
      nullable: !0
    },
    releaseNotes: {
      type: "string",
      nullable: !0
    },
    releaseDate: {
      type: "string",
      format: "date-time",
      nullable: !0
    }
  },
  additionalProperties: !1
}, hS = {
  required: ["id", "quoteId", "rowVersion", "statusId"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    name: {
      type: "string",
      nullable: !0
    },
    description: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    rank: {
      type: "integer",
      format: "int32"
    },
    displayedRank: {
      type: "string",
      nullable: !0
    },
    isOptional: {
      type: "boolean"
    },
    dataType: {
      type: "string",
      nullable: !0
    },
    targetMargin: {
      type: "number",
      format: "double",
      nullable: !0
    },
    targetPrice: {
      type: "number",
      format: "double",
      nullable: !0
    },
    margin: {
      type: "number",
      format: "double",
      nullable: !0
    },
    listPrice: {
      type: "number",
      format: "double",
      nullable: !0
    },
    cost: {
      type: "number",
      format: "double",
      nullable: !0
    },
    totalList: {
      type: "number",
      format: "double",
      nullable: !0
    },
    totalCost: {
      type: "number",
      format: "double",
      nullable: !0
    },
    totalNet: {
      type: "number",
      format: "double",
      nullable: !0
    },
    discount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    discountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceDiscount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceDiscountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    projectDiscount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    projectDiscountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    bonusDiscount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    bonusDiscountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    markup: {
      type: "number",
      format: "double",
      nullable: !0
    },
    markupPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceMarkup: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceMarkupPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    totalDiscount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    totalDiscountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    currency: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPriceCurrencies"
        }
      ],
      nullable: !0
    },
    quoteId: {
      type: "string",
      format: "uuid"
    },
    statusId: {
      type: "string",
      format: "uuid"
    },
    propertySetId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    attachmentSetId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    propertySet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPropertySets"
        }
      ],
      nullable: !0
    },
    attachmentSet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMAttachmentSets"
        }
      ],
      nullable: !0
    },
    lineItemIds: {
      type: "array",
      items: {
        type: "string",
        format: "uuid"
      },
      nullable: !0
    },
    lineItems: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VMLineItems"
      },
      nullable: !0
    },
    priceLists: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VMPriceLists"
      },
      nullable: !0
    }
  },
  additionalProperties: !1
}, IS = {
  type: "object",
  properties: {
    itemGroups: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VMItemGroups"
      },
      nullable: !0
    },
    totalCount: {
      type: "integer",
      format: "int64"
    }
  },
  additionalProperties: !1
}, SS = {
  type: "object",
  properties: {
    opportunityId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    quoteId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    name: {
      type: "string",
      nullable: !0
    },
    description: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    isOptional: {
      type: "boolean",
      nullable: !0
    },
    rank: {
      type: "integer",
      format: "int32",
      nullable: !0
    },
    propertySet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPropertySetsEmbeddedPost"
        }
      ],
      nullable: !0
    },
    attachmentSet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMAttachmentSetsEmbeddedPost"
        }
      ],
      nullable: !0
    },
    lineItems: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VMLineItemsEmbeddedPost"
      },
      nullable: !0
    },
    statusId: {
      type: "string",
      format: "uuid",
      nullable: !0
    }
  },
  additionalProperties: !1
}, PS = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    name: {
      type: "string",
      nullable: !0
    },
    description: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    isOptional: {
      type: "boolean",
      nullable: !0
    },
    rank: {
      type: "integer",
      format: "int32",
      nullable: !0
    },
    discount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    discountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceDiscount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceDiscountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    projectDiscount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    projectDiscountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    bonusDiscount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    bonusDiscountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    markup: {
      type: "number",
      format: "double",
      nullable: !0
    },
    markupPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceMarkup: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceMarkupPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    propertySet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPropertySetsEmbeddedPut"
        }
      ],
      nullable: !0
    },
    attachmentSet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMAttachmentSetsEmbeddedPut"
        }
      ],
      nullable: !0
    },
    statusId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    quoteId: {
      type: "string",
      format: "uuid",
      nullable: !0
    }
  },
  additionalProperties: !1
}, CS = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    name: {
      type: "string",
      nullable: !0
    },
    rank: {
      type: "integer",
      format: "int32"
    },
    defaultLanguage: {
      type: "boolean"
    },
    languageCode: {
      type: "string",
      nullable: !0
    },
    currency: {
      type: "string",
      nullable: !0
    },
    isoCurrencySymbol: {
      type: "string",
      nullable: !0
    },
    fallbackLanguage: {
      type: "string",
      nullable: !0
    }
  },
  additionalProperties: !1
}, qS = {
  required: ["id", "rowVersion", "statusId"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    name: {
      type: "string",
      nullable: !0
    },
    description: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    rank: {
      type: "integer",
      format: "int32"
    },
    displayedRank: {
      type: "string",
      nullable: !0
    },
    isOptional: {
      type: "boolean"
    },
    isConfigurationComplete: {
      type: "boolean",
      nullable: !0
    },
    quantity: {
      type: "number",
      format: "double",
      nullable: !0
    },
    quantityUnitSymbol: {
      type: "string",
      nullable: !0
    },
    dataType: {
      type: "string",
      nullable: !0
    },
    isTop: {
      type: "boolean",
      nullable: !0
    },
    isTopChangeable: {
      type: "boolean",
      nullable: !0
    },
    targetMargin: {
      type: "number",
      format: "double",
      nullable: !0
    },
    targetPrice: {
      type: "number",
      format: "double",
      nullable: !0
    },
    margin: {
      type: "number",
      format: "double",
      nullable: !0
    },
    listPrice: {
      type: "number",
      format: "double",
      nullable: !0
    },
    cost: {
      type: "number",
      format: "double",
      nullable: !0
    },
    totalList: {
      type: "number",
      format: "double",
      nullable: !0
    },
    totalCost: {
      type: "number",
      format: "double",
      nullable: !0
    },
    totalNet: {
      type: "number",
      format: "double",
      nullable: !0
    },
    discount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    discountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceDiscount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceDiscountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    projectDiscount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    projectDiscountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    bonusDiscount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    bonusDiscountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    markup: {
      type: "number",
      format: "double",
      nullable: !0
    },
    markupPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceMarkup: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceMarkupPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    totalDiscount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    totalDiscountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    currency: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPriceCurrencies"
        }
      ],
      nullable: !0
    },
    companyId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    statusId: {
      type: "string",
      format: "uuid"
    },
    productId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    configurationId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    itemGroupId: {
      type: "string",
      format: "uuid"
    },
    alternativeForId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    propertySetId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    attachmentSetId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    commentSetId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    quantityUnitId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    company: {
      allOf: [
        {
          $ref: "#/components/schemas/VMCompanies"
        }
      ],
      nullable: !0
    },
    product: {
      allOf: [
        {
          $ref: "#/components/schemas/VMProducts"
        }
      ],
      nullable: !0
    },
    configuration: {
      allOf: [
        {
          $ref: "#/components/schemas/VMConfigurations"
        }
      ],
      nullable: !0
    },
    status: {
      allOf: [
        {
          $ref: "#/components/schemas/VMStatus"
        }
      ],
      nullable: !0
    },
    propertySet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPropertySets"
        }
      ],
      nullable: !0
    },
    attachmentSet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMAttachmentSets"
        }
      ],
      nullable: !0
    },
    commentSet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMCommentSets"
        }
      ],
      nullable: !0
    },
    subItemIds: {
      type: "array",
      items: {
        type: "string",
        format: "uuid"
      },
      nullable: !0
    },
    subItems: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VMSubItems"
      },
      nullable: !0
    },
    alternativeItemIds: {
      type: "array",
      items: {
        type: "string",
        format: "uuid"
      },
      nullable: !0
    },
    priceLists: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VMPriceLists"
      },
      nullable: !0
    }
  },
  additionalProperties: !1
}, vS = {
  type: "object",
  properties: {
    name: {
      type: "string",
      nullable: !0
    },
    value: {
      type: "string",
      nullable: !0
    },
    rangeLower: {
      type: "number",
      format: "float",
      nullable: !0
    },
    rangeUpper: {
      type: "number",
      format: "float",
      nullable: !0
    }
  },
  additionalProperties: !1
}, TS = {
  type: "object",
  properties: {
    identifier: {
      type: "string",
      nullable: !0
    },
    name: {
      type: "string",
      nullable: !0
    },
    description: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    isOptional: {
      type: "boolean",
      nullable: !0
    },
    rank: {
      type: "integer",
      format: "int32",
      nullable: !0
    },
    quantity: {
      type: "number",
      format: "double",
      nullable: !0
    },
    statusId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    companyId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    alternativeForId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    quantityUnitId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    propertySet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPropertySetsEmbeddedPost"
        }
      ],
      nullable: !0
    },
    attachmentSet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMAttachmentSetsEmbeddedPost"
        }
      ],
      nullable: !0
    },
    productId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    product: {
      allOf: [
        {
          $ref: "#/components/schemas/VMProductsPost"
        }
      ],
      nullable: !0
    }
  },
  additionalProperties: !1
}, BS = {
  type: "object",
  properties: {
    lineItems: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VMLineItems"
      },
      nullable: !0
    },
    totalCount: {
      type: "integer",
      format: "int64"
    }
  },
  additionalProperties: !1
}, LS = {
  type: "object",
  properties: {
    identifier: {
      type: "string",
      nullable: !0
    },
    name: {
      type: "string",
      nullable: !0
    },
    description: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    isOptional: {
      type: "boolean",
      nullable: !0
    },
    rank: {
      type: "integer",
      format: "int32",
      nullable: !0
    },
    quantity: {
      type: "number",
      format: "double",
      nullable: !0
    },
    statusId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    companyId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    opportunityId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    quoteId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    itemGroupId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    alternativeForId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    quantityUnitId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    propertySet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPropertySetsEmbeddedPost"
        }
      ],
      nullable: !0
    },
    attachmentSet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMAttachmentSetsEmbeddedPost"
        }
      ],
      nullable: !0
    },
    productId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    product: {
      allOf: [
        {
          $ref: "#/components/schemas/VMProductsPost"
        }
      ],
      nullable: !0
    },
    configuration: {
      allOf: [
        {
          $ref: "#/components/schemas/VMConfigurationsEmbeddedPost"
        }
      ],
      nullable: !0
    }
  },
  additionalProperties: !1
}, GS = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    name: {
      type: "string",
      nullable: !0
    },
    description: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    isOptional: {
      type: "boolean",
      nullable: !0
    },
    isTop: {
      type: "boolean",
      nullable: !0
    },
    rank: {
      type: "integer",
      format: "int32",
      nullable: !0
    },
    quantity: {
      type: "number",
      format: "double",
      nullable: !0
    },
    discount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    discountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceDiscount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceDiscountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    projectDiscount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    projectDiscountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    bonusDiscount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    bonusDiscountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    markup: {
      type: "number",
      format: "double",
      nullable: !0
    },
    markupPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceMarkup: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceMarkupPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    statusId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    companyId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    productId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    itemGroupId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    quantityUnitId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    propertySet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPropertySetsEmbeddedPut"
        }
      ],
      nullable: !0
    },
    attachmentSet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMAttachmentSetsEmbeddedPut"
        }
      ],
      nullable: !0
    }
  },
  additionalProperties: !1
}, AS = {
  required: ["id", "rowVersion", "statusId"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    name: {
      type: "string",
      nullable: !0
    },
    description: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    uniqueNumberString: {
      type: "string",
      nullable: !0
    },
    isOptional: {
      type: "boolean"
    },
    legacyCustomerName: {
      type: "string",
      nullable: !0
    },
    region: {
      type: "string",
      nullable: !0
    },
    validFrom: {
      type: "string",
      format: "date-time",
      nullable: !0
    },
    validTo: {
      type: "string",
      format: "date-time",
      nullable: !0
    },
    dataType: {
      type: "string",
      nullable: !0
    },
    statusId: {
      type: "string",
      format: "uuid"
    },
    propertySetId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    attachementSetId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    companyId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    customerId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    propertySet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPropertySets"
        }
      ],
      nullable: !0
    },
    attachmentSet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMAttachmentSets"
        }
      ],
      nullable: !0
    },
    company: {
      allOf: [
        {
          $ref: "#/components/schemas/VMCompanies"
        }
      ],
      nullable: !0
    },
    customer: {
      allOf: [
        {
          $ref: "#/components/schemas/VMCustomers"
        }
      ],
      nullable: !0
    },
    quoteIds: {
      type: "array",
      items: {
        type: "string",
        format: "uuid"
      },
      nullable: !0
    },
    quotes: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VMQuotes"
      },
      nullable: !0
    }
  },
  additionalProperties: !1
}, FS = {
  type: "object",
  properties: {
    opportunities: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VMOpportunities"
      },
      nullable: !0
    },
    totalCount: {
      type: "integer",
      format: "int64"
    }
  },
  additionalProperties: !1
}, OS = {
  type: "object",
  properties: {
    identifier: {
      type: "string",
      nullable: !0
    },
    name: {
      type: "string",
      nullable: !0
    },
    description: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    isOptional: {
      type: "boolean",
      nullable: !0
    },
    customer: {
      type: "string",
      nullable: !0
    },
    region: {
      type: "string",
      nullable: !0
    },
    validFrom: {
      type: "string",
      format: "date-time",
      nullable: !0
    },
    validTo: {
      type: "string",
      format: "date-time",
      nullable: !0
    },
    propertySet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPropertySetsEmbeddedPost"
        }
      ],
      nullable: !0
    },
    attachmentSet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMAttachmentSetsEmbeddedPost"
        }
      ],
      nullable: !0
    },
    statusId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    companyId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    customerId: {
      type: "string",
      format: "uuid",
      nullable: !0
    }
  },
  additionalProperties: !1
}, wS = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    name: {
      type: "string",
      nullable: !0
    },
    description: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    isOptional: {
      type: "boolean",
      nullable: !0
    },
    customer: {
      type: "string",
      nullable: !0
    },
    region: {
      type: "string",
      nullable: !0
    },
    validFrom: {
      type: "string",
      format: "date-time",
      nullable: !0
    },
    validTo: {
      type: "string",
      format: "date-time",
      nullable: !0
    },
    propertySet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPropertySetsEmbeddedPut"
        }
      ],
      nullable: !0
    },
    attachmentSet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMAttachmentSetsEmbeddedPut"
        }
      ],
      nullable: !0
    },
    statusId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    companyId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    customerId: {
      type: "string",
      format: "uuid",
      nullable: !0
    }
  },
  additionalProperties: !1
}, DS = {
  required: ["id", "rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    currencyName: {
      type: "string",
      nullable: !0
    },
    symbol: {
      type: "string",
      nullable: !0
    },
    isActive: {
      type: "boolean"
    },
    isDefault: {
      type: "boolean"
    },
    decimalDigits: {
      type: "integer",
      format: "int32"
    },
    conversionFactor: {
      type: "number",
      format: "double"
    }
  },
  additionalProperties: !1
}, RS = {
  required: ["currencyId", "id", "identifier", "rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    identifier: {
      minLength: 1,
      type: "string"
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    customer: {
      type: "string",
      nullable: !0
    },
    company: {
      type: "string",
      nullable: !0
    },
    region: {
      type: "string",
      nullable: !0
    },
    validFrom: {
      type: "string",
      format: "date-time",
      nullable: !0
    },
    validTo: {
      type: "string",
      format: "date-time",
      nullable: !0
    },
    isActive: {
      type: "boolean"
    },
    precedence: {
      type: "integer",
      format: "int32",
      nullable: !0
    },
    currencyId: {
      type: "string",
      format: "uuid"
    },
    currency: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPriceCurrencies"
        }
      ],
      nullable: !0
    },
    prices: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VMPrices"
      },
      nullable: !0
    }
  },
  additionalProperties: !1
}, VS = {
  required: ["id", "rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    translations: {
      type: "object",
      additionalProperties: {
        $ref: "#/components/schemas/VMTranslationProps"
      },
      nullable: !0
    }
  },
  additionalProperties: !1
}, NS = {
  required: ["currencyId", "id", "priceTypeId", "rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    price: {
      type: "number",
      format: "double"
    },
    isActive: {
      type: "boolean"
    },
    validFrom: {
      type: "string",
      format: "date-time",
      nullable: !0
    },
    validTo: {
      type: "string",
      format: "date-time",
      nullable: !0
    },
    priceListId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    priceTypeId: {
      type: "string",
      format: "uuid"
    },
    currencyId: {
      type: "string",
      format: "uuid"
    },
    priceType: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPriceTypes"
        }
      ],
      nullable: !0
    },
    currency: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPriceCurrencies"
        }
      ],
      nullable: !0
    }
  },
  additionalProperties: !1
}, MS = {
  required: ["currencyId", "price"],
  type: "object",
  properties: {
    price: {
      type: "number",
      format: "double"
    },
    isActive: {
      type: "boolean",
      nullable: !0
    },
    validFrom: {
      type: "string",
      format: "date-time",
      nullable: !0
    },
    validTo: {
      type: "string",
      format: "date-time",
      nullable: !0
    },
    currencyId: {
      type: "string",
      format: "uuid"
    }
  },
  additionalProperties: !1
}, xS = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    price: {
      type: "number",
      format: "double",
      nullable: !0
    },
    isActive: {
      type: "boolean",
      nullable: !0
    },
    validFrom: {
      type: "string",
      format: "date-time",
      nullable: !0
    },
    validTo: {
      type: "string",
      format: "date-time",
      nullable: !0
    },
    currencyId: {
      type: "string",
      format: "uuid",
      nullable: !0
    }
  },
  additionalProperties: !1
}, ES = {
  type: "object",
  properties: {
    baseAttributeIdentifier: {
      type: "string",
      nullable: !0
    },
    filterOperator: {
      type: "string",
      nullable: !0
    },
    negated: {
      type: "boolean"
    },
    rangeFrom: {
      type: "number",
      format: "double"
    },
    rangeTo: {
      type: "number",
      format: "double"
    },
    filterValues: {
      type: "array",
      items: {
        type: "string"
      },
      nullable: !0
    }
  },
  additionalProperties: !1
}, US = {
  type: "object",
  properties: {
    productAttributeFilters: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VMProductAttributeFilter"
      },
      nullable: !0
    }
  },
  additionalProperties: !1
}, QS = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    attributeIdentifier: {
      type: "string",
      nullable: !0
    },
    productIdentifier: {
      type: "string",
      nullable: !0
    },
    rank: {
      type: "integer",
      format: "int32"
    },
    isFilterable: {
      type: "boolean"
    },
    filterOperators: {
      type: "array",
      items: {
        type: "string"
      },
      nullable: !0
    },
    propertySetId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    propertySet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPropertySets"
        }
      ],
      nullable: !0
    },
    attachmentSetId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    attachmentSet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMAttachmentSets"
        }
      ],
      nullable: !0
    },
    baseAttributeId: {
      type: "string",
      format: "uuid"
    },
    productId: {
      type: "string",
      format: "uuid"
    },
    baseAttribute: {
      allOf: [
        {
          $ref: "#/components/schemas/VMBaseAttributes"
        }
      ],
      nullable: !0
    },
    productValues: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VMProductValues"
      },
      nullable: !0
    },
    translations: {
      type: "object",
      additionalProperties: {
        $ref: "#/components/schemas/VMTranslationProps"
      },
      nullable: !0
    }
  },
  additionalProperties: !1
}, kS = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    validFrom: {
      type: "string",
      format: "date-time",
      nullable: !0
    },
    validTo: {
      type: "string",
      format: "date-time",
      nullable: !0
    },
    isActive: {
      type: "boolean"
    },
    productPath: {
      type: "string",
      nullable: !0
    },
    region: {
      type: "string",
      nullable: !0
    },
    customer: {
      type: "string",
      nullable: !0
    },
    imageId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    image: {
      allOf: [
        {
          $ref: "#/components/schemas/VMAttachments"
        }
      ],
      nullable: !0
    },
    productStateId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    productState: {
      allOf: [
        {
          $ref: "#/components/schemas/VMProductStates"
        }
      ],
      nullable: !0
    },
    categoryChildIds: {
      type: "array",
      items: {
        type: "string",
        format: "uuid"
      },
      nullable: !0
    },
    hierarchyCategoryIds: {
      type: "array",
      items: {
        type: "string",
        format: "uuid"
      },
      nullable: !0
    },
    translations: {
      type: "object",
      additionalProperties: {
        $ref: "#/components/schemas/VMTranslationProps"
      },
      nullable: !0
    }
  },
  additionalProperties: !1
}, jS = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    parentId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    rootId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    categoryId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    category: {
      allOf: [
        {
          $ref: "#/components/schemas/VMProductCategories"
        }
      ],
      nullable: !0
    },
    productId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    product: {
      allOf: [
        {
          $ref: "#/components/schemas/VMProducts"
        }
      ],
      nullable: !0
    },
    rank: {
      type: "integer",
      format: "int32"
    },
    productIdentifier: {
      type: "string",
      nullable: !0
    },
    categoryIdentifier: {
      type: "string",
      nullable: !0
    },
    propertySetId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    propertySet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPropertySets"
        }
      ],
      nullable: !0
    },
    attachmentSetId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    attachmentSet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMAttachmentSets"
        }
      ],
      nullable: !0
    },
    children: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VMProductCategoryChildren"
      },
      nullable: !0
    }
  },
  additionalProperties: !1
}, $S = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    productHierarchyId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    parentProductGroupId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    subProductGroupIds: {
      type: "array",
      items: {
        type: "string",
        format: "uuid"
      },
      nullable: !0
    },
    subProductGroups: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VMProductGroups"
      },
      nullable: !0
    },
    productIds: {
      type: "array",
      items: {
        type: "string",
        format: "uuid"
      },
      nullable: !0
    },
    products: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VMProducts"
      },
      nullable: !0
    },
    validFrom: {
      type: "string",
      format: "date-time",
      nullable: !0
    },
    validTo: {
      type: "string",
      format: "date-time",
      nullable: !0
    },
    isActive: {
      type: "boolean"
    },
    productPath: {
      type: "string",
      nullable: !0
    },
    rank: {
      type: "integer",
      format: "int32"
    },
    region: {
      type: "string",
      nullable: !0
    },
    customer: {
      type: "string",
      nullable: !0
    },
    propertySetId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    propertySet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPropertySets"
        }
      ],
      nullable: !0
    },
    attachmentSetId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    attachmentSet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMAttachmentSets"
        }
      ],
      nullable: !0
    },
    productStateId: {
      type: "string",
      format: "uuid"
    },
    productState: {
      allOf: [
        {
          $ref: "#/components/schemas/VMProductStates"
        }
      ],
      nullable: !0
    }
  },
  additionalProperties: !1
}, zS = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    root: {
      allOf: [
        {
          $ref: "#/components/schemas/VMProductHierarchyCategories"
        }
      ],
      nullable: !0
    },
    validFrom: {
      type: "string",
      format: "date-time",
      nullable: !0
    },
    validTo: {
      type: "string",
      format: "date-time",
      nullable: !0
    },
    isActive: {
      type: "boolean"
    },
    productPath: {
      type: "string",
      nullable: !0
    },
    rank: {
      type: "integer",
      format: "int32"
    },
    region: {
      type: "string",
      nullable: !0
    },
    customer: {
      type: "string",
      nullable: !0
    },
    propertySetId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    propertySet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPropertySets"
        }
      ],
      nullable: !0
    },
    attachmentSetId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    attachmentSet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMAttachmentSets"
        }
      ],
      nullable: !0
    },
    productStateId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    productState: {
      allOf: [
        {
          $ref: "#/components/schemas/VMProductStates"
        }
      ],
      nullable: !0
    },
    translations: {
      type: "object",
      additionalProperties: {
        $ref: "#/components/schemas/VMTranslationProps"
      },
      nullable: !0
    }
  },
  additionalProperties: !1
}, KS = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    hierarchyId: {
      type: "string",
      format: "uuid"
    },
    categoryId: {
      type: "string",
      format: "uuid"
    },
    propertySetId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    propertySet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPropertySets"
        }
      ],
      nullable: !0
    },
    attachmentSetId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    attachmentSet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMAttachmentSets"
        }
      ],
      nullable: !0
    },
    productStateId: {
      type: "string",
      format: "uuid"
    },
    productState: {
      allOf: [
        {
          $ref: "#/components/schemas/VMProductStates"
        }
      ],
      nullable: !0
    },
    category: {
      allOf: [
        {
          $ref: "#/components/schemas/VMProductCategories"
        }
      ],
      nullable: !0
    },
    children: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VMProductCategoryChildren"
      },
      nullable: !0
    }
  },
  additionalProperties: !1
}, HS = {
  required: ["id", "identifier", "rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    referenceId: {
      type: "string",
      nullable: !0
    },
    identifier: {
      minLength: 1,
      type: "string"
    },
    translations: {
      type: "object",
      additionalProperties: {
        $ref: "#/components/schemas/VMTranslationProps"
      },
      nullable: !0
    }
  },
  additionalProperties: !1
}, _S = {
  required: ["identifier"],
  type: "object",
  properties: {
    identifier: {
      minLength: 1,
      type: "string"
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    }
  },
  additionalProperties: !1
}, WS = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    }
  },
  additionalProperties: !1
}, ZS = {
  required: ["id", "identifier", "rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    id: {
      type: "string",
      format: "uuid"
    },
    identifier: {
      minLength: 1,
      type: "string"
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    translations: {
      type: "object",
      additionalProperties: {
        $ref: "#/components/schemas/VMTranslationProps"
      },
      nullable: !0
    }
  },
  additionalProperties: !1
}, XS = {
  required: ["identifier"],
  type: "object",
  properties: {
    identifier: {
      minLength: 1,
      type: "string"
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    }
  },
  additionalProperties: !1
}, JS = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    }
  },
  additionalProperties: !1
}, YS = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    value: {
      type: "string",
      nullable: !0
    },
    rank: {
      type: "integer",
      format: "int32"
    },
    propertySetId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    propertySet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPropertySets"
        }
      ],
      nullable: !0
    },
    attachmentSetId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    attachmentSet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMAttachmentSets"
        }
      ],
      nullable: !0
    },
    baseValueId: {
      type: "string",
      format: "uuid"
    },
    productAttributeId: {
      type: "string",
      format: "uuid"
    },
    translations: {
      type: "object",
      additionalProperties: {
        $ref: "#/components/schemas/VMTranslationProps"
      },
      nullable: !0
    }
  },
  additionalProperties: !1
}, eP = {
  required: ["id", "identifier", "productTypeId", "rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    partId: {
      type: "string",
      nullable: !0
    },
    identifier: {
      minLength: 1,
      type: "string"
    },
    name: {
      type: "string",
      nullable: !0
    },
    description: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    validFrom: {
      type: "string",
      format: "date-time",
      nullable: !0
    },
    validTo: {
      type: "string",
      format: "date-time",
      nullable: !0
    },
    isActive: {
      type: "boolean"
    },
    productPath: {
      type: "string",
      nullable: !0
    },
    typeCode: {
      type: "string",
      nullable: !0
    },
    rank: {
      type: "integer",
      format: "int32"
    },
    region: {
      type: "string",
      nullable: !0
    },
    customer: {
      type: "string",
      nullable: !0
    },
    isCustom: {
      type: "boolean"
    },
    isShared: {
      type: "boolean"
    },
    cfgObjectIdentifier: {
      type: "string",
      nullable: !0
    },
    dataType: {
      type: "string",
      nullable: !0
    },
    listPrice: {
      type: "number",
      format: "double",
      nullable: !0
    },
    cost: {
      type: "number",
      format: "double",
      nullable: !0
    },
    currency: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPriceCurrencies"
        }
      ],
      nullable: !0
    },
    originalListPrice: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPrices"
        }
      ],
      nullable: !0
    },
    originalCost: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPrices"
        }
      ],
      nullable: !0
    },
    productTypeId: {
      type: "string",
      format: "uuid"
    },
    productType: {
      allOf: [
        {
          $ref: "#/components/schemas/VMProductTypes"
        }
      ],
      nullable: !0
    },
    projectItemId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    lineItemIds: {
      type: "array",
      items: {
        type: "string",
        format: "uuid"
      },
      nullable: !0
    },
    subItemIds: {
      type: "array",
      items: {
        type: "string",
        format: "uuid"
      },
      nullable: !0
    },
    configurationId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    configuration: {
      allOf: [
        {
          $ref: "#/components/schemas/VMConfigurations"
        }
      ],
      nullable: !0
    },
    productGroupId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    propertySetId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    propertySet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPropertySets"
        }
      ],
      nullable: !0
    },
    attachmentSetId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    attachmentSet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMAttachmentSets"
        }
      ],
      nullable: !0
    },
    imageId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    image: {
      allOf: [
        {
          $ref: "#/components/schemas/VMAttachments"
        }
      ],
      nullable: !0
    },
    productStateId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    productState: {
      allOf: [
        {
          $ref: "#/components/schemas/VMProductStates"
        }
      ],
      nullable: !0
    },
    productAttributes: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VMProductAttributes"
      },
      nullable: !0
    },
    translations: {
      type: "object",
      additionalProperties: {
        $ref: "#/components/schemas/VMTranslationProps"
      },
      nullable: !0
    }
  },
  additionalProperties: !1
}, tP = {
  type: "object",
  properties: {
    products: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VMProducts"
      },
      nullable: !0
    },
    totalCount: {
      type: "integer",
      format: "int64"
    }
  },
  additionalProperties: !1
}, rP = {
  required: ["productTypeId"],
  type: "object",
  properties: {
    identifier: {
      type: "string",
      nullable: !0
    },
    name: {
      type: "string",
      nullable: !0
    },
    description: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    partId: {
      type: "string",
      nullable: !0
    },
    validFrom: {
      type: "string",
      format: "date-time",
      nullable: !0
    },
    validTo: {
      type: "string",
      format: "date-time",
      nullable: !0
    },
    isActive: {
      type: "boolean"
    },
    productPath: {
      type: "string",
      nullable: !0
    },
    typeCode: {
      type: "string",
      nullable: !0
    },
    region: {
      type: "string",
      nullable: !0
    },
    customer: {
      type: "string",
      nullable: !0
    },
    isShared: {
      type: "boolean"
    },
    cfgObjectIdentifier: {
      type: "string",
      nullable: !0
    },
    productTypeId: {
      type: "string",
      format: "uuid"
    },
    productStateId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    productGroupId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    imageId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    listPrice: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPricesEmbeddedPost"
        }
      ],
      nullable: !0
    },
    cost: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPricesEmbeddedPost"
        }
      ],
      nullable: !0
    }
  },
  additionalProperties: !1
}, oP = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    name: {
      type: "string",
      nullable: !0
    },
    description: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    partId: {
      type: "string",
      nullable: !0
    },
    validFrom: {
      type: "string",
      format: "date-time",
      nullable: !0
    },
    validTo: {
      type: "string",
      format: "date-time",
      nullable: !0
    },
    isActive: {
      type: "boolean",
      nullable: !0
    },
    productPath: {
      type: "string",
      nullable: !0
    },
    typeCode: {
      type: "string",
      nullable: !0
    },
    region: {
      type: "string",
      nullable: !0
    },
    customer: {
      type: "string",
      nullable: !0
    },
    isShared: {
      type: "boolean",
      nullable: !0
    },
    cfgObjectIdentifier: {
      type: "string",
      nullable: !0
    },
    originalListPrice: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPricesEmbeddedPut"
        }
      ],
      nullable: !0
    },
    originalCost: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPricesEmbeddedPut"
        }
      ],
      nullable: !0
    },
    productGroupId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    productTypeId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    productStateId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    configId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    imageId: {
      type: "string",
      format: "uuid",
      nullable: !0
    }
  },
  additionalProperties: !1
}, nP = {
  required: ["dataTypeId", "id", "identifier", "propertySetId", "rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    identifier: {
      minLength: 1,
      type: "string"
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    value: {
      type: "string",
      nullable: !0
    },
    propertySetId: {
      type: "string",
      format: "uuid"
    },
    dataTypeId: {
      type: "string",
      format: "uuid"
    },
    dataType: {
      allOf: [
        {
          $ref: "#/components/schemas/VMDataTypes"
        }
      ],
      nullable: !0
    },
    translations: {
      type: "object",
      additionalProperties: {
        $ref: "#/components/schemas/VMTranslationProps"
      },
      nullable: !0
    }
  },
  additionalProperties: !1
}, iP = {
  required: ["identifier"],
  type: "object",
  properties: {
    identifier: {
      minLength: 1,
      type: "string"
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    value: {
      type: "string",
      nullable: !0
    },
    dataTypeId: {
      type: "string",
      format: "uuid",
      nullable: !0
    }
  },
  additionalProperties: !1
}, aP = {
  required: ["id", "rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    id: {
      type: "string",
      format: "uuid"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    value: {
      type: "string",
      nullable: !0
    },
    dataTypeId: {
      type: "string",
      format: "uuid",
      nullable: !0
    }
  },
  additionalProperties: !1
}, sP = {
  required: ["identifier", "propertySetId"],
  type: "object",
  properties: {
    identifier: {
      minLength: 1,
      type: "string"
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    value: {
      type: "string",
      nullable: !0
    },
    propertySetId: {
      type: "string",
      format: "uuid"
    },
    dataTypeId: {
      type: "string",
      format: "uuid",
      nullable: !0
    }
  },
  additionalProperties: !1
}, uP = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    value: {
      type: "string",
      nullable: !0
    },
    dataTypeId: {
      type: "string",
      format: "uuid",
      nullable: !0
    }
  },
  additionalProperties: !1
}, lP = {
  required: ["id", "identifier", "rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    identifier: {
      minLength: 1,
      type: "string"
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    opportunityId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    quoteId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    itemGroupId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    lineItemId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    subItemId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    projectItemId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    projectListId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    attachmentId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    propertyIds: {
      type: "array",
      items: {
        type: "string",
        format: "uuid"
      },
      nullable: !0
    },
    properties: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VMProperties"
      },
      nullable: !0
    }
  },
  additionalProperties: !1
}, cP = {
  required: ["identifier"],
  type: "object",
  properties: {
    identifier: {
      minLength: 1,
      type: "string"
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    properties: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VMPropertiesEmbeddedPost"
      },
      nullable: !0
    }
  },
  additionalProperties: !1
}, dP = {
  required: ["id", "rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    id: {
      type: "string",
      format: "uuid"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    properties: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VMPropertiesEmbeddedPut"
      },
      nullable: !0
    }
  },
  additionalProperties: !1
}, pP = {
  required: ["identifier"],
  type: "object",
  properties: {
    identifier: {
      minLength: 1,
      type: "string"
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    opportunityId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    quoteId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    itemGroupId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    lineItemId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    subItemId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    projectItemId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    projectListId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    productId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    attachmentId: {
      type: "string",
      format: "uuid",
      nullable: !0
    }
  },
  additionalProperties: !1
}, mP = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    opportunityId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    quoteId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    itemGroupId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    lineItemId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    subItemId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    projectItemId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    projectListId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    attachmentId: {
      type: "string",
      format: "uuid",
      nullable: !0
    }
  },
  additionalProperties: !1
}, yP = {
  required: ["id", "opportunityId", "rowVersion", "statusId"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    name: {
      type: "string",
      nullable: !0
    },
    description: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    uniqueNumberString: {
      type: "string",
      nullable: !0
    },
    rank: {
      type: "integer",
      format: "int32"
    },
    isOptional: {
      type: "boolean"
    },
    legacyCustomerName: {
      type: "string",
      nullable: !0
    },
    legacyCompanyName: {
      type: "string",
      nullable: !0
    },
    region: {
      type: "string",
      nullable: !0
    },
    validFrom: {
      type: "string",
      format: "date-time",
      nullable: !0
    },
    validTo: {
      type: "string",
      format: "date-time",
      nullable: !0
    },
    dataType: {
      type: "string",
      nullable: !0
    },
    targetMargin: {
      type: "number",
      format: "double",
      nullable: !0
    },
    targetPrice: {
      type: "number",
      format: "double",
      nullable: !0
    },
    margin: {
      type: "number",
      format: "double",
      nullable: !0
    },
    listPrice: {
      type: "number",
      format: "double",
      nullable: !0
    },
    cost: {
      type: "number",
      format: "double",
      nullable: !0
    },
    totalList: {
      type: "number",
      format: "double",
      nullable: !0
    },
    totalCost: {
      type: "number",
      format: "double",
      nullable: !0
    },
    totalNet: {
      type: "number",
      format: "double",
      nullable: !0
    },
    discount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    discountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceDiscount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceDiscountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    projectDiscount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    projectDiscountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    bonusDiscount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    bonusDiscountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    markup: {
      type: "number",
      format: "double",
      nullable: !0
    },
    markupPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceMarkup: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceMarkupPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    totalDiscount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    totalDiscountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    optionalMargin: {
      type: "number",
      format: "double",
      nullable: !0
    },
    optionalTotalList: {
      type: "number",
      format: "double",
      nullable: !0
    },
    optionalTotalCost: {
      type: "number",
      format: "double",
      nullable: !0
    },
    optionalTotalNet: {
      type: "number",
      format: "double",
      nullable: !0
    },
    optionalTotalDiscount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    optionalTotalDiscountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    opportunityId: {
      type: "string",
      format: "uuid"
    },
    statusId: {
      type: "string",
      format: "uuid"
    },
    propertySetId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    attachmentSetId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    priceListId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    priceListServicesId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    currencyId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    companyId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    customerId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    status: {
      allOf: [
        {
          $ref: "#/components/schemas/VMStatus"
        }
      ],
      nullable: !0
    },
    propertySet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPropertySets"
        }
      ],
      nullable: !0
    },
    attachementSet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMAttachmentSets"
        }
      ],
      nullable: !0
    },
    currency: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPriceCurrencies"
        }
      ],
      nullable: !0
    },
    company: {
      allOf: [
        {
          $ref: "#/components/schemas/VMCompanies"
        }
      ],
      nullable: !0
    },
    customer: {
      allOf: [
        {
          $ref: "#/components/schemas/VMCustomers"
        }
      ],
      nullable: !0
    },
    itemGroupIds: {
      type: "array",
      items: {
        type: "string",
        format: "uuid"
      },
      nullable: !0
    },
    itemGroups: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VMItemGroups"
      },
      nullable: !0
    },
    lineItemIds: {
      type: "array",
      items: {
        type: "string",
        format: "uuid"
      },
      nullable: !0
    },
    lineItems: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VMLineItems"
      },
      nullable: !0
    },
    priceLists: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VMPriceLists"
      },
      nullable: !0
    },
    salesLocations: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VMSalesLocations"
      },
      nullable: !0
    }
  },
  additionalProperties: !1
}, gP = {
  type: "object",
  properties: {
    quotes: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VMQuotes"
      },
      nullable: !0
    },
    totalCount: {
      type: "integer",
      format: "int64"
    }
  },
  additionalProperties: !1
}, bP = {
  type: "object",
  properties: {
    identifier: {
      type: "string",
      nullable: !0
    },
    name: {
      type: "string",
      nullable: !0
    },
    description: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    isOptional: {
      type: "boolean",
      nullable: !0
    },
    rank: {
      type: "integer",
      format: "int32",
      nullable: !0
    },
    customer: {
      type: "string",
      nullable: !0
    },
    company: {
      type: "string",
      nullable: !0
    },
    region: {
      type: "string",
      nullable: !0
    },
    validFrom: {
      type: "string",
      format: "date-time",
      nullable: !0
    },
    validTo: {
      type: "string",
      format: "date-time",
      nullable: !0
    },
    propertySet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPropertySetsEmbeddedPost"
        }
      ],
      nullable: !0
    },
    attachmentSet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMAttachmentSetsEmbeddedPost"
        }
      ],
      nullable: !0
    },
    discount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    discountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceDiscount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceDiscountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    projectDiscount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    projectDiscountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    bonusDiscount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    bonusDiscountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    markup: {
      type: "number",
      format: "double",
      nullable: !0
    },
    markupPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceMarkup: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceMarkupPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    opportunityId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    statusId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    currencyId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    companyId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    customerId: {
      type: "string",
      format: "uuid",
      nullable: !0
    }
  },
  additionalProperties: !1
}, fP = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    name: {
      type: "string",
      nullable: !0
    },
    description: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    isOptional: {
      type: "boolean",
      nullable: !0
    },
    rank: {
      type: "integer",
      format: "int32",
      nullable: !0
    },
    customer: {
      type: "string",
      nullable: !0
    },
    company: {
      type: "string",
      nullable: !0
    },
    region: {
      type: "string",
      nullable: !0
    },
    validFrom: {
      type: "string",
      format: "date-time",
      nullable: !0
    },
    validTo: {
      type: "string",
      format: "date-time",
      nullable: !0
    },
    discount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    discountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceDiscount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceDiscountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    projectDiscount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    projectDiscountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    bonusDiscount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    bonusDiscountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    markup: {
      type: "number",
      format: "double",
      nullable: !0
    },
    markupPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceMarkup: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceMarkupPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    statusId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    opportunityId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    currencyId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    companyId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    customerId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    propertySet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPropertySetsEmbeddedPut"
        }
      ],
      nullable: !0
    },
    attachmentSet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMAttachmentSetsEmbeddedPut"
        }
      ],
      nullable: !0
    }
  },
  additionalProperties: !1
}, hP = {
  required: ["id", "priceListId", "rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    precedence: {
      type: "integer",
      format: "int32"
    },
    priceListId: {
      type: "string",
      format: "uuid"
    },
    quoteId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    itemGroupId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    lineItemId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    subItemId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    priceList: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPriceLists"
        }
      ],
      nullable: !0
    }
  },
  additionalProperties: !1
}, IP = {
  required: ["priceListId"],
  type: "object",
  properties: {
    priceListId: {
      type: "string",
      format: "uuid"
    },
    quoteId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    itemGroupId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    lineItemId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    subItemId: {
      type: "string",
      format: "uuid",
      nullable: !0
    }
  },
  additionalProperties: !1
}, SP = {
  required: ["priceListId"],
  type: "object",
  properties: {
    priceListId: {
      type: "string",
      format: "uuid"
    },
    precedence: {
      type: "integer",
      format: "int32"
    },
    quoteId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    itemGroupId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    lineItemId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    subItemId: {
      type: "string",
      format: "uuid",
      nullable: !0
    }
  },
  additionalProperties: !1
}, PP = {
  required: ["priceListId"],
  type: "object",
  properties: {
    priceListId: {
      type: "string",
      format: "uuid"
    },
    precedence: {
      type: "integer",
      format: "int32"
    }
  },
  additionalProperties: !1
}, CP = {
  required: ["priceListIds"],
  type: "object",
  properties: {
    quoteId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    itemGroupId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    lineItemId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    subItemId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    priceListIds: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VMRelationPriceListsReplace"
      }
    }
  },
  additionalProperties: !1
}, qP = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    customerId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    quoteId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    salesLocationId: {
      type: "string",
      format: "uuid"
    }
  },
  additionalProperties: !1
}, vP = {
  type: "object",
  properties: {
    customerIds: {
      type: "array",
      items: {
        type: "string",
        format: "uuid"
      },
      nullable: !0
    },
    quoteIds: {
      type: "array",
      items: {
        type: "string",
        format: "uuid"
      },
      nullable: !0
    }
  },
  additionalProperties: !1
}, TP = {
  type: "object",
  properties: {
    salesLocationIds: {
      type: "array",
      items: {
        type: "string",
        format: "uuid"
      },
      nullable: !0
    }
  },
  additionalProperties: !1
}, BP = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    contactSalutation: {
      type: "string",
      nullable: !0
    },
    contactTitle: {
      type: "string",
      nullable: !0
    },
    contactFirstName: {
      type: "string",
      nullable: !0
    },
    contactLastName: {
      type: "string",
      nullable: !0
    },
    street: {
      type: "string",
      nullable: !0
    },
    streetNumber: {
      type: "string",
      nullable: !0
    },
    postalCode: {
      type: "string",
      nullable: !0
    },
    town: {
      type: "string",
      nullable: !0
    },
    country: {
      type: "string",
      nullable: !0
    },
    emailAddress: {
      type: "string",
      nullable: !0
    },
    phoneNumber: {
      type: "string",
      nullable: !0
    },
    mobileNumber: {
      type: "string",
      nullable: !0
    },
    propertySetId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    companyId: {
      type: "string",
      format: "uuid"
    },
    propertySet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPropertySets"
        }
      ],
      nullable: !0
    },
    company: {
      allOf: [
        {
          $ref: "#/components/schemas/VMCompanies"
        }
      ],
      nullable: !0
    },
    customers: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VMCustomers"
      },
      nullable: !0
    }
  },
  additionalProperties: !1
}, LP = {
  type: "object",
  properties: {
    identifier: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    contactSalutation: {
      type: "string",
      nullable: !0
    },
    contactTitle: {
      type: "string",
      nullable: !0
    },
    contactFirstName: {
      type: "string",
      nullable: !0
    },
    contactLastName: {
      type: "string",
      nullable: !0
    },
    street: {
      type: "string",
      nullable: !0
    },
    streetNumber: {
      type: "string",
      nullable: !0
    },
    postalCode: {
      type: "string",
      nullable: !0
    },
    town: {
      type: "string",
      nullable: !0
    },
    country: {
      type: "string",
      nullable: !0
    },
    emailAddress: {
      type: "string",
      nullable: !0
    },
    phoneNumber: {
      type: "string",
      nullable: !0
    },
    mobileNumber: {
      type: "string",
      nullable: !0
    },
    companyId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    customerIds: {
      type: "array",
      items: {
        type: "string",
        format: "uuid"
      },
      nullable: !0
    },
    quoteIds: {
      type: "array",
      items: {
        type: "string",
        format: "uuid"
      },
      nullable: !0
    }
  },
  additionalProperties: !1
}, GP = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    contactSalutation: {
      type: "string",
      nullable: !0
    },
    contactTitle: {
      type: "string",
      nullable: !0
    },
    contactFirstName: {
      type: "string",
      nullable: !0
    },
    contactLastName: {
      type: "string",
      nullable: !0
    },
    street: {
      type: "string",
      nullable: !0
    },
    streetNumber: {
      type: "string",
      nullable: !0
    },
    postalCode: {
      type: "string",
      nullable: !0
    },
    town: {
      type: "string",
      nullable: !0
    },
    country: {
      type: "string",
      nullable: !0
    },
    emailAddress: {
      type: "string",
      nullable: !0
    },
    phoneNumber: {
      type: "string",
      nullable: !0
    },
    mobileNumber: {
      type: "string",
      nullable: !0
    },
    companyId: {
      type: "string",
      format: "uuid",
      nullable: !0
    }
  },
  additionalProperties: !1
}, AP = {
  required: ["value"],
  type: "object",
  properties: {
    value: {
      minLength: 1,
      type: "string"
    },
    resultType: {
      type: "string",
      nullable: !0
    },
    include: {
      type: "array",
      items: {
        type: "string"
      },
      nullable: !0
    },
    exclude: {
      type: "array",
      items: {
        type: "string"
      },
      nullable: !0
    }
  },
  additionalProperties: !1
}, FP = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      format: "int32"
    },
    identifier: {
      type: "string",
      nullable: !0
    }
  },
  additionalProperties: !1
}, OP = {
  required: ["id", "identifier", "rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    identifier: {
      minLength: 1,
      type: "string"
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    }
  },
  additionalProperties: !1
}, wP = {
  type: "object",
  properties: {
    identifier: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    }
  },
  additionalProperties: !1
}, DP = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    }
  },
  additionalProperties: !1
}, RP = {
  required: ["id", "title"],
  type: "object",
  properties: {
    title: {
      minLength: 1,
      type: "string"
    },
    name: {
      type: "string",
      nullable: !0
    },
    description: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    isRoot: {
      type: "boolean"
    },
    resource: {
      type: "string",
      nullable: !0
    },
    resourceId: {
      type: "string",
      format: "uuid"
    },
    hasChildren: {
      type: "boolean"
    },
    hasProducts: {
      type: "boolean"
    },
    numProducts: {
      type: "integer",
      format: "int32"
    },
    children: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VMStructureTreeCompact"
      },
      nullable: !0
    },
    translations: {
      type: "object",
      additionalProperties: {
        $ref: "#/components/schemas/VMTranslationProps"
      },
      nullable: !0
    },
    createdBy: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    rank: {
      type: "integer",
      format: "int32"
    }
  },
  additionalProperties: !1
}, VP = {
  required: ["id", "lineItemId", "rowVersion", "statusId"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    name: {
      type: "string",
      nullable: !0
    },
    description: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    rank: {
      type: "integer",
      format: "int32"
    },
    displayedRank: {
      type: "string",
      nullable: !0
    },
    isOptional: {
      type: "boolean"
    },
    isConfigurationComplete: {
      type: "boolean",
      nullable: !0
    },
    quantity: {
      type: "number",
      format: "double",
      nullable: !0
    },
    quantityUnitSymbol: {
      type: "string",
      nullable: !0
    },
    dataType: {
      type: "string",
      nullable: !0
    },
    isTop: {
      type: "boolean",
      nullable: !0
    },
    isTopChangeable: {
      type: "boolean",
      nullable: !0
    },
    targetMargin: {
      type: "number",
      format: "double",
      nullable: !0
    },
    targetPrice: {
      type: "number",
      format: "double",
      nullable: !0
    },
    margin: {
      type: "number",
      format: "double",
      nullable: !0
    },
    listPrice: {
      type: "number",
      format: "double",
      nullable: !0
    },
    cost: {
      type: "number",
      format: "double",
      nullable: !0
    },
    totalList: {
      type: "number",
      format: "double",
      nullable: !0
    },
    totalCost: {
      type: "number",
      format: "double",
      nullable: !0
    },
    totalNet: {
      type: "number",
      format: "double",
      nullable: !0
    },
    discount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    discountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceDiscount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceDiscountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    projectDiscount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    projectDiscountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    bonusDiscount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    bonusDiscountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    markup: {
      type: "number",
      format: "double",
      nullable: !0
    },
    markupPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceMarkup: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceMarkupPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    totalDiscount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    totalDiscountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    currency: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPriceCurrencies"
        }
      ],
      nullable: !0
    },
    lineItemId: {
      type: "string",
      format: "uuid"
    },
    companyId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    statusId: {
      type: "string",
      format: "uuid"
    },
    productId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    propertySetId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    attachmentSetId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    commentSetId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    configurationId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    quantityUnitId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    company: {
      allOf: [
        {
          $ref: "#/components/schemas/VMCompanies"
        }
      ],
      nullable: !0
    },
    product: {
      allOf: [
        {
          $ref: "#/components/schemas/VMProducts"
        }
      ],
      nullable: !0
    },
    status: {
      allOf: [
        {
          $ref: "#/components/schemas/VMStatus"
        }
      ],
      nullable: !0
    },
    propertySet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPropertySets"
        }
      ],
      nullable: !0
    },
    attachmentSet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMAttachmentSets"
        }
      ],
      nullable: !0
    },
    commentSet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMCommentSets"
        }
      ],
      nullable: !0
    },
    configuration: {
      allOf: [
        {
          $ref: "#/components/schemas/VMConfigurations"
        }
      ],
      nullable: !0
    },
    priceLists: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VMPriceLists"
      },
      nullable: !0
    }
  },
  additionalProperties: !1
}, NP = {
  type: "object",
  properties: {
    name: {
      type: "string",
      nullable: !0
    },
    value: {
      type: "string",
      nullable: !0
    },
    rangeLower: {
      type: "number",
      format: "float",
      nullable: !0
    },
    rangeUpper: {
      type: "number",
      format: "float",
      nullable: !0
    }
  },
  additionalProperties: !1
}, MP = {
  type: "object",
  properties: {
    subItems: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VMSubItems"
      },
      nullable: !0
    },
    totalCount: {
      type: "integer",
      format: "int64"
    }
  },
  additionalProperties: !1
}, xP = {
  required: ["lineItemId"],
  type: "object",
  properties: {
    lineItemId: {
      type: "string",
      format: "uuid"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    name: {
      type: "string",
      nullable: !0
    },
    description: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    isOptional: {
      type: "boolean",
      nullable: !0
    },
    quantity: {
      type: "number",
      format: "double",
      nullable: !0
    },
    rank: {
      type: "integer",
      format: "int32",
      nullable: !0
    },
    statusId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    companyId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    quantityUnitId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    propertySet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPropertySetsEmbeddedPost"
        }
      ],
      nullable: !0
    },
    attachmentSet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMAttachmentSetsEmbeddedPost"
        }
      ],
      nullable: !0
    },
    productId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    product: {
      allOf: [
        {
          $ref: "#/components/schemas/VMProductsPost"
        }
      ],
      nullable: !0
    }
  },
  additionalProperties: !1
}, EP = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    name: {
      type: "string",
      nullable: !0
    },
    description: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    isOptional: {
      type: "boolean",
      nullable: !0
    },
    isTop: {
      type: "boolean",
      nullable: !0
    },
    quantity: {
      type: "number",
      format: "double",
      nullable: !0
    },
    rank: {
      type: "integer",
      format: "int32",
      nullable: !0
    },
    discount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    discountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceDiscount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceDiscountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    projectDiscount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    projectDiscountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    bonusDiscount: {
      type: "number",
      format: "double",
      nullable: !0
    },
    bonusDiscountPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    markup: {
      type: "number",
      format: "double",
      nullable: !0
    },
    markupPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceMarkup: {
      type: "number",
      format: "double",
      nullable: !0
    },
    serviceMarkupPercentage: {
      type: "number",
      format: "double",
      nullable: !0
    },
    statusId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    companyId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    productId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    lineItemId: {
      type: "string",
      format: "uuid",
      nullable: !0
    },
    propertySet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMPropertySetsEmbeddedPut"
        }
      ],
      nullable: !0
    },
    attachmentSet: {
      allOf: [
        {
          $ref: "#/components/schemas/VMAttachmentSetsEmbeddedPut"
        }
      ],
      nullable: !0
    }
  },
  additionalProperties: !1
}, UP = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    id: {
      type: "integer",
      format: "int32"
    },
    companyName: {
      type: "string",
      nullable: !0
    },
    fileMaxSize: {
      type: "integer",
      format: "int64"
    },
    fileMinSize: {
      type: "integer",
      format: "int64"
    },
    multipleFiles: {
      type: "boolean"
    },
    autoCompleteMinLength: {
      type: "integer",
      format: "int32"
    }
  },
  additionalProperties: !1
}, QP = {
  required: [
    "autoCompleteMinLength",
    "companyName",
    "fileMaxSize",
    "fileMinSize",
    "id",
    "multipleFiles"
  ],
  type: "object",
  properties: {
    id: {
      type: "integer",
      format: "int32"
    },
    companyName: {
      minLength: 1,
      type: "string"
    },
    fileMaxSize: {
      type: "integer",
      format: "int64"
    },
    fileMinSize: {
      type: "integer",
      format: "int64"
    },
    multipleFiles: {
      type: "boolean"
    },
    autoCompleteMinLength: {
      type: "integer",
      format: "int32"
    }
  },
  additionalProperties: !1
}, kP = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    companyName: {
      type: "string",
      nullable: !0
    },
    fileMaxSize: {
      type: "integer",
      format: "int64",
      nullable: !0
    },
    fileMinSize: {
      type: "integer",
      format: "int64",
      nullable: !0
    },
    multipleFiles: {
      type: "boolean",
      nullable: !0
    },
    autoCompleteMinLength: {
      type: "integer",
      format: "int32",
      nullable: !0
    }
  },
  additionalProperties: !1
}, jP = {
  type: "object",
  properties: {
    languageId: {
      type: "string",
      format: "uuid"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    referenceIdentifier: {
      type: "string",
      nullable: !0
    },
    name: {
      type: "string",
      nullable: !0
    },
    description: {
      type: "string",
      nullable: !0
    }
  },
  additionalProperties: !1
}, $P = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    symbol: {
      type: "string",
      nullable: !0
    },
    isBaseDimension: {
      type: "boolean"
    },
    translations: {
      type: "object",
      additionalProperties: {
        $ref: "#/components/schemas/VMTranslationProps"
      },
      nullable: !0
    }
  },
  additionalProperties: !1
}, zP = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    symbol: {
      type: "string",
      nullable: !0
    },
    isLanguageDependent: {
      type: "boolean"
    },
    isBaseUnit: {
      type: "boolean"
    },
    numerator: {
      type: "integer",
      format: "int64"
    },
    denominator: {
      type: "integer",
      format: "int64"
    },
    offset: {
      type: "number",
      format: "double"
    },
    unitDimension: {
      allOf: [
        {
          $ref: "#/components/schemas/VMUnitDimensions"
        }
      ],
      nullable: !0
    },
    translations: {
      type: "object",
      additionalProperties: {
        $ref: "#/components/schemas/VMTranslationProps"
      },
      nullable: !0
    }
  },
  additionalProperties: !1
}, KP = {
  type: "object",
  properties: {
    id: {
      type: "string",
      format: "uuid"
    },
    email: {
      type: "string",
      nullable: !0
    },
    preferredUsername: {
      type: "string",
      nullable: !0
    },
    emailVerified: {
      type: "boolean"
    },
    name: {
      type: "string",
      nullable: !0
    },
    givenName: {
      type: "string",
      nullable: !0
    },
    familyName: {
      type: "string",
      nullable: !0
    },
    roles: {
      type: "array",
      items: {
        type: "string"
      },
      nullable: !0
    }
  },
  additionalProperties: !1
}, HP = {
  required: ["id", "identifier", "name", "rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    createdBy: {
      type: "string",
      nullable: !0
    },
    createdByName: {
      type: "string",
      nullable: !0
    },
    createdOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedOn: {
      type: "string",
      format: "date-time"
    },
    lastUpdatedBy: {
      type: "string",
      nullable: !0
    },
    lastUpdatedByName: {
      type: "string",
      nullable: !0
    },
    id: {
      type: "string",
      format: "uuid"
    },
    identifier: {
      minLength: 1,
      type: "string"
    },
    name: {
      minLength: 1,
      type: "string"
    },
    oldName: {
      type: "string",
      nullable: !0
    }
  },
  additionalProperties: !1
}, _P = {
  required: ["identifier", "name"],
  type: "object",
  properties: {
    identifier: {
      minLength: 1,
      type: "string"
    },
    name: {
      minLength: 1,
      type: "string"
    },
    oldName: {
      type: "string",
      nullable: !0
    }
  },
  additionalProperties: !1
}, WP = {
  required: ["rowVersion"],
  type: "object",
  properties: {
    rowVersion: {
      type: "integer",
      format: "int64"
    },
    identifier: {
      type: "string",
      nullable: !0
    },
    name: {
      type: "string",
      nullable: !0
    },
    oldName: {
      type: "string",
      nullable: !0
    }
  },
  additionalProperties: !1
}, up = In({
  queryKey: [Qt],
  queryFn: () => Le.getStatus(),
  staleTime: 1 / 0
}), ae = nn({
  staticData: {
    title: "__homeIcon__"
  },
  beforeLoad: async () => {
    const t = await ye.ensureQueryData(up);
    return { status: t == null ? void 0 : t.reduce((r, o) => (r[o.identifier] = o, r), {}) };
  },
  component: C.RootRouteComponent
}), lp = k("/quotes")({
  component: C.QuotesRouteComponent
}), cp = k("/configurator")({
  component: C.ConfiguratorRouteComponent,
  validateSearch: (t) => ({
    cfgObjectId: String((t == null ? void 0 : t.cfgObjectId) ?? ""),
    productId: String(t.productId ?? ""),
    quoteId: String(t.quoteId ?? ""),
    lineItemId: String(t.lineItemId ?? ""),
    productIdentifier: String(t.productIdentifier ?? ""),
    configurationId: t.configurationId ? String(t.configurationId) : void 0
  })
}), dp = k("/")({
  component: C.IndexRouteComponent
}), pp = k("/presets/")({
  component: C.PresetsRouteComponent,
  staticData: {
    title: "Presets"
  }
}), mp = k("/opportunities/")({
  component: C.OpportunityRouteComponent,
  staticData: {
    title: "Opportunities"
  },
  validateSearch: (t) => ({
    page: Number((t == null ? void 0 : t.page) ?? 1),
    pageSize: Number((t == null ? void 0 : t.pageSize) ?? 10),
    filter: t.filter || ""
  }),
  errorComponent: (t) => /* @__PURE__ */ u("div", { children: JSON.stringify(t) })
}), Pe = k("/quotes/$quoteId")({
  staticData: {
    //if in Quote, we will show the quote identifier in the Breadcrumbs instead of the title
    title: "Quote"
  },
  notFoundComponent: () => /* @__PURE__ */ u(C.QuotesQuoteIdNotFoundPage, {}),
  component: C.QuotesQuoteIdRouteComponent
});
function vt(t) {
  const { buttonProps: e, dialog: r, renderTrigger: o } = t, [n, i] = G(!1);
  function a() {
    typeof r.onClose == "function" && r.onClose(), i(!1);
  }
  function s(c) {
    c.preventDefault(), c.stopPropagation(), i(!0);
  }
  const l = o ? o({ onClick: s }) : null;
  return /* @__PURE__ */ f(w, { children: [
    !l && /* @__PURE__ */ u(Q, { ...e, onClick: s }),
    l,
    /* @__PURE__ */ f(
      It,
      {
        ...r.dialogProps,
        open: n,
        onClose: a,
        onClick: (c) => c.stopPropagation(),
        children: [
          /* @__PURE__ */ u(
            qt,
            {
              title: r.title,
              subtitle: r.subtitle,
              onClose: a
            }
          ),
          r.content && /* @__PURE__ */ u(St, { children: r.content }),
          r.actions && r.actions({ closeDialog: a })
        ]
      }
    )
  ] });
}
function st({
  onCancel: t,
  textCancel: e,
  cancelDisabled: r,
  onConfirm: o,
  textConfirm: n,
  confirmDisabled: i
}) {
  const { t: a } = T();
  return /* @__PURE__ */ f(Or, { onClick: (s) => s.stopPropagation(), children: [
    t && /* @__PURE__ */ u(
      Q,
      {
        variant: "outlined",
        onClick: (s) => {
          s.stopPropagation(), t();
        },
        disabled: r,
        children: e || a("CPQ:button.cancel")
      }
    ),
    o && /* @__PURE__ */ u(
      Q,
      {
        variant: "contained",
        onClick: (s) => {
          s.stopPropagation(), o(s);
        },
        disabled: i,
        children: n || a("CPQ:button.save")
      }
    )
  ] });
}
function yp({
  type: t = "icon",
  icon: e,
  dialog: r,
  onConfirm: o,
  disabled: n,
  renderTrigger: i
}) {
  const { t: a } = T();
  return /* @__PURE__ */ u(
    vt,
    {
      ...t === "button" ? {
        buttonProps: {
          variant: "text",
          startIcon: /* @__PURE__ */ u(F, { children: "delete" }),
          children: a("CPQ:button.delete"),
          disabled: n
        },
        renderTrigger: void 0
      } : {
        renderTrigger: i || (t === "icon" ? (l) => /* @__PURE__ */ u(z, { disabled: n, ...l, children: /* @__PURE__ */ u(F, { children: e || "delete" }) }) : void 0),
        buttonProps: void 0
      },
      dialog: {
        dialogProps: {
          fullWidth: !0,
          maxWidth: "xs"
        },
        title: r != null && r.title ? r == null ? void 0 : r.title : a("CPQ:dialog.confirm.genericDelete.title"),
        subtitle: r != null && r.subtitle ? r == null ? void 0 : r.subtitle : a("CPQ:dialog.confirm.genericDelete.subtitle"),
        actions: (l) => /* @__PURE__ */ u(
          st,
          {
            onCancel: l.closeDialog,
            onConfirm: () => {
              l.closeDialog(), o();
            }
          }
        )
      }
    }
  );
}
function gp({
  onClick: t
}) {
  return /* @__PURE__ */ u(w, { children: /* @__PURE__ */ u(
    F,
    {
      onClick: () => typeof t == "function" && t(),
      sx: { color: "rgba(0, 0, 0, 0.54)" },
      children: "content_copy"
    }
  ) });
}
function bp({ item: t }) {
  const { t: e } = T(), r = te(), { mutate: o } = qd(), { mutate: n } = Vd(), [i, a] = De.useState(null), s = !!i, l = (S) => {
    S.stopPropagation(), a(S.currentTarget);
  }, c = (S) => {
    a(null), S.stopPropagation();
  };
  function m() {
    a(null), o(
      {
        id: t.id,
        cloneDeep: !0,
        cloneAttachments: !0,
        cloneComments: !0,
        cloneConfiguration: !0,
        cloneProperties: !0
      },
      {
        onSuccess: () => {
          r.invalidateQueries({
            queryKey: [K]
          });
        }
      }
    );
  }
  function P() {
    a(null), n(
      {
        id: t.id
      },
      {
        onSuccess: () => {
          r.invalidateQueries({
            queryKey: [K]
          });
        }
      }
    );
  }
  return /* @__PURE__ */ f(w, { children: [
    /* @__PURE__ */ u(At, { onClick: l, children: /* @__PURE__ */ u(gt, { children: " more_horiz" }) }),
    /* @__PURE__ */ f(
      Mt,
      {
        anchorEl: i,
        open: s,
        onClose: c,
        onClick: (S) => S.stopPropagation(),
        children: [
          /* @__PURE__ */ f(
            bt,
            {
              onClick: m,
              sx: {
                gap: "0.75rem"
              },
              children: [
                /* @__PURE__ */ u(gp, { onClick: m }),
                e("CPQ:table.lineItems.actions.cloneRow")
              ]
            }
          ),
          /* @__PURE__ */ u(
            yp,
            {
              renderTrigger: (S) => /* @__PURE__ */ f(
                bt,
                {
                  ...S,
                  sx: {
                    gap: "0.75rem"
                  },
                  children: [
                    /* @__PURE__ */ u(gt, { sx: { color: "rgba(0, 0, 0, 0.54)" }, children: "delete" }),
                    e("CPQ:table.lineItems.actions.deleteRow")
                  ]
                }
              ),
              onConfirm: P
            }
          )
        ]
      }
    )
  ] });
}
function Co() {
  return X(So);
}
function fp({
  name: t,
  setName: e
}) {
  const { t: r } = T();
  return /* @__PURE__ */ u(h, { display: "flex", gap: "2rem", flex: 1, children: /* @__PURE__ */ u(
    ve,
    {
      autoFocus: !0,
      sx: { flex: 1 },
      required: !0,
      label: r("CPQ:dialog.addItemGroup.input.label.itemGroupName"),
      variant: "outlined",
      value: t,
      onChange: (o) => e(o.target.value)
    }
  ) });
}
function hp({
  itemGroup: t,
  disabled: e
}) {
  const { t: r } = T(), o = te(), [n, i] = G(t.identifier), { status: a } = Co(), s = a.default.id, { mutate: l, isPending: c } = zt({});
  function m() {
    i("");
  }
  function P() {
    l(
      {
        id: t.id,
        requestBody: {
          identifier: n,
          statusId: s,
          rowVersion: t.rowVersion
        }
      },
      {
        onSuccess: () => {
          o.invalidateQueries({
            queryKey: [K]
          }), m();
        },
        onError: (S) => console.error(S)
      }
    );
  }
  return c ? /* @__PURE__ */ u(be, {}) : /* @__PURE__ */ u(
    vt,
    {
      renderTrigger: (S) => /* @__PURE__ */ u(z, { disabled: e, ...S, children: /* @__PURE__ */ u(F, { children: "edit" }) }),
      dialog: {
        title: r("CPQ:dialog.updateItemGroup.title"),
        dialogProps: {
          fullWidth: !0,
          maxWidth: "xs"
        },
        content: /* @__PURE__ */ u(fp, { name: n, setName: i }),
        actions: ({ closeDialog: S }) => /* @__PURE__ */ u(
          st,
          {
            onCancel: () => {
              S(), m();
            },
            onConfirm: P,
            confirmDisabled: !n || n === t.identifier
          }
        )
      }
    }
  );
}
function qo({
  lineItems: t,
  quoteId: e
}) {
  return (t == null ? void 0 : t.length) && /* @__PURE__ */ u(h, { display: "flex", flexDirection: "column", flex: 1, children: t == null ? void 0 : t.map((r) => /* @__PURE__ */ u(
    C.LineItemAccordion,
    {
      lineItem: r,
      quoteId: e
    },
    r.id
  )) });
}
function Ip() {
  var n;
  const { t } = T(), { quoteId: e } = Rt({ from: "/quoteStandalone/$quoteId" }), r = Ee({ from: "/quoteStandalone/$quoteId" }), { data: o } = Se({
    id: e,
    includes: "PriceLists,LineItems.Status,LineItems.Configuration,LineItems.PriceLists,LineItems.SubItems.PriceLists,PropertySet.Properties.Translations.Language,LineItems.PropertySet.Properties.Translations.Language,LineItems.SubItems.PropertySet.Properties.Translations.Language,LineItems.Product.ProductType,LineItems.Product.Translations.Language,LineItems.Product.PriceSets.Prices,LineItems.SubItems.Product.ProductType,LineItems.SubItems.Product.Translations.Language,LineItems.SubItems.Company,LineItems.SubItems.Configuration,LineItems.SubItems.Product.PriceSets.Prices",
    onlyOptional: !1
  });
  return o && /* @__PURE__ */ f(h, { display: "flex", flexDirection: "column", gap: 2, children: [
    /* @__PURE__ */ u(h, { justifySelf: "flex-start", children: /* @__PURE__ */ u(
      C.GoBackToOpportunityButton,
      {
        opportunityId: o.opportunityId
      }
    ) }),
    /* @__PURE__ */ u(
      C.PageHeading,
      {
        text: t("CPQ:header.quoteDetails") + " " + o.name
      }
    ),
    (n = o.itemGroups) == null ? void 0 : n.map((i) => /* @__PURE__ */ f(
      yt,
      {
        square: !0,
        sx: {
          padding: "1rem",
          display: "flex",
          alignItems: "center"
        },
        children: [
          /* @__PURE__ */ u(
            Rn,
            {
              primary: t("CPQ:itemGroup.name"),
              secondary: i.name
            }
          ),
          /* @__PURE__ */ u(C.ItemGroupAdditionalActions, {}),
          /* @__PURE__ */ u(hp, { itemGroup: i }),
          /* @__PURE__ */ u(bp, { item: i }),
          /* @__PURE__ */ u(
            z,
            {
              onClick: () => {
                r({ to: `/itemGroups/${i.id}` });
              },
              children: /* @__PURE__ */ u(F, { children: "visibility" })
            }
          ),
          /* @__PURE__ */ u(
            z,
            {
              onClick: () => {
                r({
                  to: `/cartGroup/${i.id}`
                });
              },
              children: /* @__PURE__ */ u(F, { children: "shopping_cart" })
            }
          )
        ]
      }
    )),
    /* @__PURE__ */ u(qo, { lineItems: o.lineItems, quoteId: o.id }),
    /* @__PURE__ */ u(h, { sx: { alignSelf: "center" } }),
    e && /* @__PURE__ */ u(h, { sx: { alignSelf: "center" }, children: /* @__PURE__ */ u(
      C.AddItemGroupButton,
      {
        quoteId: e,
        variant: "contained"
      }
    ) })
  ] });
}
const Sp = k("/quoteStandalone/$quoteId")({
  component: Pp
});
function Pp() {
  return /* @__PURE__ */ u(Ip, {});
}
const Cp = k("/opportunities/$opportunityId")({
  component: C.OpportunityIdRouteComponent,
  staticData: {
    title: "Opportunity"
  },
  validateSearch: (t) => ({
    search: t.search || "",
    statusId: t.statusId || ""
  })
});
function qp({
  onClick: t,
  text: e
}) {
  return /* @__PURE__ */ u(Q, { startIcon: /* @__PURE__ */ u(F, { children: "arrow_back" }), onClick: t, children: e });
}
function vp({ itemGroup: t }) {
  const { t: e } = T(), r = Ee();
  return /* @__PURE__ */ f(h, { display: "flex", flexDirection: "column", gap: 2, children: [
    /* @__PURE__ */ u(h, { justifySelf: "flex-start", children: /* @__PURE__ */ u(
      qp,
      {
        onClick: () => r({
          to: "/quoteStandalone/$quoteId",
          params: {
            quoteId: t.quoteId
          }
        }),
        text: e("CPQ:button.goBackToQuote")
      }
    ) }),
    /* @__PURE__ */ u(
      C.PageHeading,
      {
        text: e("CPQ:header.itemGroupDetails") + " " + t.name
      }
    ),
    /* @__PURE__ */ u(qo, { lineItems: t.lineItems, quoteId: t.quoteId }),
    /* @__PURE__ */ u(C.ItemGroupActionButtonsArea, { itemGroup: t })
  ] });
}
const vo = k("/itemGroups/$itemGroupId")({
  component: () => /* @__PURE__ */ u(Tp, {})
});
function Tp() {
  const { itemGroupId: t } = vo.useParams(), { data: e } = md({
    id: t,
    includes: "LineItems.Status,LineItems.Configuration,LineItems.Product.ProductType,LineItems.Product.Translations.Language,LineItems.Product.PriceSets.Prices,LineItems.SubItems.Status,LineItems.SubItems.Configuration,LineItems.SubItems.Product.ProductType,LineItems.SubItems.Product.Translations.Language,LineItems.SubItems.Product.PriceSets.Prices"
  });
  return /* @__PURE__ */ u(w, { children: e && /* @__PURE__ */ u(vp, { itemGroup: e }) });
}
const Bp = k("/cart/$quoteId")({
  component: C.CartIdRouteComponent,
  validateSearch: (t) => ({
    search: t.search || ""
  })
}), To = k("/quotes/$quoteId/")({
  component: Lp
});
function Lp() {
  const t = To.useParams().quoteId;
  return /* @__PURE__ */ u(an, { to: "/quotes/$quoteId/salesQuotationView", params: { quoteId: t } });
}
function H() {
  return X(Io);
}
function Gp({
  text: t,
  maxWidth: e,
  maxLines: r = 1
}) {
  return /* @__PURE__ */ u(Ue, { title: t, children: /* @__PURE__ */ u(
    h,
    {
      sx: {
        maxWidth: e,
        overflow: "hidden",
        ...r === 1 ? {
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        } : {
          display: "-webkit-box",
          WebkitLineClamp: r,
          "-webkit-box-orient": "vertical",
          overflow: "hidden"
        }
      },
      children: t
    }
  ) });
}
function Ap(t) {
  return typeof t == "function";
}
function Fp(t, e) {
  return Gt(
    (r) => {
      const o = Ap(r) ? r(t) : r;
      e(o);
    },
    [t, e]
  );
}
function Op({
  table: t
}) {
  const { showTableDebugTools: e } = zr();
  return e ? /* @__PURE__ */ u(_n, { table: t }) : null;
}
function Ve(t, e, r) {
  const [o, n] = G(() => {
    const l = localStorage.getItem(t);
    return l ? JSON.parse(l) : e;
  }), i = Gt(
    (l) => {
      localStorage.setItem(t, JSON.stringify(l));
    },
    [t]
  ), a = xr(
    (l) => {
      i(l);
    },
    r
  ), s = Gt(
    (l) => {
      n((c) => {
        const m = wp(l) ? l(c) : l;
        return r ? a(m) : i(m), m;
      });
    },
    [r, a, i]
  );
  return { value: o, onChange: s };
}
function wp(t) {
  return typeof t == "function";
}
function Dp(t) {
  let e = t.length;
  return {
    rows: t.map((o) => {
      const n = o.lineItems ?? [];
      return e += n.length, {
        ...o,
        subRows: n.map((i) => {
          const a = i.subItems ?? [];
          return e += a.length, {
            ...i,
            subRows: a
          };
        })
      };
    }) || [],
    totalRowsCount: e
  };
}
function Zt({
  data: t,
  tableOptions: e
}) {
  const r = Dp(t), o = r.totalRowsCount > 50, { value: n, onChange: i } = Ve(
    "mrt_itemGroups_columnSizing",
    {},
    500
  ), a = Fp(
    n,
    i
  ), s = zn({
    ...e,
    onColumnSizingChange: a,
    state: {
      ...e.state,
      columnSizing: n
    },
    data: r.rows,
    enableRowVirtualization: o,
    rowVirtualizerOptions: { overscan: 5 },
    enableColumnVirtualization: o,
    columnVirtualizerOptions: { overscan: 3 },
    muiTableContainerProps: { sx: { maxHeight: "600px" } },
    enableColumnResizing: !0
  });
  return /* @__PURE__ */ f(w, { children: [
    /* @__PURE__ */ u(Op, { table: s }),
    /* @__PURE__ */ u(Kn, { table: s })
  ] });
}
const br = !0;
function Rp({
  quoteId: t,
  tableOptions: e
}) {
  var i;
  const { selectedLanguageId: r } = H(), { search: o } = ge({
    from: "/quotes/$quoteId/salesQuotationView"
  }), { data: n } = Se(
    No({
      id: t,
      onlyOptional: !0,
      unescapedSearchIncludes: o,
      languageIds: r ? [r] : void 0
    }),
    void 0,
    { enabled: !!t }
  );
  return n ? /* @__PURE__ */ f(Bo.Provider, { value: { isOptionalTable: br }, children: [
    /* @__PURE__ */ u(
      Zt,
      {
        tableOptions: e,
        data: (n == null ? void 0 : n.itemGroups) || []
      }
    ),
    /* @__PURE__ */ u(h, { display: "flex", alignSelf: "flex-end", children: /* @__PURE__ */ u(
      C.PriceSummary,
      {
        currencyIdentifier: (i = n.currency) == null ? void 0 : i.identifier,
        totalCost: n.optionalTotalCost,
        totalList: n.optionalTotalList,
        totalNet: n.optionalTotalNet,
        isOptionalTable: br
      }
    ) })
  ] }) : null;
}
const Bo = J({ isOptionalTable: !1 });
function Vp({
  trigger: t,
  content: e,
  defaultOpen: r = !1
}) {
  const { openDrawer: o } = Kd(), n = () => {
    o(e);
  };
  return r && n(), De.isValidElement(t) ? De.cloneElement(t, {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    onClick: (i) => {
      var a, s;
      (a = t.props) != null && a.onClick && ((s = t.props) == null || s.onClick(i)), n();
    }
  }) : /* @__PURE__ */ u("span", { onClick: n, children: t });
}
const Np = "data:image/svg+xml,%3csvg%20viewBox='0%200%20329%20222'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20fill='black'%20fill-opacity='0.04'/%3e%3cpath%20d='M204.305%2070.7111V151.289H124.695V70.7111H204.305ZM204.305%2059.2H124.695C118.44%2059.2%20113.322%2064.38%20113.322%2070.7111V151.289C113.322%20157.62%20118.44%20162.8%20124.695%20162.8H204.305C210.56%20162.8%20215.678%20157.62%20215.678%20151.289V70.7111C215.678%2064.38%20210.56%2059.2%20204.305%2059.2ZM176.669%20110.194L159.61%20132.468L147.441%20117.561L130.382%20139.778H198.619L176.669%20110.194Z'%20fill='black'%20fill-opacity='0.56'/%3e%3c/svg%3e";
function Oe({
  imageId: t,
  alt: e,
  width: r,
  height: o,
  /**
   * if undefined and an image can not be pulled, will use the standardPlaceholderImage from cpq
   */
  placeholderImg: n,
  sx: i
}) {
  const a = n || Np;
  return /* @__PURE__ */ u(
    "img",
    {
      alt: e || "",
      src: t ? `/preview/api/3pq-cpq/v1/attachments/download/${t}` : a,
      width: r,
      height: o,
      style: { objectFit: "contain", ...i },
      onError: (s) => {
        const l = s.currentTarget;
        l.src !== a && (l.src = a);
      }
    }
  );
}
const Mp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ProductImage: Oe
}, Symbol.toStringTag, { value: "Module" }));
function Lo({
  imageId: t,
  alt: e
}) {
  return t ? /* @__PURE__ */ u(
    vt,
    {
      buttonProps: {
        style: { padding: 0 },
        children: /* @__PURE__ */ u(Oe, { alt: e, imageId: t, width: 66, height: 44 })
      },
      dialog: {
        dialogProps: {
          maxWidth: "lg"
        },
        content: /* @__PURE__ */ u(Oe, { alt: e, imageId: t, width: 800, height: 600 })
      }
    }
  ) : /* @__PURE__ */ u(Oe, { width: 66, height: 44 });
}
function xp(t) {
  const { selectedLanguageId: e } = H();
  let r;
  if (ft(t) ? r = t : (O(t) || V(t)) && (r = t.product), !r) {
    console.error("could not identify product and pull translation", {
      item: t,
      isProduct: ft(t),
      isLineItem: O(t),
      isSubItem: V(t)
    });
    return;
  }
  return rr({
    product: r,
    languageId: e
  });
}
function ZP(t) {
  const { selectedLanguageId: e } = H();
  let r;
  if (ft(t) ? r = t : (O(t) || V(t)) && (r = t.product), !!r)
    return or({
      product: r,
      languageId: e
    });
}
function ee(t) {
  return localStorage.getItem(t) !== "false";
}
function Ep({
  products: t,
  quoteId: e
}) {
  const { t: r } = T(), o = ee("enableCost"), n = ee("enableListPrice");
  return /* @__PURE__ */ u(w, { children: (t == null ? void 0 : t.length) === 0 ? /* @__PURE__ */ u(U, { children: r("CPQ:relatedProducts.noProducts") }) : t == null ? void 0 : t.map((i) => {
    var a, s, l, c;
    return /* @__PURE__ */ f(
      h,
      {
        display: "flex",
        gap: 2,
        alignItems: "center",
        p: 2,
        sx: { borderTop: "solid 1px", borderColor: "divider" },
        children: [
          /* @__PURE__ */ u(
            Lo,
            {
              alt: (a = i.image) == null ? void 0 : a.filename,
              imageId: (s = i.image) == null ? void 0 : s.id
            }
          ),
          /* @__PURE__ */ u(
            Xt,
            {
              product: i,
              quoteId: e,
              listPrice: {
                value: i.listPrice,
                currency: i.currency
              },
              cost: {
                value: i.cost,
                currency: i.currency
              },
              withAddButton: !0
            }
          ),
          /* @__PURE__ */ u(Up, { product: i }),
          /* @__PURE__ */ f(h, { ml: "auto", display: "flex", gap: 1, children: [
            o && /* @__PURE__ */ u(
              C.CostPriceTag,
              {
                label: r("CPQ:productDetails.cost"),
                value: i.cost,
                currencyIdentifier: (l = i.currency) == null ? void 0 : l.identifier
              }
            ),
            n && /* @__PURE__ */ u(
              C.ListPricePriceTag,
              {
                label: r("CPQ:productDetails.listPrice"),
                value: i.listPrice,
                currencyIdentifier: (c = i.currency) == null ? void 0 : c.identifier
              }
            ),
            /* @__PURE__ */ u(
              C.AddProductsToQuoteWidget,
              {
                quoteId: e,
                products: [i]
              }
            )
          ] })
        ]
      },
      i.id
    );
  }) });
}
function Up({ product: t }) {
  const e = xp(t);
  return /* @__PURE__ */ u(U, { children: e });
}
function Go({
  products: t,
  quoteId: e,
  title: r
}) {
  return /* @__PURE__ */ f(h, { display: "flex", flexDirection: "column", children: [
    /* @__PURE__ */ u(U, { mb: 2, variant: "h6", children: r }),
    /* @__PURE__ */ u(Ep, { products: t, quoteId: e })
  ] });
}
function Qp({
  productId: t,
  quoteId: e
}) {
  const { t: r } = T(), { data: o } = Pd({
    id: t,
    includes: "ProductType,Image,Translations.Language",
    quoteId: e
  });
  return /* @__PURE__ */ u(
    Go,
    {
      products: (o == null ? void 0 : o.products) ?? void 0,
      quoteId: e,
      title: r("CPQ:alternativeProducts.title")
    }
  );
}
function kp({
  productId: t,
  quoteId: e
}) {
  const { t: r } = T(), { data: o } = Sd({
    id: t,
    includes: "ProductType,Image,Translations.Language",
    size: 5,
    quoteId: e
  });
  return /* @__PURE__ */ u(
    Go,
    {
      products: (o == null ? void 0 : o.products) ?? void 0,
      quoteId: e,
      title: r("CPQ:relatedProducts.title")
    }
  );
}
function jp({
  product: t,
  quoteId: e,
  withAddButton: r,
  listPrice: o,
  cost: n
}) {
  var s, l, c, m, P;
  const { selectedLanguageId: i } = H(), { t: a } = T();
  return /* @__PURE__ */ f(w, { children: [
    /* @__PURE__ */ f(h, { children: [
      /* @__PURE__ */ u(U, { variant: "h6", children: `${a("CPQ:productDetails.partId")}: ${t.partId}` }),
      /* @__PURE__ */ u(U, { variant: "h4", children: ((s = Me((t == null ? void 0 : t.translations) || {}, i)) == null ? void 0 : s.name) || t.name || "" })
    ] }),
    /* @__PURE__ */ u(h, { alignSelf: "center", children: /* @__PURE__ */ u(
      Oe,
      {
        alt: (l = t.image) == null ? void 0 : l.filename,
        imageId: t.imageId,
        height: 220
      }
    ) }),
    /* @__PURE__ */ f(
      h,
      {
        display: "flex",
        gap: 2,
        justifyContent: "right",
        paddingRight: "1rem",
        children: [
          /* @__PURE__ */ u(
            C.CostPriceTag,
            {
              label: a("CPQ:productDetails.cost"),
              value: n.value,
              currencyIdentifier: (c = n.currency) == null ? void 0 : c.identifier
            }
          ),
          /* @__PURE__ */ u(
            C.ListPricePriceTag,
            {
              label: a("CPQ:productDetails.listPrice"),
              value: o.value,
              currencyIdentifier: (m = o.currency) == null ? void 0 : m.identifier
            }
          ),
          e && r && /* @__PURE__ */ u(
            C.AddProductsToQuoteWidget,
            {
              quoteId: e,
              products: [t]
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ u(U, { sx: { maxHeight: "10rem", overflow: "auto" }, children: ((P = Me((t == null ? void 0 : t.translations) || {}, i)) == null ? void 0 : P.description) || (t == null ? void 0 : t.description) || "" }),
    e && /* @__PURE__ */ f(w, { children: [
      /* @__PURE__ */ u(kp, { productId: t.id, quoteId: e }),
      /* @__PURE__ */ u(
        Qp,
        {
          productId: t.id,
          quoteId: e
        }
      )
    ] })
  ] });
}
function Xt({
  text: t,
  product: e,
  defaultOpen: r = !1,
  quoteId: o,
  withAddButton: n,
  listPrice: i,
  cost: a
}) {
  const s = /* @__PURE__ */ u(
    h,
    {
      display: "flex",
      alignItems: "center",
      gap: 1,
      style: { whiteSpace: "nowrap" },
      children: /* @__PURE__ */ u(
        U,
        {
          sx: {
            cursor: "pointer",
            maxWidth: "10rem",
            textOverflow: "ellipsis",
            display: "block",
            overflow: "hidden",
            textTransform: "initial",
            textDecoration: "underline",
            fontWeight: "700"
          },
          children: t || e.partId
        }
      )
    }
  );
  return /* @__PURE__ */ u(
    Vp,
    {
      trigger: s,
      content: /* @__PURE__ */ u(
        jp,
        {
          product: e,
          quoteId: o,
          withAddButton: n,
          listPrice: i,
          cost: a
        }
      ),
      defaultOpen: r
    }
  );
}
function Jt({
  defaultValue: t = 1,
  onChange: e,
  isDebounced: r,
  endAdornment: o,
  width: n,
  min: i = 0,
  max: a = 1 / 0,
  label: s,
  allowDecimal: l = !0,
  required: c = !1
}) {
  const [m, P] = G(!1), S = xr((v) => {
    v !== t && typeof v == "number" && e(v);
  }, 1e3), [q, I] = G(
    t ?? 1
  );
  $(() => {
    I(t ?? 1);
  }, [t]);
  function B() {
    if (!q) {
      M();
      return;
    }
    if (A(String(q))) {
      const v = parseFloat(String(q));
      if (!(v !== t))
        return;
      isNaN(v) || (v < i ? M() : v > a ? I(a) : e(v));
    }
  }
  function A(v) {
    if (l)
      return /^\d*[.]?\d*$/.test(v);
    if (!l)
      return /^\d*$/.test(v);
  }
  function L(v) {
    if (!v) {
      I("");
      return;
    }
    if (A(v)) {
      let D = parseFloat(v);
      if (!isNaN(D)) {
        D > a ? (I(a), D = a) : (v.length > 1 && v[0] === "0" && !(v.includes(".") || v.includes(",")) && (v = v.slice(1)), I(v));
        const re = D !== t;
        D < i ? P(!0) : (P(!1), re && (r ? S(D) : e(D)));
      }
    }
  }
  function M() {
    I(t ?? 1), P(!1);
  }
  return /* @__PURE__ */ u(
    wr,
    {
      required: c,
      label: s,
      onKeyUp: (v) => {
        v.key === "Enter" && B();
      },
      onBlur: () => {
        B();
      },
      value: q,
      onChange: (v) => {
        L(v.currentTarget.value);
      },
      size: "small",
      margin: "none",
      error: m,
      InputProps: {
        inputProps: {
          inputMode: "numeric",
          sx: {
            width: n ?? "6ch"
          }
        },
        endAdornment: o
      }
    }
  );
}
function Yt(t) {
  return t ? [
    "discount",
    "discountPercentage",
    "serviceDiscount",
    "serviceDiscountPercentage",
    "bonusDiscount",
    "bonusDiscountPercentage",
    "projectDiscount",
    "projectDiscountPercentage",
    "quantity",
    "totalDiscount",
    "totalDiscountPercentage",
    "markup",
    "markupPercentage"
  ].includes(t) : !1;
}
function er({
  item: t,
  propertyKey: e,
  value: r,
  endAdornment: o,
  width: n,
  min: i,
  max: a,
  label: s,
  allowDecimal: l
}) {
  const { t: c } = T(), { mutate: m } = Dd(), { mutate: P } = zt(), { mutate: S } = Kt(), { mutate: q } = Ht();
  function I(B) {
    const A = {
      id: t.id,
      requestBody: {
        rowVersion: t.rowVersion,
        [e]: B
      }
    };
    function L() {
      ye.invalidateQueries({
        queryKey: [K]
      });
    }
    function M(D) {
      at.error(c("CPQ:toast.error.unknown")), console.error(D), ye.invalidateQueries({
        queryKey: [K]
      });
    }
    const v = {
      onSuccess: L,
      onError: M
    };
    Yp(t) ? m(A, v) : (_(t) && P(A, v), O(t) && S(A, v), V(t) && q(A, v));
  }
  return /* @__PURE__ */ u(
    Jt,
    {
      defaultValue: r,
      label: s,
      isDebounced: !0,
      onChange: (B) => {
        I(B);
      },
      endAdornment: o,
      width: n,
      min: i,
      max: a,
      allowDecimal: l
    }
  );
}
function $p(t, e, r) {
  return t == null || !(e != null && e.languageCode) || !r ? "" : Intl.NumberFormat(e.languageCode, {
    style: "currency",
    currency: r
  }).format(t);
}
function zp(t, e) {
  return t == null || !(e != null && e.languageCode) ? "" : Intl.NumberFormat(e.languageCode, {
    style: "percent",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(t / 100);
}
function Kp({
  value: t,
  currencyIdentifier: e
}) {
  const { selectedLanguage: r } = H();
  return $p(t, r, e);
}
function ue({
  renderedCellValue: t,
  row: e,
  column: r
}) {
  if (typeof t != "number")
    return t;
  const o = Hp(e, r);
  return /* @__PURE__ */ u(h, { display: "flex", justifyContent: "flex-end", children: /* @__PURE__ */ u(
    Kp,
    {
      value: t,
      currencyIdentifier: (o == null ? void 0 : o.identifier) || ""
    }
  ) });
}
function Hp(t, e) {
  var r, o;
  if (ft(t.original) && t.original.isCustom) {
    if (e.id === "listPrice")
      return (r = t.original.originalListPrice) == null ? void 0 : r.currency;
    if (e.id === "cost")
      return (o = t.original.originalCost) == null ? void 0 : o.currency;
  }
  return t.original.currency;
}
function _p({
  value: t
}) {
  const { selectedLanguage: e } = H();
  return zp(t, e);
}
function Ot({
  renderedCellValue: t
}) {
  return typeof t != "number" ? t : /* @__PURE__ */ u(h, { display: "flex", justifyContent: "flex-end", children: /* @__PURE__ */ u(_p, { value: t }) });
}
function ft(t) {
  return "isCustom" in t && "isShared" in t;
}
function Wp(t) {
  return _(t) && (t.lineItems ?? []).length > 0 || O(t) && (t.subItems ?? []).length > 0;
}
function Zp(t) {
  var e, r;
  return O(t) && ((r = (e = t.product) == null ? void 0 : e.productType) == null ? void 0 : r.identifier) === "Configurable";
}
function Xp(t) {
  var e;
  return ((e = t == null ? void 0 : t.productType) == null ? void 0 : e.identifier) === "Configurable";
}
function Jp(t) {
  return t.some((e) => Xp(e));
}
function Ne(t) {
  return ut(t), O(t) && !!t.product;
}
function O(t) {
  return ut(t), "dataType" in t && t.dataType === "lineItem";
}
function V(t) {
  return ut(t), "dataType" in t && t.dataType === "subItem";
}
function _(t) {
  return ut(t), "dataType" in t && t.dataType === "itemGroup";
}
function Yp(t) {
  return ut(t), "dataType" in t && t.dataType === "quote";
}
function ut(t) {
  "dataType" in t || console.error(
    `Missing dataType for item: ${JSON.stringify(t)}, you are probably using the wrong api version. cpq-api > 0.5.5 is required!`
  );
}
function Ao({
  item: t,
  languageId: e
}) {
  if ((V(t) || O(t)) && t.product)
    return rr({
      product: t.product,
      languageId: e
    });
  if ((O(t) || _(t)) && t.name)
    return t.name;
}
function Me(t, e) {
  if (!t)
    return {};
  if (!e)
    return {};
  let r = {};
  return Object.keys(t).map((o) => {
    t[o].languageId === e && (r = t[o]);
  }), r;
}
function Fo(t) {
  var e;
  if ((O(t) || V(t)) && ((e = t.product) != null && e.partId))
    return t.product.partId;
}
function em({
  row: t,
  languageId: e
}) {
  if ((V(t) || O(t)) && t.product)
    return or({
      product: t.product,
      languageId: e
    });
  if ((O(t) || _(t)) && t.description)
    return t.description;
}
function Oo(t, {
  row: e,
  renderedCellValue: r
}) {
  return (O(e.original) || V(e.original)) && e.original.product && r ? /* @__PURE__ */ u(
    Xt,
    {
      product: e.original.product,
      text: r,
      quoteId: t,
      listPrice: {
        value: e.original.listPrice,
        currency: e.original.currency
      },
      cost: {
        value: e.original.cost,
        currency: e.original.currency
      }
    }
  ) : null;
}
function wo({
  renderedCellValue: t,
  row: e
}) {
  const r = e.original;
  let o;
  return (_(r) || O(r)) && (o = "primary"), /* @__PURE__ */ u(U, { color: o, children: t });
}
function Do({
  renderedCellValue: t
}) {
  return /* @__PURE__ */ u(Gp, { text: t, maxWidth: "50ch" });
}
function Ro(t) {
  return {
    color: "primary",
    sx: {
      display: V(t.original) ? "none" : "inline-flex"
    }
  };
}
function tm({
  row: t,
  cell: e,
  column: r,
  renderedCellValue: o
}, n = {}) {
  return Yt(r.columnDef.accessorKey) ? typeof o == "number" && /* @__PURE__ */ u(
    er,
    {
      item: t.original,
      propertyKey: r.columnDef.accessorKey,
      value: e.getValue() ?? 0,
      min: n == null ? void 0 : n.min,
      max: n == null ? void 0 : n.max,
      width: n == null ? void 0 : n.width,
      allowDecimal: n == null ? void 0 : n.allowDecimal
    }
  ) : null;
}
function rm({
  row: t,
  column: e,
  renderedCellValue: r
}, o = {}) {
  var i, a;
  if (!Yt(e.columnDef.accessorKey))
    return null;
  const n = (a = (i = t == null ? void 0 : t.original) == null ? void 0 : i.currency) == null ? void 0 : a.symbol;
  return typeof r == "number" && /* @__PURE__ */ u(
    er,
    {
      item: t.original,
      propertyKey: e.columnDef.accessorKey,
      value: r,
      min: o == null ? void 0 : o.min,
      max: o == null ? void 0 : o.max,
      endAdornment: n && /* @__PURE__ */ u(Dr, { position: "end", children: n })
    }
  );
}
function om(t) {
  return /* @__PURE__ */ u(Fe, { ...t, inputProps: { max: 1 / 0 } });
}
function Fe({
  inputProps: t,
  ...e
}) {
  const { row: r, column: o, renderedCellValue: n } = e;
  return tr(r) ? /* @__PURE__ */ u(Ot, { ...e }) : Yt(o.columnDef.accessorKey) ? typeof n == "number" && /* @__PURE__ */ u(
    er,
    {
      item: r.original,
      propertyKey: o.columnDef.accessorKey,
      value: n,
      endAdornment: /* @__PURE__ */ u(Dr, { position: "end", children: "%" }),
      width: "auto",
      min: 0,
      max: (t == null ? void 0 : t.max) ?? 100
    }
  ) : null;
}
function nm(t) {
  const { row: e, renderedCellValue: r } = t, o = e.getParentRow(), n = tr(t.row);
  return n ? t.renderedCellValue : V(e.original) && o && Ne(o == null ? void 0 : o.original) || n ? /* @__PURE__ */ u(w, { children: r }) : tm(t, {
    min: 1,
    allowDecimal: !0,
    width: "4ch"
  });
}
function ct(t) {
  const e = t.row.original;
  if (V(e) || Ne(e) && !Wp(e))
    return rm(t, { min: 0 });
  if (_(e) || O(e))
    return /* @__PURE__ */ u(ue, { ...t });
}
function im({
  row: t,
  quoteId: e
}) {
  var n, i, a, s, l, c;
  const r = te(), o = t.original;
  return /* @__PURE__ */ f(w, { children: [
    e && (O(o) || V(o)) && o.productId && ((n = o.product) == null ? void 0 : n.cfgObjectIdentifier) && ((i = o.product) == null ? void 0 : i.identifier) && /* @__PURE__ */ u(
      C.IndicatorConfigurableProductInLineItem,
      {
        quoteId: e,
        lineItemId: o.id,
        productId: o.productId,
        productTypeIdentifier: (s = (a = o.product) == null ? void 0 : a.productType) == null ? void 0 : s.identifier,
        configurationId: o.configurationId || ((l = o.configuration) == null ? void 0 : l.id) || void 0,
        isConfigurationComplete: o.isConfigurationComplete || !1,
        cfgObjectId: (c = o.product) == null ? void 0 : c.cfgObjectIdentifier,
        productIdentifier: o.product.identifier
      },
      "IndicatorConfigurableProductInLineItem"
    ),
    _(o) && /* @__PURE__ */ u(
      C.AddLineItemButton,
      {
        itemGroupId: o.id,
        onSuccess: () => {
          r.invalidateQueries({
            queryKey: [K]
          });
        }
      }
    )
  ] });
}
function tr(t) {
  const { isOptionalTable: e } = X(Bo), r = "isOptional" in t.original && t.original.isOptional;
  return e && !r;
}
function am(t) {
  return t.createdByName || "";
}
function sm(t) {
  return t.createdOn || "";
}
function um(t) {
  return t.lastUpdatedOn || "";
}
function lm(t) {
  return t.lastUpdatedByName || "";
}
function fr({
  renderedCellValue: t,
  row: e
}) {
  return e.original.createdOn ? /* @__PURE__ */ u(U, { children: $n(new Date(e.original.createdOn), "dd.MM.yyyy") }) : /* @__PURE__ */ u(U, { children: t });
}
function XP(t) {
  var r;
  return ((r = t.customer) == null ? void 0 : r.company.name) || "";
}
function R(t) {
  const e = t.column.columnDef.header;
  return /* @__PURE__ */ u(Ue, { title: e, placement: "top", children: /* @__PURE__ */ u("span", { children: e }) });
}
function rr({
  product: t,
  languageId: e
}) {
  return t.isCustom ? t.name : t.translations && e && Me(t.translations, e).name || t.identifier;
}
function or({
  product: t,
  languageId: e
}) {
  let r = "";
  return t.translations && e && (r = Me(t.translations, e).description || ""), !r && t.isCustom && (r = t.description || ""), r;
}
function Vo(t) {
  return t ? t.replace(/["\\]/g, "\\$&") : "";
}
const nr = "PriceLists,ItemGroups.PriceLists,ItemGroups.LineItems.PriceLists,ItemGroups.LineItems.Configuration,ItemGroups.LineItems.Status,ItemGroups.LineItems.SubItems.PriceLists,ItemGroups.PropertySet.Properties.Translations.Language,ItemGroups.LineItems.PropertySet.Properties.Translations.Language,ItemGroups.LineItems.SubItems.PropertySet.Properties.Translations.Language,ItemGroups.LineItems.Product.ProductType,ItemGroups.LineItems.Product.PropertySet.Properties.Translations.Language,ItemGroups.LineItems.Product.Translations.Language,ItemGroups.LineItems.Product.PriceSets.Prices,ItemGroups.LineItems.SubItems.Product.ProductType,ItemGroups.LineItems.SubItems.Product.PropertySet.Properties.Translations.Language,ItemGroups.LineItems.SubItems.Product.Translations.Language,ItemGroups.LineItems.SubItems.Company,ItemGroups.LineItems.SubItems.Configuration,ItemGroups.LineItems.SubItems.Product.PriceSets.Prices";
function No(t) {
  const { unescapedSearchIncludes: e, ...r } = t;
  return {
    onlyOptional: !1,
    ...r,
    ...e && {
      searchIncludes: Vo(e)
    },
    includes: nr
  };
}
function Mo() {
  const t = Ee(), { search: e } = ge({
    strict: !1
  }), r = Vn(
    (o) => t({
      to: ".",
      search: (n) => ({ ...n, search: o })
    }),
    500
  );
  return /* @__PURE__ */ u(
    C.GenericSearchField,
    {
      defaultValue: e,
      onChange: (o) => {
        r(o);
      }
    }
  );
}
function JP(t = 0) {
  return {
    display: "flex",
    gap: "1rem",
    width: "300px",
    whiteSpace: "break-spaces",
    paddingLeft: `${1 + t}rem`
  };
}
function YP(t, e, r, o) {
  var i, a, s;
  const n = [];
  return V(t) && r && O(r) && ((a = (i = r.product) == null ? void 0 : i.productType) == null ? void 0 : a.identifier) === "Configurable" ? ((s = r.subItems) == null || s.forEach((c) => {
    c.id !== t.id && n.push({ item: c, indentLevel: 1 });
  }), n) : (e.sort((l, c) => (l.rank ?? 0) - (c.rank ?? 0)).forEach((l, c, m) => {
    var P;
    c === 0 && m.length > 1 && !V(t) && !O(t) && (t.rank ?? 0) > 1 && n.push({
      item: {
        ...l,
        name: o("CPQ:moveRowMenu.options.topPosition"),
        rank: 0,
        displayedRank: ""
      },
      indentLevel: 0
    }), l.id !== t.id && (n.push({
      item: l,
      indentLevel: 0,
      disabled: V(t)
    }), _(t) || (P = l.lineItems) == null || P.forEach((S, q, I) => {
      var B;
      V(t) && Zp(S) || (q === 0 && I.length > 1 && !V(t) && n.push({
        item: {
          ...S,
          name: o("CPQ:moveRowMenu.options.topPosition"),
          rank: 0,
          displayedRank: "",
          product: void 0
        },
        indentLevel: 1
      }), S.id !== t.id && (n.push({ item: S, indentLevel: 1 }), V(t) && ((B = S.subItems) == null || B.forEach((A, L, M) => {
        L === 0 && M.length > 1 && n.push({
          item: {
            ...A,
            name: o("CPQ:moveRowMenu.options.topPosition"),
            rank: 0,
            displayedRank: "",
            product: void 0
          },
          indentLevel: 2
        }), A.id !== t.id && n.push({ item: A, indentLevel: 2 });
      }))));
    }));
  }), n);
}
const cm = (t) => typeof t.rank == "number" ? t.rank + 1 : 1, hr = (t, e) => {
  if (e === "lineItem") {
    if (_(t))
      return t.id;
    if (O(t))
      return t.itemGroupId;
  }
  if (e === "subItem")
    return O(t) ? t.id : t.lineItemId;
};
function dm() {
  const t = te(), e = () => t.invalidateQueries({
    queryKey: [K]
  }), { mutate: r } = zt({
    onSuccess: e
  }), { mutate: o } = Kt({
    onSuccess: e
  }), { mutate: n } = Ht({
    onSuccess: e
  });
  return { updateItem: (a, s, l = {}) => {
    const c = {
      rowVersion: a.rowVersion,
      rank: s,
      ...l
    };
    _(a) ? r({ id: a.id, requestBody: c }) : O(a) ? o({ id: a.id, requestBody: c }) : V(a) && n({ id: a.id, requestBody: c });
  } };
}
function pm({
  row: t,
  table: e
}) {
  var P;
  const { updateItem: r } = dm(), o = t.original, n = o.rank || 1, i = t.getParentRow(), a = ((P = i == null ? void 0 : i.subRows) == null ? void 0 : P.length) || e.options.data.length || 0, s = () => r(o, n - 1), l = () => r(o, n + 2);
  function c(S) {
    const q = cm(S);
    if (O(o)) {
      const I = hr(S, "lineItem");
      r(o, _(S) ? 1 : q, {
        itemGroupId: I
      });
    } else if (V(o)) {
      const I = hr(S, "subItem");
      r(o, O(S) ? 1 : q, {
        lineItemId: I
      });
    } else
      r(o, q);
  }
  const m = O(o) ? 2 : V(o) ? 4 : 0;
  return /* @__PURE__ */ u(h, { sx: { marginLeft: m }, children: /* @__PURE__ */ f(Nn, { size: "small", variant: "outlined", children: [
    /* @__PURE__ */ u(At, { onClick: s, disabled: !(n > 1), children: /* @__PURE__ */ u(gt, { children: "arrow_upward" }) }),
    /* @__PURE__ */ u(
      C.MoveRowMenu,
      {
        onMoveToPosition: c,
        itemGroups: e.options.data,
        currentItem: o,
        row: t
      }
    ),
    /* @__PURE__ */ u(At, { onClick: l, disabled: !(n < a), children: /* @__PURE__ */ u(gt, { children: "arrow_downward" }) })
  ] }) });
}
const xo = () => ({
  mrtTheme: () => ({
    baseBackgroundColor: "rgba(239,239,239,0)"
  }),
  displayColumnDefOptions: {
    "mrt-row-expand": {
      maxSize: 32,
      grow: !1
    },
    "mrt-row-actions": {
      grow: !0
    }
  },
  enableDensityToggle: !1,
  muiTableBodyRowProps: { hover: !1 },
  muiTableHeadRowProps: { sx: { backgroundColor: "white" } },
  muiTablePaperProps: {
    elevation: 0,
    sx: {
      borderRadius: "0",
      border: "none"
    }
  },
  enableFullScreenToggle: !1,
  enableColumnActions: !1,
  enableTopToolbar: !1,
  defaultColumn: {
    size: 75,
    muiTableHeadCellProps: ({ column: t }) => t.id === "mrt-row-expand" ? {
      sx: {
        paddingX: "0"
      }
    } : {
      sx: {
        "& .Mui-TableHeadCell-Content-Wrapper": {
          textOverflow: "ellipsis"
        }
      }
    }
  }
});
function mm({ item: t }) {
  var I;
  const e = te(), { t: r } = T(), { mutate: o } = Od(), { mutate: n } = wd(), { mutate: i } = Rd(), a = tn(null);
  function s() {
    e.invalidateQueries({
      queryKey: [K]
    });
  }
  function l() {
    console.error("Error updating item");
  }
  const c = {
    onSuccess: s,
    onError: l
  };
  function m() {
    var L;
    const B = (L = a.current) == null ? void 0 : L.checked, A = {
      id: t.id,
      isOptional: !B
    };
    if (_(t))
      o(A, c);
    else if (O(t))
      n(A, c);
    else if (V(t))
      i(A, c);
    else
      return console.error("Unknown item type. Can not set optional.", {
        item: t,
        variables: A,
        options: c
      });
  }
  const P = (I = a.current) == null ? void 0 : I.checked, S = r(P ? "CPQ:dialog.confirm.unsetOptional.title" : "CPQ:dialog.confirm.setOptional.title"), q = r(P ? "CPQ:dialog.confirm.unsetOptional.subtitle" : "CPQ:dialog.confirm.setOptional.subtitle");
  return /* @__PURE__ */ u(
    vt,
    {
      renderTrigger: (B) => /* @__PURE__ */ u(Ft, { ...B, inputRef: a, checked: t.isOptional }),
      dialog: {
        dialogProps: {
          fullWidth: !0,
          maxWidth: "xs"
        },
        title: S,
        subtitle: q,
        // content: subtitle,
        actions: (B) => /* @__PURE__ */ u(
          st,
          {
            onCancel: B.closeDialog,
            onConfirm: () => {
              B.closeDialog(), m();
            }
          }
        )
      }
    }
  );
}
function ym({
  selectedPriceLists: t,
  handlePriceListChange: e,
  withLabel: r,
  disabled: o,
  disableMinWidth: n
}) {
  const { t: i } = T(), [a, s] = G(!1), { data: l, isFetching: c } = bd(
    { filter: "isActive == True" },
    void 0,
    { enabled: a }
  ), m = l == null ? void 0 : l.filter(
    (I) => !t.find(
      (B) => B.id === I.id
    )
  ), P = () => {
    s(!1);
  }, S = () => {
    s(!0);
  }, q = t.sort((I, B) => (I.precedence ?? 0) - (B.precedence ?? 0)).filter((I) => I.isActive);
  return /* @__PURE__ */ f(
    Et,
    {
      sx: { minWidth: n ? "inherit" : "150px" },
      disabled: o,
      children: [
        r && /* @__PURE__ */ u(Er, { children: i("CPQ:priceListSelectLabel") }),
        /* @__PURE__ */ f(
          Ut,
          {
            open: a,
            onOpen: S,
            onClose: P,
            MenuProps: {
              /**
               * the transition is reduced here, because otherwise the menu items are still clickable after they disapear.
               * Probably because the table with a lot of columns, is a little slow in unmounting them
               */
              transitionDuration: 200
            },
            multiple: !0,
            value: q.map((I) => I.id),
            onChange: e,
            input: r ? /* @__PURE__ */ u(Rr, { label: i("CPQ:priceListSelectLabel") }) : void 0,
            children: [
              c && /* @__PURE__ */ u(h, { sx: { display: "flex", justifyContent: "center", p: 1 }, children: /* @__PURE__ */ u(ht, {}) }),
              !c && (q == null ? void 0 : q.map((I) => /* @__PURE__ */ u(le, { value: I.id, children: I.identifier || I.id }, I.id))),
              (m == null ? void 0 : m.length) && /* @__PURE__ */ u(xt, {}),
              m == null ? void 0 : m.map((I) => /* @__PURE__ */ u(le, { value: I.id, children: I.identifier || I.id }, I.id))
            ]
          }
        )
      ]
    }
  );
}
function gm({
  label: t,
  required: e,
  tooltip: r,
  sx: o,
  labelSx: n,
  children: i,
  errorMessage: a
}) {
  return /* @__PURE__ */ f(Vr, { required: e, sx: o, error: !!a, children: [
    /* @__PURE__ */ u(Ue, { title: r, placement: "top", children: /* @__PURE__ */ u(Mn, { sx: n, children: t }) }),
    i,
    a && /* @__PURE__ */ u(xn, { children: a })
  ] });
}
function we({
  quoteId: t,
  itemGroupId: e,
  lineItemId: r,
  subItemId: o,
  selectedPriceLists: n,
  withLabel: i,
  disabled: a,
  disableMinWidth: s
}) {
  const { t: l } = T(), { mutate: c } = Gd({
    onSuccess: () => {
      ye.invalidateQueries({
        queryKey: [K]
      });
    }
  });
  async function m(P) {
    if (o || await jd({
      title: l("CPQ:priceList.select.confirm.title"),
      subtitle: l("CPQ:priceList.select.confirm.subtitle")
    })) {
      const S = P.target.value;
      Array.isArray(S) && c({
        requestBody: {
          quoteId: t,
          itemGroupId: e,
          lineItemId: r,
          subItemId: o,
          priceListIds: S.map((q, I) => ({
            priceListId: q,
            precedence: I
          }))
        }
      });
    }
  }
  return /* @__PURE__ */ u(
    gm,
    {
      label: i && l("CPQ:priceListSelectLabel"),
      sx: { width: "inherit" },
      children: /* @__PURE__ */ u(
        ym,
        {
          selectedPriceLists: n,
          handlePriceListChange: m,
          disabled: a,
          disableMinWidth: s
        }
      )
    }
  );
}
const bm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  PriceListSelect: we,
  default: we
}, Symbol.toStringTag, { value: "Module" }));
function fm({
  item: t,
  isTop: e,
  isTopChangeable: r
}) {
  const { t: o } = T(), { mutate: n } = Kt(), { mutate: i } = Ht();
  function a() {
    ye.invalidateQueries({
      queryKey: [K]
    });
  }
  function s(c) {
    if (r) {
      const m = {
        id: t.id,
        requestBody: {
          rowVersion: t.rowVersion,
          isTop: c.target.value === "true",
          statusId: t.statusId,
          companyId: t.companyId
        }
      };
      O(t) ? n(m, {
        onSuccess: a
      }) : V(t) && i(m, {
        onSuccess: a
      });
    }
  }
  if (!r)
    switch (e) {
      case !0:
        return o("CPQ:select.topBottom.option.label.top");
      case !1:
        return o("CPQ:select.topBottom.option.label.bottom");
    }
  return /* @__PURE__ */ u(Et, { fullWidth: !0, children: /* @__PURE__ */ f(
    Ut,
    {
      labelId: "select-topBottom",
      value: e.toString(),
      onChange: s,
      disabled: !r,
      children: [
        /* @__PURE__ */ u(le, { value: "true", children: o("CPQ:select.topBottom.option.label.top") }),
        /* @__PURE__ */ u(le, { value: "false", children: o("CPQ:select.topBottom.option.label.bottom") })
      ]
    }
  ) });
}
function Eo() {
  return X(Kr);
}
function E({
  settingKey: t,
  children: e
}) {
  const { showSettingsVisualizer: r } = Eo(), o = ee(t), n = (i) => {
    localStorage.setItem(t, String(i)), window.location.reload();
  };
  return r ? /* @__PURE__ */ f(
    "div",
    {
      style: {
        position: "relative",
        border: "1px dashed orange",
        padding: "4px"
      },
      children: [
        /* @__PURE__ */ f(
          "span",
          {
            style: {
              position: "relative",
              top: 0,
              right: 0,
              background: "red",
              fontSize: "12px",
              padding: "5px",
              color: "white",
              zIndex: 1e3,
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              gap: "8px"
            },
            children: [
              t,
              ":",
              /* @__PURE__ */ u(
                En,
                {
                  checked: o,
                  onChange: () => n(!o),
                  size: "small"
                }
              )
            ]
          }
        ),
        o && e
      ]
    }
  ) : o ? e : /* @__PURE__ */ u(w, {});
}
const N = Mr();
function hm({
  t,
  selectedLanguageId: e,
  quoteId: r
}) {
  const o = ee("enableCost"), n = ee("enableListPrice");
  return [
    N.accessor("displayedRank", {
      header: t("CPQ:table.itemGroups.header.rank"),
      Header: R,
      size: 75
    }),
    N.accessor(
      (i) => Ao({
        item: i,
        languageId: e
      }),
      {
        id: "name",
        header: t("CPQ:table.itemGroups.header.name"),
        Header: R,
        Cell: wo,
        maxSize: 250,
        size: 200
      }
    ),
    N.accessor((i) => Fo(i), {
      id: "partId",
      size: 200,
      header: t("CPQ:table.itemGroups.header.partId"),
      Header: R,
      Cell: (...i) => Oo(r, ...i)
    }),
    N.accessor(
      (i) => em({ row: i, languageId: e }),
      {
        size: 300,
        id: "description",
        header: t("CPQ:table.itemGroups.header.description"),
        Header: R,
        Cell: Do
      }
    ),
    N.accessor("priceLists", {
      size: 100,
      header: t("CPQ:table.itemGroups.header.priceList"),
      Header: R,
      Cell: ({ row: i, cell: a }) => {
        const s = tr(i), l = a.getValue() || [], c = i.original.id;
        if (_(i.original))
          return /* @__PURE__ */ u(
            we,
            {
              disabled: s,
              itemGroupId: c,
              selectedPriceLists: l,
              disableMinWidth: !0
            }
          );
        if (O(i.original))
          return /* @__PURE__ */ u(
            we,
            {
              disabled: s,
              lineItemId: c,
              selectedPriceLists: l,
              disableMinWidth: !0
            }
          );
        if (V(i.original))
          return /* @__PURE__ */ u(
            we,
            {
              subItemId: c,
              selectedPriceLists: l,
              disableMinWidth: !0
            }
          );
      }
    }),
    N.accessor("quantity", {
      header: t("CPQ:table.itemGroups.header.qty"),
      Header: R,
      Cell: nm
    }),
    N.accessor("cost", {
      header: t("CPQ:table.itemGroups.header.cost"),
      Header: (i) => /* @__PURE__ */ u(E, { settingKey: "enableCost", children: /* @__PURE__ */ u(R, { ...i }) }),
      Cell: ue,
      visibleInShowHideMenu: o,
      size: 100
    }),
    N.accessor("listPrice", {
      header: t("CPQ:table.itemGroups.header.listPrice"),
      Header: (i) => /* @__PURE__ */ u(E, { settingKey: "enableListPrice", children: /* @__PURE__ */ u(R, { ...i }) }),
      Cell: ue,
      visibleInShowHideMenu: n,
      size: 100
    }),
    N.accessor("isTop", {
      header: t("CPQ:table.itemGroups.header.costListPricing"),
      Header: R,
      Cell: ({ row: i }) => (V(i.original) || Ne(i.original)) && /* @__PURE__ */ u(
        fm,
        {
          item: i.original,
          isTop: i.original.isTop ?? !1,
          isTopChangeable: i.original.isTopChangeable ?? !1
        }
      ),
      size: 100
    }),
    N.accessor("markupPercentage", {
      header: t("CPQ:table.itemGroups.header.markupPercentage"),
      Header: (i) => /* @__PURE__ */ u(E, { settingKey: "enableCost", children: /* @__PURE__ */ u(R, { ...i }) }),
      Cell: om,
      visibleInShowHideMenu: o
    }),
    N.accessor("discountPercentage", {
      header: t("CPQ:table.itemGroups.header.discountPercentage"),
      Header: R,
      Cell: Fe
    }),
    N.accessor("discount", {
      header: t("CPQ:table.itemGroups.header.discount"),
      Header: R,
      Cell: ct,
      size: 100
    }),
    N.accessor("serviceDiscountPercentage", {
      header: t("CPQ:table.itemGroups.header.discount2Percentage"),
      Header: R,
      Cell: Fe
    }),
    N.accessor("serviceDiscount", {
      header: t("CPQ:table.itemGroups.header.discount2"),
      Header: R,
      Cell: ct,
      size: 100
    }),
    N.accessor("bonusDiscountPercentage", {
      header: t("CPQ:table.itemGroups.header.discount3Percentage"),
      Header: R,
      Cell: Fe
    }),
    N.accessor("bonusDiscount", {
      header: t("CPQ:table.itemGroups.header.discount3"),
      Header: R,
      Cell: ct,
      size: 100
    }),
    N.accessor("projectDiscountPercentage", {
      header: t("CPQ:table.itemGroups.header.discount4Percentage"),
      Header: R,
      Cell: Fe
    }),
    N.accessor("projectDiscount", {
      header: t("CPQ:table.itemGroups.header.discount4"),
      Header: R,
      Cell: ct,
      size: 100
    }),
    N.accessor("totalCost", {
      header: t("CPQ:table.itemGroups.header.totalCost"),
      Header: (i) => /* @__PURE__ */ u(E, { settingKey: "enableCost", children: /* @__PURE__ */ u(R, { ...i }) }),
      Cell: ue,
      visibleInShowHideMenu: o,
      size: 100
    }),
    N.accessor("totalList", {
      header: t("CPQ:table.itemGroups.header.totalList"),
      Header: (i) => /* @__PURE__ */ u(E, { settingKey: "enableListPrice", children: /* @__PURE__ */ u(R, { ...i }) }),
      Cell: ue,
      visibleInShowHideMenu: n,
      size: 100
    }),
    N.accessor("totalDiscountPercentage", {
      header: t("CPQ:table.itemGroups.header.totalDiscountPercentage"),
      Header: R,
      Cell: Ot
    }),
    N.accessor("totalDiscount", {
      header: t("CPQ:table.itemGroups.header.totalDiscount"),
      Header: R,
      Cell: ue,
      size: 100
    }),
    N.accessor("totalNet", {
      header: t("CPQ:table.itemGroups.header.totalNet"),
      Header: R,
      Cell: ue,
      size: 100
    }),
    N.accessor("margin", {
      header: t("CPQ:table.itemGroups.header.margin"),
      Header: R,
      Cell: Ot,
      size: 100
    }),
    N.display({
      id: "optional",
      size: 60,
      header: t("CPQ:table.lineItems.header.optional"),
      Header: R,
      enableColumnActions: !1,
      muiTableBodyCellProps: {
        align: "center"
      },
      Edit: () => /* @__PURE__ */ u(w, {}),
      Cell: ({ row: i }) => {
        const a = i.getParentRow();
        return V(i.original) && a && Ne(a == null ? void 0 : a.original) ? /* @__PURE__ */ u(w, {}) : /* @__PURE__ */ u(mm, { item: i.original });
      }
    }),
    N.display({
      size: 140,
      enableResizing: !1,
      header: t("CPQ:table.itemGroups.header.actions"),
      enableColumnActions: !1,
      visibleInShowHideMenu: !1,
      enableHiding: !1,
      Header: () => /* @__PURE__ */ u(w, {}),
      Edit: () => /* @__PURE__ */ u(w, {}),
      Cell: (i) => /* @__PURE__ */ u(im, { ...i, quoteId: r })
    })
  ];
}
function Im(t) {
  const { t: e } = T(), { selectedLanguageId: r } = H(), o = ip(), n = me(() => hm({
    t: e,
    selectedLanguageId: r,
    quoteId: t
  }), [e, r, t]);
  return { columns: me(() => typeof o == "function" ? o(n) : n, [o, n]) };
}
function Tt() {
  const t = Sn(), e = Pn();
  return t > 0 || e > 0 ? /* @__PURE__ */ u(be, {}) : null;
}
function Sm({
  item: t
}) {
  const { selectedLanguage: e } = H(), { data: r, isFetching: o } = mo({
    id: t.configurationId ?? ""
  }), i = me(() => JSON.parse((r == null ? void 0 : r.state) || "{}"), [r]).bom;
  return /* @__PURE__ */ u(w, { children: o || !r ? /* @__PURE__ */ u(Tt, {}) : i && /* @__PURE__ */ u(
    An,
    {
      data: i,
      languageCode: (e == null ? void 0 : e.languageCode) ?? "en-US"
    }
  ) });
}
function Pm(t) {
  const { t: e } = T(), { item: r } = t, [o, n] = G(!1);
  function i() {
    n((s) => !s);
  }
  function a() {
    n(!0);
  }
  return /* @__PURE__ */ f(h, { children: [
    /* @__PURE__ */ f(le, { onClick: a, children: [
      /* @__PURE__ */ u(Wn, { children: /* @__PURE__ */ u(F, { children: "list_alt_outlined" }) }),
      e("CPQ:table.lineItems.actions.showBOM")
    ] }),
    /* @__PURE__ */ u(
      Nt,
      {
        open: o,
        onClose: () => n(!1),
        anchor: "right",
        sx: { zIndex: 1300 },
        children: /* @__PURE__ */ f(
          h,
          {
            display: "flex",
            flexDirection: "column",
            padding: 2,
            gap: 2,
            width: "80rem",
            children: [
              /* @__PURE__ */ f(h, { display: "flex", justifyContent: "space-between", children: [
                /* @__PURE__ */ u(h, { children: /* @__PURE__ */ u(U, { variant: "h6", children: e("CPQ:drawer.showBOM.title") }) }),
                /* @__PURE__ */ u(h, { children: /* @__PURE__ */ u(z, { onClick: i, children: /* @__PURE__ */ u(F, { children: "close" }) }) })
              ] }),
              /* @__PURE__ */ u(Sm, { item: r })
            ]
          }
        )
      }
    )
  ] });
}
function Cm({
  item: t
}) {
  const { selectedLanguage: e } = H(), { data: r, isFetching: o } = mo({
    id: t.configurationId ?? ""
  }), i = me(() => JSON.parse((r == null ? void 0 : r.state) || "{}"), [r]).summary;
  return /* @__PURE__ */ u(w, { children: o || !r ? /* @__PURE__ */ u(Tt, {}) : i && /* @__PURE__ */ u(
    Fn,
    {
      data: i,
      languageCode: (e == null ? void 0 : e.languageCode) ?? "en-US"
    }
  ) });
}
function qm(t) {
  const { t: e } = T(), { item: r } = t, [o, n] = G(!1);
  function i() {
    n((s) => !s);
  }
  function a() {
    n(!0);
  }
  return /* @__PURE__ */ f(h, { children: [
    /* @__PURE__ */ f(le, { onClick: a, children: [
      /* @__PURE__ */ u(Un, { children: /* @__PURE__ */ u(F, { children: "list_alt_outlined" }) }),
      e("CPQ:table.lineItems.actions.showSummary")
    ] }),
    /* @__PURE__ */ u(
      Nt,
      {
        open: o,
        onClose: () => n(!1),
        anchor: "right",
        sx: { zIndex: 1300 },
        children: /* @__PURE__ */ f(
          h,
          {
            display: "flex",
            flexDirection: "column",
            padding: 2,
            gap: 2,
            width: "50rem",
            children: [
              /* @__PURE__ */ f(h, { display: "flex", justifyContent: "space-between", children: [
                /* @__PURE__ */ u(h, { children: /* @__PURE__ */ u(U, { variant: "h6", children: e("CPQ:drawer.showSummary.title") }) }),
                /* @__PURE__ */ u(h, { children: /* @__PURE__ */ u(z, { onClick: i, children: /* @__PURE__ */ u(F, { children: "close" }) }) })
              ] }),
              /* @__PURE__ */ u(Cm, { item: r })
            ]
          }
        )
      }
    )
  ] });
}
const Uo = () => ({
  enableExpanding: !0,
  createDisplayMode: "row",
  editDisplayMode: "row",
  initialState: {
    expanded: !0
  },
  displayColumnDefOptions: {
    "mrt-row-expand": {
      size: 45
    }
  },
  muiExpandButtonProps: ({ row: t }) => Ro(t),
  muiTableBodyRowProps: (t) => O(t.row.original) ? {
    sx: {
      backgroundColor: (e) => lr(e.palette.secondary.main, 0.96)
    }
  } : V(t.row.original) ? {
    sx: {
      backgroundColor: (e) => lr(e.palette.secondary.main, 0.92)
    }
  } : {}
}), vm = xo();
function Tm(t) {
  const { columns: e } = Im(t), { t: r } = T(), { search: o } = ge({
    from: "/quotes/$quoteId/salesQuotationView"
  }), n = Uo(), i = JSON.parse(
    localStorage.getItem("defaultMRTItemGroupsColumnVisibility") ?? "{}"
  ), a = ee("enableCost"), s = ee("enableListPrice"), { value: l, onChange: c } = Ve(
    "mrt_itemGroups_columnVisibility",
    {
      moveRow: !1,
      name: !0,
      description: !0,
      partId: !0,
      managingEntity: !0,
      priceLists: !1,
      supportingEntity: !0,
      quantity: !0,
      isTop: !1,
      discount: !1,
      discountPercentage: !0,
      serviceDiscount: !1,
      serviceDiscountPercentage: !1,
      bonusDiscount: !1,
      bonusDiscountPercentage: !1,
      projectDiscount: !1,
      projectDiscountPercentage: !1,
      totalDiscount: !0,
      totalDiscountPercentage: !0,
      totalNet: !0,
      margin: !0,
      optional: !0,
      actions: !0,
      ...i
    }
  );
  a || (l.cost = !1, l.totalCost = !1, l.markupPercentage = !1), s || (l.listPrice = !1, l.totalList = !1);
  const { value: m, onChange: P } = Ve(
    "mrt_itemGroups_columnOrder",
    []
  ), S = {
    ...vm,
    columns: [
      {
        id: "moveRow",
        header: r("CPQ:table.itemGroups.header.moveRow"),
        size: 150,
        visibleInShowHideMenu: !0,
        columnDefType: "display",
        enableHiding: !0,
        Cell: pm
      },
      ...e
    ],
    onColumnVisibilityChange: c,
    onColumnOrderChange: P,
    manualFiltering: !0,
    state: {
      columnVisibility: l,
      columnOrder: ["mrt-row-expand", "moveRow", ...m],
      density: "compact",
      globalFilter: o,
      columnFilters: [
        {
          id: "partId",
          value: o
        },
        {
          id: "name",
          value: o
        },
        {
          id: "description",
          value: o
        }
      ]
    }
  }, q = {
    ...S,
    ...n,
    enableRowActions: !0,
    positionActionsColumn: "last",
    positionCreatingRow: "bottom",
    enablePagination: !1,
    displayColumnDefOptions: {
      "mrt-row-actions": {
        header: "",
        Cell: ({ cell: I, row: B, staticRowIndex: A, table: L }) => {
          const M = B.getParentRow();
          return V(B.original) && M && Ne(M == null ? void 0 : M.original) ? /* @__PURE__ */ u(w, {}) : /* @__PURE__ */ u(
            Hn,
            {
              cell: I,
              row: B,
              staticRowIndex: A,
              table: L
            }
          );
        }
      },
      ...n.displayColumnDefOptions
    },
    // enableEditing: true,
    renderRowActionMenuItems: ({ row: I, closeMenu: B }) => [
      _(I.original) || O(I.original) && !I.original.productId ? /* @__PURE__ */ u(
        C.EditRowMenuItem,
        {
          item: I.original,
          closeMenu: B
        },
        I.original.id + "-edit"
      ) : null,
      /* @__PURE__ */ u(
        C.CloneRowMenuItem,
        {
          item: I.original,
          onSuccess: B
        },
        I.original.id + "-clone"
      ),
      /* @__PURE__ */ u(
        C.DeleteRowMenuItem,
        {
          item: I.original,
          onSuccess: B
        },
        I.original.id + "-delete"
      ),
      O(I.original) && I.original.configurationId ? /* @__PURE__ */ u(
        Pm,
        {
          item: I.original,
          closeMenu: B
        },
        I.original.id + "-showBOM"
      ) : null,
      O(I.original) && I.original.configurationId ? /* @__PURE__ */ u(
        qm,
        {
          item: I.original,
          closeMenu: B
        },
        I.original.id + "-showSummary"
      ) : null
    ]
  };
  return { sharedTableOptions: S, itemGroupsTableOptions: q };
}
function Ir({ title: t }) {
  return /* @__PURE__ */ u(Nr, { variant: "h6", sx: { fontWeight: "bold" }, children: t });
}
const Qo = J(null), ir = () => X(Qo);
function eC({
  quoteId: t,
  children: e
}) {
  const { data: r, isLoading: o } = Se(
    { id: t || "" },
    void 0,
    {
      enabled: !!t
    }
  );
  return !r || o ? null : /* @__PURE__ */ u(Qo.Provider, { value: r || null, children: e });
}
const ko = J({
  onChange: (t) => {
    console.log(
      "onChange is not implemented, probably you forgot to pass the onChange prop to CategoryTree",
      { item: t }
    );
  }
});
function Bm({
  onChange: t,
  children: e
}) {
  return /* @__PURE__ */ u(ko.Provider, { value: { onChange: t }, children: e });
}
function Lm() {
  return X(ko);
}
const Gm = De.forwardRef(function(e, r) {
  const { onChange: o } = Lm(), {
    classes: n,
    className: i,
    label: a,
    itemId: s,
    icon: l,
    expansionIcon: c,
    displayIcon: m,
    item: P
  } = e, {
    disabled: S,
    expanded: q,
    selected: I,
    focused: B,
    handleExpansion: A,
    preventSelection: L
  } = Zn(s), M = l || c || m, v = (re) => {
    re.stopPropagation(), A(re);
  }, D = (re) => {
    L(re), o(P);
  };
  return /* @__PURE__ */ f(
    h,
    {
      className: ei(i, n.root, {
        [n.expanded]: q,
        [n.selected]: I,
        [n.focused]: B,
        [n.disabled]: S
      }),
      sx: { border: I ? "1px solid" : "none" },
      ref: r,
      onClick: D,
      children: [
        /* @__PURE__ */ u("div", { onClick: v, className: n.iconContainer, children: M }),
        /* @__PURE__ */ u(Ue, { title: a, disableInteractive: !0, children: /* @__PURE__ */ u(
          U,
          {
            component: "div",
            className: n.label,
            maxWidth: "25ch",
            sx: {
              textOverflow: "ellipsis",
              overflow: "hidden"
            },
            children: a
          }
        ) }),
        P.hasProducts && /* @__PURE__ */ u(E, { settingKey: "showCatalogProductCount", children: /* @__PURE__ */ u(U, { sx: { fontStyle: "italic", color: "secondary.main" }, children: P.numProducts }) })
      ]
    }
  );
}), Am = De.forwardRef(function(e, r) {
  return /* @__PURE__ */ u(
    Yn,
    {
      ContentComponent: Gm,
      ...e,
      ContentProps: { item: e.item },
      ref: r
    }
  );
});
function pt({
  item: t,
  languageId: e
}) {
  var r;
  return t.resourceId && /* @__PURE__ */ u(
    Am,
    {
      itemId: t.resourceId,
      label: Fm({ item: t, languageId: e }),
      item: t,
      children: (r = t.children) == null ? void 0 : r.map(
        (o) => pt({ item: o, languageId: e })
      )
    },
    t.resourceId
  );
}
function Fm({
  item: t,
  languageId: e
}) {
  return t.translations && e && Me(t.translations, e).name || t.title;
}
function Om({
  selectedCategoryId: t,
  search: e
}) {
  var l;
  const r = Xn(), { selectedLanguageId: o } = H(), n = {
    productSearch: e
  };
  o && o !== "cimode" && (n.languageIds = [o]);
  const { data: i } = fd(n), { t: a } = T(), s = (l = i == null ? void 0 : i.find((c) => c.isRoot)) == null ? void 0 : l.resourceId;
  return i && /* @__PURE__ */ f(
    Jn,
    {
      apiRef: r,
      sx: {
        alignSelf: "flex-start"
      },
      slots: {
        expandIcon: () => /* @__PURE__ */ u(F, { children: "chevron_right" }),
        collapseIcon: () => /* @__PURE__ */ u(F, { children: "expand_more" })
      },
      selectedItems: t || null,
      defaultExpandedItems: [s || ""],
      children: [
        /* @__PURE__ */ u(E, { settingKey: "enableSharedProducts", children: pt({
          item: {
            title: a("CPQ:categories.sharedProducts"),
            id: "SharedProducts",
            resourceId: "SharedProducts"
          },
          languageId: o
        }) }),
        /* @__PURE__ */ u(E, { settingKey: "enableCustomProducts", children: pt({
          item: {
            title: a("CPQ:categories.customProducts"),
            id: "CustomProducts",
            resourceId: "CustomProducts"
          },
          languageId: o
        }) }),
        i == null ? void 0 : i.map(
          (c) => pt({ item: c, languageId: o })
        )
      ]
    }
  );
}
function wm({
  selectedCategoryId: t,
  search: e,
  onChange: r
}) {
  return /* @__PURE__ */ u(Bm, { onChange: r, children: /* @__PURE__ */ u(
    Om,
    {
      selectedCategoryId: t,
      search: e
    }
  ) });
}
function Dm({
  isOpen: t,
  toggleIsOpen: e
}) {
  const { t: r } = T();
  return /* @__PURE__ */ u(
    Q,
    {
      onClick: e,
      startIcon: /* @__PURE__ */ u(F, { children: t ? "close" : "menu" }),
      children: r("CPQ:productsTable.tree.categoriesToggleText")
    }
  );
}
function Rm() {
  const { t } = T();
  return /* @__PURE__ */ u(Nr, { variant: "h6", margin: "5rem auto", color: "secondary", children: t("CPQ:catalog.selectACategoryFirst") });
}
function Vm() {
  const { t } = T(), { selectedLanguageId: e } = H(), r = ir(), o = r == null ? void 0 : r.id, n = ee("enableCost"), i = ee("enableListPrice");
  return { columns: me(
    () => [
      {
        id: "imageId",
        header: t("CPQ:catalog.productTable.header.preview"),
        Cell: ({ row: s }) => {
          var l, c;
          return /* @__PURE__ */ u(
            Lo,
            {
              alt: (l = s.original.image) == null ? void 0 : l.filename,
              imageId: (c = s.original.image) == null ? void 0 : c.id
            }
          );
        }
      },
      {
        accessorKey: "partId",
        header: t("CPQ:catalog.productTable.header.articleNumber"),
        Cell: ({ row: s, renderedCellValue: l }) => {
          var m, P, S, q;
          const c = s.original.isCustom;
          return /* @__PURE__ */ u(
            Xt,
            {
              text: l,
              product: s.original,
              quoteId: o,
              withAddButton: !0,
              listPrice: c ? {
                value: (m = s.original.originalListPrice) == null ? void 0 : m.price,
                currency: (P = s.original.originalListPrice) == null ? void 0 : P.currency
              } : {
                value: s.original.listPrice,
                currency: s.original.currency
              },
              cost: c ? {
                value: (S = s.original.originalCost) == null ? void 0 : S.price,
                currency: (q = s.original.originalCost) == null ? void 0 : q.currency
              } : {
                value: s.original.cost,
                currency: s.original.currency
              }
            }
          );
        }
      },
      {
        id: "name",
        header: t("CPQ:catalog.productTable.header.name"),
        accessorFn: (s) => rr({
          product: s,
          languageId: e
        })
      },
      {
        id: "description",
        header: t("CPQ:catalog.productTable.header.description"),
        accessorFn: (s) => or({
          product: s,
          languageId: e
        }),
        Cell: Do
      },
      {
        accessorFn: (s) => {
          var l;
          return s.isCustom ? ((l = s.originalCost) == null ? void 0 : l.price) ?? "-" : s.cost;
        },
        id: "cost",
        header: t("CPQ:catalog.productTable.header.cost"),
        Header: (s) => /* @__PURE__ */ u(E, { settingKey: "enableCost", children: s.column.columnDef.header }),
        Cell: ue,
        muiTableBodyCellProps: {
          align: "right",
          style: { whiteSpace: "nowrap" }
        },
        grow: 0,
        size: 100,
        maxSize: 100,
        visibleInShowHideMenu: n
      },
      {
        accessorFn: (s) => {
          var l;
          return s.isCustom ? ((l = s.originalListPrice) == null ? void 0 : l.price) ?? "_" : s.listPrice;
        },
        id: "listPrice",
        header: t("CPQ:catalog.productTable.header.listPrice"),
        Header: (s) => /* @__PURE__ */ u(E, { settingKey: "enableListPrice", children: s.column.columnDef.header }),
        Cell: ue,
        muiTableBodyCellProps: {
          align: "right"
        },
        grow: 0,
        size: 100,
        maxSize: 100,
        visibleInShowHideMenu: i
      },
      {
        id: "createdByName",
        header: t("CPQ:catalog.productTable.header.createdByName"),
        accessorFn: am
      },
      {
        id: "createdOn",
        size: 150,
        header: t("CPQ:catalog.productTable.header.createdOn"),
        accessorFn: sm,
        Cell: fr
      },
      {
        id: "lastUpdatedOn",
        size: 150,
        header: t("CPQ:catalog.productTable.header.lastUpdatedOn"),
        accessorFn: um,
        Cell: fr
      },
      {
        id: "lastUpdatedByName",
        size: 150,
        header: t("CPQ:catalog.productTable.header.lastUpdatedByName"),
        accessorFn: lm
      }
    ],
    [t, o, e, n, i]
  ) };
}
function Nm() {
  const t = ee("enableCost"), e = ee("enableListPrice"), { value: r, onChange: o } = Ve(
    "mrt_catalogProductsTable_columnVisibility",
    {
      "mrt-row-select": !0,
      imageId: !0,
      partId: !0,
      name: !0,
      description: !0,
      manufacturer: !0,
      unit: !0,
      cost: t,
      listPrice: e,
      "mrt-row-actions": !0,
      createdByName: !1,
      createdOn: !1,
      lastUpdatedOn: !1,
      lastUpdatedByName: !1
    }
  ), { value: n, onChange: i } = Ve(
    "mrt_catalogProductsTable_columnOrder",
    []
  ), { columns: a } = Vm();
  return {
    columns: a,
    onColumnVisibilityChange: o,
    onColumnOrderChange: i,
    state: {
      columnVisibility: r,
      columnOrder: n
    }
  };
}
function Mm({
  label: t,
  onDelete: e
}) {
  return /* @__PURE__ */ u(ti, { label: t, onDelete: e, onClick: e });
}
function xm({
  filter: t,
  onClickDelete: e,
  onClearAll: r
}) {
  const { t: o } = T();
  return t ? /* @__PURE__ */ f(h, { display: "flex", flexWrap: "wrap", gap: 1, children: [
    t.map(
      (n) => {
        var i, a;
        return n.ident && /* @__PURE__ */ u(
          Mm,
          {
            label: `${n.translation || n.ident} ${n.operator} ${(i = n.values) == null ? void 0 : i.map((s) => s.translation || s.value).join(", ")}`,
            onDelete: () => n.ident && e(n)
          },
          `${n.ident}${n.operator}${(a = n.values) == null ? void 0 : a.map((s) => s.value).join(",")}`
        );
      }
    ),
    t.length > 0 && /* @__PURE__ */ u(Q, { onClick: r, children: o("CPQ:filter.button.clearAllFilter") })
  ] }) : null;
}
function Em() {
  const { filter: t, categoryId: e } = ge({
    strict: !1,
    select: (i) => ({
      filter: i.filter,
      categoryId: i.categoryId
    })
  }), r = Ee();
  function o(i) {
    const a = t == null ? void 0 : t.filter(
      (s) => !(s.ident === i.ident && s.operator === i.operator)
    );
    r({
      to: ".",
      search: (s) => ({ ...s, filter: a })
    });
  }
  function n() {
    r({
      to: ".",
      search: (i) => ({ ...i, filter: void 0 })
    });
  }
  return e && t && /* @__PURE__ */ u(
    xm,
    {
      filter: t,
      onClickDelete: o,
      onClearAll: n
    }
  );
}
function Um() {
  const { t } = T(), { selectedLanguageId: e } = H(), { quoteId: r } = Rt({ from: "/quotes/$quoteId" }), o = Mr();
  return { columns: me(
    () => [
      o.accessor("displayedRank", {
        header: t("CPQ:table.itemGroups.header.rank"),
        Header: R
      }),
      o.accessor(
        (i) => Ao({
          item: i,
          languageId: e
        }),
        {
          id: "name",
          header: t("CPQ:table.itemGroups.header.name"),
          Header: R,
          Cell: wo,
          maxSize: 250
        }
      ),
      o.accessor((i) => Fo(i), {
        id: "partId",
        header: t("CPQ:table.itemGroups.header.partId"),
        Header: R,
        Cell: (...i) => Oo(r, ...i)
      }),
      o.accessor("quantity", {
        header: t("CPQ:table.itemGroups.header.qty"),
        Header: R
      })
    ],
    [o, t, e, r]
  ) };
}
const Qm = xo();
function km({ quoteId: t }) {
  const { data: e } = Se(
    {
      id: t || "",
      includes: nr,
      order: "createdOn",
      sort: "desc",
      onlyOptional: !1
    },
    void 0,
    { enabled: !!t }
  ), { columns: r } = Um(), o = Uo(), n = {
    ...Qm,
    ...o,
    columns: r,
    enableRowActions: !1,
    enableTopToolbar: !1,
    enablePagination: !1,
    muiExpandButtonProps: ({ row: i }) => Ro(i),
    state: {
      density: "compact"
    }
  };
  return /* @__PURE__ */ u(yt, { sx: { padding: 2, maxWidth: "30%" }, children: /* @__PURE__ */ u(
    Zt,
    {
      tableOptions: n,
      data: (e == null ? void 0 : e.itemGroups) || []
    }
  ) });
}
const jo = J(void 0);
function jm({
  tableOptions: t,
  children: e
}) {
  return /* @__PURE__ */ u(jo.Provider, { value: t, children: e });
}
const tC = () => {
  const t = X(jo);
  if (t === void 0)
    throw new Error(
      "useProductTableOptions must be used within a ProductTableOptionsProvider"
    );
  return t;
}, Lt = "ProductType,AttachmentSet.AttachmentItems.Attachment,Image,Translations.Language";
function rC({
  onCategoryChange: t,
  onFilterChange: e
}) {
  const { search: r, categoryId: o } = ge({
    strict: !1
  }), n = ir(), [i, a] = qe(
    "isCategoryTreeOpen",
    !0,
    !0
  ), [s, l] = G(!1), c = Nm();
  return /* @__PURE__ */ f(h, { display: "flex", flexDirection: "column", flex: "1", gap: 2, children: [
    (n == null ? void 0 : n.id) && /* @__PURE__ */ u(
      C.CatalogButtons,
      {
        isLineItemsOverviewOpen: s,
        setIsLineItemsOverviewOpen: l,
        sharedTableOptions: c,
        onFilterChange: e
      }
    ),
    /* @__PURE__ */ f(h, { display: "flex", gap: 20, children: [
      /* @__PURE__ */ u(
        Dm,
        {
          isOpen: i,
          toggleIsOpen: () => a((m) => !m)
        }
      ),
      /* @__PURE__ */ f(h, { className: "catalogFilters", display: "flex", gap: 2, ml: "auto", children: [
        /* @__PURE__ */ u(h, { children: o && /* @__PURE__ */ u(Em, {}) }),
        /* @__PURE__ */ u(h, { minWidth: "20rem", children: /* @__PURE__ */ u(Mo, {}) })
      ] })
    ] }),
    /* @__PURE__ */ f(h, { display: "flex", flex: "1", gap: 2, children: [
      i && /* @__PURE__ */ u(
        wm,
        {
          selectedCategoryId: o,
          search: r,
          onChange: t
        }
      ),
      /* @__PURE__ */ f(h, { display: "flex", flexDirection: "column", minWidth: 0, flex: 1, children: [
        !o && /* @__PURE__ */ u(Rm, {}),
        o && /* @__PURE__ */ u(jm, { tableOptions: c, children: /* @__PURE__ */ u($m, {}) })
      ] }),
      (n == null ? void 0 : n.id) && s && /* @__PURE__ */ u(km, { quoteId: n == null ? void 0 : n.id })
    ] })
  ] });
}
var $o = /* @__PURE__ */ ((t) => (t.SharedProducts = "SharedProducts", t.CustomProducts = "CustomProducts", t))($o || {});
function $m() {
  const t = ir(), e = t == null ? void 0 : t.id, { selectedLanguageId: r } = H(), {
    search: o,
    filter: n,
    categoryId: i,
    start: a,
    size: s
  } = ge({
    strict: !1,
    select: (ce) => ({
      ...ce,
      filter: ce.filter
    })
  }), l = ((n == null ? void 0 : n.length) ?? 0) > 0, [c, m] = G({}), P = Vo(o), S = `partId~="${P}"|identifier~="${P}"|translations.(languageId==${r}&(name~="${P}"|description~="${P}"))`, q = o ? S : "";
  let I = "", B = !1;
  switch (i) {
    case "SharedProducts":
      I = "IsShared==True", B = !0;
      break;
    case "CustomProducts":
      I = "IsCustom==True", B = !0;
      break;
  }
  const { data: A } = Id(
    {
      includes: Lt,
      parentId: i || "",
      start: a,
      size: s,
      order: "id",
      filter: q,
      quoteId: e
    },
    void 0,
    {
      enabled: !B && !l && !!i,
      placeholderData: (ce) => ce
    }
  ), L = (A == null ? void 0 : A.products) || [], M = A == null ? void 0 : A.totalCount, { mutate: v } = Bd();
  $(() => {
    var ce;
    !l || !i || v(
      {
        includes: Lt,
        parentId: i,
        filter: q,
        quoteId: e,
        requestBody: {
          productAttributeFilters: (ce = n || []) == null ? void 0 : ce.map((de) => {
            var ur;
            return {
              baseAttributeIdentifier: de == null ? void 0 : de.ident,
              filterOperator: de.operator,
              filterValues: (ur = de.values || []) == null ? void 0 : ur.map(
                (Jo) => Jo.value || ""
              )
            };
          })
        }
      },
      {
        onSuccess: (de) => {
          m(de);
        }
      }
    );
  }, [
    l,
    n,
    i,
    q,
    v,
    e
  ]);
  const { data: D } = hd(
    {
      filter: q && I ? `(${q})&${I}` : q + I,
      includes: Lt
    },
    void 0,
    {
      enabled: B
    }
  ), re = i === "CustomProducts", sr = B ? D == null ? void 0 : D.products : l ? c == null ? void 0 : c.products : L;
  return /* @__PURE__ */ f(w, { children: [
    re && /* @__PURE__ */ u(C.AddCustomProductDialogButton, {}),
    sr && /* @__PURE__ */ u(
      C.ProductsTable,
      {
        items: sr,
        rowCount: M
      }
    )
  ] });
}
const zm = xe(Q);
function Km() {
  const { t } = T();
  return /* @__PURE__ */ u(
    zm,
    {
      to: "/quotes/$quoteId/catalog",
      search: (e) => ({
        ...e,
        categoryId: $o.CustomProducts
      }),
      from: "/quotes/$quoteId/salesQuotationView",
      startIcon: /* @__PURE__ */ u(F, { children: "add" }),
      children: t("CPQ:button.addCustomProduct")
    }
  );
}
const Hm = xe(Q);
function _m() {
  const { t } = T();
  return /* @__PURE__ */ u(
    Hm,
    {
      to: "/quotes/$quoteId/catalog",
      from: "/quotes/$quoteId/salesQuotationView",
      startIcon: /* @__PURE__ */ u(F, { children: "add" }),
      children: t("CPQ:button.addProduct")
    }
  );
}
function Wm({ quote: t }) {
  var i;
  const { t: e } = T(), { id: r } = t, { sharedTableOptions: o, itemGroupsTableOptions: n } = Tm(r);
  return /* @__PURE__ */ f(h, { display: "flex", flexDirection: "column", gap: 2, children: [
    /* @__PURE__ */ f(
      h,
      {
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
        gap: 2,
        children: [
          /* @__PURE__ */ f(h, { display: "flex", gap: 2, flex: 1, children: [
            /* @__PURE__ */ u(E, { settingKey: "enablePriceList", children: /* @__PURE__ */ u(
              C.PriceListSelect,
              {
                quoteId: r,
                selectedPriceLists: t.priceLists ?? [],
                withLabel: !0
              }
            ) }),
            /* @__PURE__ */ u(E, { settingKey: "enablePriceList", children: /* @__PURE__ */ u(
              C.QuoteCurrencySelect,
              {
                quote: t,
                withLabel: !0
              }
            ) }),
            /* @__PURE__ */ u(h, { ml: "auto", children: /* @__PURE__ */ u(Mo, {}) })
          ] }),
          /* @__PURE__ */ f(h, { display: "flex", gap: 2, justifyContent: "space-between", children: [
            /* @__PURE__ */ f(h, { display: "flex", gap: 2, flexDirection: "column", children: [
              /* @__PURE__ */ u(C.ItemGroupsFilter, {}),
              /* @__PURE__ */ u(E, { settingKey: "enableDiscounts", children: /* @__PURE__ */ u(C.QuoteDiscounts, { quote: t }) })
            ] }),
            /* @__PURE__ */ u(
              C.QuoteActionsWrapper,
              {
                quoteId: r,
                tableOptions: o
              }
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ u(h, { children: /* @__PURE__ */ f(
      yt,
      {
        sx: { padding: 2, display: "flex", flexDirection: "column", gap: 2 },
        children: [
          /* @__PURE__ */ f(h, { sx: { display: "flex", gap: 2, flexWrap: "wrap" }, children: [
            /* @__PURE__ */ u(Ir, { title: e("CPQ:table.itemGroups.title") }),
            /* @__PURE__ */ f(h, { display: "flex", ml: "auto", gap: 2, children: [
              /* @__PURE__ */ u(C.GuidedSellingButton, {}),
              /* @__PURE__ */ u(_m, {}),
              /* @__PURE__ */ u(Km, {})
            ] })
          ] }),
          /* @__PURE__ */ u(
            Zt,
            {
              tableOptions: n,
              data: (t == null ? void 0 : t.itemGroups) || []
            }
          ),
          /* @__PURE__ */ u(h, { display: "flex", alignSelf: "flex-end", children: /* @__PURE__ */ u(
            C.PriceSummary,
            {
              currencyIdentifier: (i = t.currency) == null ? void 0 : i.identifier,
              totalCost: t.totalCost,
              totalList: t.totalList,
              totalNet: t.totalNet
            }
          ) })
        ]
      }
    ) }),
    /* @__PURE__ */ u(h, { children: /* @__PURE__ */ f(yt, { sx: { padding: 2, display: "flex", flexDirection: "column" }, children: [
      /* @__PURE__ */ u(Ir, { title: e("CPQ:table.itemGroupsOptional.title") }),
      /* @__PURE__ */ u(
        Rp,
        {
          quoteId: r,
          tableOptions: n
        }
      )
    ] }) })
  ] });
}
const zo = k("/quotes/$quoteId/salesQuotationView")({
  component: Zm,
  staticData: {
    title: "Sales quotation view"
  },
  validateSearch: (t) => ({
    search: t.search || ""
  })
});
function Zm() {
  const t = zo.useParams().quoteId, { selectedLanguageId: e } = H(), { search: r } = ge({
    from: "/quotes/$quoteId/salesQuotationView"
  }), { data: o } = Se(
    No({
      id: t,
      unescapedSearchIncludes: r,
      languageIds: e && e != "cimode" ? [e] : void 0
    })
  );
  return o ? /* @__PURE__ */ u(Wm, { quote: o }) : null;
}
const Xm = k("/quotes/$quoteId/quoteInfo")({
  component: C.QuoteInfoRouteComponent,
  staticData: {
    title: "Quotes Info"
  }
}), Jm = k("/quotes/$quoteId/docGen")({
  component: C.DocGenRouteComponent,
  staticData: {
    title: "Document Generation"
  }
});
function Ym(t) {
  const e = {
    start: 0,
    size: Number(localStorage.getItem("catalogPageSize") ?? 25),
    filter: void 0
  };
  return t.categoryId && (e.categoryId = t.categoryId), Array.isArray(t.filter) && t.filter.length > 0 && (e.filter = t.filter), t.search && (e.search = t.search), typeof t.start == "number" && (e.start = t.start), typeof t.size == "number" && (e.size = t.size), e;
}
const ey = k("/quotes/$quoteId/catalog")({
  component: C.CatalogRouteComponent,
  staticData: {
    title: "Catalog"
  },
  validateSearch: Ym
}), Ko = lp.update({
  id: "/quotes",
  path: "/quotes",
  getParentRoute: () => ae
}), ty = cp.update({
  id: "/configurator",
  path: "/configurator",
  getParentRoute: () => ae
}), ry = dp.update({
  id: "/",
  path: "/",
  getParentRoute: () => ae
}), oy = pp.update({
  id: "/presets/",
  path: "/presets/",
  getParentRoute: () => ae
}), ny = mp.update({
  id: "/opportunities/",
  path: "/opportunities/",
  getParentRoute: () => ae
}), Ge = Pe.update({
  id: "/$quoteId",
  path: "/$quoteId",
  getParentRoute: () => Ko
}), iy = Sp.update({
  id: "/quoteStandalone/$quoteId",
  path: "/quoteStandalone/$quoteId",
  getParentRoute: () => ae
}), ay = Cp.update(
  {
    id: "/opportunities/$opportunityId",
    path: "/opportunities/$opportunityId",
    getParentRoute: () => ae
  }
), sy = vo.update({
  id: "/itemGroups/$itemGroupId",
  path: "/itemGroups/$itemGroupId",
  getParentRoute: () => ae
}), uy = Bp.update({
  id: "/cart/$quoteId",
  path: "/cart/$quoteId",
  getParentRoute: () => ae
}), ly = To.update({
  id: "/",
  path: "/",
  getParentRoute: () => Ge
}), cy = zo.update({
  id: "/salesQuotationView",
  path: "/salesQuotationView",
  getParentRoute: () => Ge
}), dy = Xm.update({
  id: "/quoteInfo",
  path: "/quoteInfo",
  getParentRoute: () => Ge
}), py = Jm.update({
  id: "/docGen",
  path: "/docGen",
  getParentRoute: () => Ge
}), my = ey.update({
  id: "/catalog",
  path: "/catalog",
  getParentRoute: () => Ge
}), yy = {
  QuotesQuoteIdCatalogRoute: my,
  QuotesQuoteIdDocGenRoute: py,
  QuotesQuoteIdQuoteInfoRoute: dy,
  QuotesQuoteIdSalesQuotationViewRoute: cy,
  QuotesQuoteIdIndexRoute: ly
}, gy = Ge._addFileChildren(
  yy
), by = {
  QuotesQuoteIdRoute: gy
}, fy = Ko._addFileChildren(by), hy = {
  IndexRoute: ry,
  ConfiguratorRoute: ty,
  QuotesRoute: fy,
  CartQuoteIdRoute: uy,
  ItemGroupsItemGroupIdRoute: sy,
  OpportunitiesOpportunityIdRoute: ay,
  QuoteStandaloneQuoteIdRoute: iy,
  OpportunitiesIndexRoute: ny,
  PresetsIndexRoute: oy
}, ar = ae._addFileChildren(hy)._addFileTypes();
function Iy(t) {
  t.forEach((e) => {
    const r = Pe.children.find(
      (o) => o.path === e.path
    );
    console.log({ QuotesQuoteIdImport: Pe, routeTree: ar }), r || Pe.addChildren({
      ...Pe.children,
      [e.path]: sn({
        ...e,
        getParentRoute: () => Pe
      })
    });
  });
}
const Ho = un(), Sr = Ar({
  routeTree: ar,
  basepath: "/",
  history: Ho
});
function Sy({
  basePath: t,
  routesInQuotes: e
}) {
  const r = me(() => e ? (Iy(e), Ar({
    routeTree: ar,
    history: Ho
  })) : Sr, [e]);
  return r.basepath = t ?? Sr.basepath, /* @__PURE__ */ u(ln, { router: r });
}
function Py(t) {
  const e = {
    enableSharedProducts: !0,
    enableCustomProducts: !0,
    enablePriceList: !0,
    enableDiscounts: !0,
    enableDiscount1: !0,
    enableDiscount2: !0,
    enableDiscount3: !0,
    enableDiscount4: !0,
    enableDiscount5: !0,
    enableCost: !0,
    enableListPrice: !0,
    showCatalogProductCount: !0,
    showWorkflowSelectInUserWidget: !0,
    defaultMRTItemGroupsColumnVisibility: {},
    ...t
  };
  Object.entries(e).forEach(([r, o]) => {
    try {
      localStorage.getItem(r) === null && localStorage.setItem(r, JSON.stringify(o));
    } catch (n) {
      console.error("useLocalStorage: Error while setting localStorage", {
        error: n
      });
    }
  });
}
function oC({
  componentsOverride: t,
  basePath: e,
  enableDevTools: r = !1,
  routesInQuotes: o,
  languageCode: n = "en-US",
  toastContainerProps: i,
  itemGroupsTableColumnsOverrideFn: a,
  defaultSettings: s
}) {
  return $(() => {
    Py(s);
  }, [s]), /* @__PURE__ */ u(ds, { defaultValues: { enableDevTools: r }, children: /* @__PURE__ */ u(Dt, { fallback: /* @__PURE__ */ u(be, {}), children: /* @__PURE__ */ u(
    sp,
    {
      itemGroupsTableColumnsOverrideFn: a,
      toastContainerProps: i,
      languageCode: n,
      componentsOverride: t,
      children: /* @__PURE__ */ u(
        Sy,
        {
          basePath: e,
          routesInQuotes: o
        }
      )
    }
  ) }) });
}
const Pr = Vt({}), nC = Vt(Pr, {
  components: {
    MuiAppBar: { defaultProps: { color: "transparent" } },
    MuiButtonBase: { defaultProps: { disableRipple: !0 } },
    MuiContainer: {
      styleOverrides: {
        maxWidthXl: { [Pr.breakpoints.up("xl")]: { maxWidth: "2560px" } }
      }
    },
    MuiDialog: {
      styleOverrides: {
        root: {
          ".MuiDialogTitle-root + .MuiDialogContent-root": {
            padding: "1.5rem"
          }
        }
      }
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          padding: "1.5rem",
          paddingBottom: "0",
          fontSize: "1.5rem",
          fontWeight: 500
        }
      }
    }
  }
});
function iC({
  children: t,
  client: e
}) {
  return /* @__PURE__ */ u(Fr, { client: e || ye, children: t });
}
function Cy({
  selectedCurrency: t,
  onChange: e,
  withLabel: r,
  required: o
}) {
  const { data: n } = gd(), { t: i } = T();
  return /* @__PURE__ */ f(Et, { sx: { minWidth: "110px" }, required: o, children: [
    r && /* @__PURE__ */ u(Er, { children: i("CPQ:currencySelectLabel") }),
    /* @__PURE__ */ u(
      Ut,
      {
        value: t || "",
        onChange: e,
        input: r ? /* @__PURE__ */ u(
          Rr,
          {
            label: i("CPQ:currencySelectLabel"),
            required: o
          }
        ) : void 0,
        children: n == null ? void 0 : n.map((a) => /* @__PURE__ */ u(le, { value: a.id, children: a.identifier || a.id }, a.id))
      }
    )
  ] });
}
function Cr({
  price: t,
  validFrom: e,
  validTo: r,
  currencyId: o,
  onChange: n,
  label: i,
  gap: a,
  required: s
}) {
  const { t: l } = T();
  return /* @__PURE__ */ f(Ce, { display: "flex", flexDirection: "column", gap: a, children: [
    i && /* @__PURE__ */ u(xt, { textAlign: "center", children: i }),
    /* @__PURE__ */ f(Ce, { display: "flex", gap: a, flex: 1, children: [
      /* @__PURE__ */ u(
        Jt,
        {
          required: s,
          width: "15ch",
          defaultValue: t,
          label: l("CPQ:dialog.addCustomProduct.priceCost.value"),
          onChange: (c) => {
            n((m) => ({ ...m, price: c }));
          },
          min: 0,
          allowDecimal: !0
        }
      ),
      /* @__PURE__ */ u(
        Cy,
        {
          required: s,
          selectedCurrency: o,
          onChange: (c) => {
            n((m) => ({
              ...m,
              currencyId: c.target.value
            }));
          },
          withLabel: !0
        }
      )
    ] }),
    /* @__PURE__ */ f(Ce, { display: "flex", gap: a, flex: 1, children: [
      /* @__PURE__ */ u(
        mt,
        {
          sx: { flex: 1 },
          slotProps: { textField: { size: "small" } },
          label: l("CPQ:dialog.addCustomProduct.priceCost.validFrom"),
          value: e ? new Date(e) : null,
          onChange: (c) => {
            Number.isNaN(c == null ? void 0 : c.valueOf()) ? n((m) => ({ ...m, validFrom: null })) : n((m) => ({
              ...m,
              validFrom: c == null ? void 0 : c.toISOString()
            }));
          }
        }
      ),
      /* @__PURE__ */ u(
        mt,
        {
          sx: { flex: 1 },
          slotProps: { textField: { size: "small" } },
          label: l("CPQ:dialog.addCustomProduct.priceCost.validTo"),
          value: r ? new Date(r) : null,
          onChange: (c) => {
            Number.isNaN(c == null ? void 0 : c.valueOf()) ? n((m) => ({ ...m, validTo: null })) : n((m) => ({
              ...m,
              validTo: c == null ? void 0 : c.toISOString()
            }));
          }
        }
      )
    ] })
  ] });
}
const Ae = 2;
function aC({
  inputFields: t,
  isShared: e,
  setIsShared: r,
  listPrice: o,
  setListPrice: n,
  cost: i,
  setCost: a,
  isActive: s,
  setIsActive: l
}) {
  const { t: c } = T();
  return /* @__PURE__ */ f(Ce, { display: "flex", flexDirection: "column", gap: Ae, children: [
    /* @__PURE__ */ u(Ce, { display: "flex", gap: Ae, flexWrap: "wrap", children: t.map((m, P) => /* @__PURE__ */ u(
      wr,
      {
        sx: { flex: 1, flexBasis: "200px" },
        label: m.label,
        required: m.required,
        variant: "outlined",
        value: m.state,
        onChange: (S) => m.setState(S.target.value)
      },
      P
    )) }),
    /* @__PURE__ */ u(
      Cr,
      {
        ...o,
        required: !0,
        onChange: n,
        label: c("CPQ:dialog.addCustomProduct.price"),
        gap: Ae
      }
    ),
    /* @__PURE__ */ u(
      Cr,
      {
        ...i,
        required: !0,
        onChange: a,
        label: c("CPQ:dialog.addCustomProduct.cost"),
        gap: Ae
      }
    ),
    /* @__PURE__ */ f(Ce, { display: "flex", gap: Ae, children: [
      /* @__PURE__ */ u(E, { settingKey: "enableSharedProducts", children: /* @__PURE__ */ u(
        cr,
        {
          label: c("CPQ:dialog.addCustomProduct.isShared"),
          control: /* @__PURE__ */ u(
            Ft,
            {
              checked: e,
              onChange: (m) => r(m.target.checked)
            }
          )
        }
      ) }),
      /* @__PURE__ */ u(
        cr,
        {
          label: c("CPQ:dialog.addCustomProduct.isActive"),
          control: /* @__PURE__ */ u(
            Ft,
            {
              checked: s || !1,
              onChange: (m) => l(m.target.checked)
            }
          )
        }
      )
    ] })
  ] });
}
function sC() {
  return X(fo);
}
const qy = b(
  () => import("./PageHeader-hiwVLxnn.js")
);
function qr({
  pageHeading: t,
  subNavigationItems: e
}) {
  return /* @__PURE__ */ u(Dt, { fallback: "loading PageHeader", children: /* @__PURE__ */ u(
    qy,
    {
      pageHeading: t,
      subNavigationItems: e
    }
  ) });
}
const vy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QuoteDetailsViewPageHeader: qr,
  default: qr
}, Symbol.toStringTag, { value: "Module" }));
function Ty({
  count: t,
  onClick: e
}) {
  return /* @__PURE__ */ u(
    Qn,
    {
      badgeContent: t,
      showZero: !0,
      color: "warning",
      max: 999,
      sx: {
        "& .MuiBadge-badge": {
          top: "10px"
        }
      },
      children: /* @__PURE__ */ u(
        z,
        {
          onClick: e,
          size: "large",
          sx: { color: x.primary.contrastText },
          children: /* @__PURE__ */ u(F, { fontSize: "inherit", children: "shopping_cart" })
        }
      )
    }
  );
}
const _o = K + "_CART";
function By() {
  var i;
  const t = Ee(), { quoteId: e } = Rt({
    strict: !1
  }), { data: r, isFetching: o } = Se(
    {
      id: e || "",
      includes: "ItemGroups.LineItems"
    },
    [_o],
    {
      enabled: !!e
    }
  );
  if (!e)
    return;
  if (o)
    return /* @__PURE__ */ u(ht, { color: "inherit", size: 20 });
  const n = ((i = r == null ? void 0 : r.itemGroups) == null ? void 0 : i.reduce((a, s) => s.lineItems ? a + s.lineItems.length : a, 0)) || 0;
  return /* @__PURE__ */ u(
    Ty,
    {
      onClick: () => {
        t({
          to: "/cart/$quoteId",
          params: {
            quoteId: e
          }
        });
      },
      count: n
    }
  );
}
function uC() {
  const { isCustomer: t } = Wt();
  return /* @__PURE__ */ u(Ur, { position: "sticky", children: /* @__PURE__ */ u(ri, { maxWidth: "xl", children: /* @__PURE__ */ f(h, { display: "flex", gap: "2rem", alignItems: "center", children: [
    /* @__PURE__ */ u(h, { mr: "auto", display: "flex", children: /* @__PURE__ */ u(C.MainHeaderLogo, {}) }),
    t && /* @__PURE__ */ u(By, {}),
    /* @__PURE__ */ u(C.UserWidget, {})
  ] }) }) });
}
function vr({
  itemGroup: t
}) {
  const e = te();
  return /* @__PURE__ */ u(h, { sx: { margin: "auto" }, children: /* @__PURE__ */ u(
    C.AddLineItemButton,
    {
      itemGroupId: t.id,
      onSuccess: () => {
        e.invalidateQueries({
          queryKey: [Hr]
        });
      }
    }
  ) });
}
const Ly = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ItemGroupActionButtonsArea: vr,
  default: vr
}, Symbol.toStringTag, { value: "Module" }));
function Tr(t) {
  return /* @__PURE__ */ u(h, { m: "auto" });
}
const Gy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  OpportunityActionButtonsArea: Tr,
  default: Tr
}, Symbol.toStringTag, { value: "Module" }));
function Br({
  languages: t,
  selectedLanguageId: e,
  onChange: r
}) {
  const { showDevTools: o } = Eo(), { t: n } = T();
  return /* @__PURE__ */ f(Vr, { sx: { width: "125px" }, children: [
    /* @__PURE__ */ u(kn, { children: n("CPQ:select.language") }),
    /* @__PURE__ */ f(
      jn,
      {
        value: e || "",
        onChange: (i) => {
          r(i.target.value);
        },
        label: n("CPQ:select.language"),
        children: [
          t == null ? void 0 : t.map((i) => /* @__PURE__ */ u(bt, { value: i.id, children: i.languageCode }, i.id)),
          o && /* @__PURE__ */ u(
            bt,
            {
              value: "cimode",
              sx: { border: "solid red 1px" },
              children: "cimode"
            },
            "cimode"
          )
        ]
      }
    )
  ] });
}
const Ay = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LanguageSelect: Br,
  default: Br
}, Symbol.toStringTag, { value: "Module" }));
function lC({ children: t }) {
  return /* @__PURE__ */ u(Ur, { position: "fixed", sx: { marginTop: "2rem", top: "auto", bottom: 0 }, children: t });
}
const Fy = xe(Q), Oy = xe(z);
function wy({
  quoteId: t,
  quantity: e,
  products: r,
  onSuccess: o
}) {
  const n = te(), { t: i } = T(), a = async () => {
    typeof o == "function" && o(), await n.invalidateQueries({
      queryKey: [K, _o]
    }), at.success(i("CPQ:toast.success.itemWasAddedToCart"));
  }, { mutate: s } = go({
    onSuccess: a
  });
  async function l() {
    const c = r.map(
      ({ id: m }) => ({
        quoteId: t,
        quantity: e,
        productId: m
      })
    );
    s({
      requestBody: c
    });
  }
  return /* @__PURE__ */ u(z, { color: "primary", onClick: l, children: /* @__PURE__ */ u(F, { children: "add_shopping_cart" }) });
}
function Wo({
  defaultValue: t,
  onChange: e,
  width: r = "4ch"
}) {
  return /* @__PURE__ */ u(
    Jt,
    {
      defaultValue: t,
      onChange: e,
      min: 1,
      width: r
    }
  );
}
function Zo({
  quoteId: t,
  quantity: e,
  products: r,
  onSuccess: o,
  onClose: n,
  cfgState: i,
  anchorEl: a
}) {
  var A;
  const { t: s } = T(), l = te(), c = async () => {
    typeof o == "function" && o(), at.success(s("CPQ:toast.success.itemWasAddedToQuote")), await l.invalidateQueries({
      queryKey: [K]
    });
  }, { mutate: m } = Fd({
    onSuccess: c
  }), { mutate: P } = go({
    onSuccess: c
  }), S = i ? {
    configuration: {
      //todo -[ am ]- remove when the backend removed required
      identifier: "dummyIdentifier",
      state: i
    }
  } : {}, { data: q, isLoading: I } = Se(
    {
      id: t || "",
      order: "createdOn",
      sort: "desc",
      onlyOptional: null,
      includes: nr
    },
    void 0,
    { enabled: !!a }
  );
  if (I)
    return;
  async function B(L, M) {
    if (n(), M) {
      const v = r.map(
        ({ id: D }) => ({
          isOptional: !1,
          lineItemId: L,
          quantity: e,
          productId: D
        })
      );
      m({
        requestBody: v
      });
    } else {
      const v = r.map(
        ({ id: D }) => ({
          itemGroupId: L,
          quantity: e,
          productId: D,
          ...S
        })
      );
      P({
        requestBody: v
      });
    }
  }
  return /* @__PURE__ */ f(Mt, { anchorEl: a, open: !!a, onClose: n, children: [
    /* @__PURE__ */ u(
      h,
      {
        mb: 1,
        mx: 1,
        onKeyDown: (L) => {
          L.stopPropagation();
        },
        children: /* @__PURE__ */ u(
          C.AddItemGroupButton,
          {
            quoteId: t,
            onSuccess: c,
            onConfirm: n,
            lineItems: r.map(({ id: L }) => ({
              quantity: e,
              productId: L,
              ...S
            }))
          }
        )
      }
    ),
    /* @__PURE__ */ u(xt, {}),
    (A = q == null ? void 0 : q.itemGroups) == null ? void 0 : A.sort((L, M) => (L.rank ?? 0) > (M.rank ?? 0) ? 1 : -1).map((L) => {
      var M, v;
      return /* @__PURE__ */ f(h, { children: [
        /* @__PURE__ */ f(h, { display: "flex", gap: "1rem", children: [
          /* @__PURE__ */ f(
            le,
            {
              onClick: () => B(L.id),
              sx: {
                fontWeight: "600",
                display: "flex",
                gap: "1rem",
                width: "300px",
                whiteSpace: "break-spaces"
              },
              children: [
                L.displayedRank + " " + (L.name || /* @__PURE__ */ u(U, { style: { fontStyle: "italic" }, children: "Unnamed Item Group" })),
                /* @__PURE__ */ u(
                  U,
                  {
                    sx: {
                      ml: "auto",
                      fontStyle: "italic",
                      color: "secondary.main"
                    },
                    children: (M = L.lineItems) == null ? void 0 : M.length
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ u(h, { pr: "1rem", children: !Jp(r) && /* @__PURE__ */ u(
            C.AddLineItemButtonWrapper,
            {
              products: r,
              itemGroup: L,
              children: /* @__PURE__ */ u(
                C.AddLineItemButton,
                {
                  variant: "text",
                  itemGroupId: L.id,
                  onSuccess: (D) => B(D, !0)
                }
              )
            }
          ) })
        ] }),
        (v = L.lineItems) == null ? void 0 : v.sort((D, re) => (D.rank ?? 0) > (re.rank ?? 0) ? 1 : -1).map((D) => /* @__PURE__ */ u(
          C.AddToQuoteMenuLineItem,
          {
            lineItem: D,
            onClick: B,
            products: r
          },
          D.id
        ))
      ] }, L.id);
    })
  ] });
}
function Lr({
  quoteId: t,
  products: e,
  onSuccess: r,
  defaultQuantity: o = 1
}) {
  const { isCustomer: n } = Wt(), i = e.length === 1, { t: a } = T(), [s, l] = G(o), c = (q) => {
    P(q.currentTarget);
  }, [m, P] = G(null), S = () => {
    P(null);
  };
  return /* @__PURE__ */ f(
    h,
    {
      sx: { minWidth: "max-content" },
      display: "flex",
      flexDirection: "row",
      gap: "1rem",
      children: [
        /* @__PURE__ */ u(Wo, { defaultValue: o, onChange: l }),
        n ? /* @__PURE__ */ u(
          wy,
          {
            quoteId: t,
            quantity: s,
            products: e,
            onSuccess: r
          }
        ) : /* @__PURE__ */ f(w, { children: [
          /* @__PURE__ */ u(
            Q,
            {
              id: "basic-button",
              onClick: c,
              startIcon: /* @__PURE__ */ u(F, { children: "add" }),
              variant: "contained",
              sx: { minWidth: "fit-content" },
              children: a(i ? "CPQ:catalog.productTable.buttons.addProductsToQuote" : "CPQ:catalog.productTable.buttons.addAllProductsToQuote")
            }
          ),
          /* @__PURE__ */ u(
            Zo,
            {
              quoteId: t,
              quantity: s,
              products: e,
              onSuccess: r,
              anchorEl: m,
              onClose: S
            }
          )
        ] })
      ]
    }
  );
}
const Dy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AddProductsToQuoteWidget: Lr,
  default: Lr
}, Symbol.toStringTag, { value: "Module" }));
function Gr({ quote: t }) {
  return /* @__PURE__ */ f(h, { display: "flex", gap: 2, children: [
    /* @__PURE__ */ u(E, { settingKey: "enableDiscount1", children: /* @__PURE__ */ u(
      C.QuoteNumericInputPercentage,
      {
        quote: t,
        propertyKey: "markupPercentage"
      }
    ) }),
    /* @__PURE__ */ u(E, { settingKey: "enableDiscount2", children: /* @__PURE__ */ u(
      C.QuoteNumericInputPercentage,
      {
        quote: t,
        propertyKey: "discountPercentage"
      }
    ) }),
    /* @__PURE__ */ u(E, { settingKey: "enableDiscount3", children: /* @__PURE__ */ u(
      C.QuoteNumericInputPercentage,
      {
        quote: t,
        propertyKey: "serviceDiscountPercentage"
      }
    ) }),
    /* @__PURE__ */ u(E, { settingKey: "enableDiscount4", children: /* @__PURE__ */ u(
      C.QuoteNumericInputPercentage,
      {
        quote: t,
        propertyKey: "bonusDiscountPercentage"
      }
    ) }),
    /* @__PURE__ */ u(E, { settingKey: "enableDiscount5", children: /* @__PURE__ */ u(
      C.QuoteNumericInputPercentage,
      {
        quote: t,
        propertyKey: "projectDiscountPercentage"
      }
    ) })
  ] });
}
const Ry = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  QuoteDiscounts: Gr,
  default: Gr
}, Symbol.toStringTag, { value: "Module" }));
var wt = /* @__PURE__ */ ((t) => (t.Configurable = "Configurable", t.NonConfigurable = "NonConfigurable", t.PreConfigured = "PreConfigured", t.Default = "default", t))(wt || {});
function Vy({
  tooltipTitle: t,
  item: {
    quoteId: e,
    cfgObjectId: r,
    lineItemId: o,
    productId: n,
    productIdentifier: i,
    configurationId: a
  },
  color: s,
  buttonText: l
}) {
  i || console.error(
    "productIdentifier is undefined in IndicatorConfigurationButton"
  );
  const c = {
    cfgObjectId: r ?? "",
    quoteId: e,
    productId: n ?? "",
    productIdentifier: i ?? "",
    lineItemId: o,
    configurationId: a
  };
  return /* @__PURE__ */ u(Ue, { title: t, children: l ? /* @__PURE__ */ u(
    Fy,
    {
      to: "/configurator",
      search: c,
      startIcon: /* @__PURE__ */ u(F, { children: "settings" }),
      color: s,
      children: l
    }
  ) : /* @__PURE__ */ u(Oy, { size: "small", to: "/configurator", search: c, children: /* @__PURE__ */ u(F, { color: s, children: "settings" }) }) });
}
function Ny(t, e) {
  return t ? e ? "complete" : "incomplete" : "toConfigure";
}
function My(t) {
  return t === "toConfigure" ? "primary" : t === "complete" ? "success" : "warning";
}
function xy({
  quoteId: t,
  lineItemId: e,
  productId: r,
  configurationId: o,
  isConfigurationComplete: n,
  productTypeIdentifier: i,
  cfgObjectId: a,
  disableButtonText: s = !1,
  productIdentifier: l
}) {
  const { t: c } = T(), m = Ny(
    o,
    n
  );
  return i === wt.Configurable || i === wt.PreConfigured || o ? /* @__PURE__ */ u(
    Vy,
    {
      tooltipTitle: c(
        "CPQ:product.types.tooltip.configurationStatus." + m
      ),
      item: {
        quoteId: t,
        cfgObjectId: a,
        productId: r,
        lineItemId: e,
        configurationId: o,
        productIdentifier: l
      },
      color: My(m),
      buttonText: s ? "" : c("CPQ:product.status.text." + m)
    }
  ) : /* @__PURE__ */ u(w, {});
}
const Ey = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  IndicatorConfigurableProductInLineItem: xy
}, Symbol.toStringTag, { value: "Module" }));
function Xo({
  icon: t,
  variant: e = "text",
  size: r = "medium",
  children: o,
  dialogComponent: n
}) {
  const [i, a] = G(!1);
  function s(m) {
    m.stopPropagation(), a(!0);
  }
  function l() {
    a(!1);
  }
  return /* @__PURE__ */ f(w, { children: [
    o ? /* @__PURE__ */ u(
      Q,
      {
        size: r,
        onClick: s,
        startIcon: t ? /* @__PURE__ */ u(F, { children: t }) : null,
        variant: e,
        children: o
      }
    ) : /* @__PURE__ */ u(z, { size: r, onClick: s, children: /* @__PURE__ */ u(F, { children: t ? /* @__PURE__ */ u(F, { children: t }) : null }) }),
    /* @__PURE__ */ u(n, { open: i, onClose: l })
  ] });
}
function Uy({
  name: t,
  setName: e,
  validFrom: r,
  validTo: o,
  description: n,
  setValidFrom: i,
  setValidTo: a,
  setDescription: s
}) {
  const { t: l } = T();
  return /* @__PURE__ */ f(
    St,
    {
      onClick: (c) => c.stopPropagation(),
      sx: {
        display: "flex",
        flexDirection: "column",
        gap: "2rem",
        paddingTop: "1rem"
      },
      children: [
        /* @__PURE__ */ u(h, { display: "flex", gap: "2rem", flex: 1, children: /* @__PURE__ */ u(
          ve,
          {
            sx: { flex: 1 },
            required: !0,
            label: l("CPQ:dialog.createOpportunity.input.label.opportunityName"),
            variant: "outlined",
            value: t,
            onChange: (c) => e(c.target.value)
          }
        ) }),
        /* @__PURE__ */ f(h, { display: "flex", gap: "2rem", children: [
          /* @__PURE__ */ u(
            mt,
            {
              sx: { flex: 1 },
              label: l("CPQ:dialog.createOpportunity.input.validFrom.label"),
              value: r && new Date(r) || null,
              onChange: (c) => i(String(c) || null)
            }
          ),
          /* @__PURE__ */ u(
            mt,
            {
              sx: { flex: 1 },
              label: l("CPQ:dialog.createOpportunity.input.validTo.label"),
              value: o && new Date(o) || null,
              onChange: (c) => a(String(c) || null)
            }
          )
        ] }),
        /* @__PURE__ */ u(
          ve,
          {
            multiline: !0,
            fullWidth: !0,
            minRows: 5,
            label: l("CPQ:dialog.createOpportunity.input.label.description"),
            variant: "outlined",
            value: n,
            onChange: (c) => s(c.target.value)
          }
        )
      ]
    }
  );
}
function Qy({
  onClose: t,
  open: e
}) {
  const { t: r } = T(), { mutate: o, isPending: n } = Td(), i = te(), [a, s] = G(""), [l, c] = G(""), [m, P] = G(null), [S, q] = G(null), { status: I } = Co(), B = I.default.id;
  function A() {
    s(""), P(null), q(null), c("");
  }
  const L = () => {
    A(), t();
  };
  function M() {
    const v = {
      name: a,
      description: l,
      statusId: B
    };
    m && (v.validFrom = new Date(m).toISOString()), S && (v.validTo = new Date(S).toISOString()), o(
      {
        requestBody: v
      },
      {
        onSuccess: () => {
          i.invalidateQueries({
            queryKey: [_r]
          });
        },
        onError: (D) => console.error(D),
        onSettled: () => {
          L();
        }
      }
    );
  }
  return n ? /* @__PURE__ */ u(be, {}) : /* @__PURE__ */ f(It, { onClose: L, open: e, maxWidth: "md", fullWidth: !0, children: [
    /* @__PURE__ */ u(
      qt,
      {
        title: r("CPQ:dialog.createOpportunity.title"),
        subtitle: r("CPQ:dialog.createOpportunity.subtitle"),
        onClose: L
      }
    ),
    /* @__PURE__ */ u(
      Uy,
      {
        name: a,
        setName: s,
        description: l,
        setDescription: c,
        validFrom: m,
        validTo: S,
        setValidFrom: P,
        setValidTo: q
      }
    ),
    /* @__PURE__ */ u(
      st,
      {
        onCancel: L,
        onConfirm: M,
        confirmDisabled: !a
      }
    )
  ] });
}
function cC() {
  const { t } = T();
  return /* @__PURE__ */ u(
    Xo,
    {
      icon: "add",
      variant: "contained",
      dialogComponent: Qy,
      children: t("CPQ:button.createOpportunity")
    }
  );
}
function ky({
  name: t,
  description: e,
  setName: r,
  setDescription: o
}) {
  const { t: n } = T();
  return /* @__PURE__ */ u(
    St,
    {
      onClick: (i) => i.stopPropagation(),
      sx: {
        display: "flex",
        flexDirection: "column",
        gap: "2rem",
        paddingTop: "1rem"
      },
      children: /* @__PURE__ */ f(h, { display: "flex", gap: "2rem", flex: 1, flexDirection: "column", children: [
        /* @__PURE__ */ u(
          ve,
          {
            required: !0,
            label: n("CPQ:dialog.createQuote.input.label.name"),
            variant: "outlined",
            value: t,
            onChange: (i) => r(i.target.value)
          }
        ),
        /* @__PURE__ */ u(
          ve,
          {
            multiline: !0,
            minRows: 5,
            label: n("CPQ:dialog.createQuote.input.label.description"),
            variant: "outlined",
            value: e,
            onChange: (i) => o(i.target.value)
          }
        )
      ] })
    }
  );
}
function jy({
  onClose: t,
  open: e,
  opportunityId: r,
  onSuccessfulCreate: o
}) {
  const { t: n } = T(), { mutate: i, isPending: a } = Ld({}), [s, l] = G(""), [c, m] = G("");
  function P() {
    l(""), m("");
  }
  const S = () => {
    P(), t();
  };
  function q() {
    i(
      {
        requestBody: {
          opportunityId: r,
          name: s,
          description: c
        }
      },
      {
        onSuccess: (I) => {
          typeof o == "function" && o({ quoteId: I.id });
        },
        onError: (I) => console.error(I),
        onSettled: () => {
          S();
        }
      }
    );
  }
  return a ? /* @__PURE__ */ u(be, {}) : /* @__PURE__ */ f(It, { onClose: S, open: e, maxWidth: "sm", fullWidth: !0, children: [
    /* @__PURE__ */ u(
      qt,
      {
        title: n("CPQ:dialog.createQuote.title"),
        subtitle: n("CPQ:dialog.createQuote.subtitle"),
        onClose: S
      }
    ),
    /* @__PURE__ */ u(
      ky,
      {
        name: s,
        description: c,
        setName: l,
        setDescription: m
      }
    ),
    /* @__PURE__ */ u(
      st,
      {
        onCancel: S,
        onConfirm: q,
        confirmDisabled: !s
      }
    )
  ] });
}
function dC({
  opportunityId: t,
  onSuccessfulCreate: e
}) {
  const { t: r } = T();
  return /* @__PURE__ */ u(
    Xo,
    {
      icon: "add",
      variant: "contained",
      dialogComponent: (o) => /* @__PURE__ */ u(
        jy,
        {
          ...o,
          opportunityId: t,
          onSuccessfulCreate: e
        }
      ),
      children: r("CPQ:button.createQuote")
    }
  );
}
function $y({ headers: t, rows: e }) {
  return /* @__PURE__ */ u(ii, { children: e == null ? void 0 : e.map((r) => /* @__PURE__ */ u(kr, { children: t == null ? void 0 : t.map(({ accessor: o }) => /* @__PURE__ */ u(
    Qr,
    {
      sx: {
        fontWeight: o === "partId" ? "700" : null
      },
      children: r[o]
    },
    o
  )) }, r.partId)) });
}
function zy({
  items: t
}) {
  return console.log({ items: t }), t ? /* @__PURE__ */ u(h, { sx: { display: "flex", flexDirection: "column", gap: "1rem" }, children: t.map((e) => /* @__PURE__ */ f(h, { sx: { display: "flex", justifyContent: "end", gap: "2rem" }, children: [
    /* @__PURE__ */ u(h, { children: e.label }),
    /* @__PURE__ */ u(h, { children: e.value })
  ] })) }) : /* @__PURE__ */ u(w, {});
}
function Ky({
  headers: t
}) {
  return /* @__PURE__ */ u(ai, { children: /* @__PURE__ */ u(kr, { children: t == null ? void 0 : t.map(({ accessor: e, label: r }) => /* @__PURE__ */ u(Qr, { children: /* @__PURE__ */ u(h, { display: "flex", flexDirection: "row", children: /* @__PURE__ */ u(U, { children: r }) }) }, e)) }) });
}
function pC({ headers: t, rows: e, footer: r }) {
  return /* @__PURE__ */ f(ni, { children: [
    /* @__PURE__ */ f(oi, { "aria-label": "basicTable", children: [
      /* @__PURE__ */ u(Ky, { headers: t }),
      /* @__PURE__ */ u($y, { headers: t, rows: e })
    ] }),
    /* @__PURE__ */ u(zy, { items: r })
  ] });
}
const mC = {
  headers: [
    { accessor: "partId", label: "" },
    { accessor: "header1", label: "Header 1" },
    { accessor: "header2", label: "Header 2" },
    {
      accessor: "header3",
      label: "Header 3"
    }
  ],
  rows: [
    {
      partId: 1,
      header1: "Value 1",
      header2: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam",
      header3: "XXX EUR"
    },
    {
      partId: 2,
      header1: "Value 2",
      header2: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.",
      header3: "XXX EUR"
    },
    {
      partId: 3,
      header1: "Value 3",
      header2: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam",
      header3: "XXX EUR"
    },
    {
      partId: 4,
      header1: "Value 4",
      header2: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam",
      header3: "XXX EUR"
    },
    {
      partId: 5,
      header1: "Value 5",
      header2: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam",
      header3: "XXX EUR"
    }
  ],
  footer: [
    { label: "Total", value: "XX333X EUR" },
    { label: "Total", value: "XXX EUR" }
  ]
};
function Hy({ item: t }) {
  const [e, r] = G(null), o = !!e, n = (a) => {
    a.stopPropagation(), a.preventDefault(), r(a.currentTarget);
  }, i = () => {
    r(null);
  };
  return t ? /* @__PURE__ */ f(w, { children: [
    /* @__PURE__ */ u(z, { onClick: n, size: "small", children: /* @__PURE__ */ u(F, { children: "more_horiz" }) }),
    /* @__PURE__ */ f(Mt, { open: o, anchorEl: e, onClose: i, children: [
      /* @__PURE__ */ u(
        C.CloneRowMenuItem,
        {
          item: t,
          onSuccess: i
        },
        t.id + "-clone"
      ),
      /* @__PURE__ */ u(
        C.DeleteRowMenuItem,
        {
          item: t,
          onSuccess: i
        },
        t.id + "-delete"
      )
    ] })
  ] }) : null;
}
const _y = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ItemActionMenu: Hy
}, Symbol.toStringTag, { value: "Module" })), Wy = "/preview/api/3pq-ot/v1/document-generation", Zy = "/preview/api/3pq-ds/v1";
function Xy(t, e) {
  const r = atob(t), o = new Array(r.length);
  for (let s = 0; s < r.length; s++)
    o[s] = r.charCodeAt(s);
  const n = new Uint8Array(o), i = new Blob([n], {
    type: "application/pdf"
    // "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  }), a = document.createElement("a");
  a.href = URL.createObjectURL(i), a.download = e, document.body.appendChild(a), a.click(), document.body.removeChild(a), URL.revokeObjectURL(a.href);
}
async function Jy(t, e) {
  const r = Wy + "/generic-document-generation/", o = {
    ...t,
    documentLayoutId: e.documentLayoutId
  }, n = {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(o)
  };
  try {
    const i = await fetch(r, n);
    if (!i.ok)
      throw new Error(
        "There is something wrong with the response: " + i.statusText
      );
    const a = await i.json();
    console.debug("Success fetching: ", a, `from ${r}`);
    const s = JSON.parse(a.Content).data;
    Xy(s, "document.pdf");
  } catch (i) {
    console.error("Error:", i);
  }
}
function yC({
  printRequestParams: t,
  printButtonAreaIdentifier: e,
  vertical: r = !0
}) {
  const [o, n] = G(), [i, a] = G(!1), [s, l] = G([]);
  if ($(() => {
    async function m() {
      try {
        a(!0);
        const S = await (await fetch(
          `${Zy}/print-button-area/identifier/${e}`
        )).json();
        l(S.printButtons), a(!1);
      } catch (P) {
        console.error(P), a(!1);
      }
    }
    m();
  }, [e]), i)
    return /* @__PURE__ */ u(Tt, {});
  async function c() {
    o && await Jy(
      {
        locale: "en-US",
        printRequestParams: t
      },
      o
    );
  }
  return /* @__PURE__ */ f(h, { display: "flex", flexDirection: r ? "column" : "row", gap: 2, children: [
    /* @__PURE__ */ u(
      Yy,
      {
        data: s,
        selectedButton: o,
        setSelectedButton: n,
        printButtonAreaIdentifier: e
      }
    ),
    /* @__PURE__ */ f(
      Q,
      {
        disabled: !o,
        variant: "contained",
        sx: {
          marginRight: r ? 0 : "2em",
          minWidth: "250px",
          maxWidth: "fit-content"
        },
        onClick: () => o && c(),
        children: [
          /* @__PURE__ */ u(si, { sx: { marginRight: "0.5em" } }),
          "Print"
        ]
      }
    )
  ] });
}
function Yy({
  selectedButton: t,
  setSelectedButton: e,
  data: r
}) {
  return /* @__PURE__ */ u(
    ve,
    {
      label: "Print Template",
      select: !0,
      value: (t == null ? void 0 : t.id) ?? "",
      onChange: (o) => e(r == null ? void 0 : r.find(({ id: n }) => n === o.target.value)),
      sx: { minWidth: "250px", maxWidth: "fit-content" },
      children: r == null ? void 0 : r.map((o, n) => /* @__PURE__ */ f(le, { value: o.id, children: [
        "template ",
        n + 1,
        " - ",
        o.name
      ] }, o.id))
    }
  );
}
function eg({
  quoteId: t,
  quantity: e,
  product: r,
  onSuccess: o
}) {
  const { t: n } = T(), { saveConfiguration: i } = jr(), a = async () => {
    typeof o == "function" && o(), at.success(n("CPQ:toast.success.itemWasAddedToCart"));
  }, { mutate: s } = vd({
    onSuccess: a
  });
  async function l() {
    const { state: c } = await i(), m = c ? {
      configuration: {
        //todo -[ am ]- remove when the backend removed required
        identifier: "dummyIdentifier",
        state: c
      }
    } : {};
    s({
      requestBody: {
        quoteId: t,
        quantity: e,
        productId: r.id,
        ...m
      }
    });
  }
  return /* @__PURE__ */ u(z, { color: "primary", onClick: l, children: /* @__PURE__ */ u(F, { children: "add_shopping_cart" }) });
}
function tg({
  quoteId: t,
  quantity: e,
  product: r,
  onClose: o,
  anchorEl: n,
  onSuccess: i
}) {
  const { saveConfiguration: a } = jr(), [s, l] = G(null), [c, m] = G(!0);
  return $(() => {
    n && (async () => {
      const { state: S } = await a();
      l(S), m(!1);
    })();
  }, [a, n]), n ? c ? /* @__PURE__ */ u(Tt, {}) : s ? /* @__PURE__ */ u(
    Zo,
    {
      quoteId: t,
      quantity: e,
      products: [r],
      cfgState: s,
      onSuccess: i,
      anchorEl: n,
      onClose: o
    }
  ) : (console.error("could not get configuration state"), null) : null;
}
function gC({
  quoteId: t,
  product: e,
  onSuccess: r,
  defaultQuantity: o = 1
}) {
  const { isCustomer: n } = Wt(), { t: i } = T(), [a, s] = G(o), l = (S) => {
    m(S.currentTarget);
  }, [c, m] = G(null), P = () => {
    m(null);
  };
  return /* @__PURE__ */ f(
    h,
    {
      sx: { minWidth: "max-content" },
      display: "flex",
      flexDirection: "row",
      gap: "1rem",
      children: [
        /* @__PURE__ */ u(Wo, { defaultValue: o, onChange: s }),
        n ? /* @__PURE__ */ u(
          eg,
          {
            quoteId: t,
            quantity: a,
            product: e,
            onSuccess: r
          }
        ) : /* @__PURE__ */ f(w, { children: [
          /* @__PURE__ */ u(
            Q,
            {
              id: "basic-button",
              onClick: l,
              startIcon: /* @__PURE__ */ u(F, { children: "add" }),
              variant: "contained",
              sx: { minWidth: "fit-content" },
              children: i("CPQ:buttons.addConfigurationToItemGroupsButtonSelect.label")
            }
          ),
          /* @__PURE__ */ u(
            tg,
            {
              quoteId: t,
              quantity: a,
              product: e,
              onSuccess: r,
              anchorEl: c,
              onClose: P
            }
          )
        ] })
      ]
    }
  );
}
export {
  Mb as $,
  be as A,
  _r as B,
  vt as C,
  yC as D,
  dC as E,
  Kp as F,
  yp as G,
  mp as H,
  Vy as I,
  Xb as J,
  Wt as K,
  Pe as L,
  No as M,
  at as N,
  C as O,
  wt as P,
  ey as Q,
  Jm as R,
  eC as S,
  rC as T,
  Yf as U,
  tu as V,
  qt as W,
  Xo as X,
  th as Y,
  lu as Z,
  Uh as _,
  ph as a,
  ui as a$,
  du as a0,
  Nb as a1,
  Dd as a2,
  K as a3,
  qh as a4,
  vc as a5,
  Rf as a6,
  Ph as a7,
  Xm as a8,
  vd as a9,
  Op as aA,
  ep as aB,
  Bb as aC,
  qo as aD,
  Bp as aE,
  Vo as aF,
  nr as aG,
  sm as aH,
  yo as aI,
  fc as aJ,
  Of as aK,
  Cp as aL,
  hh as aM,
  qd as aN,
  ih as aO,
  Gh as aP,
  Yp as aQ,
  _ as aR,
  II as aS,
  Vd as aT,
  pI as aU,
  vI as aV,
  yI as aW,
  ft as aX,
  zt as aY,
  Kt as aZ,
  $h as a_,
  H as aa,
  Jb as ab,
  jh as ac,
  Uy as ad,
  mI as ae,
  gm as af,
  Cy as ag,
  nh as ah,
  fp as ai,
  Hr as aj,
  rh as ak,
  Fo as al,
  qp as am,
  O as an,
  V as ao,
  xp as ap,
  ZP as aq,
  er as ar,
  _p as as,
  ir as at,
  qe as au,
  tC as av,
  cf as aw,
  $o as ax,
  Me as ay,
  Ir as az,
  st as b,
  Us as b$,
  ky as b0,
  rr as b1,
  YP as b2,
  JP as b3,
  qb as b4,
  oC as b5,
  nC as b6,
  as as b7,
  iC as b8,
  sC as b9,
  ms as bA,
  ys as bB,
  gs as bC,
  bs as bD,
  fs as bE,
  hs as bF,
  Is as bG,
  Ss as bH,
  Ps as bI,
  Cs as bJ,
  qs as bK,
  vs as bL,
  Ts as bM,
  Bs as bN,
  Ls as bO,
  Gs as bP,
  As as bQ,
  Fs as bR,
  Os as bS,
  ws as bT,
  Ds as bU,
  Rs as bV,
  Vs as bW,
  Ns as bX,
  Ms as bY,
  xs as bZ,
  Es as b_,
  qr as ba,
  Re as bb,
  Um as bc,
  yr as bd,
  uC as be,
  vr as bf,
  Tr as bg,
  yi as bh,
  xd as bi,
  Br as bj,
  lC as bk,
  Lr as bl,
  Gr as bm,
  or as bn,
  xy as bo,
  Fy as bp,
  Oy as bq,
  Gp as br,
  pC as bs,
  mC as bt,
  ar as bu,
  Hy as bv,
  Oe as bw,
  Ne as bx,
  gC as by,
  jd as bz,
  aC as c,
  el as c$,
  Qs as c0,
  ks as c1,
  js as c2,
  $s as c3,
  zs as c4,
  Ks as c5,
  Hs as c6,
  _s as c7,
  Ws as c8,
  Zs as c9,
  Bu as cA,
  Lu as cB,
  Gu as cC,
  Au as cD,
  Fu as cE,
  Ou as cF,
  wu as cG,
  Du as cH,
  Ru as cI,
  Vu as cJ,
  Nu as cK,
  Mu as cL,
  xu as cM,
  Eu as cN,
  Uu as cO,
  Qu as cP,
  ku as cQ,
  ju as cR,
  $u as cS,
  zu as cT,
  Ku as cU,
  _u as cV,
  Wu as cW,
  Zu as cX,
  Xu as cY,
  Ju as cZ,
  Yu as c_,
  Xs as ca,
  Js as cb,
  Ys as cc,
  eu as cd,
  ru as ce,
  ou as cf,
  nu as cg,
  iu as ch,
  au as ci,
  su as cj,
  uu as ck,
  cu as cl,
  pu as cm,
  mu as cn,
  yu as co,
  gu as cp,
  bu as cq,
  fu as cr,
  hu as cs,
  Iu as ct,
  Su as cu,
  Pu as cv,
  Cu as cw,
  qu as cx,
  vu as cy,
  Tu as cz,
  Ql as d,
  cc as d$,
  tl as d0,
  rl as d1,
  ol as d2,
  nl as d3,
  il as d4,
  al as d5,
  sl as d6,
  ul as d7,
  ll as d8,
  cl as d9,
  Nl as dA,
  Ml as dB,
  xl as dC,
  El as dD,
  Ul as dE,
  kl as dF,
  jl as dG,
  $l as dH,
  zl as dI,
  Kl as dJ,
  Hl as dK,
  _l as dL,
  Wl as dM,
  Zl as dN,
  Xl as dO,
  Jl as dP,
  Yl as dQ,
  ec as dR,
  tc as dS,
  rc as dT,
  oc as dU,
  nc as dV,
  ic as dW,
  ac as dX,
  sc as dY,
  uc as dZ,
  lc as d_,
  dl as da,
  pl as db,
  ml as dc,
  yl as dd,
  gl as de,
  bl as df,
  fl as dg,
  hl as dh,
  Il as di,
  Sl as dj,
  Pl as dk,
  Cl as dl,
  ql as dm,
  vl as dn,
  Tl as dp,
  Bl as dq,
  Ll as dr,
  Gl as ds,
  Al as dt,
  Fl as du,
  Ol as dv,
  wl as dw,
  Dl as dx,
  Rl as dy,
  Vl as dz,
  E as e,
  Qb as e$,
  dc as e0,
  pc as e1,
  mc as e2,
  yc as e3,
  gc as e4,
  bc as e5,
  hc as e6,
  Ic as e7,
  Sc as e8,
  Pc as e9,
  _c as eA,
  pb as eB,
  mb as eC,
  yb as eD,
  gb as eE,
  bb as eF,
  fb as eG,
  hb as eH,
  Ib as eI,
  Sb as eJ,
  Pb as eK,
  Cb as eL,
  vb as eM,
  Tb as eN,
  Lb as eO,
  Gb as eP,
  Ab as eQ,
  Fb as eR,
  Ob as eS,
  wb as eT,
  Rb as eU,
  Vb as eV,
  mo as eW,
  dd as eX,
  xb as eY,
  Eb as eZ,
  Ub as e_,
  Cc as ea,
  qc as eb,
  Tc as ec,
  Bc as ed,
  Lc as ee,
  Gc as ef,
  Ac as eg,
  Qt as eh,
  Fc as ei,
  Oc as ej,
  wc as ek,
  Dc as el,
  Rc as em,
  Vc as en,
  Nc as eo,
  Mc as ep,
  xc as eq,
  Ec as er,
  Uc as es,
  Qc as et,
  kc as eu,
  jc as ev,
  $c as ew,
  zc as ex,
  Kc as ey,
  Hc as ez,
  go as f,
  Wf as f$,
  kb as f0,
  jb as f1,
  $b as f2,
  zb as f3,
  Kb as f4,
  pd as f5,
  Hb as f6,
  md as f7,
  yd as f8,
  _b as f9,
  Sd as fA,
  Pd as fB,
  Pf as fC,
  Cf as fD,
  qf as fE,
  Tf as fF,
  Bf as fG,
  Lf as fH,
  Gf as fI,
  Af as fJ,
  Ff as fK,
  wf as fL,
  Df as fM,
  Vf as fN,
  Nf as fO,
  Mf as fP,
  xf as fQ,
  Ef as fR,
  Uf as fS,
  Qf as fT,
  kf as fU,
  jf as fV,
  $f as fW,
  zf as fX,
  Kf as fY,
  Hf as fZ,
  _f as f_,
  Wb as fa,
  Zb as fb,
  gd as fc,
  Yb as fd,
  bd as fe,
  ef as ff,
  tf as fg,
  rf as fh,
  of as fi,
  nf as fj,
  af as fk,
  sf as fl,
  uf as fm,
  lf as fn,
  df as fo,
  pf as fp,
  mf as fq,
  yf as fr,
  gf as fs,
  bf as ft,
  fd as fu,
  ff as fv,
  hf as fw,
  If as fx,
  Sf as fy,
  Id as fz,
  hd as g,
  lI as g$,
  Zf as g0,
  Xf as g1,
  Jf as g2,
  eh as g3,
  Cd as g4,
  oh as g5,
  ah as g6,
  Td as g7,
  sh as g8,
  uh as g9,
  Mh as gA,
  xh as gB,
  Eh as gC,
  Qh as gD,
  Od as gE,
  kh as gF,
  wd as gG,
  zh as gH,
  Kh as gI,
  Hh as gJ,
  _h as gK,
  Wh as gL,
  Zh as gM,
  Ht as gN,
  Xh as gO,
  Rd as gP,
  Jh as gQ,
  Yh as gR,
  eI as gS,
  tI as gT,
  rI as gU,
  oI as gV,
  nI as gW,
  iI as gX,
  aI as gY,
  sI as gZ,
  uI as g_,
  lh as ga,
  ch as gb,
  dh as gc,
  Bd as gd,
  mh as ge,
  yh as gf,
  gh as gg,
  bh as gh,
  fh as gi,
  Ld as gj,
  Ih as gk,
  Gd as gl,
  Sh as gm,
  Ch as gn,
  vh as go,
  Ad as gp,
  Bh as gq,
  Lh as gr,
  Ah as gs,
  Fh as gt,
  Oh as gu,
  wh as gv,
  Dh as gw,
  Rh as gx,
  Vh as gy,
  Nh as gz,
  Co as h,
  SS as h$,
  cI as h0,
  dI as h1,
  gI as h2,
  bI as h3,
  fI as h4,
  hI as h5,
  SI as h6,
  PI as h7,
  CI as h8,
  qI as h9,
  HI as hA,
  _I as hB,
  WI as hC,
  ZI as hD,
  XI as hE,
  JI as hF,
  YI as hG,
  eS as hH,
  tS as hI,
  rS as hJ,
  oS as hK,
  nS as hL,
  iS as hM,
  aS as hN,
  sS as hO,
  uS as hP,
  lS as hQ,
  cS as hR,
  dS as hS,
  pS as hT,
  mS as hU,
  yS as hV,
  gS as hW,
  bS as hX,
  fS as hY,
  hS as hZ,
  IS as h_,
  TI as ha,
  BI as hb,
  mr as hc,
  Zc as hd,
  Wc as he,
  d as hf,
  LI as hg,
  GI as hh,
  AI as hi,
  FI as hj,
  OI as hk,
  wI as hl,
  DI as hm,
  RI as hn,
  VI as ho,
  NI as hp,
  MI as hq,
  xI as hr,
  EI as hs,
  UI as ht,
  QI as hu,
  kI as hv,
  jI as hw,
  $I as hx,
  zI as hy,
  KI as hz,
  Db as i,
  GP as i$,
  PS as i0,
  CS as i1,
  qS as i2,
  vS as i3,
  TS as i4,
  BS as i5,
  LS as i6,
  GS as i7,
  AS as i8,
  FS as i9,
  tP as iA,
  rP as iB,
  oP as iC,
  nP as iD,
  iP as iE,
  aP as iF,
  sP as iG,
  uP as iH,
  lP as iI,
  cP as iJ,
  dP as iK,
  pP as iL,
  mP as iM,
  yP as iN,
  gP as iO,
  bP as iP,
  fP as iQ,
  hP as iR,
  IP as iS,
  SP as iT,
  PP as iU,
  CP as iV,
  qP as iW,
  vP as iX,
  TP as iY,
  BP as iZ,
  LP as i_,
  OS as ia,
  wS as ib,
  DS as ic,
  RS as id,
  VS as ie,
  NS as ig,
  MS as ih,
  xS as ii,
  ES as ij,
  US as ik,
  QS as il,
  kS as im,
  jS as io,
  $S as ip,
  zS as iq,
  KS as ir,
  HS as is,
  _S as it,
  WS as iu,
  ZS as iv,
  XS as iw,
  JS as ix,
  YS as iy,
  eP as iz,
  Se as j,
  rt as j$,
  AP as j0,
  FP as j1,
  OP as j2,
  wP as j3,
  DP as j4,
  RP as j5,
  VP as j6,
  NP as j7,
  MP as j8,
  xP as j9,
  Jr as jA,
  $t as jB,
  Yr as jC,
  ud as jD,
  ld as jE,
  fe as jF,
  eo as jG,
  oe as jH,
  Be as jI,
  to as jJ,
  ro as jK,
  oo as jL,
  no as jM,
  io as jN,
  Pt as jO,
  ao as jP,
  so as jQ,
  he as jR,
  uo as jS,
  ne as jT,
  Je as jU,
  Ye as jV,
  lo as jW,
  et as jX,
  tt as jY,
  Ie as jZ,
  Ct as j_,
  EP as ja,
  UP as jb,
  QP as jc,
  kP as jd,
  jP as je,
  $P as jf,
  zP as jg,
  KP as jh,
  HP as ji,
  _P as jj,
  WP as jk,
  ke as jl,
  je as jm,
  Te as jn,
  $e as jo,
  ze as jp,
  sd as jq,
  jt as jr,
  Zr as js,
  Ke as jt,
  He as ju,
  _e as jv,
  We as jw,
  Ze as jx,
  Xe as jy,
  Xr as jz,
  Fd as k,
  ot as k0,
  cd as k1,
  co as k2,
  Le as k3,
  ie as k4,
  nt as k5,
  po as k6,
  it as k7,
  Th as l,
  zr as m,
  Eo as n,
  Tt as o,
  Nd as p,
  ye as q,
  cC as r,
  ps as s,
  Mo as t,
  vf as u,
  XP as v,
  fr as w,
  um as x,
  xo as y,
  Hu as z
};
